
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree891"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree891"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.4" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.4";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.4";

});



parcelRegister("5ETHc", function(module, exports) {

var $9vzhD = parcelRequire("9vzhD");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $9vzhD(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("9vzhD", function(module, exports) {
function $6ec260e3212aa3ad$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $6ec260e3212aa3ad$var$RetryOperation;
$6ec260e3212aa3ad$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.start = $6ec260e3212aa3ad$var$RetryOperation.prototype.try;
$6ec260e3212aa3ad$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



/**
 * @license lucide-react v1.23.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.23.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.23.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $5921600fb4e81be8$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();


/**
 * @license lucide-react v1.23.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $ebab042c7bf4d462$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();


/**
 * @license lucide-react v1.23.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.23.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $679cfb4006de9dc2$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());


const $05938c6aab1a7024$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $679cfb4006de9dc2$export$86f54f62aa7a7514)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.23.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $b02e0cdef8864a93$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};


/**
 * @license lucide-react v1.23.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $08ed9cd30f364255$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};




var $acw62 = parcelRequire("acw62");
"use strict";
"use client";
const $fdd26cba762f63b6$var$LucideContext = (0, $acw62.createContext)({});
function $fdd26cba762f63b6$export$f4a5ae9d8b2d8a16({ children: children, size: size, color: color, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className }) {
    const value = (0, $acw62.useMemo)(()=>({
            size: size,
            color: color,
            strokeWidth: strokeWidth,
            absoluteStrokeWidth: absoluteStrokeWidth,
            className: className
        }), [
        size,
        color,
        strokeWidth,
        absoluteStrokeWidth,
        className
    ]);
    return (0, $acw62.createElement)($fdd26cba762f63b6$var$LucideContext.Provider, {
        value: value
    }, children);
}
const $fdd26cba762f63b6$export$52ee7576b6cde767 = ()=>(0, $acw62.useContext)($fdd26cba762f63b6$var$LucideContext);


"use strict";
"use client";
const $8c69f6577678916e$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color, size: size, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    const { size: contextSize = 24, strokeWidth: contextStrokeWidth = 2, absoluteStrokeWidth: contextAbsoluteStrokeWidth = false, color: contextColor = "currentColor", className: contextClass = "" } = (0, $fdd26cba762f63b6$export$52ee7576b6cde767)() ?? {};
    const calculatedStrokeWidth = absoluteStrokeWidth ?? contextAbsoluteStrokeWidth ? Number(strokeWidth ?? contextStrokeWidth) * 24 / Number(size ?? contextSize) : strokeWidth ?? contextStrokeWidth;
    return (0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $b02e0cdef8864a93$export$2e2bcd8739ae039),
        width: size ?? contextSize ?? (0, $b02e0cdef8864a93$export$2e2bcd8739ae039).width,
        height: size ?? contextSize ?? (0, $b02e0cdef8864a93$export$2e2bcd8739ae039).height,
        stroke: color ?? contextColor,
        strokeWidth: calculatedStrokeWidth,
        className: (0, $5921600fb4e81be8$export$3d46f4579dba46e5)("lucide", contextClass, className),
        ...!children && !(0, $08ed9cd30f364255$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $cb908d1b06653674$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $8c69f6577678916e$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $5921600fb4e81be8$export$3d46f4579dba46e5)(`lucide-${(0, $ebab042c7bf4d462$export$73bda83cddbc7187)((0, $05938c6aab1a7024$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $05938c6aab1a7024$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $e89d7dac6d00534a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 16 4-4-4-4",
            key: "1inbqp"
        }
    ],
    [
        "path",
        {
            d: "m6 8-4 4 4 4",
            key: "15zrgr"
        }
    ],
    [
        "path",
        {
            d: "m14.5 4-5 16",
            key: "e7oirm"
        }
    ]
];
const $e89d7dac6d00534a$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("code-xml", $e89d7dac6d00534a$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.23.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $96b330d9ae0cfa5e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const $96b330d9ae0cfa5e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("refresh-cw", $96b330d9ae0cfa5e$export$3efd853dbb351e94);


var $065dc4985456da65$require$Code2 = $e89d7dac6d00534a$export$2e2bcd8739ae039;
var $065dc4985456da65$require$RefreshCw = $96b330d9ae0cfa5e$export$2e2bcd8739ae039;
const $065dc4985456da65$var$NavBar = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            borderBottom: "1px solid #1E2939"
        },
        className: "w-screen",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-[#09090B] shadow-2xl h-16 text-zinc-100 flex items-center w-screen justify-between",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center gap-3 p-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "#",
                            className: "w-10 h-10 md:w-9 md:h-9 flex items-center justify-center rounded-lg  bg-gradient-to-tr from-indigo-500 to-purple-600 text-white  shadow-lg shadow-indigo-500/20 transition-colors",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($065dc4985456da65$require$Code2, {
                                size: 20
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col items-start justify-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-sm md:text-xl text-gray-100 font-semibold text-lg leading-tight tracking-tight",
                                    children: "Interative Code Explainer (Beta)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs text-gray-400 font-medium",
                                    children: "Break & Understand what every code block is doing"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "p-4 flex items-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        title: "Refresh",
                        onClick: ()=>window.location.reload(),
                        className: "w-9 h-9 cursor-pointer flex items-center justify-center rounded-lg bg-gray-800 hover:bg-gray-700 text-white transition-colors",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($065dc4985456da65$require$RefreshCw, {
                            size: 20
                        })
                    })
                })
            ]
        })
    });
};
var $065dc4985456da65$export$2e2bcd8739ae039 = $065dc4985456da65$var$NavBar;




var $acw62 = parcelRequire("acw62");
function $bee55e9bb705b0f2$export$93cc12bcce4c2e3c(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $bee55e9bb705b0f2$export$993bf82df8051d40(r) {
    if (Array.isArray(r)) return r;
}
function $bee55e9bb705b0f2$export$fdab3c20aae16ddf(e, r, t) {
    return (r = $bee55e9bb705b0f2$export$615c81bad063d605(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $bee55e9bb705b0f2$export$861af887bcb88094(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $bee55e9bb705b0f2$export$37ce4bd7a39fe25f() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bee55e9bb705b0f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bee55e9bb705b0f2$export$df72099fd95ee399(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bee55e9bb705b0f2$var$ownKeys(Object(t), true).forEach(function(r) {
            $bee55e9bb705b0f2$export$fdab3c20aae16ddf(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bee55e9bb705b0f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bee55e9bb705b0f2$export$d8a2083381e8fcb(e, t) {
    if (null == e) return {};
    var o, r, i = $bee55e9bb705b0f2$export$81942a8f34b531c4(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $bee55e9bb705b0f2$export$81942a8f34b531c4(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $bee55e9bb705b0f2$export$12b6a547ec390b98(r, e) {
    return $bee55e9bb705b0f2$export$993bf82df8051d40(r) || $bee55e9bb705b0f2$export$861af887bcb88094(r, e) || $bee55e9bb705b0f2$export$b471fbbbe6d7806(r, e) || $bee55e9bb705b0f2$export$37ce4bd7a39fe25f();
}
function $bee55e9bb705b0f2$export$df1528eb86e943d6(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $bee55e9bb705b0f2$export$615c81bad063d605(t) {
    var i = $bee55e9bb705b0f2$export$df1528eb86e943d6(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $bee55e9bb705b0f2$export$b471fbbbe6d7806(r, a) {
    if (r) {
        if ("string" == typeof r) return $bee55e9bb705b0f2$export$93cc12bcce4c2e3c(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $bee55e9bb705b0f2$export$93cc12bcce4c2e3c(r, a) : void 0;
    }
}


function $9060348473dc28ea$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9060348473dc28ea$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9060348473dc28ea$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9060348473dc28ea$var$ownKeys(Object(source), true).forEach(function(key) {
            $9060348473dc28ea$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9060348473dc28ea$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9060348473dc28ea$var$compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
}
function $9060348473dc28ea$var$curry(fn) {
    return function curried() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len3 = arguments.length, nextArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)nextArgs[_key3] = arguments[_key3];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}
function $9060348473dc28ea$var$isObject(value) {
    return ({}).toString.call(value).includes('Object');
}
function $9060348473dc28ea$var$isEmpty(obj) {
    return !Object.keys(obj).length;
}
function $9060348473dc28ea$var$isFunction(value) {
    return typeof value === 'function';
}
function $9060348473dc28ea$var$hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
function $9060348473dc28ea$var$validateChanges(initial, changes) {
    if (!$9060348473dc28ea$var$isObject(changes)) $9060348473dc28ea$var$errorHandler('changeType');
    if (Object.keys(changes).some(function(field) {
        return !$9060348473dc28ea$var$hasOwnProperty(initial, field);
    })) $9060348473dc28ea$var$errorHandler('changeField');
    return changes;
}
function $9060348473dc28ea$var$validateSelector(selector) {
    if (!$9060348473dc28ea$var$isFunction(selector)) $9060348473dc28ea$var$errorHandler('selectorType');
}
function $9060348473dc28ea$var$validateHandler(handler) {
    if (!($9060348473dc28ea$var$isFunction(handler) || $9060348473dc28ea$var$isObject(handler))) $9060348473dc28ea$var$errorHandler('handlerType');
    if ($9060348473dc28ea$var$isObject(handler) && Object.values(handler).some(function(_handler) {
        return !$9060348473dc28ea$var$isFunction(_handler);
    })) $9060348473dc28ea$var$errorHandler('handlersType');
}
function $9060348473dc28ea$var$validateInitial(initial) {
    if (!initial) $9060348473dc28ea$var$errorHandler('initialIsRequired');
    if (!$9060348473dc28ea$var$isObject(initial)) $9060348473dc28ea$var$errorHandler('initialType');
    if ($9060348473dc28ea$var$isEmpty(initial)) $9060348473dc28ea$var$errorHandler('initialContent');
}
function $9060348473dc28ea$var$throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var $9060348473dc28ea$var$errorMessages = {
    initialIsRequired: 'initial state is required',
    initialType: 'initial state should be an object',
    initialContent: 'initial state shouldn\'t be an empty object',
    handlerType: 'handler should be an object or a function',
    handlersType: 'all handlers should be a functions',
    selectorType: 'selector should be a function',
    changeType: 'provided value of changes should be an object',
    changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
    "default": 'an unknown error accured in `state-local` package'
};
var $9060348473dc28ea$var$errorHandler = $9060348473dc28ea$var$curry($9060348473dc28ea$var$throwError)($9060348473dc28ea$var$errorMessages);
var $9060348473dc28ea$var$validators = {
    changes: $9060348473dc28ea$var$validateChanges,
    selector: $9060348473dc28ea$var$validateSelector,
    handler: $9060348473dc28ea$var$validateHandler,
    initial: $9060348473dc28ea$var$validateInitial
};
function $9060348473dc28ea$var$create(initial) {
    var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $9060348473dc28ea$var$validators.initial(initial);
    $9060348473dc28ea$var$validators.handler(handler);
    var state = {
        current: initial
    };
    var didUpdate = $9060348473dc28ea$var$curry($9060348473dc28ea$var$didStateUpdate)(state, handler);
    var update = $9060348473dc28ea$var$curry($9060348473dc28ea$var$updateState)(state);
    var validate = $9060348473dc28ea$var$curry($9060348473dc28ea$var$validators.changes)(initial);
    var getChanges = $9060348473dc28ea$var$curry($9060348473dc28ea$var$extractChanges)(state);
    function getState() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function(state) {
            return state;
        };
        $9060348473dc28ea$var$validators.selector(selector);
        return selector(state.current);
    }
    function setState(causedChanges) {
        $9060348473dc28ea$var$compose(didUpdate, update, validate, getChanges)(causedChanges);
    }
    return [
        getState,
        setState
    ];
}
function $9060348473dc28ea$var$extractChanges(state, causedChanges) {
    return $9060348473dc28ea$var$isFunction(causedChanges) ? causedChanges(state.current) : causedChanges;
}
function $9060348473dc28ea$var$updateState(state, changes) {
    state.current = $9060348473dc28ea$var$_objectSpread2($9060348473dc28ea$var$_objectSpread2({}, state.current), changes);
    return changes;
}
function $9060348473dc28ea$var$didStateUpdate(state, handler, changes) {
    $9060348473dc28ea$var$isFunction(handler) ? handler(state.current) : Object.keys(changes).forEach(function(field) {
        var _handler$field;
        return (_handler$field = handler[field]) === null || _handler$field === void 0 ? void 0 : _handler$field.call(handler, state.current[field]);
    });
    return changes;
}
var $9060348473dc28ea$var$index = {
    create: $9060348473dc28ea$var$create
};
var $9060348473dc28ea$export$2e2bcd8739ae039 = $9060348473dc28ea$var$index;


var $c482d67a3b2162b4$export$2e2bcd8739ae039 = {
    paths: {
        vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.55.1/min/vs'
    }
};


function $32601aa89bd9af55$export$2e2bcd8739ae039(fn) {
    return function curried() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)nextArgs[_key2] = arguments[_key2];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}


function $92c97a4a229f3a23$export$2e2bcd8739ae039(value) {
    return ({}).toString.call(value).includes('Object');
}


/**
 * validates the configuration object and informs about deprecation
 * @param {Object} config - the configuration object 
 * @return {Object} config - the validated configuration object
 */ function $cf5f38a3a625a9e0$var$validateConfig(config) {
    if (!config) $cf5f38a3a625a9e0$export$cc3fdd528b56c4a9('configIsRequired');
    if (!(0, $92c97a4a229f3a23$export$2e2bcd8739ae039)(config)) $cf5f38a3a625a9e0$export$cc3fdd528b56c4a9('configType');
    if (config.urls) {
        $cf5f38a3a625a9e0$var$informAboutDeprecation();
        return {
            paths: {
                vs: config.urls.monacoBase
            }
        };
    }
    return config;
}
/**
 * logs deprecation message
 */ function $cf5f38a3a625a9e0$var$informAboutDeprecation() {
    console.warn($cf5f38a3a625a9e0$export$d8bd0967cb58683.deprecation);
}
function $cf5f38a3a625a9e0$var$throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var $cf5f38a3a625a9e0$export$d8bd0967cb58683 = {
    configIsRequired: 'the configuration object is required',
    configType: 'the configuration object should be an object',
    "default": 'an unknown error accured in `@monaco-editor/loader` package',
    deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
};
var $cf5f38a3a625a9e0$export$cc3fdd528b56c4a9 = (0, $32601aa89bd9af55$export$2e2bcd8739ae039)($cf5f38a3a625a9e0$var$throwError)($cf5f38a3a625a9e0$export$d8bd0967cb58683);
var $cf5f38a3a625a9e0$export$2e2bcd8739ae039 = {
    config: $cf5f38a3a625a9e0$var$validateConfig
};


var $cdea1942f0eebb85$export$2e2bcd8739ae039 = function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
};



function $2587816bf76728ed$export$2e2bcd8739ae039(target, source) {
    Object.keys(source).forEach(function(key) {
        if (source[key] instanceof Object) {
            if (target[key]) Object.assign(source[key], $2587816bf76728ed$export$2e2bcd8739ae039(target[key], source[key]));
        }
    });
    return (0, $bee55e9bb705b0f2$export$df72099fd95ee399)((0, $bee55e9bb705b0f2$export$df72099fd95ee399)({}, target), source);
}


// The source (has been changed) is https://github.com/facebook/react/issues/5465#issuecomment-157888325
var $cbf26bd161834ccb$export$ef4ebf120f9f6749 = {
    type: 'cancelation',
    msg: 'operation is manually canceled'
};
function $cbf26bd161834ccb$export$2e2bcd8739ae039(promise) {
    var hasCanceled_ = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(val) {
            return hasCanceled_ ? reject($cbf26bd161834ccb$export$ef4ebf120f9f6749) : resolve(val);
        });
        promise["catch"](reject);
    });
    return wrappedPromise.cancel = function() {
        return hasCanceled_ = true;
    }, wrappedPromise;
}


var $0840e892d82f5480$var$_excluded = [
    "monaco"
];
/** the local state of the module */ var $0840e892d82f5480$var$_state$create = (0, $9060348473dc28ea$export$2e2bcd8739ae039).create({
    config: (0, $c482d67a3b2162b4$export$2e2bcd8739ae039),
    isInitialized: false,
    resolve: null,
    reject: null,
    monaco: null
}), $0840e892d82f5480$var$_state$create2 = (0, $bee55e9bb705b0f2$export$12b6a547ec390b98)($0840e892d82f5480$var$_state$create, 2), $0840e892d82f5480$var$getState = $0840e892d82f5480$var$_state$create2[0], $0840e892d82f5480$var$setState = $0840e892d82f5480$var$_state$create2[1];
/**
 * set the loader configuration
 * @param {Object} config - the configuration object
 */ function $0840e892d82f5480$var$config(globalConfig) {
    var _validators$config = (0, $cf5f38a3a625a9e0$export$2e2bcd8739ae039).config(globalConfig), monaco = _validators$config.monaco, config = (0, $bee55e9bb705b0f2$export$d8a2083381e8fcb)(_validators$config, $0840e892d82f5480$var$_excluded);
    $0840e892d82f5480$var$setState(function(state) {
        return {
            config: (0, $2587816bf76728ed$export$2e2bcd8739ae039)(state.config, config),
            monaco: monaco
        };
    });
}
/**
 * handles the initialization of the monaco-editor
 * @return {Promise} - returns an instance of monaco (with a cancelable promise)
 */ function $0840e892d82f5480$var$init() {
    var state = $0840e892d82f5480$var$getState(function(_ref) {
        var monaco = _ref.monaco, isInitialized = _ref.isInitialized, resolve = _ref.resolve;
        return {
            monaco: monaco,
            isInitialized: isInitialized,
            resolve: resolve
        };
    });
    if (!state.isInitialized) {
        $0840e892d82f5480$var$setState({
            isInitialized: true
        });
        if (state.monaco) {
            state.resolve(state.monaco);
            return (0, $cbf26bd161834ccb$export$2e2bcd8739ae039)($0840e892d82f5480$var$wrapperPromise);
        }
        if (window.monaco && window.monaco.editor) {
            $0840e892d82f5480$var$storeMonacoInstance(window.monaco);
            state.resolve(window.monaco);
            return (0, $cbf26bd161834ccb$export$2e2bcd8739ae039)($0840e892d82f5480$var$wrapperPromise);
        }
        (0, $cdea1942f0eebb85$export$2e2bcd8739ae039)($0840e892d82f5480$var$injectScripts, $0840e892d82f5480$var$getMonacoLoaderScript)($0840e892d82f5480$var$configureLoader);
    }
    return (0, $cbf26bd161834ccb$export$2e2bcd8739ae039)($0840e892d82f5480$var$wrapperPromise);
}
/**
 * injects provided scripts into the document.body
 * @param {Object} script - an HTML script element
 * @return {Object} - the injected HTML script element
 */ function $0840e892d82f5480$var$injectScripts(script) {
    return document.body.appendChild(script);
}
/**
 * creates an HTML script element with/without provided src
 * @param {string} [src] - the source path of the script
 * @return {Object} - the created HTML script element
 */ function $0840e892d82f5480$var$createScript(src) {
    var script = document.createElement('script');
    return src && (script.src = src), script;
}
/**
 * creates an HTML script element with the monaco loader src
 * @return {Object} - the created HTML script element
 */ function $0840e892d82f5480$var$getMonacoLoaderScript(configureLoader) {
    var state = $0840e892d82f5480$var$getState(function(_ref2) {
        var config = _ref2.config, reject = _ref2.reject;
        return {
            config: config,
            reject: reject
        };
    });
    var loaderScript = $0840e892d82f5480$var$createScript("".concat(state.config.paths.vs, "/loader.js"));
    loaderScript.onload = function() {
        return configureLoader();
    };
    loaderScript.onerror = state.reject;
    return loaderScript;
}
/**
 * configures the monaco loader
 */ function $0840e892d82f5480$var$configureLoader() {
    var state = $0840e892d82f5480$var$getState(function(_ref3) {
        var config = _ref3.config, resolve = _ref3.resolve, reject = _ref3.reject;
        return {
            config: config,
            resolve: resolve,
            reject: reject
        };
    });
    var require = window.require;
    require.config(state.config);
    require([
        'vs/editor/editor.main'
    ], function(loaded) {
        var monaco = loaded.m /* for 0.53 & 0.54 */  || loaded /* for other versions */ ;
        $0840e892d82f5480$var$storeMonacoInstance(monaco);
        state.resolve(monaco);
    }, function(error) {
        state.reject(error);
    });
}
/**
 * store monaco instance in local state
 */ function $0840e892d82f5480$var$storeMonacoInstance(monaco) {
    if (!$0840e892d82f5480$var$getState().monaco) $0840e892d82f5480$var$setState({
        monaco: monaco
    });
}
/**
 * internal helper function
 * extracts stored monaco instance
 * @return {Object|null} - the monaco instance
 */ function $0840e892d82f5480$var$__getMonacoInstance() {
    return $0840e892d82f5480$var$getState(function(_ref4) {
        var monaco = _ref4.monaco;
        return monaco;
    });
}
var $0840e892d82f5480$var$wrapperPromise = new Promise(function(resolve, reject) {
    return $0840e892d82f5480$var$setState({
        resolve: resolve,
        reject: reject
    });
});
var $0840e892d82f5480$export$2e2bcd8739ae039 = {
    config: $0840e892d82f5480$var$config,
    init: $0840e892d82f5480$var$init,
    __getMonacoInstance: $0840e892d82f5480$var$__getMonacoInstance
};





var $acw62 = parcelRequire("acw62");
var $e964c7ac951d5673$var$le = {
    wrapper: {
        display: "flex",
        position: "relative",
        textAlign: "initial"
    },
    fullWidth: {
        width: "100%"
    },
    hide: {
        display: "none"
    }
}, $e964c7ac951d5673$var$v = $e964c7ac951d5673$var$le;
var $e964c7ac951d5673$var$ae = {
    container: {
        display: "flex",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center"
    }
}, $e964c7ac951d5673$var$Y = $e964c7ac951d5673$var$ae;
function $e964c7ac951d5673$var$Me({ children: e }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: $e964c7ac951d5673$var$Y.container
    }, e);
}
var $e964c7ac951d5673$var$Z = $e964c7ac951d5673$var$Me;
var $e964c7ac951d5673$var$$ = $e964c7ac951d5673$var$Z;
function $e964c7ac951d5673$var$Ee({ width: e, height: r, isEditorReady: n, loading: t, _ref: a, className: m, wrapperProps: E }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        style: {
            ...$e964c7ac951d5673$var$v.wrapper,
            width: e,
            height: r
        },
        ...E
    }, !n && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e964c7ac951d5673$var$$, null, t), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: a,
        style: {
            ...$e964c7ac951d5673$var$v.fullWidth,
            ...!n && $e964c7ac951d5673$var$v.hide
        },
        className: m
    }));
}
var $e964c7ac951d5673$var$ee = $e964c7ac951d5673$var$Ee;
var $e964c7ac951d5673$var$H = (0, $acw62.memo)($e964c7ac951d5673$var$ee);
function $e964c7ac951d5673$var$Ce(e) {
    (0, $acw62.useEffect)(e, []);
}
var $e964c7ac951d5673$var$k = $e964c7ac951d5673$var$Ce;
function $e964c7ac951d5673$var$he(e, r, n = !0) {
    let t = (0, $acw62.useRef)(!0);
    (0, $acw62.useEffect)(t.current || !n ? ()=>{
        t.current = !1;
    } : e, r);
}
var $e964c7ac951d5673$var$l = $e964c7ac951d5673$var$he;
function $e964c7ac951d5673$var$D() {}
function $e964c7ac951d5673$var$h(e, r, n, t) {
    return $e964c7ac951d5673$var$De(e, t) || $e964c7ac951d5673$var$be(e, r, n, t);
}
function $e964c7ac951d5673$var$De(e, r) {
    return e.editor.getModel($e964c7ac951d5673$var$te(e, r));
}
function $e964c7ac951d5673$var$be(e, r, n, t) {
    return e.editor.createModel(r, n, t ? $e964c7ac951d5673$var$te(e, t) : void 0);
}
function $e964c7ac951d5673$var$te(e, r) {
    return e.Uri.parse(r);
}
function $e964c7ac951d5673$var$Oe({ original: e, modified: r, language: n, originalLanguage: t, modifiedLanguage: a, originalModelPath: m, modifiedModelPath: E, keepCurrentOriginalModel: g = !1, keepCurrentModifiedModel: N = !1, theme: x = "light", loading: P = "Loading...", options: y = {}, height: V = "100%", width: z = "100%", className: F, wrapperProps: j = {}, beforeMount: A = $e964c7ac951d5673$var$D, onMount: q = $e964c7ac951d5673$var$D }) {
    let [M, O] = (0, $acw62.useState)(!1), [T, s] = (0, $acw62.useState)(!0), u = (0, $acw62.useRef)(null), c = (0, $acw62.useRef)(null), w = (0, $acw62.useRef)(null), d = (0, $acw62.useRef)(q), o = (0, $acw62.useRef)(A), b = (0, $acw62.useRef)(!1);
    $e964c7ac951d5673$var$k(()=>{
        let i = (0, $0840e892d82f5480$export$2e2bcd8739ae039).init();
        return i.then((f)=>(c.current = f) && s(!1)).catch((f)=>f?.type !== "cancelation" && console.error("Monaco initialization: error:", f)), ()=>u.current ? I() : i.cancel();
    }), $e964c7ac951d5673$var$l(()=>{
        if (u.current && c.current) {
            let i = u.current.getOriginalEditor(), f = $e964c7ac951d5673$var$h(c.current, e || "", t || n || "text", m || "");
            f !== i.getModel() && i.setModel(f);
        }
    }, [
        m
    ], M), $e964c7ac951d5673$var$l(()=>{
        if (u.current && c.current) {
            let i = u.current.getModifiedEditor(), f = $e964c7ac951d5673$var$h(c.current, r || "", a || n || "text", E || "");
            f !== i.getModel() && i.setModel(f);
        }
    }, [
        E
    ], M), $e964c7ac951d5673$var$l(()=>{
        let i = u.current.getModifiedEditor();
        i.getOption(c.current.editor.EditorOption.readOnly) ? i.setValue(r || "") : r !== i.getValue() && (i.executeEdits("", [
            {
                range: i.getModel().getFullModelRange(),
                text: r || "",
                forceMoveMarkers: !0
            }
        ]), i.pushUndoStop());
    }, [
        r
    ], M), $e964c7ac951d5673$var$l(()=>{
        u.current?.getModel()?.original.setValue(e || "");
    }, [
        e
    ], M), $e964c7ac951d5673$var$l(()=>{
        let { original: i, modified: f } = u.current.getModel();
        c.current.editor.setModelLanguage(i, t || n || "text"), c.current.editor.setModelLanguage(f, a || n || "text");
    }, [
        n,
        t,
        a
    ], M), $e964c7ac951d5673$var$l(()=>{
        c.current?.editor.setTheme(x);
    }, [
        x
    ], M), $e964c7ac951d5673$var$l(()=>{
        u.current?.updateOptions(y);
    }, [
        y
    ], M);
    let L = (0, $acw62.useCallback)(()=>{
        if (!c.current) return;
        o.current(c.current);
        let i = $e964c7ac951d5673$var$h(c.current, e || "", t || n || "text", m || ""), f = $e964c7ac951d5673$var$h(c.current, r || "", a || n || "text", E || "");
        u.current?.setModel({
            original: i,
            modified: f
        });
    }, [
        n,
        r,
        a,
        e,
        t,
        m,
        E
    ]), U = (0, $acw62.useCallback)(()=>{
        !b.current && w.current && (u.current = c.current.editor.createDiffEditor(w.current, {
            automaticLayout: !0,
            ...y
        }), L(), c.current?.editor.setTheme(x), O(!0), b.current = !0);
    }, [
        y,
        x,
        L
    ]);
    (0, $acw62.useEffect)(()=>{
        M && d.current(u.current, c.current);
    }, [
        M
    ]), (0, $acw62.useEffect)(()=>{
        !T && !M && U();
    }, [
        T,
        M,
        U
    ]);
    function I() {
        let i = u.current?.getModel();
        g || i?.original?.dispose(), N || i?.modified?.dispose(), u.current?.dispose();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e964c7ac951d5673$var$H, {
        width: z,
        height: V,
        isEditorReady: M,
        loading: P,
        _ref: w,
        className: F,
        wrapperProps: j
    });
}
var $e964c7ac951d5673$var$ie = $e964c7ac951d5673$var$Oe;
var $e964c7ac951d5673$export$f95cfa31b5a0bc91 = (0, $acw62.memo)($e964c7ac951d5673$var$ie);
function $e964c7ac951d5673$var$Pe() {
    let [e, r] = (0, $acw62.useState)((0, $0840e892d82f5480$export$2e2bcd8739ae039).__getMonacoInstance());
    return $e964c7ac951d5673$var$k(()=>{
        let n;
        return e || (n = (0, $0840e892d82f5480$export$2e2bcd8739ae039).init(), n.then((t)=>{
            r(t);
        })), ()=>n?.cancel();
    }), e;
}
var $e964c7ac951d5673$export$7c29dcfb1e21cfdd = $e964c7ac951d5673$var$Pe;
function $e964c7ac951d5673$var$He(e) {
    let r = (0, $acw62.useRef)();
    return (0, $acw62.useEffect)(()=>{
        r.current = e;
    }, [
        e
    ]), r.current;
}
var $e964c7ac951d5673$var$se = $e964c7ac951d5673$var$He;
var $e964c7ac951d5673$var$_ = new Map;
function $e964c7ac951d5673$var$Ve({ defaultValue: e, defaultLanguage: r, defaultPath: n, value: t, language: a, path: m, theme: E = "light", line: g, loading: N = "Loading...", options: x = {}, overrideServices: P = {}, saveViewState: y = !0, keepCurrentModel: V = !1, width: z = "100%", height: F = "100%", className: j, wrapperProps: A = {}, beforeMount: q = $e964c7ac951d5673$var$D, onMount: M = $e964c7ac951d5673$var$D, onChange: O, onValidate: T = $e964c7ac951d5673$var$D }) {
    let [s, u] = (0, $acw62.useState)(!1), [c, w] = (0, $acw62.useState)(!0), d = (0, $acw62.useRef)(null), o = (0, $acw62.useRef)(null), b = (0, $acw62.useRef)(null), L = (0, $acw62.useRef)(M), U = (0, $acw62.useRef)(q), I = (0, $acw62.useRef)(), i = (0, $acw62.useRef)(t), f = $e964c7ac951d5673$var$se(m), Q = (0, $acw62.useRef)(!1), B = (0, $acw62.useRef)(!1);
    $e964c7ac951d5673$var$k(()=>{
        let p = (0, $0840e892d82f5480$export$2e2bcd8739ae039).init();
        return p.then((R)=>(d.current = R) && w(!1)).catch((R)=>R?.type !== "cancelation" && console.error("Monaco initialization: error:", R)), ()=>o.current ? pe() : p.cancel();
    }), $e964c7ac951d5673$var$l(()=>{
        let p = $e964c7ac951d5673$var$h(d.current, e || t || "", r || a || "", m || n || "");
        p !== o.current?.getModel() && (y && $e964c7ac951d5673$var$_.set(f, o.current?.saveViewState()), o.current?.setModel(p), y && o.current?.restoreViewState($e964c7ac951d5673$var$_.get(m)));
    }, [
        m
    ], s), $e964c7ac951d5673$var$l(()=>{
        o.current?.updateOptions(x);
    }, [
        x
    ], s), $e964c7ac951d5673$var$l(()=>{
        !o.current || t === void 0 || (o.current.getOption(d.current.editor.EditorOption.readOnly) ? o.current.setValue(t) : t !== o.current.getValue() && (B.current = !0, o.current.executeEdits("", [
            {
                range: o.current.getModel().getFullModelRange(),
                text: t,
                forceMoveMarkers: !0
            }
        ]), o.current.pushUndoStop(), B.current = !1));
    }, [
        t
    ], s), $e964c7ac951d5673$var$l(()=>{
        let p = o.current?.getModel();
        p && a && d.current?.editor.setModelLanguage(p, a);
    }, [
        a
    ], s), $e964c7ac951d5673$var$l(()=>{
        g !== void 0 && o.current?.revealLine(g);
    }, [
        g
    ], s), $e964c7ac951d5673$var$l(()=>{
        d.current?.editor.setTheme(E);
    }, [
        E
    ], s);
    let X = (0, $acw62.useCallback)(()=>{
        if (!(!b.current || !d.current) && !Q.current) {
            U.current(d.current);
            let p = m || n, R = $e964c7ac951d5673$var$h(d.current, t || e || "", r || a || "", p || "");
            o.current = d.current?.editor.create(b.current, {
                model: R,
                automaticLayout: !0,
                ...x
            }, P), y && o.current.restoreViewState($e964c7ac951d5673$var$_.get(p)), d.current.editor.setTheme(E), g !== void 0 && o.current.revealLine(g), u(!0), Q.current = !0;
        }
    }, [
        e,
        r,
        n,
        t,
        a,
        m,
        x,
        P,
        y,
        E,
        g
    ]);
    (0, $acw62.useEffect)(()=>{
        s && L.current(o.current, d.current);
    }, [
        s
    ]), (0, $acw62.useEffect)(()=>{
        !c && !s && X();
    }, [
        c,
        s,
        X
    ]), i.current = t, (0, $acw62.useEffect)(()=>{
        s && O && (I.current?.dispose(), I.current = o.current?.onDidChangeModelContent((p)=>{
            B.current || O(o.current.getValue(), p);
        }));
    }, [
        s,
        O
    ]), (0, $acw62.useEffect)(()=>{
        if (s) {
            let p = d.current.editor.onDidChangeMarkers((R)=>{
                let G = o.current.getModel()?.uri;
                if (G && R.find((J)=>J.path === G.path)) {
                    let J = d.current.editor.getModelMarkers({
                        resource: G
                    });
                    T?.(J);
                }
            });
            return ()=>{
                p?.dispose();
            };
        }
        return ()=>{};
    }, [
        s,
        T
    ]);
    function pe() {
        I.current?.dispose(), V ? y && $e964c7ac951d5673$var$_.set(m, o.current.saveViewState()) : o.current.getModel()?.dispose(), o.current.dispose();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e964c7ac951d5673$var$H, {
        width: z,
        height: F,
        isEditorReady: s,
        loading: N,
        _ref: b,
        className: j,
        wrapperProps: A
    });
}
var $e964c7ac951d5673$var$fe = $e964c7ac951d5673$var$Ve;
var $e964c7ac951d5673$export$7cda8d932e2f33c0 = (0, $acw62.memo)($e964c7ac951d5673$var$fe);
var $e964c7ac951d5673$export$2e2bcd8739ae039 = $e964c7ac951d5673$export$7cda8d932e2f33c0;


var $b6d378dfee037fa8$exports = {};
'use strict';
var $e0c9a09fa1097fc7$exports = {};

$e0c9a09fa1097fc7$exports = (parcelRequire("5ETHc"));


const $b6d378dfee037fa8$var$networkErrorMsgs = [
    'Failed to fetch',
    'NetworkError when attempting to fetch resource.',
    'The Internet connection appears to be offline.',
    'Network request failed' // `cross-fetch`
];
class $b6d378dfee037fa8$var$AbortError extends Error {
    constructor(message){
        super();
        if (message instanceof Error) {
            this.originalError = message;
            ({ message: message } = message);
        } else {
            this.originalError = new Error(message);
            this.originalError.stack = this.stack;
        }
        this.name = 'AbortError';
        this.message = message;
    }
}
const $b6d378dfee037fa8$var$decorateErrorWithCounts = (error, attemptNumber, options)=>{
    // Minus 1 from attemptNumber because the first attempt does not count as a retry
    const retriesLeft = options.retries - (attemptNumber - 1);
    error.attemptNumber = attemptNumber;
    error.retriesLeft = retriesLeft;
    return error;
};
const $b6d378dfee037fa8$var$isNetworkError = (errorMessage)=>$b6d378dfee037fa8$var$networkErrorMsgs.includes(errorMessage);
const $b6d378dfee037fa8$var$pRetry = (input, options)=>new Promise((resolve, reject)=>{
        options = {
            onFailedAttempt: ()=>{},
            retries: 10,
            ...options
        };
        const operation = $e0c9a09fa1097fc7$exports.operation(options);
        operation.attempt(async (attemptNumber)=>{
            try {
                resolve(await input(attemptNumber));
            } catch (error) {
                if (!(error instanceof Error)) {
                    reject(new TypeError(`Non-error was thrown: "${error}". You should only throw errors.`));
                    return;
                }
                if (error instanceof $b6d378dfee037fa8$var$AbortError) {
                    operation.stop();
                    reject(error.originalError);
                } else if (error instanceof TypeError && !$b6d378dfee037fa8$var$isNetworkError(error.message)) {
                    operation.stop();
                    reject(error);
                } else {
                    $b6d378dfee037fa8$var$decorateErrorWithCounts(error, attemptNumber, options);
                    try {
                        await options.onFailedAttempt(error);
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (!operation.retry(error)) reject(operation.mainError());
                }
            }
        });
    });
$b6d378dfee037fa8$exports = $b6d378dfee037fa8$var$pRetry;
// TODO: remove this in the next major version
$b6d378dfee037fa8$exports.default = $b6d378dfee037fa8$var$pRetry;
$b6d378dfee037fa8$exports.AbortError = $b6d378dfee037fa8$var$AbortError;


/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ let $e4deb49dba5321bc$var$_defaultBaseGeminiUrl = undefined;
let $e4deb49dba5321bc$var$_defaultBaseVertexUrl = undefined;
/**
 * Overrides the base URLs for the Gemini API and Vertex AI API.
 *
 * @remarks This function should be called before initializing the SDK. If the
 * base URLs are set after initializing the SDK, the base URLs will not be
 * updated. Base URLs provided in the HttpOptions will also take precedence over
 * URLs set here.
 *
 * @example
 * ```ts
 * import {GoogleGenAI, setDefaultBaseUrls} from '@google/genai';
 * // Override the base URL for the Gemini API.
 * setDefaultBaseUrls({geminiUrl:'https://gemini.google.com'});
 *
 * // Override the base URL for the Vertex AI API.
 * setDefaultBaseUrls({vertexUrl: 'https://vertexai.googleapis.com'});
 *
 * const ai = new GoogleGenAI({apiKey: 'GEMINI_API_KEY'});
 * ```
 */ function $e4deb49dba5321bc$export$73f5ab1d327f9edc(baseUrlParams) {
    $e4deb49dba5321bc$var$_defaultBaseGeminiUrl = baseUrlParams.geminiUrl;
    $e4deb49dba5321bc$var$_defaultBaseVertexUrl = baseUrlParams.vertexUrl;
}
/**
 * Returns the default base URLs for the Gemini API and Vertex AI API.
 */ function $e4deb49dba5321bc$var$getDefaultBaseUrls() {
    return {
        geminiUrl: $e4deb49dba5321bc$var$_defaultBaseGeminiUrl,
        vertexUrl: $e4deb49dba5321bc$var$_defaultBaseVertexUrl
    };
}
/**
 * Returns the default base URL based on the following priority:
 *   1. Base URLs set via HttpOptions.
 *   2. Base URLs set via the latest call to setDefaultBaseUrls.
 *   3. Base URLs set via environment variables.
 */ function $e4deb49dba5321bc$var$getBaseUrl(httpOptions, vertexai, vertexBaseUrlFromEnv, geminiBaseUrlFromEnv) {
    var _a, _b;
    if (!(httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.baseUrl)) {
        const defaultBaseUrls = $e4deb49dba5321bc$var$getDefaultBaseUrls();
        if (vertexai) return (_a = defaultBaseUrls.vertexUrl) !== null && _a !== void 0 ? _a : vertexBaseUrlFromEnv;
        else return (_b = defaultBaseUrls.geminiUrl) !== null && _b !== void 0 ? _b : geminiBaseUrlFromEnv;
    }
    return httpOptions.baseUrl;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$BaseModule {
}
function $e4deb49dba5321bc$var$formatMap(templateString, valueMap) {
    // Use a regular expression to find all placeholders in the template string
    const regex = /\{([^}]+)\}/g;
    // Replace each placeholder with its corresponding value from the valueMap
    return templateString.replace(regex, (match, key)=>{
        if (Object.prototype.hasOwnProperty.call(valueMap, key)) {
            const value = valueMap[key];
            // Convert the value to a string if it's not a string already
            return value !== undefined && value !== null ? String(value) : '';
        } else // Handle missing keys
        throw new Error(`Key '${key}' not found in valueMap.`);
    });
}
function $e4deb49dba5321bc$var$setValueByPath(data, keys, value) {
    for(let i = 0; i < keys.length - 1; i++){
        const key = keys[i];
        if (key.endsWith('[]')) {
            const keyName = key.slice(0, -2);
            if (!(keyName in data)) {
                if (Array.isArray(value)) data[keyName] = Array.from({
                    length: value.length
                }, ()=>({}));
                else throw new Error(`Value must be a list given an array path ${key}`);
            }
            if (Array.isArray(data[keyName])) {
                const arrayData = data[keyName];
                if (Array.isArray(value)) for(let j = 0; j < arrayData.length; j++){
                    const entry = arrayData[j];
                    $e4deb49dba5321bc$var$setValueByPath(entry, keys.slice(i + 1), value[j]);
                }
                else for (const d of arrayData)$e4deb49dba5321bc$var$setValueByPath(d, keys.slice(i + 1), value);
            }
            return;
        } else if (key.endsWith('[0]')) {
            const keyName = key.slice(0, -3);
            if (!(keyName in data)) data[keyName] = [
                {}
            ];
            const arrayData = data[keyName];
            $e4deb49dba5321bc$var$setValueByPath(arrayData[0], keys.slice(i + 1), value);
            return;
        }
        if (!data[key] || typeof data[key] !== 'object') data[key] = {};
        data = data[key];
    }
    const keyToSet = keys[keys.length - 1];
    const existingData = data[keyToSet];
    if (existingData !== undefined) {
        if (!value || typeof value === 'object' && Object.keys(value).length === 0) return;
        if (value === existingData) return;
        if (typeof existingData === 'object' && typeof value === 'object' && existingData !== null && value !== null) Object.assign(existingData, value);
        else throw new Error(`Cannot set value for an existing key. Key: ${keyToSet}`);
    } else if (keyToSet === '_self' && typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const valueAsRecord = value;
        Object.assign(data, valueAsRecord);
    } else data[keyToSet] = value;
}
function $e4deb49dba5321bc$var$getValueByPath(data, keys, defaultValue) {
    try {
        if (keys.length === 1 && keys[0] === '_self') return data;
        for(let i = 0; i < keys.length; i++){
            if (typeof data !== 'object' || data === null) return defaultValue;
            const key = keys[i];
            if (key.endsWith('[]')) {
                const keyName = key.slice(0, -2);
                if (keyName in data) {
                    const arrayData = data[keyName];
                    if (!Array.isArray(arrayData)) return defaultValue;
                    return arrayData.map((d)=>$e4deb49dba5321bc$var$getValueByPath(d, keys.slice(i + 1), defaultValue));
                } else return defaultValue;
            } else data = data[key];
        }
        return data;
    } catch (error) {
        if (error instanceof TypeError) return defaultValue;
        throw error;
    }
}
/**
 * Moves values from source paths to destination paths.
 *
 * Examples:
 *   moveValueByPath(
 *     {'requests': [{'content': v1}, {'content': v2}]},
 *     {'requests[].*': 'requests[].request.*'}
 *   )
 *     -> {'requests': [{'request': {'content': v1}}, {'request': {'content': v2}}]}
 */ function $e4deb49dba5321bc$var$moveValueByPath(data, paths) {
    for (const [sourcePath, destPath] of Object.entries(paths)){
        const sourceKeys = sourcePath.split('.');
        const destKeys = destPath.split('.');
        // Determine keys to exclude from wildcard to avoid cyclic references
        const excludeKeys = new Set();
        let wildcardIdx = -1;
        for(let i = 0; i < sourceKeys.length; i++)if (sourceKeys[i] === '*') {
            wildcardIdx = i;
            break;
        }
        if (wildcardIdx !== -1 && destKeys.length > wildcardIdx) // Extract the intermediate key between source and dest paths
        // Example: source=['requests[]', '*'], dest=['requests[]', 'request', '*']
        // We want to exclude 'request'
        for(let i = wildcardIdx; i < destKeys.length; i++){
            const key = destKeys[i];
            if (key !== '*' && !key.endsWith('[]') && !key.endsWith('[0]')) excludeKeys.add(key);
        }
        $e4deb49dba5321bc$var$_moveValueRecursive(data, sourceKeys, destKeys, 0, excludeKeys);
    }
}
/**
 * Recursively moves values from source path to destination path.
 */ function $e4deb49dba5321bc$var$_moveValueRecursive(data, sourceKeys, destKeys, keyIdx, excludeKeys) {
    if (keyIdx >= sourceKeys.length) return;
    if (typeof data !== 'object' || data === null) return;
    const key = sourceKeys[keyIdx];
    if (key.endsWith('[]')) {
        const keyName = key.slice(0, -2);
        const dataRecord = data;
        if (keyName in dataRecord && Array.isArray(dataRecord[keyName])) for (const item of dataRecord[keyName])$e4deb49dba5321bc$var$_moveValueRecursive(item, sourceKeys, destKeys, keyIdx + 1, excludeKeys);
    } else if (key === '*') // wildcard - move all fields
    {
        if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
            const dataRecord = data;
            const keysToMove = Object.keys(dataRecord).filter((k)=>!k.startsWith('_') && !excludeKeys.has(k));
            const valuesToMove = {};
            for (const k of keysToMove)valuesToMove[k] = dataRecord[k];
            // Set values at destination
            for (const [k, v] of Object.entries(valuesToMove)){
                const newDestKeys = [];
                for (const dk of destKeys.slice(keyIdx))if (dk === '*') newDestKeys.push(k);
                else newDestKeys.push(dk);
                $e4deb49dba5321bc$var$setValueByPath(dataRecord, newDestKeys, v);
            }
            for (const k of keysToMove)delete dataRecord[k];
        }
    } else {
        // Navigate to next level
        const dataRecord = data;
        if (key in dataRecord) $e4deb49dba5321bc$var$_moveValueRecursive(dataRecord[key], sourceKeys, destKeys, keyIdx + 1, excludeKeys);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$tBytes$1(fromBytes) {
    if (typeof fromBytes !== 'string') throw new Error('fromImageBytes must be a string');
    // TODO(b/389133914): Remove dummy bytes converter.
    return fromBytes;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$fetchPredictOperationParametersToVertex(fromObject) {
    const toObject = {};
    const fromOperationName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'operationName'
    ]);
    if (fromOperationName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'operationName'
    ], fromOperationName);
    const fromResourceName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'resourceName'
    ]);
    if (fromResourceName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'resourceName'
    ], fromResourceName);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosOperationFromMldev$1(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response',
        'generateVideoResponse'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateVideosResponseFromMldev$1(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosOperationFromVertex$1(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateVideosResponseFromVertex$1(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosResponseFromMldev$1(fromObject) {
    const toObject = {};
    const fromGeneratedVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generatedSamples'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedVideoFromMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosResponseFromVertex$1(fromObject) {
    const toObject = {};
    const fromGeneratedVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videos'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedVideoFromVertex$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function $e4deb49dba5321bc$var$generatedVideoFromMldev$1(fromObject) {
    const toObject = {};
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$videoFromMldev$1(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generatedVideoFromVertex$1(fromObject) {
    const toObject = {};
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$videoFromVertex$1(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$getOperationParametersToMldev(fromObject) {
    const toObject = {};
    const fromOperationName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'operationName'
    ]);
    if (fromOperationName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'operationName'
    ], fromOperationName);
    return toObject;
}
function $e4deb49dba5321bc$var$getOperationParametersToVertex(fromObject) {
    const toObject = {};
    const fromOperationName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'operationName'
    ]);
    if (fromOperationName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'operationName'
    ], fromOperationName);
    return toObject;
}
function $e4deb49dba5321bc$var$importFileOperationFromMldev$1(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$importFileResponseFromMldev$1(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$importFileResponseFromMldev$1(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromParent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parent'
    ]);
    if (fromParent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parent'
    ], fromParent);
    const fromDocumentName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'documentName'
    ]);
    if (fromDocumentName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'documentName'
    ], fromDocumentName);
    return toObject;
}
function $e4deb49dba5321bc$var$uploadToFileSearchStoreOperationFromMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$uploadToFileSearchStoreResponseFromMldev(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$uploadToFileSearchStoreResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromParent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parent'
    ]);
    if (fromParent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parent'
    ], fromParent);
    const fromDocumentName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'documentName'
    ]);
    if (fromDocumentName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'documentName'
    ], fromDocumentName);
    return toObject;
}
function $e4deb49dba5321bc$var$videoFromMldev$1(fromObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encodedVideo'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoBytes'
    ], $e4deb49dba5321bc$var$tBytes$1(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encoding'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoFromVertex$1(fromObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoBytes'
    ], $e4deb49dba5321bc$var$tBytes$1(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /** Outcome of the code execution. */ var $e4deb49dba5321bc$export$524cbb9c5a897bf8;
(function(Outcome) {
    /**
     * Unspecified status. This value should not be used.
     */ Outcome["OUTCOME_UNSPECIFIED"] = "OUTCOME_UNSPECIFIED";
    /**
     * Code execution completed successfully.
     */ Outcome["OUTCOME_OK"] = "OUTCOME_OK";
    /**
     * Code execution finished but with a failure. `stderr` should contain the reason.
     */ Outcome["OUTCOME_FAILED"] = "OUTCOME_FAILED";
    /**
     * Code execution ran for too long, and was cancelled. There may or may not be a partial output present.
     */ Outcome["OUTCOME_DEADLINE_EXCEEDED"] = "OUTCOME_DEADLINE_EXCEEDED";
})($e4deb49dba5321bc$export$524cbb9c5a897bf8 || ($e4deb49dba5321bc$export$524cbb9c5a897bf8 = {}));
/** Programming language of the `code`. */ var $e4deb49dba5321bc$export$ce4fe1c9e6520c1a;
(function(Language) {
    /**
     * Unspecified language. This value should not be used.
     */ Language["LANGUAGE_UNSPECIFIED"] = "LANGUAGE_UNSPECIFIED";
    /**
     * Python >= 3.10, with numpy and simpy available.
     */ Language["PYTHON"] = "PYTHON";
})($e4deb49dba5321bc$export$ce4fe1c9e6520c1a || ($e4deb49dba5321bc$export$ce4fe1c9e6520c1a = {}));
/** Specifies how the response should be scheduled in the conversation. */ var $e4deb49dba5321bc$export$5faf5a36745d3723;
(function(FunctionResponseScheduling) {
    /**
     * This value is unused.
     */ FunctionResponseScheduling["SCHEDULING_UNSPECIFIED"] = "SCHEDULING_UNSPECIFIED";
    /**
     * Only add the result to the conversation context, do not interrupt or trigger generation.
     */ FunctionResponseScheduling["SILENT"] = "SILENT";
    /**
     * Add the result to the conversation context, and prompt to generate output without interrupting ongoing generation.
     */ FunctionResponseScheduling["WHEN_IDLE"] = "WHEN_IDLE";
    /**
     * Add the result to the conversation context, interrupt ongoing generation and prompt to generate output.
     */ FunctionResponseScheduling["INTERRUPT"] = "INTERRUPT";
})($e4deb49dba5321bc$export$5faf5a36745d3723 || ($e4deb49dba5321bc$export$5faf5a36745d3723 = {}));
/** The type of the data. */ var $e4deb49dba5321bc$export$92738401e1603719;
(function(Type) {
    /**
     * Not specified, should not be used.
     */ Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    /**
     * OpenAPI string type
     */ Type["STRING"] = "STRING";
    /**
     * OpenAPI number type
     */ Type["NUMBER"] = "NUMBER";
    /**
     * OpenAPI integer type
     */ Type["INTEGER"] = "INTEGER";
    /**
     * OpenAPI boolean type
     */ Type["BOOLEAN"] = "BOOLEAN";
    /**
     * OpenAPI array type
     */ Type["ARRAY"] = "ARRAY";
    /**
     * OpenAPI object type
     */ Type["OBJECT"] = "OBJECT";
    /**
     * Null type
     */ Type["NULL"] = "NULL";
})($e4deb49dba5321bc$export$92738401e1603719 || ($e4deb49dba5321bc$export$92738401e1603719 = {}));
/** Sites with confidence level chosen & above this value will be blocked from the search results. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$834f9d49019de650;
(function(PhishBlockThreshold) {
    /**
     * Defaults to unspecified.
     */ PhishBlockThreshold["PHISH_BLOCK_THRESHOLD_UNSPECIFIED"] = "PHISH_BLOCK_THRESHOLD_UNSPECIFIED";
    /**
     * Blocks Low and above confidence URL that is risky.
     */ PhishBlockThreshold["BLOCK_LOW_AND_ABOVE"] = "BLOCK_LOW_AND_ABOVE";
    /**
     * Blocks Medium and above confidence URL that is risky.
     */ PhishBlockThreshold["BLOCK_MEDIUM_AND_ABOVE"] = "BLOCK_MEDIUM_AND_ABOVE";
    /**
     * Blocks High and above confidence URL that is risky.
     */ PhishBlockThreshold["BLOCK_HIGH_AND_ABOVE"] = "BLOCK_HIGH_AND_ABOVE";
    /**
     * Blocks Higher and above confidence URL that is risky.
     */ PhishBlockThreshold["BLOCK_HIGHER_AND_ABOVE"] = "BLOCK_HIGHER_AND_ABOVE";
    /**
     * Blocks Very high and above confidence URL that is risky.
     */ PhishBlockThreshold["BLOCK_VERY_HIGH_AND_ABOVE"] = "BLOCK_VERY_HIGH_AND_ABOVE";
    /**
     * Blocks Extremely high confidence URL that is risky.
     */ PhishBlockThreshold["BLOCK_ONLY_EXTREMELY_HIGH"] = "BLOCK_ONLY_EXTREMELY_HIGH";
})($e4deb49dba5321bc$export$834f9d49019de650 || ($e4deb49dba5321bc$export$834f9d49019de650 = {}));
/** The API spec that the external API implements. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$31f7f72babb81944;
(function(ApiSpec) {
    /**
     * Unspecified API spec. This value should not be used.
     */ ApiSpec["API_SPEC_UNSPECIFIED"] = "API_SPEC_UNSPECIFIED";
    /**
     * Simple search API spec.
     */ ApiSpec["SIMPLE_SEARCH"] = "SIMPLE_SEARCH";
    /**
     * Elastic search API spec.
     */ ApiSpec["ELASTIC_SEARCH"] = "ELASTIC_SEARCH";
})($e4deb49dba5321bc$export$31f7f72babb81944 || ($e4deb49dba5321bc$export$31f7f72babb81944 = {}));
/** Type of auth scheme. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$e04cb10fd7e39267;
(function(AuthType) {
    AuthType["AUTH_TYPE_UNSPECIFIED"] = "AUTH_TYPE_UNSPECIFIED";
    /**
     * No Auth.
     */ AuthType["NO_AUTH"] = "NO_AUTH";
    /**
     * API Key Auth.
     */ AuthType["API_KEY_AUTH"] = "API_KEY_AUTH";
    /**
     * HTTP Basic Auth.
     */ AuthType["HTTP_BASIC_AUTH"] = "HTTP_BASIC_AUTH";
    /**
     * Google Service Account Auth.
     */ AuthType["GOOGLE_SERVICE_ACCOUNT_AUTH"] = "GOOGLE_SERVICE_ACCOUNT_AUTH";
    /**
     * OAuth auth.
     */ AuthType["OAUTH"] = "OAUTH";
    /**
     * OpenID Connect (OIDC) Auth.
     */ AuthType["OIDC_AUTH"] = "OIDC_AUTH";
})($e4deb49dba5321bc$export$e04cb10fd7e39267 || ($e4deb49dba5321bc$export$e04cb10fd7e39267 = {}));
/** The location of the API key. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$c98bbdcbceec6af6;
(function(HttpElementLocation) {
    HttpElementLocation["HTTP_IN_UNSPECIFIED"] = "HTTP_IN_UNSPECIFIED";
    /**
     * Element is in the HTTP request query.
     */ HttpElementLocation["HTTP_IN_QUERY"] = "HTTP_IN_QUERY";
    /**
     * Element is in the HTTP request header.
     */ HttpElementLocation["HTTP_IN_HEADER"] = "HTTP_IN_HEADER";
    /**
     * Element is in the HTTP request path.
     */ HttpElementLocation["HTTP_IN_PATH"] = "HTTP_IN_PATH";
    /**
     * Element is in the HTTP request body.
     */ HttpElementLocation["HTTP_IN_BODY"] = "HTTP_IN_BODY";
    /**
     * Element is in the HTTP request cookie.
     */ HttpElementLocation["HTTP_IN_COOKIE"] = "HTTP_IN_COOKIE";
})($e4deb49dba5321bc$export$c98bbdcbceec6af6 || ($e4deb49dba5321bc$export$c98bbdcbceec6af6 = {}));
/** Specifies the function Behavior. Currently only supported by the BidiGenerateContent method. This enum is not supported in Vertex AI. */ var $e4deb49dba5321bc$export$875db781adde08fb;
(function(Behavior) {
    /**
     * This value is unused.
     */ Behavior["UNSPECIFIED"] = "UNSPECIFIED";
    /**
     * If set, the system will wait to receive the function response before continuing the conversation.
     */ Behavior["BLOCKING"] = "BLOCKING";
    /**
     * If set, the system will not wait to receive the function response. Instead, it will attempt to handle function responses as they become available while maintaining the conversation between the user and the model.
     */ Behavior["NON_BLOCKING"] = "NON_BLOCKING";
})($e4deb49dba5321bc$export$875db781adde08fb || ($e4deb49dba5321bc$export$875db781adde08fb = {}));
/** The mode of the predictor to be used in dynamic retrieval. */ var $e4deb49dba5321bc$export$a95ec93224b807c1;
(function(DynamicRetrievalConfigMode) {
    /**
     * Always trigger retrieval.
     */ DynamicRetrievalConfigMode["MODE_UNSPECIFIED"] = "MODE_UNSPECIFIED";
    /**
     * Run retrieval only when system decides it is necessary.
     */ DynamicRetrievalConfigMode["MODE_DYNAMIC"] = "MODE_DYNAMIC";
})($e4deb49dba5321bc$export$a95ec93224b807c1 || ($e4deb49dba5321bc$export$a95ec93224b807c1 = {}));
/** Function calling mode. */ var $e4deb49dba5321bc$export$dd6bff2bc68258b9;
(function(FunctionCallingConfigMode) {
    /**
     * Unspecified function calling mode. This value should not be used.
     */ FunctionCallingConfigMode["MODE_UNSPECIFIED"] = "MODE_UNSPECIFIED";
    /**
     * Default model behavior, model decides to predict either function calls or natural language response.
     */ FunctionCallingConfigMode["AUTO"] = "AUTO";
    /**
     * Model is constrained to always predicting function calls only. If "allowed_function_names" are set, the predicted function calls will be limited to any one of "allowed_function_names", else the predicted function calls will be any one of the provided "function_declarations".
     */ FunctionCallingConfigMode["ANY"] = "ANY";
    /**
     * Model will not predict any function calls. Model behavior is same as when not passing any function declarations.
     */ FunctionCallingConfigMode["NONE"] = "NONE";
    /**
     * Model is constrained to predict either function calls or natural language response. If "allowed_function_names" are set, the predicted function calls will be limited to any one of "allowed_function_names", else the predicted function calls will be any one of the provided "function_declarations".
     */ FunctionCallingConfigMode["VALIDATED"] = "VALIDATED";
})($e4deb49dba5321bc$export$dd6bff2bc68258b9 || ($e4deb49dba5321bc$export$dd6bff2bc68258b9 = {}));
/** The number of thoughts tokens that the model should generate. */ var $e4deb49dba5321bc$export$d13806ce060d5375;
(function(ThinkingLevel) {
    /**
     * Unspecified thinking level.
     */ ThinkingLevel["THINKING_LEVEL_UNSPECIFIED"] = "THINKING_LEVEL_UNSPECIFIED";
    /**
     * Low thinking level.
     */ ThinkingLevel["LOW"] = "LOW";
    /**
     * Medium thinking level.
     */ ThinkingLevel["MEDIUM"] = "MEDIUM";
    /**
     * High thinking level.
     */ ThinkingLevel["HIGH"] = "HIGH";
    /**
     * MINIMAL thinking level.
     */ ThinkingLevel["MINIMAL"] = "MINIMAL";
})($e4deb49dba5321bc$export$d13806ce060d5375 || ($e4deb49dba5321bc$export$d13806ce060d5375 = {}));
/** Harm category. */ var $e4deb49dba5321bc$export$798c77e44df53af3;
(function(HarmCategory) {
    /**
     * The harm category is unspecified.
     */ HarmCategory["HARM_CATEGORY_UNSPECIFIED"] = "HARM_CATEGORY_UNSPECIFIED";
    /**
     * The harm category is harassment.
     */ HarmCategory["HARM_CATEGORY_HARASSMENT"] = "HARM_CATEGORY_HARASSMENT";
    /**
     * The harm category is hate speech.
     */ HarmCategory["HARM_CATEGORY_HATE_SPEECH"] = "HARM_CATEGORY_HATE_SPEECH";
    /**
     * The harm category is sexually explicit content.
     */ HarmCategory["HARM_CATEGORY_SEXUALLY_EXPLICIT"] = "HARM_CATEGORY_SEXUALLY_EXPLICIT";
    /**
     * The harm category is dangerous content.
     */ HarmCategory["HARM_CATEGORY_DANGEROUS_CONTENT"] = "HARM_CATEGORY_DANGEROUS_CONTENT";
    /**
     * Deprecated: Election filter is not longer supported. The harm category is civic integrity.
     */ HarmCategory["HARM_CATEGORY_CIVIC_INTEGRITY"] = "HARM_CATEGORY_CIVIC_INTEGRITY";
    /**
     * The harm category is image hate. This enum value is not supported in Gemini API.
     */ HarmCategory["HARM_CATEGORY_IMAGE_HATE"] = "HARM_CATEGORY_IMAGE_HATE";
    /**
     * The harm category is image dangerous content. This enum value is not supported in Gemini API.
     */ HarmCategory["HARM_CATEGORY_IMAGE_DANGEROUS_CONTENT"] = "HARM_CATEGORY_IMAGE_DANGEROUS_CONTENT";
    /**
     * The harm category is image harassment. This enum value is not supported in Gemini API.
     */ HarmCategory["HARM_CATEGORY_IMAGE_HARASSMENT"] = "HARM_CATEGORY_IMAGE_HARASSMENT";
    /**
     * The harm category is image sexually explicit content. This enum value is not supported in Gemini API.
     */ HarmCategory["HARM_CATEGORY_IMAGE_SEXUALLY_EXPLICIT"] = "HARM_CATEGORY_IMAGE_SEXUALLY_EXPLICIT";
    /**
     * The harm category is for jailbreak prompts. This enum value is not supported in Gemini API.
     */ HarmCategory["HARM_CATEGORY_JAILBREAK"] = "HARM_CATEGORY_JAILBREAK";
})($e4deb49dba5321bc$export$798c77e44df53af3 || ($e4deb49dba5321bc$export$798c77e44df53af3 = {}));
/** Specify if the threshold is used for probability or severity score. If not specified, the threshold is used for probability score. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$963daae60acaff70;
(function(HarmBlockMethod) {
    /**
     * The harm block method is unspecified.
     */ HarmBlockMethod["HARM_BLOCK_METHOD_UNSPECIFIED"] = "HARM_BLOCK_METHOD_UNSPECIFIED";
    /**
     * The harm block method uses both probability and severity scores.
     */ HarmBlockMethod["SEVERITY"] = "SEVERITY";
    /**
     * The harm block method uses the probability score.
     */ HarmBlockMethod["PROBABILITY"] = "PROBABILITY";
})($e4deb49dba5321bc$export$963daae60acaff70 || ($e4deb49dba5321bc$export$963daae60acaff70 = {}));
/** The harm block threshold. */ var $e4deb49dba5321bc$export$b0bfc55fdde52aac;
(function(HarmBlockThreshold) {
    /**
     * Unspecified harm block threshold.
     */ HarmBlockThreshold["HARM_BLOCK_THRESHOLD_UNSPECIFIED"] = "HARM_BLOCK_THRESHOLD_UNSPECIFIED";
    /**
     * Block low threshold and above (i.e. block more).
     */ HarmBlockThreshold["BLOCK_LOW_AND_ABOVE"] = "BLOCK_LOW_AND_ABOVE";
    /**
     * Block medium threshold and above.
     */ HarmBlockThreshold["BLOCK_MEDIUM_AND_ABOVE"] = "BLOCK_MEDIUM_AND_ABOVE";
    /**
     * Block only high threshold (i.e. block less).
     */ HarmBlockThreshold["BLOCK_ONLY_HIGH"] = "BLOCK_ONLY_HIGH";
    /**
     * Block none.
     */ HarmBlockThreshold["BLOCK_NONE"] = "BLOCK_NONE";
    /**
     * Turn off the safety filter.
     */ HarmBlockThreshold["OFF"] = "OFF";
})($e4deb49dba5321bc$export$b0bfc55fdde52aac || ($e4deb49dba5321bc$export$b0bfc55fdde52aac = {}));
/** Output only. The reason why the model stopped generating tokens.

If empty, the model has not stopped generating the tokens. */ var $e4deb49dba5321bc$export$e94f0100e6b2fa1a;
(function(FinishReason) {
    /**
     * The finish reason is unspecified.
     */ FinishReason["FINISH_REASON_UNSPECIFIED"] = "FINISH_REASON_UNSPECIFIED";
    /**
     * Token generation reached a natural stopping point or a configured stop sequence.
     */ FinishReason["STOP"] = "STOP";
    /**
     * Token generation reached the configured maximum output tokens.
     */ FinishReason["MAX_TOKENS"] = "MAX_TOKENS";
    /**
     * Token generation stopped because the content potentially contains safety violations. NOTE: When streaming, [content][] is empty if content filters blocks the output.
     */ FinishReason["SAFETY"] = "SAFETY";
    /**
     * The token generation stopped because of potential recitation.
     */ FinishReason["RECITATION"] = "RECITATION";
    /**
     * The token generation stopped because of using an unsupported language.
     */ FinishReason["LANGUAGE"] = "LANGUAGE";
    /**
     * All other reasons that stopped the token generation.
     */ FinishReason["OTHER"] = "OTHER";
    /**
     * Token generation stopped because the content contains forbidden terms.
     */ FinishReason["BLOCKLIST"] = "BLOCKLIST";
    /**
     * Token generation stopped for potentially containing prohibited content.
     */ FinishReason["PROHIBITED_CONTENT"] = "PROHIBITED_CONTENT";
    /**
     * Token generation stopped because the content potentially contains Sensitive Personally Identifiable Information (SPII).
     */ FinishReason["SPII"] = "SPII";
    /**
     * The function call generated by the model is invalid.
     */ FinishReason["MALFORMED_FUNCTION_CALL"] = "MALFORMED_FUNCTION_CALL";
    /**
     * Token generation stopped because generated images have safety violations.
     */ FinishReason["IMAGE_SAFETY"] = "IMAGE_SAFETY";
    /**
     * The tool call generated by the model is invalid.
     */ FinishReason["UNEXPECTED_TOOL_CALL"] = "UNEXPECTED_TOOL_CALL";
    /**
     * Image generation stopped because the generated images have prohibited content.
     */ FinishReason["IMAGE_PROHIBITED_CONTENT"] = "IMAGE_PROHIBITED_CONTENT";
    /**
     * The model was expected to generate an image, but none was generated.
     */ FinishReason["NO_IMAGE"] = "NO_IMAGE";
    /**
     * Image generation stopped because the generated image may be a recitation from a source.
     */ FinishReason["IMAGE_RECITATION"] = "IMAGE_RECITATION";
    /**
     * Image generation stopped for a reason not otherwise specified.
     */ FinishReason["IMAGE_OTHER"] = "IMAGE_OTHER";
})($e4deb49dba5321bc$export$e94f0100e6b2fa1a || ($e4deb49dba5321bc$export$e94f0100e6b2fa1a = {}));
/** Output only. Harm probability levels in the content. */ var $e4deb49dba5321bc$export$d51a615154b7f9a;
(function(HarmProbability) {
    /**
     * Harm probability unspecified.
     */ HarmProbability["HARM_PROBABILITY_UNSPECIFIED"] = "HARM_PROBABILITY_UNSPECIFIED";
    /**
     * Negligible level of harm.
     */ HarmProbability["NEGLIGIBLE"] = "NEGLIGIBLE";
    /**
     * Low level of harm.
     */ HarmProbability["LOW"] = "LOW";
    /**
     * Medium level of harm.
     */ HarmProbability["MEDIUM"] = "MEDIUM";
    /**
     * High level of harm.
     */ HarmProbability["HIGH"] = "HIGH";
})($e4deb49dba5321bc$export$d51a615154b7f9a || ($e4deb49dba5321bc$export$d51a615154b7f9a = {}));
/** Output only. Harm severity levels in the content. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$7b3efb76b33fbefa;
(function(HarmSeverity) {
    /**
     * Harm severity unspecified.
     */ HarmSeverity["HARM_SEVERITY_UNSPECIFIED"] = "HARM_SEVERITY_UNSPECIFIED";
    /**
     * Negligible level of harm severity.
     */ HarmSeverity["HARM_SEVERITY_NEGLIGIBLE"] = "HARM_SEVERITY_NEGLIGIBLE";
    /**
     * Low level of harm severity.
     */ HarmSeverity["HARM_SEVERITY_LOW"] = "HARM_SEVERITY_LOW";
    /**
     * Medium level of harm severity.
     */ HarmSeverity["HARM_SEVERITY_MEDIUM"] = "HARM_SEVERITY_MEDIUM";
    /**
     * High level of harm severity.
     */ HarmSeverity["HARM_SEVERITY_HIGH"] = "HARM_SEVERITY_HIGH";
})($e4deb49dba5321bc$export$7b3efb76b33fbefa || ($e4deb49dba5321bc$export$7b3efb76b33fbefa = {}));
/** Status of the url retrieval. */ var $e4deb49dba5321bc$export$975c9cf3fb61453a;
(function(UrlRetrievalStatus) {
    /**
     * Default value. This value is unused.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_UNSPECIFIED"] = "URL_RETRIEVAL_STATUS_UNSPECIFIED";
    /**
     * Url retrieval is successful.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_SUCCESS"] = "URL_RETRIEVAL_STATUS_SUCCESS";
    /**
     * Url retrieval is failed due to error.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_ERROR"] = "URL_RETRIEVAL_STATUS_ERROR";
    /**
     * Url retrieval is failed because the content is behind paywall. This enum value is not supported in Vertex AI.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_PAYWALL"] = "URL_RETRIEVAL_STATUS_PAYWALL";
    /**
     * Url retrieval is failed because the content is unsafe. This enum value is not supported in Vertex AI.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_UNSAFE"] = "URL_RETRIEVAL_STATUS_UNSAFE";
})($e4deb49dba5321bc$export$975c9cf3fb61453a || ($e4deb49dba5321bc$export$975c9cf3fb61453a = {}));
/** Output only. The reason why the prompt was blocked. */ var $e4deb49dba5321bc$export$b3338cf9227c61d4;
(function(BlockedReason) {
    /**
     * The blocked reason is unspecified.
     */ BlockedReason["BLOCKED_REASON_UNSPECIFIED"] = "BLOCKED_REASON_UNSPECIFIED";
    /**
     * The prompt was blocked for safety reasons.
     */ BlockedReason["SAFETY"] = "SAFETY";
    /**
     * The prompt was blocked for other reasons. For example, it may be due to the prompt's language, or because it contains other harmful content.
     */ BlockedReason["OTHER"] = "OTHER";
    /**
     * The prompt was blocked because it contains a term from the terminology blocklist.
     */ BlockedReason["BLOCKLIST"] = "BLOCKLIST";
    /**
     * The prompt was blocked because it contains prohibited content.
     */ BlockedReason["PROHIBITED_CONTENT"] = "PROHIBITED_CONTENT";
    /**
     * The prompt was blocked because it contains content that is unsafe for image generation.
     */ BlockedReason["IMAGE_SAFETY"] = "IMAGE_SAFETY";
    /**
     * The prompt was blocked by Model Armor. This enum value is not supported in Gemini API.
     */ BlockedReason["MODEL_ARMOR"] = "MODEL_ARMOR";
    /**
     * The prompt was blocked as a jailbreak attempt. This enum value is not supported in Gemini API.
     */ BlockedReason["JAILBREAK"] = "JAILBREAK";
})($e4deb49dba5321bc$export$b3338cf9227c61d4 || ($e4deb49dba5321bc$export$b3338cf9227c61d4 = {}));
/** Output only. The traffic type for this request. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$fd67c688a6010ded;
(function(TrafficType) {
    /**
     * Unspecified request traffic type.
     */ TrafficType["TRAFFIC_TYPE_UNSPECIFIED"] = "TRAFFIC_TYPE_UNSPECIFIED";
    /**
     * The request was processed using Pay-As-You-Go quota.
     */ TrafficType["ON_DEMAND"] = "ON_DEMAND";
    /**
     * Type for Provisioned Throughput traffic.
     */ TrafficType["PROVISIONED_THROUGHPUT"] = "PROVISIONED_THROUGHPUT";
})($e4deb49dba5321bc$export$fd67c688a6010ded || ($e4deb49dba5321bc$export$fd67c688a6010ded = {}));
/** Server content modalities. */ var $e4deb49dba5321bc$export$9c9a8220008ddfc0;
(function(Modality) {
    /**
     * The modality is unspecified.
     */ Modality["MODALITY_UNSPECIFIED"] = "MODALITY_UNSPECIFIED";
    /**
     * Indicates the model should return text
     */ Modality["TEXT"] = "TEXT";
    /**
     * Indicates the model should return images.
     */ Modality["IMAGE"] = "IMAGE";
    /**
     * Indicates the model should return audio.
     */ Modality["AUDIO"] = "AUDIO";
})($e4deb49dba5321bc$export$9c9a8220008ddfc0 || ($e4deb49dba5321bc$export$9c9a8220008ddfc0 = {}));
/** The media resolution to use. */ var $e4deb49dba5321bc$export$c7a89108d7123ab7;
(function(MediaResolution) {
    /**
     * Media resolution has not been set
     */ MediaResolution["MEDIA_RESOLUTION_UNSPECIFIED"] = "MEDIA_RESOLUTION_UNSPECIFIED";
    /**
     * Media resolution set to low (64 tokens).
     */ MediaResolution["MEDIA_RESOLUTION_LOW"] = "MEDIA_RESOLUTION_LOW";
    /**
     * Media resolution set to medium (256 tokens).
     */ MediaResolution["MEDIA_RESOLUTION_MEDIUM"] = "MEDIA_RESOLUTION_MEDIUM";
    /**
     * Media resolution set to high (zoomed reframing with 256 tokens).
     */ MediaResolution["MEDIA_RESOLUTION_HIGH"] = "MEDIA_RESOLUTION_HIGH";
})($e4deb49dba5321bc$export$c7a89108d7123ab7 || ($e4deb49dba5321bc$export$c7a89108d7123ab7 = {}));
/** Tuning mode. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$8c0e99cba1f473f5;
(function(TuningMode) {
    /**
     * Tuning mode is unspecified.
     */ TuningMode["TUNING_MODE_UNSPECIFIED"] = "TUNING_MODE_UNSPECIFIED";
    /**
     * Full fine-tuning mode.
     */ TuningMode["TUNING_MODE_FULL"] = "TUNING_MODE_FULL";
    /**
     * PEFT adapter tuning mode.
     */ TuningMode["TUNING_MODE_PEFT_ADAPTER"] = "TUNING_MODE_PEFT_ADAPTER";
})($e4deb49dba5321bc$export$8c0e99cba1f473f5 || ($e4deb49dba5321bc$export$8c0e99cba1f473f5 = {}));
/** Adapter size for tuning. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$4d0388a23e87b9ee;
(function(AdapterSize) {
    /**
     * Adapter size is unspecified.
     */ AdapterSize["ADAPTER_SIZE_UNSPECIFIED"] = "ADAPTER_SIZE_UNSPECIFIED";
    /**
     * Adapter size 1.
     */ AdapterSize["ADAPTER_SIZE_ONE"] = "ADAPTER_SIZE_ONE";
    /**
     * Adapter size 2.
     */ AdapterSize["ADAPTER_SIZE_TWO"] = "ADAPTER_SIZE_TWO";
    /**
     * Adapter size 4.
     */ AdapterSize["ADAPTER_SIZE_FOUR"] = "ADAPTER_SIZE_FOUR";
    /**
     * Adapter size 8.
     */ AdapterSize["ADAPTER_SIZE_EIGHT"] = "ADAPTER_SIZE_EIGHT";
    /**
     * Adapter size 16.
     */ AdapterSize["ADAPTER_SIZE_SIXTEEN"] = "ADAPTER_SIZE_SIXTEEN";
    /**
     * Adapter size 32.
     */ AdapterSize["ADAPTER_SIZE_THIRTY_TWO"] = "ADAPTER_SIZE_THIRTY_TWO";
})($e4deb49dba5321bc$export$4d0388a23e87b9ee || ($e4deb49dba5321bc$export$4d0388a23e87b9ee = {}));
/** Job state. */ var $e4deb49dba5321bc$export$d30a7cb66801c974;
(function(JobState) {
    /**
     * The job state is unspecified.
     */ JobState["JOB_STATE_UNSPECIFIED"] = "JOB_STATE_UNSPECIFIED";
    /**
     * The job has been just created or resumed and processing has not yet begun.
     */ JobState["JOB_STATE_QUEUED"] = "JOB_STATE_QUEUED";
    /**
     * The service is preparing to run the job.
     */ JobState["JOB_STATE_PENDING"] = "JOB_STATE_PENDING";
    /**
     * The job is in progress.
     */ JobState["JOB_STATE_RUNNING"] = "JOB_STATE_RUNNING";
    /**
     * The job completed successfully.
     */ JobState["JOB_STATE_SUCCEEDED"] = "JOB_STATE_SUCCEEDED";
    /**
     * The job failed.
     */ JobState["JOB_STATE_FAILED"] = "JOB_STATE_FAILED";
    /**
     * The job is being cancelled. From this state the job may only go to either `JOB_STATE_SUCCEEDED`, `JOB_STATE_FAILED` or `JOB_STATE_CANCELLED`.
     */ JobState["JOB_STATE_CANCELLING"] = "JOB_STATE_CANCELLING";
    /**
     * The job has been cancelled.
     */ JobState["JOB_STATE_CANCELLED"] = "JOB_STATE_CANCELLED";
    /**
     * The job has been stopped, and can be resumed.
     */ JobState["JOB_STATE_PAUSED"] = "JOB_STATE_PAUSED";
    /**
     * The job has expired.
     */ JobState["JOB_STATE_EXPIRED"] = "JOB_STATE_EXPIRED";
    /**
     * The job is being updated. Only jobs in the `JOB_STATE_RUNNING` state can be updated. After updating, the job goes back to the `JOB_STATE_RUNNING` state.
     */ JobState["JOB_STATE_UPDATING"] = "JOB_STATE_UPDATING";
    /**
     * The job is partially succeeded, some results may be missing due to errors.
     */ JobState["JOB_STATE_PARTIALLY_SUCCEEDED"] = "JOB_STATE_PARTIALLY_SUCCEEDED";
})($e4deb49dba5321bc$export$d30a7cb66801c974 || ($e4deb49dba5321bc$export$d30a7cb66801c974 = {}));
/** The tuning task. Either I2V or T2V. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$c219c92dc5374d63;
(function(TuningTask) {
    /**
     * Default value. This value is unused.
     */ TuningTask["TUNING_TASK_UNSPECIFIED"] = "TUNING_TASK_UNSPECIFIED";
    /**
     * Tuning task for image to video.
     */ TuningTask["TUNING_TASK_I2V"] = "TUNING_TASK_I2V";
    /**
     * Tuning task for text to video.
     */ TuningTask["TUNING_TASK_T2V"] = "TUNING_TASK_T2V";
    /**
     * Tuning task for reference to video.
     */ TuningTask["TUNING_TASK_R2V"] = "TUNING_TASK_R2V";
})($e4deb49dba5321bc$export$c219c92dc5374d63 || ($e4deb49dba5321bc$export$c219c92dc5374d63 = {}));
/** The tokenization quality used for given media. */ var $e4deb49dba5321bc$export$e11a6ed625c60d8a;
(function(PartMediaResolutionLevel) {
    /**
     * Media resolution has not been set.
     */ PartMediaResolutionLevel["MEDIA_RESOLUTION_UNSPECIFIED"] = "MEDIA_RESOLUTION_UNSPECIFIED";
    /**
     * Media resolution set to low.
     */ PartMediaResolutionLevel["MEDIA_RESOLUTION_LOW"] = "MEDIA_RESOLUTION_LOW";
    /**
     * Media resolution set to medium.
     */ PartMediaResolutionLevel["MEDIA_RESOLUTION_MEDIUM"] = "MEDIA_RESOLUTION_MEDIUM";
    /**
     * Media resolution set to high.
     */ PartMediaResolutionLevel["MEDIA_RESOLUTION_HIGH"] = "MEDIA_RESOLUTION_HIGH";
    /**
     * Media resolution set to ultra high.
     */ PartMediaResolutionLevel["MEDIA_RESOLUTION_ULTRA_HIGH"] = "MEDIA_RESOLUTION_ULTRA_HIGH";
})($e4deb49dba5321bc$export$e11a6ed625c60d8a || ($e4deb49dba5321bc$export$e11a6ed625c60d8a = {}));
/** Resource scope. */ var $e4deb49dba5321bc$export$ce358901f8c7a617;
(function(ResourceScope) {
    /**
     * When setting base_url, this value configures resource scope to be the collection.
        The resource name will not include api version, project, or location.
        For example, if base_url is set to "https://aiplatform.googleapis.com",
        then the resource name for a Model would be
        "https://aiplatform.googleapis.com/publishers/google/models/gemini-3-pro-preview
     */ ResourceScope["COLLECTION"] = "COLLECTION";
})($e4deb49dba5321bc$export$ce358901f8c7a617 || ($e4deb49dba5321bc$export$ce358901f8c7a617 = {}));
/** Options for feature selection preference. */ var $e4deb49dba5321bc$export$5154132c56fb1c00;
(function(FeatureSelectionPreference) {
    FeatureSelectionPreference["FEATURE_SELECTION_PREFERENCE_UNSPECIFIED"] = "FEATURE_SELECTION_PREFERENCE_UNSPECIFIED";
    FeatureSelectionPreference["PRIORITIZE_QUALITY"] = "PRIORITIZE_QUALITY";
    FeatureSelectionPreference["BALANCED"] = "BALANCED";
    FeatureSelectionPreference["PRIORITIZE_COST"] = "PRIORITIZE_COST";
})($e4deb49dba5321bc$export$5154132c56fb1c00 || ($e4deb49dba5321bc$export$5154132c56fb1c00 = {}));
/** The environment being operated. */ var $e4deb49dba5321bc$export$7dc6752a22ab011a;
(function(Environment) {
    /**
     * Defaults to browser.
     */ Environment["ENVIRONMENT_UNSPECIFIED"] = "ENVIRONMENT_UNSPECIFIED";
    /**
     * Operates in a web browser.
     */ Environment["ENVIRONMENT_BROWSER"] = "ENVIRONMENT_BROWSER";
})($e4deb49dba5321bc$export$7dc6752a22ab011a || ($e4deb49dba5321bc$export$7dc6752a22ab011a = {}));
/** Enum for controlling whether the model can generate images of prominent people (celebrities). */ var $e4deb49dba5321bc$export$8f9c651e5adfa09e;
(function(ProminentPeople) {
    /**
     * Unspecified value. The model will proceed with the default behavior, which is to allow generation of prominent people.
     */ ProminentPeople["PROMINENT_PEOPLE_UNSPECIFIED"] = "PROMINENT_PEOPLE_UNSPECIFIED";
    /**
     * Allows the model to generate images of prominent people.
     */ ProminentPeople["ALLOW_PROMINENT_PEOPLE"] = "ALLOW_PROMINENT_PEOPLE";
    /**
     * Prevents the model from generating images of prominent people.
     */ ProminentPeople["BLOCK_PROMINENT_PEOPLE"] = "BLOCK_PROMINENT_PEOPLE";
})($e4deb49dba5321bc$export$8f9c651e5adfa09e || ($e4deb49dba5321bc$export$8f9c651e5adfa09e = {}));
/** Enum representing the Vertex embedding API to use. */ var $e4deb49dba5321bc$export$adb1a6c77f7d58e6;
(function(EmbeddingApiType) {
    /**
     * predict API endpoint (default)
     */ EmbeddingApiType["PREDICT"] = "PREDICT";
    /**
     * embedContent API Endpoint
     */ EmbeddingApiType["EMBED_CONTENT"] = "EMBED_CONTENT";
})($e4deb49dba5321bc$export$adb1a6c77f7d58e6 || ($e4deb49dba5321bc$export$adb1a6c77f7d58e6 = {}));
/** Enum that controls the safety filter level for objectionable content. */ var $e4deb49dba5321bc$export$5204024137f6aea1;
(function(SafetyFilterLevel) {
    SafetyFilterLevel["BLOCK_LOW_AND_ABOVE"] = "BLOCK_LOW_AND_ABOVE";
    SafetyFilterLevel["BLOCK_MEDIUM_AND_ABOVE"] = "BLOCK_MEDIUM_AND_ABOVE";
    SafetyFilterLevel["BLOCK_ONLY_HIGH"] = "BLOCK_ONLY_HIGH";
    SafetyFilterLevel["BLOCK_NONE"] = "BLOCK_NONE";
})($e4deb49dba5321bc$export$5204024137f6aea1 || ($e4deb49dba5321bc$export$5204024137f6aea1 = {}));
/** Enum that controls the generation of people. */ var $e4deb49dba5321bc$export$d9baac936bd08721;
(function(PersonGeneration) {
    /**
     * Block generation of images of people.
     */ PersonGeneration["DONT_ALLOW"] = "DONT_ALLOW";
    /**
     * Generate images of adults, but not children.
     */ PersonGeneration["ALLOW_ADULT"] = "ALLOW_ADULT";
    /**
     * Generate images that include adults and children.
     */ PersonGeneration["ALLOW_ALL"] = "ALLOW_ALL";
})($e4deb49dba5321bc$export$d9baac936bd08721 || ($e4deb49dba5321bc$export$d9baac936bd08721 = {}));
/** Enum that specifies the language of the text in the prompt. */ var $e4deb49dba5321bc$export$504293347a2f9b0;
(function(ImagePromptLanguage) {
    /**
     * Auto-detect the language.
     */ ImagePromptLanguage["auto"] = "auto";
    /**
     * English
     */ ImagePromptLanguage["en"] = "en";
    /**
     * Japanese
     */ ImagePromptLanguage["ja"] = "ja";
    /**
     * Korean
     */ ImagePromptLanguage["ko"] = "ko";
    /**
     * Hindi
     */ ImagePromptLanguage["hi"] = "hi";
    /**
     * Chinese
     */ ImagePromptLanguage["zh"] = "zh";
    /**
     * Portuguese
     */ ImagePromptLanguage["pt"] = "pt";
    /**
     * Spanish
     */ ImagePromptLanguage["es"] = "es";
})($e4deb49dba5321bc$export$504293347a2f9b0 || ($e4deb49dba5321bc$export$504293347a2f9b0 = {}));
/** Enum representing the mask mode of a mask reference image. */ var $e4deb49dba5321bc$export$76940fd539710332;
(function(MaskReferenceMode) {
    MaskReferenceMode["MASK_MODE_DEFAULT"] = "MASK_MODE_DEFAULT";
    MaskReferenceMode["MASK_MODE_USER_PROVIDED"] = "MASK_MODE_USER_PROVIDED";
    MaskReferenceMode["MASK_MODE_BACKGROUND"] = "MASK_MODE_BACKGROUND";
    MaskReferenceMode["MASK_MODE_FOREGROUND"] = "MASK_MODE_FOREGROUND";
    MaskReferenceMode["MASK_MODE_SEMANTIC"] = "MASK_MODE_SEMANTIC";
})($e4deb49dba5321bc$export$76940fd539710332 || ($e4deb49dba5321bc$export$76940fd539710332 = {}));
/** Enum representing the control type of a control reference image. */ var $e4deb49dba5321bc$export$26974b3b69e46d1d;
(function(ControlReferenceType) {
    ControlReferenceType["CONTROL_TYPE_DEFAULT"] = "CONTROL_TYPE_DEFAULT";
    ControlReferenceType["CONTROL_TYPE_CANNY"] = "CONTROL_TYPE_CANNY";
    ControlReferenceType["CONTROL_TYPE_SCRIBBLE"] = "CONTROL_TYPE_SCRIBBLE";
    ControlReferenceType["CONTROL_TYPE_FACE_MESH"] = "CONTROL_TYPE_FACE_MESH";
})($e4deb49dba5321bc$export$26974b3b69e46d1d || ($e4deb49dba5321bc$export$26974b3b69e46d1d = {}));
/** Enum representing the subject type of a subject reference image. */ var $e4deb49dba5321bc$export$59262bdf2638eb32;
(function(SubjectReferenceType) {
    SubjectReferenceType["SUBJECT_TYPE_DEFAULT"] = "SUBJECT_TYPE_DEFAULT";
    SubjectReferenceType["SUBJECT_TYPE_PERSON"] = "SUBJECT_TYPE_PERSON";
    SubjectReferenceType["SUBJECT_TYPE_ANIMAL"] = "SUBJECT_TYPE_ANIMAL";
    SubjectReferenceType["SUBJECT_TYPE_PRODUCT"] = "SUBJECT_TYPE_PRODUCT";
})($e4deb49dba5321bc$export$59262bdf2638eb32 || ($e4deb49dba5321bc$export$59262bdf2638eb32 = {}));
/** Enum representing the editing mode. */ var $e4deb49dba5321bc$export$5304145354a3bee9;
(function(EditMode) {
    EditMode["EDIT_MODE_DEFAULT"] = "EDIT_MODE_DEFAULT";
    EditMode["EDIT_MODE_INPAINT_REMOVAL"] = "EDIT_MODE_INPAINT_REMOVAL";
    EditMode["EDIT_MODE_INPAINT_INSERTION"] = "EDIT_MODE_INPAINT_INSERTION";
    EditMode["EDIT_MODE_OUTPAINT"] = "EDIT_MODE_OUTPAINT";
    EditMode["EDIT_MODE_CONTROLLED_EDITING"] = "EDIT_MODE_CONTROLLED_EDITING";
    EditMode["EDIT_MODE_STYLE"] = "EDIT_MODE_STYLE";
    EditMode["EDIT_MODE_BGSWAP"] = "EDIT_MODE_BGSWAP";
    EditMode["EDIT_MODE_PRODUCT_IMAGE"] = "EDIT_MODE_PRODUCT_IMAGE";
})($e4deb49dba5321bc$export$5304145354a3bee9 || ($e4deb49dba5321bc$export$5304145354a3bee9 = {}));
/** Enum that represents the segmentation mode. */ var $e4deb49dba5321bc$export$824f092534347f02;
(function(SegmentMode) {
    SegmentMode["FOREGROUND"] = "FOREGROUND";
    SegmentMode["BACKGROUND"] = "BACKGROUND";
    SegmentMode["PROMPT"] = "PROMPT";
    SegmentMode["SEMANTIC"] = "SEMANTIC";
    SegmentMode["INTERACTIVE"] = "INTERACTIVE";
})($e4deb49dba5321bc$export$824f092534347f02 || ($e4deb49dba5321bc$export$824f092534347f02 = {}));
/** Enum for the reference type of a video generation reference image. */ var $e4deb49dba5321bc$export$492cea19f892fe1e;
(function(VideoGenerationReferenceType) {
    /**
     * A reference image that provides assets to the generated video,
        such as the scene, an object, a character, etc.
     */ VideoGenerationReferenceType["ASSET"] = "ASSET";
    /**
     * A reference image that provides aesthetics including colors,
        lighting, texture, etc., to be used as the style of the generated video,
        such as 'anime', 'photography', 'origami', etc.
     */ VideoGenerationReferenceType["STYLE"] = "STYLE";
})($e4deb49dba5321bc$export$492cea19f892fe1e || ($e4deb49dba5321bc$export$492cea19f892fe1e = {}));
/** Enum for the mask mode of a video generation mask. */ var $e4deb49dba5321bc$export$99d85d0ee14173f1;
(function(VideoGenerationMaskMode) {
    /**
     * The image mask contains a masked rectangular region which is
        applied on the first frame of the input video. The object described in
        the prompt is inserted into this region and will appear in subsequent
        frames.
     */ VideoGenerationMaskMode["INSERT"] = "INSERT";
    /**
     * The image mask is used to determine an object in the
        first video frame to track. This object is removed from the video.
     */ VideoGenerationMaskMode["REMOVE"] = "REMOVE";
    /**
     * The image mask is used to determine a region in the
        video. Objects in this region will be removed.
     */ VideoGenerationMaskMode["REMOVE_STATIC"] = "REMOVE_STATIC";
    /**
     * The image mask contains a masked rectangular region where
        the input video will go. The remaining area will be generated. Video
        masks are not supported.
     */ VideoGenerationMaskMode["OUTPAINT"] = "OUTPAINT";
})($e4deb49dba5321bc$export$99d85d0ee14173f1 || ($e4deb49dba5321bc$export$99d85d0ee14173f1 = {}));
/** Enum that controls the compression quality of the generated videos. */ var $e4deb49dba5321bc$export$c8d56a80437cfac3;
(function(VideoCompressionQuality) {
    /**
     * Optimized video compression quality. This will produce videos
        with a compressed, smaller file size.
     */ VideoCompressionQuality["OPTIMIZED"] = "OPTIMIZED";
    /**
     * Lossless video compression quality. This will produce videos
        with a larger file size.
     */ VideoCompressionQuality["LOSSLESS"] = "LOSSLESS";
})($e4deb49dba5321bc$export$c8d56a80437cfac3 || ($e4deb49dba5321bc$export$c8d56a80437cfac3 = {}));
/** Enum representing the tuning method. */ var $e4deb49dba5321bc$export$d72986ac56b9469e;
(function(TuningMethod) {
    /**
     * Supervised fine tuning.
     */ TuningMethod["SUPERVISED_FINE_TUNING"] = "SUPERVISED_FINE_TUNING";
    /**
     * Preference optimization tuning.
     */ TuningMethod["PREFERENCE_TUNING"] = "PREFERENCE_TUNING";
    /**
     * Distillation tuning.
     */ TuningMethod["DISTILLATION"] = "DISTILLATION";
})($e4deb49dba5321bc$export$d72986ac56b9469e || ($e4deb49dba5321bc$export$d72986ac56b9469e = {}));
/** State for the lifecycle of a Document. */ var $e4deb49dba5321bc$export$4c6f7616f18c0be;
(function(DocumentState) {
    DocumentState["STATE_UNSPECIFIED"] = "STATE_UNSPECIFIED";
    DocumentState["STATE_PENDING"] = "STATE_PENDING";
    DocumentState["STATE_ACTIVE"] = "STATE_ACTIVE";
    DocumentState["STATE_FAILED"] = "STATE_FAILED";
})($e4deb49dba5321bc$export$4c6f7616f18c0be || ($e4deb49dba5321bc$export$4c6f7616f18c0be = {}));
/** State for the lifecycle of a File. */ var $e4deb49dba5321bc$export$4ddb69e6513a9971;
(function(FileState) {
    FileState["STATE_UNSPECIFIED"] = "STATE_UNSPECIFIED";
    FileState["PROCESSING"] = "PROCESSING";
    FileState["ACTIVE"] = "ACTIVE";
    FileState["FAILED"] = "FAILED";
})($e4deb49dba5321bc$export$4ddb69e6513a9971 || ($e4deb49dba5321bc$export$4ddb69e6513a9971 = {}));
/** Source of the File. */ var $e4deb49dba5321bc$export$27a4864e1e35718c;
(function(FileSource) {
    FileSource["SOURCE_UNSPECIFIED"] = "SOURCE_UNSPECIFIED";
    FileSource["UPLOADED"] = "UPLOADED";
    FileSource["GENERATED"] = "GENERATED";
    FileSource["REGISTERED"] = "REGISTERED";
})($e4deb49dba5321bc$export$27a4864e1e35718c || ($e4deb49dba5321bc$export$27a4864e1e35718c = {}));
/** The reason why the turn is complete. */ var $e4deb49dba5321bc$export$99c4e0f48ba51160;
(function(TurnCompleteReason) {
    /**
     * Default value. Reason is unspecified.
     */ TurnCompleteReason["TURN_COMPLETE_REASON_UNSPECIFIED"] = "TURN_COMPLETE_REASON_UNSPECIFIED";
    /**
     * The function call generated by the model is invalid.
     */ TurnCompleteReason["MALFORMED_FUNCTION_CALL"] = "MALFORMED_FUNCTION_CALL";
    /**
     * The response is rejected by the model.
     */ TurnCompleteReason["RESPONSE_REJECTED"] = "RESPONSE_REJECTED";
    /**
     * Needs more input from the user.
     */ TurnCompleteReason["NEED_MORE_INPUT"] = "NEED_MORE_INPUT";
})($e4deb49dba5321bc$export$99c4e0f48ba51160 || ($e4deb49dba5321bc$export$99c4e0f48ba51160 = {}));
/** Server content modalities. */ var $e4deb49dba5321bc$export$cd2f9f264fad7b02;
(function(MediaModality) {
    /**
     * The modality is unspecified.
     */ MediaModality["MODALITY_UNSPECIFIED"] = "MODALITY_UNSPECIFIED";
    /**
     * Plain text.
     */ MediaModality["TEXT"] = "TEXT";
    /**
     * Images.
     */ MediaModality["IMAGE"] = "IMAGE";
    /**
     * Video.
     */ MediaModality["VIDEO"] = "VIDEO";
    /**
     * Audio.
     */ MediaModality["AUDIO"] = "AUDIO";
    /**
     * Document, e.g. PDF.
     */ MediaModality["DOCUMENT"] = "DOCUMENT";
})($e4deb49dba5321bc$export$cd2f9f264fad7b02 || ($e4deb49dba5321bc$export$cd2f9f264fad7b02 = {}));
/** The type of the VAD signal. */ var $e4deb49dba5321bc$export$d962e369f570c257;
(function(VadSignalType) {
    /**
     * The default is VAD_SIGNAL_TYPE_UNSPECIFIED.
     */ VadSignalType["VAD_SIGNAL_TYPE_UNSPECIFIED"] = "VAD_SIGNAL_TYPE_UNSPECIFIED";
    /**
     * Start of sentence signal.
     */ VadSignalType["VAD_SIGNAL_TYPE_SOS"] = "VAD_SIGNAL_TYPE_SOS";
    /**
     * End of sentence signal.
     */ VadSignalType["VAD_SIGNAL_TYPE_EOS"] = "VAD_SIGNAL_TYPE_EOS";
})($e4deb49dba5321bc$export$d962e369f570c257 || ($e4deb49dba5321bc$export$d962e369f570c257 = {}));
/** The type of the voice activity signal. */ var $e4deb49dba5321bc$export$4af8b5043679ed9b;
(function(VoiceActivityType) {
    /**
     * The default is VOICE_ACTIVITY_TYPE_UNSPECIFIED.
     */ VoiceActivityType["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    /**
     * Start of sentence signal.
     */ VoiceActivityType["ACTIVITY_START"] = "ACTIVITY_START";
    /**
     * End of sentence signal.
     */ VoiceActivityType["ACTIVITY_END"] = "ACTIVITY_END";
})($e4deb49dba5321bc$export$4af8b5043679ed9b || ($e4deb49dba5321bc$export$4af8b5043679ed9b = {}));
/** Start of speech sensitivity. */ var $e4deb49dba5321bc$export$148372f2e0cd8282;
(function(StartSensitivity) {
    /**
     * The default is START_SENSITIVITY_LOW.
     */ StartSensitivity["START_SENSITIVITY_UNSPECIFIED"] = "START_SENSITIVITY_UNSPECIFIED";
    /**
     * Automatic detection will detect the start of speech more often.
     */ StartSensitivity["START_SENSITIVITY_HIGH"] = "START_SENSITIVITY_HIGH";
    /**
     * Automatic detection will detect the start of speech less often.
     */ StartSensitivity["START_SENSITIVITY_LOW"] = "START_SENSITIVITY_LOW";
})($e4deb49dba5321bc$export$148372f2e0cd8282 || ($e4deb49dba5321bc$export$148372f2e0cd8282 = {}));
/** End of speech sensitivity. */ var $e4deb49dba5321bc$export$c980be37f56c00d9;
(function(EndSensitivity) {
    /**
     * The default is END_SENSITIVITY_LOW.
     */ EndSensitivity["END_SENSITIVITY_UNSPECIFIED"] = "END_SENSITIVITY_UNSPECIFIED";
    /**
     * Automatic detection ends speech more often.
     */ EndSensitivity["END_SENSITIVITY_HIGH"] = "END_SENSITIVITY_HIGH";
    /**
     * Automatic detection ends speech less often.
     */ EndSensitivity["END_SENSITIVITY_LOW"] = "END_SENSITIVITY_LOW";
})($e4deb49dba5321bc$export$c980be37f56c00d9 || ($e4deb49dba5321bc$export$c980be37f56c00d9 = {}));
/** The different ways of handling user activity. */ var $e4deb49dba5321bc$export$d8dcee4c2401eaaa;
(function(ActivityHandling) {
    /**
     * If unspecified, the default behavior is `START_OF_ACTIVITY_INTERRUPTS`.
     */ ActivityHandling["ACTIVITY_HANDLING_UNSPECIFIED"] = "ACTIVITY_HANDLING_UNSPECIFIED";
    /**
     * If true, start of activity will interrupt the model's response (also called "barge in"). The model's current response will be cut-off in the moment of the interruption. This is the default behavior.
     */ ActivityHandling["START_OF_ACTIVITY_INTERRUPTS"] = "START_OF_ACTIVITY_INTERRUPTS";
    /**
     * The model's response will not be interrupted.
     */ ActivityHandling["NO_INTERRUPTION"] = "NO_INTERRUPTION";
})($e4deb49dba5321bc$export$d8dcee4c2401eaaa || ($e4deb49dba5321bc$export$d8dcee4c2401eaaa = {}));
/** Options about which input is included in the user's turn. */ var $e4deb49dba5321bc$export$23fe448c5e1fa7ce;
(function(TurnCoverage) {
    /**
     * If unspecified, the default behavior is `TURN_INCLUDES_ONLY_ACTIVITY`.
     */ TurnCoverage["TURN_COVERAGE_UNSPECIFIED"] = "TURN_COVERAGE_UNSPECIFIED";
    /**
     * The users turn only includes activity since the last turn, excluding inactivity (e.g. silence on the audio stream). This is the default behavior.
     */ TurnCoverage["TURN_INCLUDES_ONLY_ACTIVITY"] = "TURN_INCLUDES_ONLY_ACTIVITY";
    /**
     * The users turn includes all realtime input since the last turn, including inactivity (e.g. silence on the audio stream).
     */ TurnCoverage["TURN_INCLUDES_ALL_INPUT"] = "TURN_INCLUDES_ALL_INPUT";
})($e4deb49dba5321bc$export$23fe448c5e1fa7ce || ($e4deb49dba5321bc$export$23fe448c5e1fa7ce = {}));
/** Scale of the generated music. */ var $e4deb49dba5321bc$export$d60cfc58d3c358b6;
(function(Scale) {
    /**
     * Default value. This value is unused.
     */ Scale["SCALE_UNSPECIFIED"] = "SCALE_UNSPECIFIED";
    /**
     * C major or A minor.
     */ Scale["C_MAJOR_A_MINOR"] = "C_MAJOR_A_MINOR";
    /**
     * Db major or Bb minor.
     */ Scale["D_FLAT_MAJOR_B_FLAT_MINOR"] = "D_FLAT_MAJOR_B_FLAT_MINOR";
    /**
     * D major or B minor.
     */ Scale["D_MAJOR_B_MINOR"] = "D_MAJOR_B_MINOR";
    /**
     * Eb major or C minor
     */ Scale["E_FLAT_MAJOR_C_MINOR"] = "E_FLAT_MAJOR_C_MINOR";
    /**
     * E major or Db minor.
     */ Scale["E_MAJOR_D_FLAT_MINOR"] = "E_MAJOR_D_FLAT_MINOR";
    /**
     * F major or D minor.
     */ Scale["F_MAJOR_D_MINOR"] = "F_MAJOR_D_MINOR";
    /**
     * Gb major or Eb minor.
     */ Scale["G_FLAT_MAJOR_E_FLAT_MINOR"] = "G_FLAT_MAJOR_E_FLAT_MINOR";
    /**
     * G major or E minor.
     */ Scale["G_MAJOR_E_MINOR"] = "G_MAJOR_E_MINOR";
    /**
     * Ab major or F minor.
     */ Scale["A_FLAT_MAJOR_F_MINOR"] = "A_FLAT_MAJOR_F_MINOR";
    /**
     * A major or Gb minor.
     */ Scale["A_MAJOR_G_FLAT_MINOR"] = "A_MAJOR_G_FLAT_MINOR";
    /**
     * Bb major or G minor.
     */ Scale["B_FLAT_MAJOR_G_MINOR"] = "B_FLAT_MAJOR_G_MINOR";
    /**
     * B major or Ab minor.
     */ Scale["B_MAJOR_A_FLAT_MINOR"] = "B_MAJOR_A_FLAT_MINOR";
})($e4deb49dba5321bc$export$d60cfc58d3c358b6 || ($e4deb49dba5321bc$export$d60cfc58d3c358b6 = {}));
/** The mode of music generation. */ var $e4deb49dba5321bc$export$23b8931bd532ef11;
(function(MusicGenerationMode) {
    /**
     * Rely on the server default generation mode.
     */ MusicGenerationMode["MUSIC_GENERATION_MODE_UNSPECIFIED"] = "MUSIC_GENERATION_MODE_UNSPECIFIED";
    /**
     * Steer text prompts to regions of latent space with higher quality
        music.
     */ MusicGenerationMode["QUALITY"] = "QUALITY";
    /**
     * Steer text prompts to regions of latent space with a larger
        diversity of music.
     */ MusicGenerationMode["DIVERSITY"] = "DIVERSITY";
    /**
     * Steer text prompts to regions of latent space more likely to
        generate music with vocals.
     */ MusicGenerationMode["VOCALIZATION"] = "VOCALIZATION";
})($e4deb49dba5321bc$export$23b8931bd532ef11 || ($e4deb49dba5321bc$export$23b8931bd532ef11 = {}));
/** The playback control signal to apply to the music generation. */ var $e4deb49dba5321bc$export$3d1b3b2fa769f3a;
(function(LiveMusicPlaybackControl) {
    /**
     * This value is unused.
     */ LiveMusicPlaybackControl["PLAYBACK_CONTROL_UNSPECIFIED"] = "PLAYBACK_CONTROL_UNSPECIFIED";
    /**
     * Start generating the music.
     */ LiveMusicPlaybackControl["PLAY"] = "PLAY";
    /**
     * Hold the music generation. Use PLAY to resume from the current position.
     */ LiveMusicPlaybackControl["PAUSE"] = "PAUSE";
    /**
     * Stop the music generation and reset the context (prompts retained).
        Use PLAY to restart the music generation.
     */ LiveMusicPlaybackControl["STOP"] = "STOP";
    /**
     * Reset the context of the music generation without stopping it.
        Retains the current prompts and config.
     */ LiveMusicPlaybackControl["RESET_CONTEXT"] = "RESET_CONTEXT";
})($e4deb49dba5321bc$export$3d1b3b2fa769f3a || ($e4deb49dba5321bc$export$3d1b3b2fa769f3a = {}));
/** Raw media bytes for function response.

Text should not be sent as raw bytes, use the FunctionResponse.response
field. */ class $e4deb49dba5321bc$export$986b56fce455c677 {
}
/** URI based data for function response. */ class $e4deb49dba5321bc$export$3297d9ce7c428abc {
}
/** A datatype containing media that is part of a `FunctionResponse` message.

A `FunctionResponsePart` consists of data which has an associated datatype. A
`FunctionResponsePart` can only contain one of the accepted types in
`FunctionResponsePart.data`.

A `FunctionResponsePart` must have a fixed IANA MIME type identifying the
type and subtype of the media if the `inline_data` field is filled with raw
bytes. */ class $e4deb49dba5321bc$export$aa6d46887deab26c {
}
/**
 * Creates a `FunctionResponsePart` object from a `base64` encoded `string`.
 */ function $e4deb49dba5321bc$export$e9d5b9ce9b46d2e2(data, mimeType) {
    return {
        inlineData: {
            data: data,
            mimeType: mimeType
        }
    };
}
/**
 * Creates a `FunctionResponsePart` object from a `URI` string.
 */ function $e4deb49dba5321bc$export$3a70ab76783719f9(uri, mimeType) {
    return {
        fileData: {
            fileUri: uri,
            mimeType: mimeType
        }
    };
}
/** A function response. */ class $e4deb49dba5321bc$export$65d34e7763af8846 {
}
/**
 * Creates a `Part` object from a `URI` string.
 */ function $e4deb49dba5321bc$export$609bc3722c813117(uri, mimeType, mediaResolution) {
    return Object.assign({
        fileData: {
            fileUri: uri,
            mimeType: mimeType
        }
    }, mediaResolution && {
        mediaResolution: {
            level: mediaResolution
        }
    });
}
/**
 * Creates a `Part` object from a `text` string.
 */ function $e4deb49dba5321bc$export$2db44f3a4d11da4c(text) {
    return {
        text: text
    };
}
/**
 * Creates a `Part` object from a `FunctionCall` object.
 */ function $e4deb49dba5321bc$export$a3e123769033f7c0(name, args) {
    return {
        functionCall: {
            name: name,
            args: args
        }
    };
}
/**
 * Creates a `Part` object from a `FunctionResponse` object.
 */ function $e4deb49dba5321bc$export$2636c86ed18e1200(id, name, response, parts = []) {
    return {
        functionResponse: Object.assign({
            id: id,
            name: name,
            response: response
        }, parts.length > 0 && {
            parts: parts
        })
    };
}
/**
 * Creates a `Part` object from a `base64` encoded `string`.
 */ function $e4deb49dba5321bc$export$fff7d82602c9c90f(data, mimeType, mediaResolution) {
    return Object.assign({
        inlineData: {
            data: data,
            mimeType: mimeType
        }
    }, mediaResolution && {
        mediaResolution: {
            level: mediaResolution
        }
    });
}
/**
 * Creates a `Part` object from the `outcome` and `output` of a `CodeExecutionResult` object.
 */ function $e4deb49dba5321bc$export$42aa341e98336a1b(outcome, output) {
    return {
        codeExecutionResult: {
            outcome: outcome,
            output: output
        }
    };
}
/**
 * Creates a `Part` object from the `code` and `language` of an `ExecutableCode` object.
 */ function $e4deb49dba5321bc$export$245f0e57663865ef(code, language) {
    return {
        executableCode: {
            code: code,
            language: language
        }
    };
}
function $e4deb49dba5321bc$var$_isPart(obj) {
    if (typeof obj === 'object' && obj !== null) return 'fileData' in obj || 'text' in obj || 'functionCall' in obj || 'functionResponse' in obj || 'inlineData' in obj || 'videoMetadata' in obj || 'codeExecutionResult' in obj || 'executableCode' in obj;
    return false;
}
function $e4deb49dba5321bc$var$_toParts(partOrString) {
    const parts = [];
    if (typeof partOrString === 'string') parts.push($e4deb49dba5321bc$export$2db44f3a4d11da4c(partOrString));
    else if ($e4deb49dba5321bc$var$_isPart(partOrString)) parts.push(partOrString);
    else if (Array.isArray(partOrString)) {
        if (partOrString.length === 0) throw new Error('partOrString cannot be an empty array');
        for (const part of partOrString){
            if (typeof part === 'string') parts.push($e4deb49dba5321bc$export$2db44f3a4d11da4c(part));
            else if ($e4deb49dba5321bc$var$_isPart(part)) parts.push(part);
            else throw new Error('element in PartUnion must be a Part object or string');
        }
    } else throw new Error('partOrString must be a Part object, string, or array');
    return parts;
}
/**
 * Creates a `Content` object with a user role from a `PartListUnion` object or `string`.
 */ function $e4deb49dba5321bc$export$fe075102324a2d5b(partOrString) {
    return {
        role: 'user',
        parts: $e4deb49dba5321bc$var$_toParts(partOrString)
    };
}
/**
 * Creates a `Content` object with a model role from a `PartListUnion` object or `string`.
 */ function $e4deb49dba5321bc$export$f32d0a9788adfa64(partOrString) {
    return {
        role: 'model',
        parts: $e4deb49dba5321bc$var$_toParts(partOrString)
    };
}
/** A wrapper class for the http response. */ class $e4deb49dba5321bc$export$1d94dfe0d9d1f1e7 {
    constructor(response){
        // Process the headers.
        const headers = {};
        for (const pair of response.headers.entries())headers[pair[0]] = pair[1];
        this.headers = headers;
        // Keep the original response.
        this.responseInternal = response;
    }
    json() {
        return this.responseInternal.json();
    }
}
/** Content filter results for a prompt sent in the request. Note: This is sent only in the first stream chunk and only if no candidates were generated due to content violations. */ class $e4deb49dba5321bc$export$37d485a092233165 {
}
/** Usage metadata about the content generation request and response. This message provides a detailed breakdown of token usage and other relevant metrics. This data type is not supported in Gemini API. */ class $e4deb49dba5321bc$export$3248e9acea8b5df0 {
}
/** Response message for PredictionService.GenerateContent. */ class $e4deb49dba5321bc$export$87445595052c5212 {
    /**
     * Returns the concatenation of all text parts from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the text from the first
     * one will be returned.
     * If there are non-text parts in the response, the concatenation of all text
     * parts will be returned, and a warning will be logged.
     * If there are thought parts in the response, the concatenation of all text
     * parts excluding the thought parts will be returned.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateContent({
     *   model: 'gemini-2.0-flash',
     *   contents:
     *     'Why is the sky blue?',
     * });
     *
     * console.debug(response.text);
     * ```
     */ get text() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning text from the first one.');
        let text = '';
        let anyTextPartText = false;
        const nonTextParts = [];
        for (const part of (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) !== null && _h !== void 0 ? _h : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'text' && fieldName !== 'thought' && fieldName !== 'thoughtSignature' && (fieldValue !== null || fieldValue !== undefined)) nonTextParts.push(fieldName);
            if (typeof part.text === 'string') {
                if (typeof part.thought === 'boolean' && part.thought) continue;
                anyTextPartText = true;
                text += part.text;
            }
        }
        if (nonTextParts.length > 0) console.warn(`there are non-text parts ${nonTextParts} in the response, returning concatenation of all text parts. Please refer to the non text parts for a full response from model.`);
        // part.text === '' is different from part.text is null
        return anyTextPartText ? text : undefined;
    }
    /**
     * Returns the concatenation of all inline data parts from the first candidate
     * in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the inline data from the
     * first one will be returned. If there are non-inline data parts in the
     * response, the concatenation of all inline data parts will be returned, and
     * a warning will be logged.
     */ get data() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning data from the first one.');
        let data = '';
        const nonDataParts = [];
        for (const part of (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) !== null && _h !== void 0 ? _h : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'inlineData' && (fieldValue !== null || fieldValue !== undefined)) nonDataParts.push(fieldName);
            if (part.inlineData && typeof part.inlineData.data === 'string') data += atob(part.inlineData.data);
        }
        if (nonDataParts.length > 0) console.warn(`there are non-data parts ${nonDataParts} in the response, returning concatenation of all data parts. Please refer to the non data parts for a full response from model.`);
        return data.length > 0 ? btoa(data) : undefined;
    }
    /**
     * Returns the function calls from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the function calls from
     * the first one will be returned.
     * If there are no function calls in the response, undefined will be returned.
     *
     * @example
     * ```ts
     * const controlLightFunctionDeclaration: FunctionDeclaration = {
     *   name: 'controlLight',
     *   parameters: {
     *   type: Type.OBJECT,
     *   description: 'Set the brightness and color temperature of a room light.',
     *   properties: {
     *     brightness: {
     *       type: Type.NUMBER,
     *       description:
     *         'Light level from 0 to 100. Zero is off and 100 is full brightness.',
     *     },
     *     colorTemperature: {
     *       type: Type.STRING,
     *       description:
     *         'Color temperature of the light fixture which can be `daylight`, `cool` or `warm`.',
     *     },
     *   },
     *   required: ['brightness', 'colorTemperature'],
     *  };
     *  const response = await ai.models.generateContent({
     *     model: 'gemini-2.0-flash',
     *     contents: 'Dim the lights so the room feels cozy and warm.',
     *     config: {
     *       tools: [{functionDeclarations: [controlLightFunctionDeclaration]}],
     *       toolConfig: {
     *         functionCallingConfig: {
     *           mode: FunctionCallingConfigMode.ANY,
     *           allowedFunctionNames: ['controlLight'],
     *         },
     *       },
     *     },
     *   });
     *  console.debug(JSON.stringify(response.functionCalls));
     * ```
     */ get functionCalls() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning function calls from the first one.');
        const functionCalls = (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) === null || _h === void 0 ? void 0 : _h.filter((part)=>part.functionCall).map((part)=>part.functionCall).filter((functionCall)=>functionCall !== undefined);
        if ((functionCalls === null || functionCalls === void 0 ? void 0 : functionCalls.length) === 0) return undefined;
        return functionCalls;
    }
    /**
     * Returns the first executable code from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the executable code from
     * the first one will be returned.
     * If there are no executable code in the response, undefined will be
     * returned.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateContent({
     *   model: 'gemini-2.0-flash',
     *   contents:
     *     'What is the sum of the first 50 prime numbers? Generate and run code for the calculation, and make sure you get all 50.'
     *   config: {
     *     tools: [{codeExecution: {}}],
     *   },
     * });
     *
     * console.debug(response.executableCode);
     * ```
     */ get executableCode() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning executable code from the first one.');
        const executableCode = (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) === null || _h === void 0 ? void 0 : _h.filter((part)=>part.executableCode).map((part)=>part.executableCode).filter((executableCode)=>executableCode !== undefined);
        if ((executableCode === null || executableCode === void 0 ? void 0 : executableCode.length) === 0) return undefined;
        return (_j = executableCode === null || executableCode === void 0 ? void 0 : executableCode[0]) === null || _j === void 0 ? void 0 : _j.code;
    }
    /**
     * Returns the first code execution result from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the code execution result from
     * the first one will be returned.
     * If there are no code execution result in the response, undefined will be returned.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateContent({
     *   model: 'gemini-2.0-flash',
     *   contents:
     *     'What is the sum of the first 50 prime numbers? Generate and run code for the calculation, and make sure you get all 50.'
     *   config: {
     *     tools: [{codeExecution: {}}],
     *   },
     * });
     *
     * console.debug(response.codeExecutionResult);
     * ```
     */ get codeExecutionResult() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning code execution result from the first one.');
        const codeExecutionResult = (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) === null || _h === void 0 ? void 0 : _h.filter((part)=>part.codeExecutionResult).map((part)=>part.codeExecutionResult).filter((codeExecutionResult)=>codeExecutionResult !== undefined);
        if ((codeExecutionResult === null || codeExecutionResult === void 0 ? void 0 : codeExecutionResult.length) === 0) return undefined;
        return (_j = codeExecutionResult === null || codeExecutionResult === void 0 ? void 0 : codeExecutionResult[0]) === null || _j === void 0 ? void 0 : _j.output;
    }
}
/** Response for the embed_content method. */ class $e4deb49dba5321bc$export$1e9eee8641627f00 {
}
/** The output images response. */ class $e4deb49dba5321bc$export$f08095e7138eb0f4 {
}
/** Response for the request to edit an image. */ class $e4deb49dba5321bc$export$661afcf00ed2fbe8 {
}
class $e4deb49dba5321bc$export$690402256314214 {
}
/** The output images response. */ class $e4deb49dba5321bc$export$c2ead2074351d0f2 {
}
/** The output images response. */ class $e4deb49dba5321bc$export$304f360366a6eb53 {
}
class $e4deb49dba5321bc$export$f159131a50016456 {
}
class $e4deb49dba5321bc$export$179335935ae1d762 {
}
/** Response for counting tokens. */ class $e4deb49dba5321bc$export$b2422e769fe9acde {
}
/** Response for computing tokens. */ class $e4deb49dba5321bc$export$8fb35c7d28173be {
}
/** Response with generated videos. */ class $e4deb49dba5321bc$export$b2145aacd8f1c9d6 {
}
/** A video generation operation. */ class $e4deb49dba5321bc$export$d39812a6cdac2c57 {
    /**
     * Instantiates an Operation of the same type as the one being called with the fields set from the API response.
     * @internal
     */ _fromAPIResponse({ apiResponse: apiResponse, _isVertexAI: _isVertexAI }) {
        const operation = new $e4deb49dba5321bc$export$d39812a6cdac2c57();
        let response;
        const op = apiResponse;
        if (_isVertexAI) response = $e4deb49dba5321bc$var$generateVideosOperationFromVertex$1(op);
        else response = $e4deb49dba5321bc$var$generateVideosOperationFromMldev$1(op);
        Object.assign(operation, response);
        return operation;
    }
}
/** Response for the list tuning jobs method. */ class $e4deb49dba5321bc$export$32bcd29afb9d1292 {
}
/** Empty response for tunings.cancel method. */ class $e4deb49dba5321bc$export$4ec84eddeb3a0f6d {
}
/** Empty response for caches.delete method. */ class $e4deb49dba5321bc$export$12b40cf453f95df4 {
}
class $e4deb49dba5321bc$export$b704e9f6d5866ff0 {
}
/** Config for documents.list return value. */ class $e4deb49dba5321bc$export$5cc5885838c19de3 {
}
/** Config for file_search_stores.list return value. */ class $e4deb49dba5321bc$export$e4346969d6f84113 {
}
/** Response for the resumable upload method. */ class $e4deb49dba5321bc$export$179988cb790ed88a {
}
/** Response for ImportFile to import a File API file with a file search store. */ class $e4deb49dba5321bc$export$aef018cf5290edf7 {
}
/** Long-running operation for importing a file to a FileSearchStore. */ class $e4deb49dba5321bc$export$12076be78e50463e {
    /**
     * Instantiates an Operation of the same type as the one being called with the fields set from the API response.
     * @internal
     */ _fromAPIResponse({ apiResponse: apiResponse, _isVertexAI: _isVertexAI }) {
        const operation = new $e4deb49dba5321bc$export$12076be78e50463e();
        const op = apiResponse;
        const response = $e4deb49dba5321bc$var$importFileOperationFromMldev$1(op);
        Object.assign(operation, response);
        return operation;
    }
}
/** Response for the list files method. */ class $e4deb49dba5321bc$export$70c4c7aa1360da5a {
}
/** Response for the create file method. */ class $e4deb49dba5321bc$export$e6f7a7cf305d85e3 {
}
/** Response for the delete file method. */ class $e4deb49dba5321bc$export$a33f0b325263613a {
}
/** Response for the _register file method. */ class $e4deb49dba5321bc$export$aecf05d67e6b4829 {
}
/** Config for `inlined_responses` parameter. */ class $e4deb49dba5321bc$export$5a6a720963f2cc93 {
}
/** Config for `response` parameter. */ class $e4deb49dba5321bc$export$bcc77db6b6164a92 {
}
/** Config for `inlined_embedding_responses` parameter. */ class $e4deb49dba5321bc$export$37d6004458e8d4bf {
}
/** Config for batches.list return value. */ class $e4deb49dba5321bc$export$aad8e472c65c38a4 {
}
/** Represents a single response in a replay. */ class $e4deb49dba5321bc$export$aacd0b67d1adb66d {
}
/** A raw reference image.

A raw reference image represents the base image to edit, provided by the user.
It can optionally be provided in addition to a mask reference image or
a style reference image. */ class $e4deb49dba5321bc$export$66efc3ead37215f1 {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_RAW',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId
        };
        return referenceImageAPI;
    }
}
/** A mask reference image.

This encapsulates either a mask image provided by the user and configs for
the user provided mask, or only config parameters for the model to generate
a mask.

A mask image is an image whose non-zero values indicate where to edit the base
image. If the user provides a mask image, the mask must be in the same
dimensions as the raw image. */ class $e4deb49dba5321bc$export$df9dc1e4034fa3a8 {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_MASK',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            maskImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A control reference image.

The image of the control reference image is either a control image provided
by the user, or a regular image which the backend will use to generate a
control image of. In the case of the latter, the
enable_control_image_computation field in the config should be set to True.

A control image is an image that represents a sketch image of areas for the
model to fill in based on the prompt. */ class $e4deb49dba5321bc$export$35d10f93a6c10713 {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_CONTROL',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            controlImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A style reference image.

This encapsulates a style reference image provided by the user, and
additionally optional config parameters for the style reference image.

A raw reference image can also be provided as a destination for the style to
be applied to. */ class $e4deb49dba5321bc$export$36a9e1f6d51bfc4f {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_STYLE',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            styleImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A subject reference image.

This encapsulates a subject reference image provided by the user, and
additionally optional config parameters for the subject reference image.

A raw reference image can also be provided as a destination for the subject to
be applied to. */ class $e4deb49dba5321bc$export$47ed4b5d00a5d70b {
    /* Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_SUBJECT',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            subjectImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A content reference image.

A content reference image represents a subject to reference (ex. person,
product, animal) provided by the user. It can optionally be provided in
addition to a style reference image (ex. background, style reference). */ class $e4deb49dba5321bc$export$ebe9cec99c220ebb {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_CONTENT',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId
        };
        return referenceImageAPI;
    }
}
/** Response message for API call. */ class $e4deb49dba5321bc$export$a509bcf6072c871c {
    /**
     * Returns the concatenation of all text parts from the server content if present.
     *
     * @remarks
     * If there are non-text parts in the response, the concatenation of all text
     * parts will be returned, and a warning will be logged.
     */ get text() {
        var _a, _b, _c;
        let text = '';
        let anyTextPartFound = false;
        const nonTextParts = [];
        for (const part of (_c = (_b = (_a = this.serverContent) === null || _a === void 0 ? void 0 : _a.modelTurn) === null || _b === void 0 ? void 0 : _b.parts) !== null && _c !== void 0 ? _c : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'text' && fieldName !== 'thought' && fieldValue !== null) nonTextParts.push(fieldName);
            if (typeof part.text === 'string') {
                if (typeof part.thought === 'boolean' && part.thought) continue;
                anyTextPartFound = true;
                text += part.text;
            }
        }
        if (nonTextParts.length > 0) console.warn(`there are non-text parts ${nonTextParts} in the response, returning concatenation of all text parts. Please refer to the non text parts for a full response from model.`);
        // part.text === '' is different from part.text is null
        return anyTextPartFound ? text : undefined;
    }
    /**
     * Returns the concatenation of all inline data parts from the server content if present.
     *
     * @remarks
     * If there are non-inline data parts in the
     * response, the concatenation of all inline data parts will be returned, and
     * a warning will be logged.
     */ get data() {
        var _a, _b, _c;
        let data = '';
        const nonDataParts = [];
        for (const part of (_c = (_b = (_a = this.serverContent) === null || _a === void 0 ? void 0 : _a.modelTurn) === null || _b === void 0 ? void 0 : _b.parts) !== null && _c !== void 0 ? _c : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'inlineData' && fieldValue !== null) nonDataParts.push(fieldName);
            if (part.inlineData && typeof part.inlineData.data === 'string') data += atob(part.inlineData.data);
        }
        if (nonDataParts.length > 0) console.warn(`there are non-data parts ${nonDataParts} in the response, returning concatenation of all data parts. Please refer to the non data parts for a full response from model.`);
        return data.length > 0 ? btoa(data) : undefined;
    }
}
/** Client generated response to a `ToolCall` received from the server.

Individual `FunctionResponse` objects are matched to the respective
`FunctionCall` objects by the `id` field.

Note that in the unary and server-streaming GenerateContent APIs function
calling happens by exchanging the `Content` parts, while in the bidi
GenerateContent APIs function calling happens over this dedicated set of
messages. */ class $e4deb49dba5321bc$export$690fe23e241eac7d {
}
/** Parameters for sending tool responses to the live API. */ class $e4deb49dba5321bc$export$5e9f94bd32ad075f {
    constructor(){
        /** Tool responses to send to the session. */ this.functionResponses = [];
    }
}
/** Response message for the LiveMusicClientMessage call. */ class $e4deb49dba5321bc$export$5f085d7f78cd2680 {
    /**
     * Returns the first audio chunk from the server content, if present.
     *
     * @remarks
     * If there are no audio chunks in the response, undefined will be returned.
     */ get audioChunk() {
        if (this.serverContent && this.serverContent.audioChunks && this.serverContent.audioChunks.length > 0) return this.serverContent.audioChunks[0];
        return undefined;
    }
}
/** The response when long-running operation for uploading a file to a FileSearchStore complete. */ class $e4deb49dba5321bc$export$37c90edafa324a50 {
}
/** Long-running operation for uploading a file to a FileSearchStore. */ class $e4deb49dba5321bc$export$9b1ce68551588ef4 {
    /**
     * Instantiates an Operation of the same type as the one being called with the fields set from the API response.
     * @internal
     */ _fromAPIResponse({ apiResponse: apiResponse, _isVertexAI: _isVertexAI }) {
        const operation = new $e4deb49dba5321bc$export$9b1ce68551588ef4();
        const op = apiResponse;
        const response = $e4deb49dba5321bc$var$uploadToFileSearchStoreOperationFromMldev(op);
        Object.assign(operation, response);
        return operation;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$tModel(apiClient, model) {
    if (!model || typeof model !== 'string') throw new Error('model is required and must be a string');
    if (model.includes('..') || model.includes('?') || model.includes('&')) throw new Error('invalid model parameter');
    if (apiClient.isVertexAI()) {
        if (model.startsWith('publishers/') || model.startsWith('projects/') || model.startsWith('models/')) return model;
        else if (model.indexOf('/') >= 0) {
            const parts = model.split('/', 2);
            return `publishers/${parts[0]}/models/${parts[1]}`;
        } else return `publishers/google/models/${model}`;
    } else {
        if (model.startsWith('models/') || model.startsWith('tunedModels/')) return model;
        else return `models/${model}`;
    }
}
function $e4deb49dba5321bc$var$tCachesModel(apiClient, model) {
    const transformedModel = $e4deb49dba5321bc$var$tModel(apiClient, model);
    if (!transformedModel) return '';
    if (transformedModel.startsWith('publishers/') && apiClient.isVertexAI()) // vertex caches only support model name start with projects.
    return `projects/${apiClient.getProject()}/locations/${apiClient.getLocation()}/${transformedModel}`;
    else if (transformedModel.startsWith('models/') && apiClient.isVertexAI()) return `projects/${apiClient.getProject()}/locations/${apiClient.getLocation()}/publishers/google/${transformedModel}`;
    else return transformedModel;
}
function $e4deb49dba5321bc$var$tBlobs(blobs) {
    if (Array.isArray(blobs)) return blobs.map((blob)=>$e4deb49dba5321bc$var$tBlob(blob));
    else return [
        $e4deb49dba5321bc$var$tBlob(blobs)
    ];
}
function $e4deb49dba5321bc$var$tBlob(blob) {
    if (typeof blob === 'object' && blob !== null) return blob;
    throw new Error(`Could not parse input as Blob. Unsupported blob type: ${typeof blob}`);
}
function $e4deb49dba5321bc$var$tImageBlob(blob) {
    const transformedBlob = $e4deb49dba5321bc$var$tBlob(blob);
    if (transformedBlob.mimeType && transformedBlob.mimeType.startsWith('image/')) return transformedBlob;
    throw new Error(`Unsupported mime type: ${transformedBlob.mimeType}`);
}
function $e4deb49dba5321bc$var$tAudioBlob(blob) {
    const transformedBlob = $e4deb49dba5321bc$var$tBlob(blob);
    if (transformedBlob.mimeType && transformedBlob.mimeType.startsWith('audio/')) return transformedBlob;
    throw new Error(`Unsupported mime type: ${transformedBlob.mimeType}`);
}
function $e4deb49dba5321bc$var$tPart(origin) {
    if (origin === null || origin === undefined) throw new Error('PartUnion is required');
    if (typeof origin === 'object') return origin;
    if (typeof origin === 'string') return {
        text: origin
    };
    throw new Error(`Unsupported part type: ${typeof origin}`);
}
function $e4deb49dba5321bc$var$tParts(origin) {
    if (origin === null || origin === undefined || Array.isArray(origin) && origin.length === 0) throw new Error('PartListUnion is required');
    if (Array.isArray(origin)) return origin.map((item)=>$e4deb49dba5321bc$var$tPart(item));
    return [
        $e4deb49dba5321bc$var$tPart(origin)
    ];
}
function $e4deb49dba5321bc$var$_isContent(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'parts' in origin && Array.isArray(origin.parts);
}
function $e4deb49dba5321bc$var$_isFunctionCallPart(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'functionCall' in origin;
}
function $e4deb49dba5321bc$var$_isFunctionResponsePart(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'functionResponse' in origin;
}
function $e4deb49dba5321bc$var$tContent(origin) {
    if (origin === null || origin === undefined) throw new Error('ContentUnion is required');
    if ($e4deb49dba5321bc$var$_isContent(origin)) // _isContent is a utility function that checks if the
    // origin is a Content.
    return origin;
    return {
        role: 'user',
        parts: $e4deb49dba5321bc$var$tParts(origin)
    };
}
function $e4deb49dba5321bc$var$tContentsForEmbed(apiClient, origin) {
    if (!origin) return [];
    if (apiClient.isVertexAI() && Array.isArray(origin)) return origin.flatMap((item)=>{
        const content = $e4deb49dba5321bc$var$tContent(item);
        if (content.parts && content.parts.length > 0 && content.parts[0].text !== undefined) return [
            content.parts[0].text
        ];
        return [];
    });
    else if (apiClient.isVertexAI()) {
        const content = $e4deb49dba5321bc$var$tContent(origin);
        if (content.parts && content.parts.length > 0 && content.parts[0].text !== undefined) return [
            content.parts[0].text
        ];
        return [];
    }
    if (Array.isArray(origin)) return origin.map((item)=>$e4deb49dba5321bc$var$tContent(item));
    return [
        $e4deb49dba5321bc$var$tContent(origin)
    ];
}
function $e4deb49dba5321bc$var$tContents(origin) {
    if (origin === null || origin === undefined || Array.isArray(origin) && origin.length === 0) throw new Error('contents are required');
    if (!Array.isArray(origin)) {
        // If it's not an array, it's a single content or a single PartUnion.
        if ($e4deb49dba5321bc$var$_isFunctionCallPart(origin) || $e4deb49dba5321bc$var$_isFunctionResponsePart(origin)) throw new Error('To specify functionCall or functionResponse parts, please wrap them in a Content object, specifying the role for them');
        return [
            $e4deb49dba5321bc$var$tContent(origin)
        ];
    }
    const result = [];
    const accumulatedParts = [];
    const isContentArray = $e4deb49dba5321bc$var$_isContent(origin[0]);
    for (const item of origin){
        const isContent = $e4deb49dba5321bc$var$_isContent(item);
        if (isContent != isContentArray) throw new Error('Mixing Content and Parts is not supported, please group the parts into a the appropriate Content objects and specify the roles for them');
        if (isContent) // `isContent` contains the result of _isContent, which is a utility
        // function that checks if the item is a Content.
        result.push(item);
        else if ($e4deb49dba5321bc$var$_isFunctionCallPart(item) || $e4deb49dba5321bc$var$_isFunctionResponsePart(item)) throw new Error('To specify functionCall or functionResponse parts, please wrap them, and any other parts, in Content objects as appropriate, specifying the role for them');
        else accumulatedParts.push(item);
    }
    if (!isContentArray) result.push({
        role: 'user',
        parts: $e4deb49dba5321bc$var$tParts(accumulatedParts)
    });
    return result;
}
/*
Transform the type field from an array of types to an array of anyOf fields.
Example:
  {type: ['STRING', 'NUMBER']}
will be transformed to
  {anyOf: [{type: 'STRING'}, {type: 'NUMBER'}]}
*/ function $e4deb49dba5321bc$var$flattenTypeArrayToAnyOf(typeList, resultingSchema) {
    if (typeList.includes('null')) resultingSchema['nullable'] = true;
    const listWithoutNull = typeList.filter((type)=>type !== 'null');
    if (listWithoutNull.length === 1) resultingSchema['type'] = Object.values($e4deb49dba5321bc$export$92738401e1603719).includes(listWithoutNull[0].toUpperCase()) ? listWithoutNull[0].toUpperCase() : $e4deb49dba5321bc$export$92738401e1603719.TYPE_UNSPECIFIED;
    else {
        resultingSchema['anyOf'] = [];
        for (const i of listWithoutNull)resultingSchema['anyOf'].push({
            'type': Object.values($e4deb49dba5321bc$export$92738401e1603719).includes(i.toUpperCase()) ? i.toUpperCase() : $e4deb49dba5321bc$export$92738401e1603719.TYPE_UNSPECIFIED
        });
    }
}
function $e4deb49dba5321bc$var$processJsonSchema(_jsonSchema) {
    const genAISchema = {};
    const schemaFieldNames = [
        'items'
    ];
    const listSchemaFieldNames = [
        'anyOf'
    ];
    const dictSchemaFieldNames = [
        'properties'
    ];
    if (_jsonSchema['type'] && _jsonSchema['anyOf']) throw new Error('type and anyOf cannot be both populated.');
    /*
    This is to handle the nullable array or object. The _jsonSchema will
    be in the format of {anyOf: [{type: 'null'}, {type: 'object'}]}. The
    logic is to check if anyOf has 2 elements and one of the element is null,
    if so, the anyOf field is unnecessary, so we need to get rid of the anyOf
    field and make the schema nullable. Then use the other element as the new
    _jsonSchema for processing. This is because the backend doesn't have a null
    type.
    This has to be checked before we process any other fields.
    For example:
      const objectNullable = z.object({
        nullableArray: z.array(z.string()).nullable(),
      });
    Will have the raw _jsonSchema as:
    {
      type: 'OBJECT',
      properties: {
          nullableArray: {
             anyOf: [
                {type: 'null'},
                {
                  type: 'array',
                  items: {type: 'string'},
                },
              ],
          }
      },
      required: [ 'nullableArray' ],
    }
    Will result in following schema compatible with Gemini API:
      {
        type: 'OBJECT',
        properties: {
           nullableArray: {
              nullable: true,
              type: 'ARRAY',
              items: {type: 'string'},
           }
        },
        required: [ 'nullableArray' ],
      }
    */ const incomingAnyOf = _jsonSchema['anyOf'];
    if (incomingAnyOf != null && incomingAnyOf.length == 2) {
        if (incomingAnyOf[0]['type'] === 'null') {
            genAISchema['nullable'] = true;
            _jsonSchema = incomingAnyOf[1];
        } else if (incomingAnyOf[1]['type'] === 'null') {
            genAISchema['nullable'] = true;
            _jsonSchema = incomingAnyOf[0];
        }
    }
    if (_jsonSchema['type'] instanceof Array) $e4deb49dba5321bc$var$flattenTypeArrayToAnyOf(_jsonSchema['type'], genAISchema);
    for (const [fieldName, fieldValue] of Object.entries(_jsonSchema)){
        // Skip if the fieldvalue is undefined or null.
        if (fieldValue == null) continue;
        if (fieldName == 'type') {
            if (fieldValue === 'null') throw new Error('type: null can not be the only possible type for the field.');
            if (fieldValue instanceof Array) continue;
            genAISchema['type'] = Object.values($e4deb49dba5321bc$export$92738401e1603719).includes(fieldValue.toUpperCase()) ? fieldValue.toUpperCase() : $e4deb49dba5321bc$export$92738401e1603719.TYPE_UNSPECIFIED;
        } else if (schemaFieldNames.includes(fieldName)) genAISchema[fieldName] = $e4deb49dba5321bc$var$processJsonSchema(fieldValue);
        else if (listSchemaFieldNames.includes(fieldName)) {
            const listSchemaFieldValue = [];
            for (const item of fieldValue){
                if (item['type'] == 'null') {
                    genAISchema['nullable'] = true;
                    continue;
                }
                listSchemaFieldValue.push($e4deb49dba5321bc$var$processJsonSchema(item));
            }
            genAISchema[fieldName] = listSchemaFieldValue;
        } else if (dictSchemaFieldNames.includes(fieldName)) {
            const dictSchemaFieldValue = {};
            for (const [key, value] of Object.entries(fieldValue))dictSchemaFieldValue[key] = $e4deb49dba5321bc$var$processJsonSchema(value);
            genAISchema[fieldName] = dictSchemaFieldValue;
        } else {
            // additionalProperties is not included in JSONSchema, skipping it.
            if (fieldName === 'additionalProperties') continue;
            genAISchema[fieldName] = fieldValue;
        }
    }
    return genAISchema;
}
// we take the unknown in the schema field because we want enable user to pass
// the output of major schema declaration tools without casting. Tools such as
// zodToJsonSchema, typebox, zodToJsonSchema function can return JsonSchema7Type
// or object, see details in
// https://github.com/StefanTerdell/zod-to-json-schema/blob/70525efe555cd226691e093d171370a3b10921d1/src/zodToJsonSchema.ts#L7
// typebox can return unknown, see details in
// https://github.com/sinclairzx81/typebox/blob/5a5431439f7d5ca6b494d0d18fbfd7b1a356d67c/src/type/create/type.ts#L35
// Note: proper json schemas with the $schema field set never arrive to this
// transformer. Schemas with $schema are routed to the equivalent API json
// schema field.
function $e4deb49dba5321bc$var$tSchema(schema) {
    return $e4deb49dba5321bc$var$processJsonSchema(schema);
}
function $e4deb49dba5321bc$var$tSpeechConfig(speechConfig) {
    if (typeof speechConfig === 'object') return speechConfig;
    else if (typeof speechConfig === 'string') return {
        voiceConfig: {
            prebuiltVoiceConfig: {
                voiceName: speechConfig
            }
        }
    };
    else throw new Error(`Unsupported speechConfig type: ${typeof speechConfig}`);
}
function $e4deb49dba5321bc$var$tLiveSpeechConfig(speechConfig) {
    if ('multiSpeakerVoiceConfig' in speechConfig) throw new Error('multiSpeakerVoiceConfig is not supported in the live API.');
    return speechConfig;
}
function $e4deb49dba5321bc$var$tTool(tool) {
    if (tool.functionDeclarations) for (const functionDeclaration of tool.functionDeclarations){
        if (functionDeclaration.parameters) {
            if (!Object.keys(functionDeclaration.parameters).includes('$schema')) functionDeclaration.parameters = $e4deb49dba5321bc$var$processJsonSchema(functionDeclaration.parameters);
            else if (!functionDeclaration.parametersJsonSchema) {
                functionDeclaration.parametersJsonSchema = functionDeclaration.parameters;
                delete functionDeclaration.parameters;
            }
        }
        if (functionDeclaration.response) {
            if (!Object.keys(functionDeclaration.response).includes('$schema')) functionDeclaration.response = $e4deb49dba5321bc$var$processJsonSchema(functionDeclaration.response);
            else if (!functionDeclaration.responseJsonSchema) {
                functionDeclaration.responseJsonSchema = functionDeclaration.response;
                delete functionDeclaration.response;
            }
        }
    }
    return tool;
}
function $e4deb49dba5321bc$var$tTools(tools) {
    // Check if the incoming type is defined.
    if (tools === undefined || tools === null) throw new Error('tools is required');
    if (!Array.isArray(tools)) throw new Error('tools is required and must be an array of Tools');
    const result = [];
    for (const tool of tools)result.push(tool);
    return result;
}
/**
 * Prepends resource name with project, location, resource_prefix if needed.
 *
 * @param client The API client.
 * @param resourceName The resource name.
 * @param resourcePrefix The resource prefix.
 * @param splitsAfterPrefix The number of splits after the prefix.
 * @returns The completed resource name.
 *
 * Examples:
 *
 * ```
 * resource_name = '123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = True
 * client.project = 'bar'
 * client.location = 'us-west1'
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * returns: 'projects/bar/locations/us-west1/cachedContents/123'
 * ```
 *
 * ```
 * resource_name = 'projects/foo/locations/us-central1/cachedContents/123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = True
 * client.project = 'bar'
 * client.location = 'us-west1'
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * returns: 'projects/foo/locations/us-central1/cachedContents/123'
 * ```
 *
 * ```
 * resource_name = '123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = False
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * returns 'cachedContents/123'
 * ```
 *
 * ```
 * resource_name = 'some/wrong/cachedContents/resource/name/123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = False
 * # client.vertexai = True
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * -> 'some/wrong/resource/name/123'
 * ```
 */ function $e4deb49dba5321bc$var$resourceName(client, resourceName1, resourcePrefix, splitsAfterPrefix = 1) {
    const shouldAppendPrefix = !resourceName1.startsWith(`${resourcePrefix}/`) && resourceName1.split('/').length === splitsAfterPrefix;
    if (client.isVertexAI()) {
        if (resourceName1.startsWith('projects/')) return resourceName1;
        else if (resourceName1.startsWith('locations/')) return `projects/${client.getProject()}/${resourceName1}`;
        else if (resourceName1.startsWith(`${resourcePrefix}/`)) return `projects/${client.getProject()}/locations/${client.getLocation()}/${resourceName1}`;
        else if (shouldAppendPrefix) return `projects/${client.getProject()}/locations/${client.getLocation()}/${resourcePrefix}/${resourceName1}`;
        else return resourceName1;
    }
    if (shouldAppendPrefix) return `${resourcePrefix}/${resourceName1}`;
    return resourceName1;
}
function $e4deb49dba5321bc$var$tCachedContentName(apiClient, name) {
    if (typeof name !== 'string') throw new Error('name must be a string');
    return $e4deb49dba5321bc$var$resourceName(apiClient, name, 'cachedContents');
}
function $e4deb49dba5321bc$var$tTuningJobStatus(status) {
    switch(status){
        case 'STATE_UNSPECIFIED':
            return 'JOB_STATE_UNSPECIFIED';
        case 'CREATING':
            return 'JOB_STATE_RUNNING';
        case 'ACTIVE':
            return 'JOB_STATE_SUCCEEDED';
        case 'FAILED':
            return 'JOB_STATE_FAILED';
        default:
            return status;
    }
}
function $e4deb49dba5321bc$var$tBytes(fromImageBytes) {
    return $e4deb49dba5321bc$var$tBytes$1(fromImageBytes);
}
function $e4deb49dba5321bc$var$_isFile(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'name' in origin;
}
function $e4deb49dba5321bc$var$isGeneratedVideo(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'video' in origin;
}
function $e4deb49dba5321bc$var$isVideo(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'uri' in origin;
}
function $e4deb49dba5321bc$var$tFileName(fromName) {
    var _a;
    let name;
    if ($e4deb49dba5321bc$var$_isFile(fromName)) name = fromName.name;
    if ($e4deb49dba5321bc$var$isVideo(fromName)) {
        name = fromName.uri;
        if (name === undefined) return undefined;
    }
    if ($e4deb49dba5321bc$var$isGeneratedVideo(fromName)) {
        name = (_a = fromName.video) === null || _a === void 0 ? void 0 : _a.uri;
        if (name === undefined) return undefined;
    }
    if (typeof fromName === 'string') name = fromName;
    if (name === undefined) throw new Error('Could not extract file name from the provided input.');
    if (name.startsWith('https://')) {
        const suffix = name.split('files/')[1];
        const match = suffix.match(/[a-z0-9]+/);
        if (match === null) throw new Error(`Could not extract file name from URI ${name}`);
        name = match[0];
    } else if (name.startsWith('files/')) name = name.split('files/')[1];
    return name;
}
function $e4deb49dba5321bc$var$tModelsUrl(apiClient, baseModels) {
    let res;
    if (apiClient.isVertexAI()) res = baseModels ? 'publishers/google/models' : 'models';
    else res = baseModels ? 'models' : 'tunedModels';
    return res;
}
function $e4deb49dba5321bc$var$tExtractModels(response) {
    for (const key of [
        'models',
        'tunedModels',
        'publisherModels'
    ]){
        if ($e4deb49dba5321bc$var$hasField(response, key)) return response[key];
    }
    return [];
}
function $e4deb49dba5321bc$var$hasField(data, fieldName) {
    return data !== null && typeof data === 'object' && fieldName in data;
}
function $e4deb49dba5321bc$var$mcpToGeminiTool(mcpTool, config = {}) {
    const mcpToolSchema = mcpTool;
    const functionDeclaration = {
        name: mcpToolSchema['name'],
        description: mcpToolSchema['description'],
        parametersJsonSchema: mcpToolSchema['inputSchema']
    };
    if (mcpToolSchema['outputSchema']) functionDeclaration['responseJsonSchema'] = mcpToolSchema['outputSchema'];
    if (config.behavior) functionDeclaration['behavior'] = config.behavior;
    const geminiTool = {
        functionDeclarations: [
            functionDeclaration
        ]
    };
    return geminiTool;
}
/**
 * Converts a list of MCP tools to a single Gemini tool with a list of function
 * declarations.
 */ function $e4deb49dba5321bc$var$mcpToolsToGeminiTool(mcpTools, config = {}) {
    const functionDeclarations = [];
    const toolNames = new Set();
    for (const mcpTool of mcpTools){
        const mcpToolName = mcpTool.name;
        if (toolNames.has(mcpToolName)) throw new Error(`Duplicate function name ${mcpToolName} found in MCP tools. Please ensure function names are unique.`);
        toolNames.add(mcpToolName);
        const geminiTool = $e4deb49dba5321bc$var$mcpToGeminiTool(mcpTool, config);
        if (geminiTool.functionDeclarations) functionDeclarations.push(...geminiTool.functionDeclarations);
    }
    return {
        functionDeclarations: functionDeclarations
    };
}
// Transforms a source input into a BatchJobSource object with validation.
function $e4deb49dba5321bc$var$tBatchJobSource(client, src) {
    let sourceObj;
    if (typeof src === 'string') {
        if (client.isVertexAI()) {
            if (src.startsWith('gs://')) sourceObj = {
                format: 'jsonl',
                gcsUri: [
                    src
                ]
            };
            else if (src.startsWith('bq://')) sourceObj = {
                format: 'bigquery',
                bigqueryUri: src
            };
            else throw new Error(`Unsupported string source for Vertex AI: ${src}`);
        } else {
            // MLDEV
            if (src.startsWith('files/')) sourceObj = {
                fileName: src
            }; // Default to fileName for string input
            else throw new Error(`Unsupported string source for Gemini API: ${src}`);
        }
    } else if (Array.isArray(src)) {
        if (client.isVertexAI()) throw new Error('InlinedRequest[] is not supported in Vertex AI.');
        sourceObj = {
            inlinedRequests: src
        };
    } else // It's already a BatchJobSource object
    sourceObj = src;
    // Validation logic
    const vertexSourcesCount = [
        sourceObj.gcsUri,
        sourceObj.bigqueryUri
    ].filter(Boolean).length;
    const mldevSourcesCount = [
        sourceObj.inlinedRequests,
        sourceObj.fileName
    ].filter(Boolean).length;
    if (client.isVertexAI()) {
        if (mldevSourcesCount > 0 || vertexSourcesCount !== 1) throw new Error('Exactly one of `gcsUri` or `bigqueryUri` must be set for Vertex AI.');
    } else {
        // MLDEV
        if (vertexSourcesCount > 0 || mldevSourcesCount !== 1) throw new Error("Exactly one of `inlinedRequests`, `fileName`, must be set for Gemini API.");
    }
    return sourceObj;
}
function $e4deb49dba5321bc$var$tBatchJobDestination(dest) {
    if (typeof dest !== 'string') return dest;
    const destString = dest;
    if (destString.startsWith('gs://')) return {
        format: 'jsonl',
        gcsUri: destString
    };
    else if (destString.startsWith('bq://')) return {
        format: 'bigquery',
        bigqueryUri: destString
    };
    else throw new Error(`Unsupported destination: ${destString}`);
}
function $e4deb49dba5321bc$var$tRecvBatchJobDestination(dest) {
    // Ensure dest is a non-null object before proceeding.
    if (typeof dest !== 'object' || dest === null) // If the input is not an object, it cannot be a valid BatchJobDestination
    // based on the operations performed. Return it cast, or handle as an error.
    // Casting an empty object might be a safe default.
    return {};
    // Cast to Record<string, unknown> to allow string property access.
    const obj = dest;
    // Safely access nested properties.
    const inlineResponsesVal = obj['inlinedResponses'];
    if (typeof inlineResponsesVal !== 'object' || inlineResponsesVal === null) return dest;
    const inlineResponsesObj = inlineResponsesVal;
    const responsesArray = inlineResponsesObj['inlinedResponses'];
    if (!Array.isArray(responsesArray) || responsesArray.length === 0) return dest;
    // Check if any response has the 'embedding' property.
    let hasEmbedding = false;
    for (const responseItem of responsesArray){
        if (typeof responseItem !== 'object' || responseItem === null) continue;
        const responseItemObj = responseItem;
        const responseVal = responseItemObj['response'];
        if (typeof responseVal !== 'object' || responseVal === null) continue;
        const responseObj = responseVal;
        // Check for the existence of the 'embedding' key.
        if (responseObj['embedding'] !== undefined) {
            hasEmbedding = true;
            break;
        }
    }
    // Perform the transformation if an embedding was found.
    if (hasEmbedding) {
        obj['inlinedEmbedContentResponses'] = obj['inlinedResponses'];
        delete obj['inlinedResponses'];
    }
    // Cast the (potentially) modified object to the target type.
    return dest;
}
function $e4deb49dba5321bc$var$tBatchJobName(apiClient, name) {
    const nameString = name;
    if (!apiClient.isVertexAI()) {
        const mldevPattern = /batches\/[^/]+$/;
        if (mldevPattern.test(nameString)) return nameString.split('/').pop();
        else throw new Error(`Invalid batch job name: ${nameString}.`);
    }
    const vertexPattern = /^projects\/[^/]+\/locations\/[^/]+\/batchPredictionJobs\/[^/]+$/;
    if (vertexPattern.test(nameString)) return nameString.split('/').pop();
    else if (/^\d+$/.test(nameString)) return nameString;
    else throw new Error(`Invalid batch job name: ${nameString}.`);
}
function $e4deb49dba5321bc$var$tJobState(state) {
    const stateString = state;
    if (stateString === 'BATCH_STATE_UNSPECIFIED') return 'JOB_STATE_UNSPECIFIED';
    else if (stateString === 'BATCH_STATE_PENDING') return 'JOB_STATE_PENDING';
    else if (stateString === 'BATCH_STATE_RUNNING') return 'JOB_STATE_RUNNING';
    else if (stateString === 'BATCH_STATE_SUCCEEDED') return 'JOB_STATE_SUCCEEDED';
    else if (stateString === 'BATCH_STATE_FAILED') return 'JOB_STATE_FAILED';
    else if (stateString === 'BATCH_STATE_CANCELLED') return 'JOB_STATE_CANCELLED';
    else if (stateString === 'BATCH_STATE_EXPIRED') return 'JOB_STATE_EXPIRED';
    else return stateString;
}
function $e4deb49dba5321bc$var$tIsVertexEmbedContentModel(model) {
    return model.includes('gemini') && model !== 'gemini-embedding-001' || model.includes('maas');
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$batchJobDestinationFromMldev(fromObject) {
    const toObject = {};
    const fromFileName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responsesFile'
    ]);
    if (fromFileName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileName'
    ], fromFileName);
    const fromInlinedResponses = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedResponses',
        'inlinedResponses'
    ]);
    if (fromInlinedResponses != null) {
        let transformedList = fromInlinedResponses;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$inlinedResponseFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'inlinedResponses'
        ], transformedList);
    }
    const fromInlinedEmbedContentResponses = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedEmbedContentResponses',
        'inlinedResponses'
    ]);
    if (fromInlinedEmbedContentResponses != null) {
        let transformedList = fromInlinedEmbedContentResponses;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'inlinedEmbedContentResponses'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobDestinationFromVertex(fromObject) {
    const toObject = {};
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictionsFormat'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'format'
    ], fromFormat);
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsDestination',
        'outputUriPrefix'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromBigqueryUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigqueryDestination',
        'outputUri'
    ]);
    if (fromBigqueryUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bigqueryUri'
    ], fromBigqueryUri);
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobDestinationToVertex(fromObject) {
    const toObject = {};
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'format'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'predictionsFormat'
    ], fromFormat);
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsDestination',
        'outputUriPrefix'
    ], fromGcsUri);
    const fromBigqueryUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigqueryUri'
    ]);
    if (fromBigqueryUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bigqueryDestination',
        'outputUri'
    ], fromBigqueryUri);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]) !== undefined) throw new Error('fileName parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedResponses'
    ]) !== undefined) throw new Error('inlinedResponses parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedEmbedContentResponses'
    ]) !== undefined) throw new Error('inlinedEmbedContentResponses parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobFromMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], $e4deb49dba5321bc$var$tJobState(fromState));
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromDest = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'output'
    ]);
    if (fromDest != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dest'
    ], $e4deb49dba5321bc$var$batchJobDestinationFromMldev($e4deb49dba5321bc$var$tRecvBatchJobDestination(fromDest)));
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobFromVertex(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], $e4deb49dba5321bc$var$tJobState(fromState));
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromSrc = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputConfig'
    ]);
    if (fromSrc != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'src'
    ], $e4deb49dba5321bc$var$batchJobSourceFromVertex(fromSrc));
    const fromDest = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputConfig'
    ]);
    if (fromDest != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dest'
    ], $e4deb49dba5321bc$var$batchJobDestinationFromVertex($e4deb49dba5321bc$var$tRecvBatchJobDestination(fromDest)));
    const fromCompletionStats = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'completionStats'
    ]);
    if (fromCompletionStats != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'completionStats'
    ], fromCompletionStats);
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobSourceFromVertex(fromObject) {
    const toObject = {};
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'instancesFormat'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'format'
    ], fromFormat);
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsSource',
        'uris'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromBigqueryUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigquerySource',
        'inputUri'
    ]);
    if (fromBigqueryUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bigqueryUri'
    ], fromBigqueryUri);
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobSourceToMldev(apiClient, fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'format'
    ]) !== undefined) throw new Error('format parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]) !== undefined) throw new Error('gcsUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigqueryUri'
    ]) !== undefined) throw new Error('bigqueryUri parameter is not supported in Gemini API.');
    const fromFileName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]);
    if (fromFileName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileName'
    ], fromFileName);
    const fromInlinedRequests = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedRequests'
    ]);
    if (fromInlinedRequests != null) {
        let transformedList = fromInlinedRequests;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$inlinedRequestToMldev(apiClient, item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'requests',
            'requests'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobSourceToVertex(fromObject) {
    const toObject = {};
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'format'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instancesFormat'
    ], fromFormat);
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsSource',
        'uris'
    ], fromGcsUri);
    const fromBigqueryUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigqueryUri'
    ]);
    if (fromBigqueryUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bigquerySource',
        'inputUri'
    ], fromBigqueryUri);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]) !== undefined) throw new Error('fileName parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedRequests'
    ]) !== undefined) throw new Error('inlinedRequests parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$blobToMldev$4(fromObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$cancelBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$cancelBatchJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$candidateFromMldev$1(fromObject) {
    const toObject = {};
    const fromContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'content'
    ]);
    if (fromContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'content'
    ], fromContent);
    const fromCitationMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationMetadata'
    ]);
    if (fromCitationMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'citationMetadata'
    ], $e4deb49dba5321bc$var$citationMetadataFromMldev$1(fromCitationMetadata));
    const fromTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tokenCount'
    ]);
    if (fromTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    const fromFinishReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'finishReason'
    ]);
    if (fromFinishReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'finishReason'
    ], fromFinishReason);
    const fromGroundingMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromAvgLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'avgLogprobs'
    ]);
    if (fromAvgLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'avgLogprobs'
    ], fromAvgLogprobs);
    const fromIndex = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'index'
    ]);
    if (fromIndex != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'index'
    ], fromIndex);
    const fromLogprobsResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobsResult'
    ]);
    if (fromLogprobsResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobsResult'
    ], fromLogprobsResult);
    const fromSafetyRatings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyRatings'
    ]);
    if (fromSafetyRatings != null) {
        let transformedList = fromSafetyRatings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'safetyRatings'
        ], transformedList);
    }
    const fromUrlContextMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContextMetadata'
    ]);
    if (fromUrlContextMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContextMetadata'
    ], fromUrlContextMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$citationMetadataFromMldev$1(fromObject) {
    const toObject = {};
    const fromCitations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationSources'
    ]);
    if (fromCitations != null) {
        let transformedList = fromCitations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'citations'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev$4(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev$4(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$createBatchJobConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'batch',
        'displayName'
    ], fromDisplayName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dest'
    ]) !== undefined) throw new Error('dest parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$createBatchJobConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromDest = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dest'
    ]);
    if (parentObject !== undefined && fromDest != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'outputConfig'
    ], $e4deb49dba5321bc$var$batchJobDestinationToVertex($e4deb49dba5321bc$var$tBatchJobDestination(fromDest)));
    return toObject;
}
function $e4deb49dba5321bc$var$createBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSrc = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'src'
    ]);
    if (fromSrc != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'batch',
        'inputConfig'
    ], $e4deb49dba5321bc$var$batchJobSourceToMldev(apiClient, $e4deb49dba5321bc$var$tBatchJobSource(apiClient, fromSrc)));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createBatchJobConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$createBatchJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSrc = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'src'
    ]);
    if (fromSrc != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inputConfig'
    ], $e4deb49dba5321bc$var$batchJobSourceToVertex($e4deb49dba5321bc$var$tBatchJobSource(apiClient, fromSrc)));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createBatchJobConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$createEmbeddingsBatchJobConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'batch',
        'displayName'
    ], fromDisplayName);
    return toObject;
}
function $e4deb49dba5321bc$var$createEmbeddingsBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSrc = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'src'
    ]);
    if (fromSrc != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'batch',
        'inputConfig'
    ], $e4deb49dba5321bc$var$embeddingsBatchJobSourceToMldev(apiClient, fromSrc));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createEmbeddingsBatchJobConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteBatchJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteResourceJobFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteResourceJobFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentBatchToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContentsForEmbed(apiClient, fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'requests[]',
            'request',
            'content'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) {
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            '_self'
        ], $e4deb49dba5321bc$var$embedContentConfigToMldev$1(fromConfig, toObject));
        $e4deb49dba5321bc$var$moveValueByPath(toObject, {
            'requests[].*': 'requests[].request.*'
        });
    }
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentConfigToMldev$1(fromObject, parentObject) {
    const toObject = {};
    const fromTaskType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'taskType'
    ]);
    if (parentObject !== undefined && fromTaskType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'taskType'
    ], fromTaskType);
    const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'title'
    ]);
    if (parentObject !== undefined && fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'title'
    ], fromTitle);
    const fromOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputDimensionality'
    ]);
    if (parentObject !== undefined && fromOutputDimensionality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'outputDimensionality'
    ], fromOutputDimensionality);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]) !== undefined) throw new Error('mimeType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'autoTruncate'
    ]) !== undefined) throw new Error('autoTruncate parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$embeddingsBatchJobSourceToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromFileName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]);
    if (fromFileName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'file_name'
    ], fromFileName);
    const fromInlinedRequests = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedRequests'
    ]);
    if (fromInlinedRequests != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'requests'
    ], $e4deb49dba5321bc$var$embedContentBatchToMldev(apiClient, fromInlinedRequests));
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev$4(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev$4(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partialArgs'
    ]) !== undefined) throw new Error('partialArgs parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'willContinue'
    ]) !== undefined) throw new Error('willContinue parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallingConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromAllowedFunctionNames = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'streamFunctionCallArguments'
    ]) !== undefined) throw new Error('streamFunctionCallArguments parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentConfigToMldev$1(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev$4($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], $e4deb49dba5321bc$var$tSchema(fromResponseSchema));
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]) !== undefined) throw new Error('routingConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]) !== undefined) throw new Error('modelSelectionConfig parameter is not supported in Gemini API.');
    const fromSafetySettings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetySettings'
    ]);
    if (parentObject !== undefined && fromSafetySettings != null) {
        let transformedList = fromSafetySettings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$safetySettingToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'safetySettings'
        ], transformedList);
    }
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev$4($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToMldev$2(fromToolConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    const fromCachedContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContent'
    ]);
    if (parentObject !== undefined && fromCachedContent != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'cachedContent'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromCachedContent));
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], $e4deb49dba5321bc$var$tSpeechConfig(fromSpeechConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]) !== undefined) throw new Error('audioTimestamp parameter is not supported in Gemini API.');
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageConfig'
    ]);
    if (fromImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageConfig'
    ], $e4deb49dba5321bc$var$imageConfigToMldev$1(fromImageConfig));
    const fromEnableEnhancedCivicAnswers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableEnhancedCivicAnswers'
    ]);
    if (fromEnableEnhancedCivicAnswers != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableEnhancedCivicAnswers'
    ], fromEnableEnhancedCivicAnswers);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelArmorConfig'
    ]) !== undefined) throw new Error('modelArmorConfig parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentResponseFromMldev$1(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromCandidates = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidates'
    ]);
    if (fromCandidates != null) {
        let transformedList = fromCandidates;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$candidateFromMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'candidates'
        ], transformedList);
    }
    const fromModelVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelVersion'
    ]);
    if (fromModelVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelVersion'
    ], fromModelVersion);
    const fromPromptFeedback = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptFeedback'
    ]);
    if (fromPromptFeedback != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptFeedback'
    ], fromPromptFeedback);
    const fromResponseId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseId'
    ]);
    if (fromResponseId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseId'
    ], fromResponseId);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$getBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$getBatchJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToMldev$4(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]) !== undefined) throw new Error('authConfig parameter is not supported in Gemini API.');
    const fromEnableWidget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableWidget'
    ]);
    if (fromEnableWidget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableWidget'
    ], fromEnableWidget);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev$4(fromObject) {
    const toObject = {};
    const fromSearchTypes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'searchTypes'
    ]);
    if (fromSearchTypes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'searchTypes'
    ], fromSearchTypes);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'blockingConfidence'
    ]) !== undefined) throw new Error('blockingConfidence parameter is not supported in Gemini API.');
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], fromTimeRangeFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$imageConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'aspectRatio'
    ], fromAspectRatio);
    const fromImageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageSize'
    ]);
    if (fromImageSize != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageSize'
    ], fromImageSize);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]) !== undefined) throw new Error('personGeneration parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prominentPeople'
    ]) !== undefined) throw new Error('prominentPeople parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]) !== undefined) throw new Error('outputMimeType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]) !== undefined) throw new Error('outputCompressionQuality parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$inlinedRequestToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'request',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToMldev$4(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'request',
            'contents'
        ], transformedList);
    }
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'request',
        'generationConfig'
    ], $e4deb49dba5321bc$var$generateContentConfigToMldev$1(apiClient, fromConfig, $e4deb49dba5321bc$var$getValueByPath(toObject, [
        'request'
    ], {})));
    return toObject;
}
function $e4deb49dba5321bc$var$inlinedResponseFromMldev(fromObject) {
    const toObject = {};
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateContentResponseFromMldev$1(fromResponse));
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]) !== undefined) throw new Error('filter parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listBatchJobsConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsParametersToVertex(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listBatchJobsConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromBatchJobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'operations'
    ]);
    if (fromBatchJobs != null) {
        let transformedList = fromBatchJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$batchJobFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'batchJobs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromBatchJobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'batchPredictionJobs'
    ]);
    if (fromBatchJobs != null) {
        let transformedList = fromBatchJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$batchJobFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'batchJobs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev$4(fromObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev$4(fromFileData));
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev$4(fromFunctionCall));
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev$4(fromInlineData));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$safetySettingToMldev$1(fromObject) {
    const toObject = {};
    const fromCategory = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'category'
    ]);
    if (fromCategory != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'category'
    ], fromCategory);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'method'
    ]) !== undefined) throw new Error('method parameter is not supported in Gemini API.');
    const fromThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'threshold'
    ]);
    if (fromThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'threshold'
    ], fromThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], fromRetrievalConfig);
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], $e4deb49dba5321bc$var$functionCallingConfigToMldev$2(fromFunctionCallingConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev$4(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    const fromFileSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]);
    if (fromFileSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileSearch'
    ], fromFileSearch);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev$4(fromGoogleSearch));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToMldev$4(fromGoogleMaps));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    const fromMcpServers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]);
    if (fromMcpServers != null) {
        let transformedList = fromMcpServers;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mcpServers'
        ], transformedList);
    }
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ var $e4deb49dba5321bc$export$e18b8de308fd2439;
(function(PagedItem) {
    PagedItem["PAGED_ITEM_BATCH_JOBS"] = "batchJobs";
    PagedItem["PAGED_ITEM_MODELS"] = "models";
    PagedItem["PAGED_ITEM_TUNING_JOBS"] = "tuningJobs";
    PagedItem["PAGED_ITEM_FILES"] = "files";
    PagedItem["PAGED_ITEM_CACHED_CONTENTS"] = "cachedContents";
    PagedItem["PAGED_ITEM_FILE_SEARCH_STORES"] = "fileSearchStores";
    PagedItem["PAGED_ITEM_DOCUMENTS"] = "documents";
})($e4deb49dba5321bc$export$e18b8de308fd2439 || ($e4deb49dba5321bc$export$e18b8de308fd2439 = {}));
/**
 * Pager class for iterating through paginated results.
 */ class $e4deb49dba5321bc$export$57625d62e5386b09 {
    constructor(name, request, response, params){
        this.pageInternal = [];
        this.paramsInternal = {};
        this.requestInternal = request;
        this.init(name, response, params);
    }
    init(name, response, params) {
        var _a, _b;
        this.nameInternal = name;
        this.pageInternal = response[this.nameInternal] || [];
        this.sdkHttpResponseInternal = response === null || response === void 0 ? void 0 : response.sdkHttpResponse;
        this.idxInternal = 0;
        let requestParams = {
            config: {}
        };
        if (!params || Object.keys(params).length === 0) requestParams = {
            config: {}
        };
        else if (typeof params === 'object') requestParams = Object.assign({}, params);
        else requestParams = params;
        if (requestParams['config']) requestParams['config']['pageToken'] = response['nextPageToken'];
        this.paramsInternal = requestParams;
        this.pageInternalSize = (_b = (_a = requestParams['config']) === null || _a === void 0 ? void 0 : _a['pageSize']) !== null && _b !== void 0 ? _b : this.pageInternal.length;
    }
    initNextPage(response) {
        this.init(this.nameInternal, response, this.paramsInternal);
    }
    /**
     * Returns the current page, which is a list of items.
     *
     * @remarks
     * The first page is retrieved when the pager is created. The returned list of
     * items could be a subset of the entire list.
     */ get page() {
        return this.pageInternal;
    }
    /**
     * Returns the type of paged item (for example, ``batch_jobs``).
     */ get name() {
        return this.nameInternal;
    }
    /**
     * Returns the length of the page fetched each time by this pager.
     *
     * @remarks
     * The number of items in the page is less than or equal to the page length.
     */ get pageSize() {
        return this.pageInternalSize;
    }
    /**
     * Returns the headers of the API response.
     */ get sdkHttpResponse() {
        return this.sdkHttpResponseInternal;
    }
    /**
     * Returns the parameters when making the API request for the next page.
     *
     * @remarks
     * Parameters contain a set of optional configs that can be
     * used to customize the API request. For example, the `pageToken` parameter
     * contains the token to request the next page.
     */ get params() {
        return this.paramsInternal;
    }
    /**
     * Returns the total number of items in the current page.
     */ get pageLength() {
        return this.pageInternal.length;
    }
    /**
     * Returns the item at the given index.
     */ getItem(index) {
        return this.pageInternal[index];
    }
    /**
     * Returns an async iterator that support iterating through all items
     * retrieved from the API.
     *
     * @remarks
     * The iterator will automatically fetch the next page if there are more items
     * to fetch from the API.
     *
     * @example
     *
     * ```ts
     * const pager = await ai.files.list({config: {pageSize: 10}});
     * for await (const file of pager) {
     *   console.log(file.name);
     * }
     * ```
     */ [Symbol.asyncIterator]() {
        return {
            next: async ()=>{
                if (this.idxInternal >= this.pageLength) {
                    if (this.hasNextPage()) await this.nextPage();
                    else return {
                        value: undefined,
                        done: true
                    };
                }
                const item = this.getItem(this.idxInternal);
                this.idxInternal += 1;
                return {
                    value: item,
                    done: false
                };
            },
            return: async ()=>{
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     * Fetches the next page of items. This makes a new API request.
     *
     * @throws {Error} If there are no more pages to fetch.
     *
     * @example
     *
     * ```ts
     * const pager = await ai.files.list({config: {pageSize: 10}});
     * let page = pager.page;
     * while (true) {
     *   for (const file of page) {
     *     console.log(file.name);
     *   }
     *   if (!pager.hasNextPage()) {
     *     break;
     *   }
     *   page = await pager.nextPage();
     * }
     * ```
     */ async nextPage() {
        if (!this.hasNextPage()) throw new Error('No more pages to fetch.');
        const response = await this.requestInternal(this.params);
        this.initNextPage(response);
        return this.page;
    }
    /**
     * Returns true if there are more pages to fetch from the API.
     */ hasNextPage() {
        var _a;
        if (((_a = this.params['config']) === null || _a === void 0 ? void 0 : _a['pageToken']) !== undefined) return true;
        return false;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$ed828fcd19953e0d extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists batch jobs.
         *
         * @param params - The parameters for the list request.
         * @return - A pager of batch jobs.
         *
         * @example
         * ```ts
         * const batchJobs = await ai.batches.list({config: {'pageSize': 2}});
         * for await (const batchJob of batchJobs) {
         *   console.log(batchJob);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_BATCH_JOBS, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
        /**
         * Create batch job.
         *
         * @param params - The parameters for create batch job request.
         * @return The created batch job.
         *
         * @example
         * ```ts
         * const response = await ai.batches.create({
         *   model: 'gemini-2.0-flash',
         *   src: {gcsUri: 'gs://bucket/path/to/file.jsonl', format: 'jsonl'},
         *   config: {
         *     dest: {gcsUri: 'gs://bucket/path/output/directory', format: 'jsonl'},
         *   }
         * });
         * console.log(response);
         * ```
         */ this.create = async (params)=>{
            if (this.apiClient.isVertexAI()) // Format destination if not provided
            // Cast params.src as Vertex AI path does not handle InlinedRequest[]
            params.config = this.formatDestination(params.src, params.config);
            return this.createInternal(params);
        };
        /**
         * **Experimental** Creates an embedding batch job.
         *
         * @param params - The parameters for create embedding batch job request.
         * @return The created batch job.
         *
         * @example
         * ```ts
         * const response = await ai.batches.createEmbeddings({
         *   model: 'text-embedding-004',
         *   src: {fileName: 'files/my_embedding_input'},
         * });
         * console.log(response);
         * ```
         */ this.createEmbeddings = async (params)=>{
            console.warn('batches.createEmbeddings() is experimental and may change without notice.');
            if (this.apiClient.isVertexAI()) throw new Error('Vertex AI does not support batches.createEmbeddings.');
            return this.createEmbeddingsInternal(params);
        };
    }
    // Helper function to handle inlined generate content requests
    createInlinedGenerateContentRequest(params) {
        const body = $e4deb49dba5321bc$var$createBatchJobParametersToMldev(this.apiClient, params);
        const urlParams = body['_url'];
        const path = $e4deb49dba5321bc$var$formatMap('{model}:batchGenerateContent', urlParams);
        const batch = body['batch'];
        const inputConfig = batch['inputConfig'];
        const requestsWrapper = inputConfig['requests'];
        const requests = requestsWrapper['requests'];
        const newRequests = [];
        for (const request of requests){
            const requestDict = Object.assign({}, request); // Clone
            if (requestDict['systemInstruction']) {
                const systemInstructionValue = requestDict['systemInstruction'];
                delete requestDict['systemInstruction'];
                const requestContent = requestDict['request'];
                requestContent['systemInstruction'] = systemInstructionValue;
                requestDict['request'] = requestContent;
            }
            newRequests.push(requestDict);
        }
        requestsWrapper['requests'] = newRequests;
        delete body['config'];
        delete body['_url'];
        delete body['_query'];
        return {
            path: path,
            body: body
        };
    }
    // Helper function to get the first GCS URI
    getGcsUri(src) {
        if (typeof src === 'string') return src.startsWith('gs://') ? src : undefined;
        if (!Array.isArray(src) && src.gcsUri && src.gcsUri.length > 0) return src.gcsUri[0];
        return undefined;
    }
    // Helper function to get the BigQuery URI
    getBigqueryUri(src) {
        if (typeof src === 'string') return src.startsWith('bq://') ? src : undefined;
        if (!Array.isArray(src)) return src.bigqueryUri;
        return undefined;
    }
    // Function to format the destination configuration for Vertex AI
    formatDestination(src, config) {
        const newConfig = config ? Object.assign({}, config) : {};
        const timestampStr = Date.now().toString();
        if (!newConfig.displayName) newConfig.displayName = `genaiBatchJob_${timestampStr}`;
        if (newConfig.dest === undefined) {
            const gcsUri = this.getGcsUri(src);
            const bigqueryUri = this.getBigqueryUri(src);
            if (gcsUri) {
                if (gcsUri.endsWith('.jsonl')) // For .jsonl files, remove suffix and add /dest
                newConfig.dest = `${gcsUri.slice(0, -6)}/dest`;
                else // Fallback for other GCS URIs
                newConfig.dest = `${gcsUri}_dest_${timestampStr}`;
            } else if (bigqueryUri) newConfig.dest = `${bigqueryUri}_dest_${timestampStr}`;
            else throw new Error('Unsupported source for Vertex AI: No GCS or BigQuery URI found.');
        }
        return newConfig;
    }
    /**
     * Internal method to create batch job.
     *
     * @param params - The parameters for create batch job request.
     * @return The created batch job.
     *
     */ async createInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$createBatchJobParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$createBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:batchGenerateContent', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Internal method to create batch job.
     *
     * @param params - The parameters for create batch job request.
     * @return The created batch job.
     *
     */ async createEmbeddingsInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createEmbeddingsBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:asyncBatchEmbedContent', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Gets batch job configurations.
     *
     * @param params - The parameters for the get request.
     * @return The batch job.
     *
     * @example
     * ```ts
     * await ai.batches.get({name: '...'}); // The server-generated resource name.
     * ```
     */ async get(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getBatchJobParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs/{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$getBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batches/{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Cancels a batch job.
     *
     * @param params - The parameters for the cancel request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.batches.cancel({name: '...'}); // The server-generated resource name.
     * ```
     */ async cancel(params) {
        var _a, _b, _c, _d;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$cancelBatchJobParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs/{name}:cancel', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            await this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            });
        } else {
            const body = $e4deb49dba5321bc$var$cancelBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batches/{name}:cancel', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            await this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$listBatchJobsParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listBatchJobsResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$aad8e472c65c38a4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$listBatchJobsParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('batches', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listBatchJobsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$aad8e472c65c38a4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Deletes a batch job.
     *
     * @param params - The parameters for the delete request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.batches.delete({name: '...'}); // The server-generated resource name.
     * ```
     */ async delete(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$deleteBatchJobParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs/{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteResourceJobFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$deleteBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batches/{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteResourceJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$blobToMldev$3(fromObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev$3(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev$3(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$createCachedContentConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromTtl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (parentObject !== undefined && fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToMldev$3(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'contents'
        ], transformedList);
    }
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev$3($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = fromTools;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev$3(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToMldev$1(fromToolConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'kmsKeyName'
    ]) !== undefined) throw new Error('kmsKeyName parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$createCachedContentConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromTtl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (parentObject !== undefined && fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'contents'
        ], transformedList);
    }
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$tContent(fromSystemInstruction));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = fromTools;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToVertex$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], fromToolConfig);
    const fromKmsKeyName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'kmsKeyName'
    ]);
    if (parentObject !== undefined && fromKmsKeyName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'encryption_spec',
        'kmsKeyName'
    ], fromKmsKeyName);
    return toObject;
}
function $e4deb49dba5321bc$var$createCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], $e4deb49dba5321bc$var$tCachesModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createCachedContentConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$createCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], $e4deb49dba5321bc$var$tCachesModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createCachedContentConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteCachedContentResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteCachedContentResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev$3(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev$3(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partialArgs'
    ]) !== undefined) throw new Error('partialArgs parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'willContinue'
    ]) !== undefined) throw new Error('willContinue parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallingConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromAllowedFunctionNames = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'streamFunctionCallArguments'
    ]) !== undefined) throw new Error('streamFunctionCallArguments parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToVertex$2(fromObject) {
    const toObject = {};
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]) !== undefined) throw new Error('behavior parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$getCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$getCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToMldev$3(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]) !== undefined) throw new Error('authConfig parameter is not supported in Gemini API.');
    const fromEnableWidget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableWidget'
    ]);
    if (fromEnableWidget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableWidget'
    ], fromEnableWidget);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev$3(fromObject) {
    const toObject = {};
    const fromSearchTypes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'searchTypes'
    ]);
    if (fromSearchTypes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'searchTypes'
    ], fromSearchTypes);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'blockingConfidence'
    ]) !== undefined) throw new Error('blockingConfidence parameter is not supported in Gemini API.');
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], fromTimeRangeFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listCachedContentsConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsParametersToVertex(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listCachedContentsConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromCachedContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContents'
    ]);
    if (fromCachedContents != null) {
        let transformedList = fromCachedContents;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'cachedContents'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromCachedContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContents'
    ]);
    if (fromCachedContents != null) {
        let transformedList = fromCachedContents;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'cachedContents'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev$3(fromObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev$3(fromFileData));
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev$3(fromFunctionCall));
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev$3(fromInlineData));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], fromRetrievalConfig);
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], $e4deb49dba5321bc$var$functionCallingConfigToMldev$1(fromFunctionCallingConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev$3(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    const fromFileSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]);
    if (fromFileSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileSearch'
    ], fromFileSearch);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev$3(fromGoogleSearch));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToMldev$3(fromGoogleMaps));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    const fromMcpServers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]);
    if (fromMcpServers != null) {
        let transformedList = fromMcpServers;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mcpServers'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$toolToVertex$2(fromObject) {
    const toObject = {};
    const fromRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]);
    if (fromRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrieval'
    ], fromRetrieval);
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]) !== undefined) throw new Error('fileSearch parameter is not supported in Vertex AI.');
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], fromGoogleSearch);
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    const fromEnterpriseWebSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]);
    if (fromEnterpriseWebSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enterpriseWebSearch'
    ], fromEnterpriseWebSearch);
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToVertex$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], fromGoogleMaps);
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]) !== undefined) throw new Error('mcpServers parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$updateCachedContentConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromTtl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    return toObject;
}
function $e4deb49dba5321bc$var$updateCachedContentConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromTtl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    return toObject;
}
function $e4deb49dba5321bc$var$updateCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$updateCachedContentConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$updateCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$updateCachedContentConfigToVertex(fromConfig, toObject);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$4c60919c4fe22d9 extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists cached contents.
         *
         * @param params - The parameters for the list request.
         * @return - A pager of cached contents.
         *
         * @example
         * ```ts
         * const cachedContents = await ai.caches.list({config: {'pageSize': 2}});
         * for await (const cachedContent of cachedContents) {
         *   console.log(cachedContent);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_CACHED_CONTENTS, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
    }
    /**
     * Creates a cached contents resource.
     *
     * @remarks
     * Context caching is only supported for specific models. See [Gemini
     * Developer API reference](https://ai.google.dev/gemini-api/docs/caching?lang=node/context-cac)
     * and [Vertex AI reference](https://cloud.google.com/vertex-ai/generative-ai/docs/context-cache/context-cache-overview#supported_models)
     * for more information.
     *
     * @param params - The parameters for the create request.
     * @return The created cached content.
     *
     * @example
     * ```ts
     * const contents = ...; // Initialize the content to cache.
     * const response = await ai.caches.create({
     *   model: 'gemini-2.0-flash-001',
     *   config: {
     *    'contents': contents,
     *    'displayName': 'test cache',
     *    'systemInstruction': 'What is the sum of the two pdfs?',
     *    'ttl': '86400s',
     *  }
     * });
     * ```
     */ async create(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$createCachedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$createCachedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    /**
     * Gets cached content configurations.
     *
     * @param params - The parameters for the get request.
     * @return The cached content.
     *
     * @example
     * ```ts
     * await ai.caches.get({name: '...'}); // The server-generated resource name.
     * ```
     */ async get(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getCachedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$getCachedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    /**
     * Deletes cached content.
     *
     * @param params - The parameters for the delete request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.caches.delete({name: '...'}); // The server-generated resource name.
     * ```
     */ async delete(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$deleteCachedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteCachedContentResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$12b40cf453f95df4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$deleteCachedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteCachedContentResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$12b40cf453f95df4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Updates cached content configurations.
     *
     * @param params - The parameters for the update request.
     * @return The updated cached content.
     *
     * @example
     * ```ts
     * const response = await ai.caches.update({
     *   name: '...',  // The server-generated resource name.
     *   config: {'ttl': '7600s'}
     * });
     * ```
     */ async update(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$updateCachedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$updateCachedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$listCachedContentsParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listCachedContentsResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$b704e9f6d5866ff0();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$listCachedContentsParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listCachedContentsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$b704e9f6d5866ff0();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $e4deb49dba5321bc$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e4deb49dba5321bc$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e4deb49dba5321bc$var$__await(v) {
    return this instanceof $e4deb49dba5321bc$var$__await ? (this.v = v, this) : new $e4deb49dba5321bc$var$__await(v);
}
function $e4deb49dba5321bc$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e4deb49dba5321bc$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e4deb49dba5321bc$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e4deb49dba5321bc$var$__values === "function" ? $e4deb49dba5321bc$var$__values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
typeof SuppressedError === "function" && SuppressedError;
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Returns true if the response is valid, false otherwise.
 */ function $e4deb49dba5321bc$var$isValidResponse(response) {
    var _a;
    if (response.candidates == undefined || response.candidates.length === 0) return false;
    const content = (_a = response.candidates[0]) === null || _a === void 0 ? void 0 : _a.content;
    if (content === undefined) return false;
    return $e4deb49dba5321bc$var$isValidContent(content);
}
function $e4deb49dba5321bc$var$isValidContent(content) {
    if (content.parts === undefined || content.parts.length === 0) return false;
    for (const part of content.parts){
        if (part === undefined || Object.keys(part).length === 0) return false;
    }
    return true;
}
/**
 * Validates the history contains the correct roles.
 *
 * @throws Error if the history does not start with a user turn.
 * @throws Error if the history contains an invalid role.
 */ function $e4deb49dba5321bc$var$validateHistory(history) {
    // Empty history is valid.
    if (history.length === 0) return;
    for (const content of history){
        if (content.role !== 'user' && content.role !== 'model') throw new Error(`Role must be user or model, but got ${content.role}.`);
    }
}
/**
 * Extracts the curated (valid) history from a comprehensive history.
 *
 * @remarks
 * The model may sometimes generate invalid or empty contents(e.g., due to safty
 * filters or recitation). Extracting valid turns from the history
 * ensures that subsequent requests could be accpeted by the model.
 */ function $e4deb49dba5321bc$var$extractCuratedHistory(comprehensiveHistory) {
    if (comprehensiveHistory === undefined || comprehensiveHistory.length === 0) return [];
    const curatedHistory = [];
    const length = comprehensiveHistory.length;
    let i = 0;
    while(i < length)if (comprehensiveHistory[i].role === 'user') {
        curatedHistory.push(comprehensiveHistory[i]);
        i++;
    } else {
        const modelOutput = [];
        let isValid = true;
        while(i < length && comprehensiveHistory[i].role === 'model'){
            modelOutput.push(comprehensiveHistory[i]);
            if (isValid && !$e4deb49dba5321bc$var$isValidContent(comprehensiveHistory[i])) isValid = false;
            i++;
        }
        if (isValid) curatedHistory.push(...modelOutput);
        else // Remove the last user input when model content is invalid.
        curatedHistory.pop();
    }
    return curatedHistory;
}
/**
 * A utility class to create a chat session.
 */ class $e4deb49dba5321bc$export$84088b07cfe11a74 {
    constructor(modelsModule, apiClient){
        this.modelsModule = modelsModule;
        this.apiClient = apiClient;
    }
    /**
     * Creates a new chat session.
     *
     * @remarks
     * The config in the params will be used for all requests within the chat
     * session unless overridden by a per-request `config` in
     * @see {@link types.SendMessageParameters#config}.
     *
     * @param params - Parameters for creating a chat session.
     * @returns A new chat session.
     *
     * @example
     * ```ts
     * const chat = ai.chats.create({
     *   model: 'gemini-2.0-flash'
     *   config: {
     *     temperature: 0.5,
     *     maxOutputTokens: 1024,
     *   }
     * });
     * ```
     */ create(params) {
        return new $e4deb49dba5321bc$export$d49dffca20dba6f7(this.apiClient, this.modelsModule, params.model, params.config, // Deep copy the history to avoid mutating the history outside of the
        // chat session.
        structuredClone(params.history));
    }
}
/**
 * Chat session that enables sending messages to the model with previous
 * conversation context.
 *
 * @remarks
 * The session maintains all the turns between user and model.
 */ class $e4deb49dba5321bc$export$d49dffca20dba6f7 {
    constructor(apiClient, modelsModule, model, config = {}, history = []){
        this.apiClient = apiClient;
        this.modelsModule = modelsModule;
        this.model = model;
        this.config = config;
        this.history = history;
        // A promise to represent the current state of the message being sent to the
        // model.
        this.sendPromise = Promise.resolve();
        $e4deb49dba5321bc$var$validateHistory(history);
    }
    /**
     * Sends a message to the model and returns the response.
     *
     * @remarks
     * This method will wait for the previous message to be processed before
     * sending the next message.
     *
     * @see {@link Chat#sendMessageStream} for streaming method.
     * @param params - parameters for sending messages within a chat session.
     * @returns The model's response.
     *
     * @example
     * ```ts
     * const chat = ai.chats.create({model: 'gemini-2.0-flash'});
     * const response = await chat.sendMessage({
     *   message: 'Why is the sky blue?'
     * });
     * console.log(response.text);
     * ```
     */ async sendMessage(params) {
        var _a;
        await this.sendPromise;
        const inputContent = $e4deb49dba5321bc$var$tContent(params.message);
        const responsePromise = this.modelsModule.generateContent({
            model: this.model,
            contents: this.getHistory(true).concat(inputContent),
            config: (_a = params.config) !== null && _a !== void 0 ? _a : this.config
        });
        this.sendPromise = (async ()=>{
            var _a, _b, _c;
            const response = await responsePromise;
            const outputContent = (_b = (_a = response.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content;
            // Because the AFC input contains the entire curated chat history in
            // addition to the new user input, we need to truncate the AFC history
            // to deduplicate the existing chat history.
            const fullAutomaticFunctionCallingHistory = response.automaticFunctionCallingHistory;
            const index = this.getHistory(true).length;
            let automaticFunctionCallingHistory = [];
            if (fullAutomaticFunctionCallingHistory != null) automaticFunctionCallingHistory = (_c = fullAutomaticFunctionCallingHistory.slice(index)) !== null && _c !== void 0 ? _c : [];
            const modelOutput = outputContent ? [
                outputContent
            ] : [];
            this.recordHistory(inputContent, modelOutput, automaticFunctionCallingHistory);
            return;
        })();
        await this.sendPromise.catch(()=>{
            // Resets sendPromise to avoid subsequent calls failing
            this.sendPromise = Promise.resolve();
        });
        return responsePromise;
    }
    /**
     * Sends a message to the model and returns the response in chunks.
     *
     * @remarks
     * This method will wait for the previous message to be processed before
     * sending the next message.
     *
     * @see {@link Chat#sendMessage} for non-streaming method.
     * @param params - parameters for sending the message.
     * @return The model's response.
     *
     * @example
     * ```ts
     * const chat = ai.chats.create({model: 'gemini-2.0-flash'});
     * const response = await chat.sendMessageStream({
     *   message: 'Why is the sky blue?'
     * });
     * for await (const chunk of response) {
     *   console.log(chunk.text);
     * }
     * ```
     */ async sendMessageStream(params) {
        var _a;
        await this.sendPromise;
        const inputContent = $e4deb49dba5321bc$var$tContent(params.message);
        const streamResponse = this.modelsModule.generateContentStream({
            model: this.model,
            contents: this.getHistory(true).concat(inputContent),
            config: (_a = params.config) !== null && _a !== void 0 ? _a : this.config
        });
        // Resolve the internal tracking of send completion promise - `sendPromise`
        // for both success and failure response. The actual failure is still
        // propagated by the `await streamResponse`.
        this.sendPromise = streamResponse.then(()=>undefined).catch(()=>undefined);
        const response = await streamResponse;
        const result = this.processStreamResponse(response, inputContent);
        return result;
    }
    /**
     * Returns the chat history.
     *
     * @remarks
     * The history is a list of contents alternating between user and model.
     *
     * There are two types of history:
     * - The `curated history` contains only the valid turns between user and
     * model, which will be included in the subsequent requests sent to the model.
     * - The `comprehensive history` contains all turns, including invalid or
     *   empty model outputs, providing a complete record of the history.
     *
     * The history is updated after receiving the response from the model,
     * for streaming response, it means receiving the last chunk of the response.
     *
     * The `comprehensive history` is returned by default. To get the `curated
     * history`, set the `curated` parameter to `true`.
     *
     * @param curated - whether to return the curated history or the comprehensive
     *     history.
     * @return History contents alternating between user and model for the entire
     *     chat session.
     */ getHistory(curated = false) {
        const history = curated ? $e4deb49dba5321bc$var$extractCuratedHistory(this.history) : this.history;
        // Deep copy the history to avoid mutating the history outside of the
        // chat session.
        return structuredClone(history);
    }
    processStreamResponse(streamResponse, inputContent) {
        return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* processStreamResponse_1() {
            var _a, e_1, _b, _c;
            var _d, _e;
            const outputContent = [];
            try {
                for(var _f = true, streamResponse_1 = $e4deb49dba5321bc$var$__asyncValues(streamResponse), streamResponse_1_1; streamResponse_1_1 = yield $e4deb49dba5321bc$var$__await(streamResponse_1.next()), _a = streamResponse_1_1.done, !_a; _f = true){
                    _c = streamResponse_1_1.value;
                    _f = false;
                    const chunk = _c;
                    if ($e4deb49dba5321bc$var$isValidResponse(chunk)) {
                        const content = (_e = (_d = chunk.candidates) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.content;
                        if (content !== undefined) outputContent.push(content);
                    }
                    yield yield $e4deb49dba5321bc$var$__await(chunk);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (!_f && !_a && (_b = streamResponse_1.return)) yield $e4deb49dba5321bc$var$__await(_b.call(streamResponse_1));
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            this.recordHistory(inputContent, outputContent);
        });
    }
    recordHistory(userInput, modelOutput, automaticFunctionCallingHistory) {
        let outputContents = [];
        if (modelOutput.length > 0 && modelOutput.every((content)=>content.role !== undefined)) outputContents = modelOutput;
        else // Appends an empty content when model returns empty response, so that the
        // history is always alternating between user and model.
        outputContents.push({
            role: 'model',
            parts: []
        });
        if (automaticFunctionCallingHistory && automaticFunctionCallingHistory.length > 0) this.history.push(...$e4deb49dba5321bc$var$extractCuratedHistory(automaticFunctionCallingHistory));
        else this.history.push(userInput);
        this.history.push(...outputContents);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * API errors raised by the GenAI API.
 */ class $e4deb49dba5321bc$export$f2e832acab1bdd79 extends Error {
    constructor(options){
        super(options.message);
        this.name = 'ApiError';
        this.status = options.status;
        Object.setPrototypeOf(this, $e4deb49dba5321bc$export$f2e832acab1bdd79.prototype);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$createFileParametersToMldev(fromObject) {
    const toObject = {};
    const fromFile = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'file'
    ]);
    if (fromFile != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'file'
    ], fromFile);
    return toObject;
}
function $e4deb49dba5321bc$var$createFileResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteFileParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'file'
    ], $e4deb49dba5321bc$var$tFileName(fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteFileResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$getFileParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'file'
    ], $e4deb49dba5321bc$var$tFileName(fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$internalRegisterFilesParametersToMldev(fromObject) {
    const toObject = {};
    const fromUris = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uris'
    ]);
    if (fromUris != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uris'
    ], fromUris);
    return toObject;
}
function $e4deb49dba5321bc$var$listFilesConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listFilesParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listFilesConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listFilesResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromFiles = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'files'
    ]);
    if (fromFiles != null) {
        let transformedList = fromFiles;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'files'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$registerFilesResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromFiles = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'files'
    ]);
    if (fromFiles != null) {
        let transformedList = fromFiles;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'files'
        ], transformedList);
    }
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$9330ab61a7e5c11b extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists files.
         *
         * @param params - The parameters for the list request.
         * @return - A pager of files.
         *
         * @example
         * ```ts
         * const files = await ai.files.list({config: {'pageSize': 2}});
         * for await (const file of files) {
         *   console.log(file);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_FILES, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
    }
    /**
     * Uploads a file asynchronously to the Gemini API.
     * This method is not available in Vertex AI.
     * Supported upload sources:
     * - Node.js: File path (string) or Blob object.
     * - Browser: Blob object (e.g., File).
     *
     * @remarks
     * The `mimeType` can be specified in the `config` parameter. If omitted:
     *  - For file path (string) inputs, the `mimeType` will be inferred from the
     *     file extension.
     *  - For Blob object inputs, the `mimeType` will be set to the Blob's `type`
     *     property.
     * Somex eamples for file extension to mimeType mapping:
     * .txt -> text/plain
     * .json -> application/json
     * .jpg  -> image/jpeg
     * .png -> image/png
     * .mp3 -> audio/mpeg
     * .mp4 -> video/mp4
     *
     * This section can contain multiple paragraphs and code examples.
     *
     * @param params - Optional parameters specified in the
     *        `types.UploadFileParameters` interface.
     *         @see {@link types.UploadFileParameters#config} for the optional
     *         config in the parameters.
     * @return A promise that resolves to a `types.File` object.
     * @throws An error if called on a Vertex AI client.
     * @throws An error if the `mimeType` is not provided and can not be inferred,
     * the `mimeType` can be provided in the `params.config` parameter.
     * @throws An error occurs if a suitable upload location cannot be established.
     *
     * @example
     * The following code uploads a file to Gemini API.
     *
     * ```ts
     * const file = await ai.files.upload({file: 'file.txt', config: {
     *   mimeType: 'text/plain',
     * }});
     * console.log(file.name);
     * ```
     */ async upload(params) {
        if (this.apiClient.isVertexAI()) throw new Error('Vertex AI does not support uploading files. You can share files through a GCS bucket.');
        return this.apiClient.uploadFile(params.file, params.config).then((resp)=>{
            return resp;
        });
    }
    /**
     * Downloads a remotely stored file asynchronously to a location specified in
     * the `params` object. This method only works on Node environment, to
     * download files in the browser, use a browser compliant method like an <a>
     * tag.
     *
     * @param params - The parameters for the download request.
     *
     * @example
     * The following code downloads an example file named "files/mehozpxf877d" as
     * "file.txt".
     *
     * ```ts
     * await ai.files.download({file: file.name, downloadPath: 'file.txt'});
     * ```
     */ async download(params) {
        await this.apiClient.downloadFile(params);
    }
    /**
     * Registers Google Cloud Storage files for use with the API.
     * This method is only available in Node.js environments.
     */ async registerFiles(params) {
        throw new Error('registerFiles is only supported in Node.js environments.');
    }
    async _registerFiles(params) {
        return this.registerFilesInternal(params);
    }
    async listInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$listFilesParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('files', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listFilesResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$70c4c7aa1360da5a();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async createInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createFileParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('upload/v1beta/files', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$createFileResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$e6f7a7cf305d85e3();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Retrieves the file information from the service.
     *
     * @param params - The parameters for the get request
     * @return The Promise that resolves to the types.File object requested.
     *
     * @example
     * ```ts
     * const config: GetFileParameters = {
     *   name: fileName,
     * };
     * file = await ai.files.get(config);
     * console.log(file.name);
     * ```
     */ async get(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$getFileParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('files/{file}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    /**
     * Deletes a remotely stored file.
     *
     * @param params - The parameters for the delete request.
     * @return The DeleteFileResponse, the response for the delete method.
     *
     * @example
     * The following code deletes an example file named "files/mehozpxf877d".
     *
     * ```ts
     * await ai.files.delete({name: file.name});
     * ```
     */ async delete(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$deleteFileParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('files/{file}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteFileResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$a33f0b325263613a();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async registerFilesInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$internalRegisterFilesParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('files:register', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$registerFilesResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$aecf05d67e6b4829();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$blobToMldev$2(fromObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev$2(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev$2(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev$2(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partialArgs'
    ]) !== undefined) throw new Error('partialArgs parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'willContinue'
    ]) !== undefined) throw new Error('willContinue parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToVertex$1(fromObject) {
    const toObject = {};
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]) !== undefined) throw new Error('behavior parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$generationConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromModelSelectionConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]);
    if (fromModelSelectionConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelConfig'
    ], fromModelSelectionConfig);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    const fromAudioTimestamp = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]);
    if (fromAudioTimestamp != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioTimestamp'
    ], fromAudioTimestamp);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], fromResponseSchema);
    const fromRoutingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]);
    if (fromRoutingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'routingConfig'
    ], fromRoutingConfig);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], fromSpeechConfig);
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableEnhancedCivicAnswers'
    ]) !== undefined) throw new Error('enableEnhancedCivicAnswers parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToMldev$2(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]) !== undefined) throw new Error('authConfig parameter is not supported in Gemini API.');
    const fromEnableWidget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableWidget'
    ]);
    if (fromEnableWidget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableWidget'
    ], fromEnableWidget);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev$2(fromObject) {
    const toObject = {};
    const fromSearchTypes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'searchTypes'
    ]);
    if (fromSearchTypes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'searchTypes'
    ], fromSearchTypes);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'blockingConfidence'
    ]) !== undefined) throw new Error('blockingConfidence parameter is not supported in Gemini API.');
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], fromTimeRangeFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectConfigToMldev$1(fromObject, parentObject) {
    const toObject = {};
    const fromGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig'
    ], fromGenerationConfig);
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (parentObject !== undefined && fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'responseModalities'
    ], fromResponseModalities);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (parentObject !== undefined && fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (parentObject !== undefined && fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (parentObject !== undefined && fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topK'
    ], fromTopK);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (parentObject !== undefined && fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (parentObject !== undefined && fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'mediaResolution'
    ], fromMediaResolution);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (parentObject !== undefined && fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'speechConfig'
    ], $e4deb49dba5321bc$var$tLiveSpeechConfig(fromSpeechConfig));
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (parentObject !== undefined && fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (parentObject !== undefined && fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev$2($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev$2($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'setup',
            'tools'
        ], transformedList);
    }
    const fromSessionResumption = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumption'
    ]);
    if (parentObject !== undefined && fromSessionResumption != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'sessionResumption'
    ], $e4deb49dba5321bc$var$sessionResumptionConfigToMldev$1(fromSessionResumption));
    const fromInputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromInputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'inputAudioTranscription'
    ], fromInputAudioTranscription);
    const fromOutputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromOutputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'outputAudioTranscription'
    ], fromOutputAudioTranscription);
    const fromRealtimeInputConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'realtimeInputConfig'
    ]);
    if (parentObject !== undefined && fromRealtimeInputConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'realtimeInputConfig'
    ], fromRealtimeInputConfig);
    const fromContextWindowCompression = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contextWindowCompression'
    ]);
    if (parentObject !== undefined && fromContextWindowCompression != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'contextWindowCompression'
    ], fromContextWindowCompression);
    const fromProactivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'proactivity'
    ]);
    if (parentObject !== undefined && fromProactivity != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'proactivity'
    ], fromProactivity);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'explicitVadSignal'
    ]) !== undefined) throw new Error('explicitVadSignal parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig'
    ], $e4deb49dba5321bc$var$generationConfigToVertex$1(fromGenerationConfig));
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (parentObject !== undefined && fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'responseModalities'
    ], fromResponseModalities);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (parentObject !== undefined && fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (parentObject !== undefined && fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (parentObject !== undefined && fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topK'
    ], fromTopK);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (parentObject !== undefined && fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (parentObject !== undefined && fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'mediaResolution'
    ], fromMediaResolution);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (parentObject !== undefined && fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'speechConfig'
    ], $e4deb49dba5321bc$var$tLiveSpeechConfig(fromSpeechConfig));
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (parentObject !== undefined && fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (parentObject !== undefined && fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'systemInstruction'
    ], $e4deb49dba5321bc$var$tContent(fromSystemInstruction));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToVertex$1($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'setup',
            'tools'
        ], transformedList);
    }
    const fromSessionResumption = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumption'
    ]);
    if (parentObject !== undefined && fromSessionResumption != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'sessionResumption'
    ], fromSessionResumption);
    const fromInputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromInputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'inputAudioTranscription'
    ], fromInputAudioTranscription);
    const fromOutputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromOutputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'outputAudioTranscription'
    ], fromOutputAudioTranscription);
    const fromRealtimeInputConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'realtimeInputConfig'
    ]);
    if (parentObject !== undefined && fromRealtimeInputConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'realtimeInputConfig'
    ], fromRealtimeInputConfig);
    const fromContextWindowCompression = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contextWindowCompression'
    ]);
    if (parentObject !== undefined && fromContextWindowCompression != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'contextWindowCompression'
    ], fromContextWindowCompression);
    const fromProactivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'proactivity'
    ]);
    if (parentObject !== undefined && fromProactivity != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'proactivity'
    ], fromProactivity);
    const fromExplicitVadSignal = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'explicitVadSignal'
    ]);
    if (parentObject !== undefined && fromExplicitVadSignal != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'explicitVadSignal'
    ], fromExplicitVadSignal);
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setup',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$liveConnectConfigToMldev$1(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setup',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$liveConnectConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicSetConfigParametersToMldev(fromObject) {
    const toObject = {};
    const fromMusicGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'musicGenerationConfig'
    ]);
    if (fromMusicGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'musicGenerationConfig'
    ], fromMusicGenerationConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicSetWeightedPromptsParametersToMldev(fromObject) {
    const toObject = {};
    const fromWeightedPrompts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'weightedPrompts'
    ]);
    if (fromWeightedPrompts != null) {
        let transformedList = fromWeightedPrompts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'weightedPrompts'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$liveSendRealtimeInputParametersToMldev(fromObject) {
    const toObject = {};
    const fromMedia = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'media'
    ]);
    if (fromMedia != null) {
        let transformedList = $e4deb49dba5321bc$var$tBlobs(fromMedia);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$blobToMldev$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mediaChunks'
        ], transformedList);
    }
    const fromAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audio'
    ]);
    if (fromAudio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audio'
    ], $e4deb49dba5321bc$var$blobToMldev$2($e4deb49dba5321bc$var$tAudioBlob(fromAudio)));
    const fromAudioStreamEnd = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioStreamEnd'
    ]);
    if (fromAudioStreamEnd != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioStreamEnd'
    ], fromAudioStreamEnd);
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$blobToMldev$2($e4deb49dba5321bc$var$tImageBlob(fromVideo)));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromActivityStart = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityStart'
    ]);
    if (fromActivityStart != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityStart'
    ], fromActivityStart);
    const fromActivityEnd = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityEnd'
    ]);
    if (fromActivityEnd != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityEnd'
    ], fromActivityEnd);
    return toObject;
}
function $e4deb49dba5321bc$var$liveSendRealtimeInputParametersToVertex(fromObject) {
    const toObject = {};
    const fromMedia = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'media'
    ]);
    if (fromMedia != null) {
        let transformedList = $e4deb49dba5321bc$var$tBlobs(fromMedia);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mediaChunks'
        ], transformedList);
    }
    const fromAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audio'
    ]);
    if (fromAudio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audio'
    ], $e4deb49dba5321bc$var$tAudioBlob(fromAudio));
    const fromAudioStreamEnd = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioStreamEnd'
    ]);
    if (fromAudioStreamEnd != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioStreamEnd'
    ], fromAudioStreamEnd);
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$tImageBlob(fromVideo));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromActivityStart = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityStart'
    ]);
    if (fromActivityStart != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityStart'
    ], fromActivityStart);
    const fromActivityEnd = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityEnd'
    ]);
    if (fromActivityEnd != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityEnd'
    ], fromActivityEnd);
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerMessageFromVertex(fromObject) {
    const toObject = {};
    const fromSetupComplete = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'setupComplete'
    ]);
    if (fromSetupComplete != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setupComplete'
    ], fromSetupComplete);
    const fromServerContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'serverContent'
    ]);
    if (fromServerContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'serverContent'
    ], fromServerContent);
    const fromToolCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCall'
    ]);
    if (fromToolCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCall'
    ], fromToolCall);
    const fromToolCallCancellation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCallCancellation'
    ]);
    if (fromToolCallCancellation != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCallCancellation'
    ], fromToolCallCancellation);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], $e4deb49dba5321bc$var$usageMetadataFromVertex(fromUsageMetadata));
    const fromGoAway = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'goAway'
    ]);
    if (fromGoAway != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'goAway'
    ], fromGoAway);
    const fromSessionResumptionUpdate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumptionUpdate'
    ]);
    if (fromSessionResumptionUpdate != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sessionResumptionUpdate'
    ], fromSessionResumptionUpdate);
    const fromVoiceActivityDetectionSignal = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceActivityDetectionSignal'
    ]);
    if (fromVoiceActivityDetectionSignal != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceActivityDetectionSignal'
    ], fromVoiceActivityDetectionSignal);
    const fromVoiceActivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceActivity'
    ]);
    if (fromVoiceActivity != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceActivity'
    ], $e4deb49dba5321bc$var$voiceActivityFromVertex(fromVoiceActivity));
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev$2(fromObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev$2(fromFileData));
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev$2(fromFunctionCall));
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev$2(fromInlineData));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$sessionResumptionConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromHandle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'handle'
    ]);
    if (fromHandle != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'handle'
    ], fromHandle);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'transparent'
    ]) !== undefined) throw new Error('transparent parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev$2(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    const fromFileSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]);
    if (fromFileSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileSearch'
    ], fromFileSearch);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev$2(fromGoogleSearch));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToMldev$2(fromGoogleMaps));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    const fromMcpServers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]);
    if (fromMcpServers != null) {
        let transformedList = fromMcpServers;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mcpServers'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$toolToVertex$1(fromObject) {
    const toObject = {};
    const fromRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]);
    if (fromRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrieval'
    ], fromRetrieval);
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]) !== undefined) throw new Error('fileSearch parameter is not supported in Vertex AI.');
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], fromGoogleSearch);
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    const fromEnterpriseWebSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]);
    if (fromEnterpriseWebSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enterpriseWebSearch'
    ], fromEnterpriseWebSearch);
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToVertex$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], fromGoogleMaps);
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]) !== undefined) throw new Error('mcpServers parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$usageMetadataFromVertex(fromObject) {
    const toObject = {};
    const fromPromptTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptTokenCount'
    ]);
    if (fromPromptTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptTokenCount'
    ], fromPromptTokenCount);
    const fromCachedContentTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContentTokenCount'
    ]);
    if (fromCachedContentTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'cachedContentTokenCount'
    ], fromCachedContentTokenCount);
    const fromResponseTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidatesTokenCount'
    ]);
    if (fromResponseTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseTokenCount'
    ], fromResponseTokenCount);
    const fromToolUsePromptTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolUsePromptTokenCount'
    ]);
    if (fromToolUsePromptTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolUsePromptTokenCount'
    ], fromToolUsePromptTokenCount);
    const fromThoughtsTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtsTokenCount'
    ]);
    if (fromThoughtsTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtsTokenCount'
    ], fromThoughtsTokenCount);
    const fromTotalTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'totalTokenCount'
    ]);
    if (fromTotalTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'totalTokenCount'
    ], fromTotalTokenCount);
    const fromPromptTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptTokensDetails'
    ]);
    if (fromPromptTokensDetails != null) {
        let transformedList = fromPromptTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'promptTokensDetails'
        ], transformedList);
    }
    const fromCacheTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cacheTokensDetails'
    ]);
    if (fromCacheTokensDetails != null) {
        let transformedList = fromCacheTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'cacheTokensDetails'
        ], transformedList);
    }
    const fromResponseTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidatesTokensDetails'
    ]);
    if (fromResponseTokensDetails != null) {
        let transformedList = fromResponseTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'responseTokensDetails'
        ], transformedList);
    }
    const fromToolUsePromptTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolUsePromptTokensDetails'
    ]);
    if (fromToolUsePromptTokensDetails != null) {
        let transformedList = fromToolUsePromptTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'toolUsePromptTokensDetails'
        ], transformedList);
    }
    const fromTrafficType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'trafficType'
    ]);
    if (fromTrafficType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'trafficType'
    ], fromTrafficType);
    return toObject;
}
function $e4deb49dba5321bc$var$voiceActivityFromVertex(fromObject) {
    const toObject = {};
    const fromVoiceActivityType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'type'
    ]);
    if (fromVoiceActivityType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceActivityType'
    ], fromVoiceActivityType);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$blobToMldev$1(fromObject, _rootObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$candidateFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'content'
    ]);
    if (fromContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'content'
    ], fromContent);
    const fromCitationMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationMetadata'
    ]);
    if (fromCitationMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'citationMetadata'
    ], $e4deb49dba5321bc$var$citationMetadataFromMldev(fromCitationMetadata));
    const fromTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tokenCount'
    ]);
    if (fromTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    const fromFinishReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'finishReason'
    ]);
    if (fromFinishReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'finishReason'
    ], fromFinishReason);
    const fromGroundingMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromAvgLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'avgLogprobs'
    ]);
    if (fromAvgLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'avgLogprobs'
    ], fromAvgLogprobs);
    const fromIndex = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'index'
    ]);
    if (fromIndex != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'index'
    ], fromIndex);
    const fromLogprobsResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobsResult'
    ]);
    if (fromLogprobsResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobsResult'
    ], fromLogprobsResult);
    const fromSafetyRatings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyRatings'
    ]);
    if (fromSafetyRatings != null) {
        let transformedList = fromSafetyRatings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'safetyRatings'
        ], transformedList);
    }
    const fromUrlContextMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContextMetadata'
    ]);
    if (fromUrlContextMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContextMetadata'
    ], fromUrlContextMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$citationMetadataFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromCitations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationSources'
    ]);
    if (fromCitations != null) {
        let transformedList = fromCitations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'citations'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$computeTokensParametersToVertex(apiClient, fromObject, _rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$computeTokensResponseFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromTokensInfo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tokensInfo'
    ]);
    if (fromTokensInfo != null) {
        let transformedList = fromTokensInfo;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'tokensInfo'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$contentEmbeddingFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromValues = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'values'
    ]);
    if (fromValues != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'values'
    ], fromValues);
    const fromStatistics = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'statistics'
    ]);
    if (fromStatistics != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'statistics'
    ], $e4deb49dba5321bc$var$contentEmbeddingStatisticsFromVertex(fromStatistics));
    return toObject;
}
function $e4deb49dba5321bc$var$contentEmbeddingStatisticsFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromTruncated = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'truncated'
    ]);
    if (fromTruncated != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'truncated'
    ], fromTruncated);
    const fromTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'token_count'
    ]);
    if (fromTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev$1(fromObject, rootObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$controlReferenceConfigToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromControlType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'controlType'
    ]);
    if (fromControlType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'controlType'
    ], fromControlType);
    const fromEnableControlImageComputation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableControlImageComputation'
    ]);
    if (fromEnableControlImageComputation != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computeControl'
    ], fromEnableControlImageComputation);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensConfigToMldev(fromObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]) !== undefined) throw new Error('systemInstruction parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]) !== undefined) throw new Error('tools parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]) !== undefined) throw new Error('generationConfig parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensConfigToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$tContent(fromSystemInstruction));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = fromTools;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'generationConfig'
    ], $e4deb49dba5321bc$var$generationConfigToVertex(fromGenerationConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensParametersToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$countTokensConfigToMldev(fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$countTokensConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensResponseFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromTotalTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'totalTokens'
    ]);
    if (fromTotalTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'totalTokens'
    ], fromTotalTokens);
    const fromCachedContentTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContentTokenCount'
    ]);
    if (fromCachedContentTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'cachedContentTokenCount'
    ], fromCachedContentTokenCount);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensResponseFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromTotalTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'totalTokens'
    ]);
    if (fromTotalTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'totalTokens'
    ], fromTotalTokens);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteModelParametersToMldev(apiClient, fromObject, _rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteModelParametersToVertex(apiClient, fromObject, _rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteModelResponseFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteModelResponseFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$editImageConfigToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromNegativePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromGuidanceScale = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'guidanceScale'
    ]);
    if (parentObject !== undefined && fromGuidanceScale != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'guidanceScale'
    ], fromGuidanceScale);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeSafetyAttributes'
    ]);
    if (parentObject !== undefined && fromIncludeSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeSafetyAttributes'
    ], fromIncludeSafetyAttributes);
    const fromIncludeRaiReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromLanguage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'language'
    ]);
    if (parentObject !== undefined && fromLanguage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'language'
    ], fromLanguage);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromAddWatermark = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'addWatermark'
    ]);
    if (parentObject !== undefined && fromAddWatermark != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'addWatermark'
    ], fromAddWatermark);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    const fromEditMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'editMode'
    ]);
    if (parentObject !== undefined && fromEditMode != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'editMode'
    ], fromEditMode);
    const fromBaseSteps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseSteps'
    ]);
    if (parentObject !== undefined && fromBaseSteps != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'editConfig',
        'baseSteps'
    ], fromBaseSteps);
    return toObject;
}
function $e4deb49dba5321bc$var$editImageParametersInternalToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromReferenceImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceImages'
    ]);
    if (fromReferenceImages != null) {
        let transformedList = fromReferenceImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$referenceImageAPIInternalToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'instances[0]',
            'referenceImages'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$editImageConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$editImageResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentConfigToMldev(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromTaskType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'taskType'
    ]);
    if (parentObject !== undefined && fromTaskType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'taskType'
    ], fromTaskType);
    const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'title'
    ]);
    if (parentObject !== undefined && fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'title'
    ], fromTitle);
    const fromOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputDimensionality'
    ]);
    if (parentObject !== undefined && fromOutputDimensionality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'outputDimensionality'
    ], fromOutputDimensionality);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]) !== undefined) throw new Error('mimeType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'autoTruncate'
    ]) !== undefined) throw new Error('autoTruncate parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentConfigToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    let discriminatorTaskType = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorTaskType === undefined) discriminatorTaskType = 'PREDICT';
    if (discriminatorTaskType === 'PREDICT') {
        const fromTaskType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'taskType'
        ]);
        if (parentObject !== undefined && fromTaskType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[]',
            'task_type'
        ], fromTaskType);
    } else if (discriminatorTaskType === 'EMBED_CONTENT') {
        const fromTaskType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'taskType'
        ]);
        if (parentObject !== undefined && fromTaskType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'taskType'
        ], fromTaskType);
    }
    let discriminatorTitle = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorTitle === undefined) discriminatorTitle = 'PREDICT';
    if (discriminatorTitle === 'PREDICT') {
        const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'title'
        ]);
        if (parentObject !== undefined && fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[]',
            'title'
        ], fromTitle);
    } else if (discriminatorTitle === 'EMBED_CONTENT') {
        const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'title'
        ]);
        if (parentObject !== undefined && fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'title'
        ], fromTitle);
    }
    let discriminatorOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorOutputDimensionality === undefined) discriminatorOutputDimensionality = 'PREDICT';
    if (discriminatorOutputDimensionality === 'PREDICT') {
        const fromOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'outputDimensionality'
        ]);
        if (parentObject !== undefined && fromOutputDimensionality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'parameters',
            'outputDimensionality'
        ], fromOutputDimensionality);
    } else if (discriminatorOutputDimensionality === 'EMBED_CONTENT') {
        const fromOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'outputDimensionality'
        ]);
        if (parentObject !== undefined && fromOutputDimensionality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'outputDimensionality'
        ], fromOutputDimensionality);
    }
    let discriminatorMimeType = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorMimeType === undefined) discriminatorMimeType = 'PREDICT';
    if (discriminatorMimeType === 'PREDICT') {
        const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'mimeType'
        ]);
        if (parentObject !== undefined && fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[]',
            'mimeType'
        ], fromMimeType);
    }
    let discriminatorAutoTruncate = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorAutoTruncate === undefined) discriminatorAutoTruncate = 'PREDICT';
    if (discriminatorAutoTruncate === 'PREDICT') {
        const fromAutoTruncate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'autoTruncate'
        ]);
        if (parentObject !== undefined && fromAutoTruncate != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'parameters',
            'autoTruncate'
        ], fromAutoTruncate);
    } else if (discriminatorAutoTruncate === 'EMBED_CONTENT') {
        const fromAutoTruncate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'autoTruncate'
        ]);
        if (parentObject !== undefined && fromAutoTruncate != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'autoTruncate'
        ], fromAutoTruncate);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentParametersPrivateToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContentsForEmbed(apiClient, fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'requests[]',
            'content'
        ], transformedList);
    }
    const fromContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'content'
    ]);
    if (fromContent != null) $e4deb49dba5321bc$var$contentToMldev$1($e4deb49dba5321bc$var$tContent(fromContent));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$embedContentConfigToMldev(fromConfig, toObject);
    const fromModelForEmbedContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModelForEmbedContent !== undefined) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'requests[]',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModelForEmbedContent));
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentParametersPrivateToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    let discriminatorContents = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorContents === undefined) discriminatorContents = 'PREDICT';
    if (discriminatorContents === 'PREDICT') {
        const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'contents'
        ]);
        if (fromContents != null) {
            let transformedList = $e4deb49dba5321bc$var$tContentsForEmbed(apiClient, fromContents);
            if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
                return item;
            });
            $e4deb49dba5321bc$var$setValueByPath(toObject, [
                'instances[]',
                'content'
            ], transformedList);
        }
    }
    let discriminatorContent = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorContent === undefined) discriminatorContent = 'PREDICT';
    if (discriminatorContent === 'EMBED_CONTENT') {
        const fromContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'content'
        ]);
        if (fromContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'content'
        ], $e4deb49dba5321bc$var$tContent(fromContent));
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$embedContentConfigToVertex(fromConfig, toObject, rootObject);
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentResponseFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromEmbeddings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'embeddings'
    ]);
    if (fromEmbeddings != null) {
        let transformedList = fromEmbeddings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'embeddings'
        ], transformedList);
    }
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromEmbeddings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions[]',
        'embeddings'
    ]);
    if (fromEmbeddings != null) {
        let transformedList = fromEmbeddings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentEmbeddingFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'embeddings'
        ], transformedList);
    }
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    if (rootObject && $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]) === 'EMBED_CONTENT') {
        const embedding = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'embedding'
        ]);
        const usageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'usageMetadata'
        ]);
        const truncated = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'truncated'
        ]);
        if (embedding) {
            const stats = {};
            if (usageMetadata && usageMetadata['promptTokenCount']) stats.tokenCount = usageMetadata['promptTokenCount'];
            if (truncated) stats.truncated = truncated;
            embedding.statistics = stats;
            $e4deb49dba5321bc$var$setValueByPath(toObject, [
                'embeddings'
            ], [
                embedding
            ]);
        }
    }
    return toObject;
}
function $e4deb49dba5321bc$var$endpointFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endpoint'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDeployedModelId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'deployedModelId'
    ]);
    if (fromDeployedModelId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'deployedModelId'
    ], fromDeployedModelId);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev$1(fromObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev$1(fromObject, _rootObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partialArgs'
    ]) !== undefined) throw new Error('partialArgs parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'willContinue'
    ]) !== undefined) throw new Error('willContinue parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallingConfigToMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromAllowedFunctionNames = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'streamFunctionCallArguments'
    ]) !== undefined) throw new Error('streamFunctionCallArguments parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]) !== undefined) throw new Error('behavior parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentConfigToMldev(apiClient, fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev$1($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], $e4deb49dba5321bc$var$tSchema(fromResponseSchema));
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]) !== undefined) throw new Error('routingConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]) !== undefined) throw new Error('modelSelectionConfig parameter is not supported in Gemini API.');
    const fromSafetySettings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetySettings'
    ]);
    if (parentObject !== undefined && fromSafetySettings != null) {
        let transformedList = fromSafetySettings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$safetySettingToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'safetySettings'
        ], transformedList);
    }
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev$1($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToMldev(fromToolConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    const fromCachedContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContent'
    ]);
    if (parentObject !== undefined && fromCachedContent != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'cachedContent'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromCachedContent));
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], $e4deb49dba5321bc$var$tSpeechConfig(fromSpeechConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]) !== undefined) throw new Error('audioTimestamp parameter is not supported in Gemini API.');
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageConfig'
    ]);
    if (fromImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageConfig'
    ], $e4deb49dba5321bc$var$imageConfigToMldev(fromImageConfig));
    const fromEnableEnhancedCivicAnswers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableEnhancedCivicAnswers'
    ]);
    if (fromEnableEnhancedCivicAnswers != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableEnhancedCivicAnswers'
    ], fromEnableEnhancedCivicAnswers);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelArmorConfig'
    ]) !== undefined) throw new Error('modelArmorConfig parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentConfigToVertex(apiClient, fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$tContent(fromSystemInstruction));
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], $e4deb49dba5321bc$var$tSchema(fromResponseSchema));
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    const fromRoutingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]);
    if (fromRoutingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'routingConfig'
    ], fromRoutingConfig);
    const fromModelSelectionConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]);
    if (fromModelSelectionConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelConfig'
    ], fromModelSelectionConfig);
    const fromSafetySettings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetySettings'
    ]);
    if (parentObject !== undefined && fromSafetySettings != null) {
        let transformedList = fromSafetySettings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'safetySettings'
        ], transformedList);
    }
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToVertex($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], fromToolConfig);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    const fromCachedContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContent'
    ]);
    if (parentObject !== undefined && fromCachedContent != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'cachedContent'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromCachedContent));
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], $e4deb49dba5321bc$var$tSpeechConfig(fromSpeechConfig));
    const fromAudioTimestamp = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]);
    if (fromAudioTimestamp != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioTimestamp'
    ], fromAudioTimestamp);
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageConfig'
    ]);
    if (fromImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageConfig'
    ], $e4deb49dba5321bc$var$imageConfigToVertex(fromImageConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableEnhancedCivicAnswers'
    ]) !== undefined) throw new Error('enableEnhancedCivicAnswers parameter is not supported in Vertex AI.');
    const fromModelArmorConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelArmorConfig'
    ]);
    if (parentObject !== undefined && fromModelArmorConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'modelArmorConfig'
    ], fromModelArmorConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentParametersToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'generationConfig'
    ], $e4deb49dba5321bc$var$generateContentConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'generationConfig'
    ], $e4deb49dba5321bc$var$generateContentConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentResponseFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromCandidates = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidates'
    ]);
    if (fromCandidates != null) {
        let transformedList = fromCandidates;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$candidateFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'candidates'
        ], transformedList);
    }
    const fromModelVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelVersion'
    ]);
    if (fromModelVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelVersion'
    ], fromModelVersion);
    const fromPromptFeedback = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptFeedback'
    ]);
    if (fromPromptFeedback != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptFeedback'
    ], fromPromptFeedback);
    const fromResponseId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseId'
    ]);
    if (fromResponseId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseId'
    ], fromResponseId);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentResponseFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromCandidates = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidates'
    ]);
    if (fromCandidates != null) {
        let transformedList = fromCandidates;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'candidates'
        ], transformedList);
    }
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromModelVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelVersion'
    ]);
    if (fromModelVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelVersion'
    ], fromModelVersion);
    const fromPromptFeedback = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptFeedback'
    ]);
    if (fromPromptFeedback != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptFeedback'
    ], fromPromptFeedback);
    const fromResponseId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseId'
    ]);
    if (fromResponseId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseId'
    ], fromResponseId);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesConfigToMldev(fromObject, parentObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]) !== undefined) throw new Error('outputGcsUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]) !== undefined) throw new Error('negativePrompt parameter is not supported in Gemini API.');
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromGuidanceScale = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'guidanceScale'
    ]);
    if (parentObject !== undefined && fromGuidanceScale != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'guidanceScale'
    ], fromGuidanceScale);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]) !== undefined) throw new Error('seed parameter is not supported in Gemini API.');
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeSafetyAttributes'
    ]);
    if (parentObject !== undefined && fromIncludeSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeSafetyAttributes'
    ], fromIncludeSafetyAttributes);
    const fromIncludeRaiReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromLanguage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'language'
    ]);
    if (parentObject !== undefined && fromLanguage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'language'
    ], fromLanguage);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'addWatermark'
    ]) !== undefined) throw new Error('addWatermark parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    const fromImageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageSize'
    ]);
    if (parentObject !== undefined && fromImageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleImageSize'
    ], fromImageSize);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]) !== undefined) throw new Error('enhancePrompt parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesConfigToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromNegativePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromGuidanceScale = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'guidanceScale'
    ]);
    if (parentObject !== undefined && fromGuidanceScale != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'guidanceScale'
    ], fromGuidanceScale);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeSafetyAttributes'
    ]);
    if (parentObject !== undefined && fromIncludeSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeSafetyAttributes'
    ], fromIncludeSafetyAttributes);
    const fromIncludeRaiReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromLanguage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'language'
    ]);
    if (parentObject !== undefined && fromLanguage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'language'
    ], fromLanguage);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromAddWatermark = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'addWatermark'
    ]);
    if (parentObject !== undefined && fromAddWatermark != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'addWatermark'
    ], fromAddWatermark);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    const fromImageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageSize'
    ]);
    if (parentObject !== undefined && fromImageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleImageSize'
    ], fromImageSize);
    const fromEnhancePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesParametersToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$generateImagesConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$generateImagesConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesResponseFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    const fromPositivePromptSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'positivePromptSafetyAttributes'
    ]);
    if (fromPositivePromptSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'positivePromptSafetyAttributes'
    ], $e4deb49dba5321bc$var$safetyAttributesFromMldev(fromPositivePromptSafetyAttributes));
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    const fromPositivePromptSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'positivePromptSafetyAttributes'
    ]);
    if (fromPositivePromptSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'positivePromptSafetyAttributes'
    ], $e4deb49dba5321bc$var$safetyAttributesFromVertex(fromPositivePromptSafetyAttributes));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosConfigToMldev(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromNumberOfVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfVideos'
    ]);
    if (parentObject !== undefined && fromNumberOfVideos != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfVideos);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]) !== undefined) throw new Error('outputGcsUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]) !== undefined) throw new Error('fps parameter is not supported in Gemini API.');
    const fromDurationSeconds = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'durationSeconds'
    ]);
    if (parentObject !== undefined && fromDurationSeconds != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'durationSeconds'
    ], fromDurationSeconds);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]) !== undefined) throw new Error('seed parameter is not supported in Gemini API.');
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'resolution'
    ]);
    if (parentObject !== undefined && fromResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'resolution'
    ], fromResolution);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pubsubTopic'
    ]) !== undefined) throw new Error('pubsubTopic parameter is not supported in Gemini API.');
    const fromNegativePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromEnhancePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generateAudio'
    ]) !== undefined) throw new Error('generateAudio parameter is not supported in Gemini API.');
    const fromLastFrame = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'lastFrame'
    ]);
    if (parentObject !== undefined && fromLastFrame != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'lastFrame'
    ], $e4deb49dba5321bc$var$imageToMldev(fromLastFrame));
    const fromReferenceImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceImages'
    ]);
    if (parentObject !== undefined && fromReferenceImages != null) {
        let transformedList = fromReferenceImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$videoGenerationReferenceImageToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[0]',
            'referenceImages'
        ], transformedList);
    }
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mask'
    ]) !== undefined) throw new Error('mask parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'compressionQuality'
    ]) !== undefined) throw new Error('compressionQuality parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosConfigToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromNumberOfVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfVideos'
    ]);
    if (parentObject !== undefined && fromNumberOfVideos != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfVideos);
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (parentObject !== undefined && fromFps != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'fps'
    ], fromFps);
    const fromDurationSeconds = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'durationSeconds'
    ]);
    if (parentObject !== undefined && fromDurationSeconds != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'durationSeconds'
    ], fromDurationSeconds);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'resolution'
    ]);
    if (parentObject !== undefined && fromResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'resolution'
    ], fromResolution);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromPubsubTopic = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pubsubTopic'
    ]);
    if (parentObject !== undefined && fromPubsubTopic != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'pubsubTopic'
    ], fromPubsubTopic);
    const fromNegativePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromEnhancePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    const fromGenerateAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generateAudio'
    ]);
    if (parentObject !== undefined && fromGenerateAudio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'generateAudio'
    ], fromGenerateAudio);
    const fromLastFrame = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'lastFrame'
    ]);
    if (parentObject !== undefined && fromLastFrame != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'lastFrame'
    ], $e4deb49dba5321bc$var$imageToVertex(fromLastFrame));
    const fromReferenceImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceImages'
    ]);
    if (parentObject !== undefined && fromReferenceImages != null) {
        let transformedList = fromReferenceImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$videoGenerationReferenceImageToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[0]',
            'referenceImages'
        ], transformedList);
    }
    const fromMask = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mask'
    ]);
    if (parentObject !== undefined && fromMask != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'mask'
    ], $e4deb49dba5321bc$var$videoGenerationMaskToVertex(fromMask));
    const fromCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'compressionQuality'
    ]);
    if (parentObject !== undefined && fromCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'compressionQuality'
    ], fromCompressionQuality);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosOperationFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response',
        'generateVideoResponse'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateVideosResponseFromMldev(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosOperationFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateVideosResponseFromVertex(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosParametersToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToMldev(fromImage));
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'video'
    ], $e4deb49dba5321bc$var$videoToMldev(fromVideo));
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$generateVideosSourceToMldev(fromSource, toObject);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$generateVideosConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'video'
    ], $e4deb49dba5321bc$var$videoToVertex(fromVideo));
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$generateVideosSourceToVertex(fromSource, toObject);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$generateVideosConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosResponseFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromGeneratedVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generatedSamples'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedVideoFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromGeneratedVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videos'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedVideoFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosSourceToMldev(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (parentObject !== undefined && fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (parentObject !== undefined && fromImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToMldev(fromImage));
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (parentObject !== undefined && fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'video'
    ], $e4deb49dba5321bc$var$videoToMldev(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosSourceToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (parentObject !== undefined && fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (parentObject !== undefined && fromImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (parentObject !== undefined && fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'video'
    ], $e4deb49dba5321bc$var$videoToVertex(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generatedImageFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageFromMldev(fromImage));
    const fromRaiFilteredReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiFilteredReason'
    ]);
    if (fromRaiFilteredReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiFilteredReason'
    ], fromRaiFilteredReason);
    const fromSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'safetyAttributes'
    ], $e4deb49dba5321bc$var$safetyAttributesFromMldev(fromSafetyAttributes));
    return toObject;
}
function $e4deb49dba5321bc$var$generatedImageFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageFromVertex(fromImage));
    const fromRaiFilteredReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiFilteredReason'
    ]);
    if (fromRaiFilteredReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiFilteredReason'
    ], fromRaiFilteredReason);
    const fromSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'safetyAttributes'
    ], $e4deb49dba5321bc$var$safetyAttributesFromVertex(fromSafetyAttributes));
    const fromEnhancedPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromEnhancedPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enhancedPrompt'
    ], fromEnhancedPrompt);
    return toObject;
}
function $e4deb49dba5321bc$var$generatedImageMaskFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromMask = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromMask != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mask'
    ], $e4deb49dba5321bc$var$imageFromVertex(fromMask));
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) {
        let transformedList = fromLabels;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'labels'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$generatedVideoFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$videoFromMldev(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generatedVideoFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$videoFromVertex(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generationConfigToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromModelSelectionConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]);
    if (fromModelSelectionConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelConfig'
    ], fromModelSelectionConfig);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    const fromAudioTimestamp = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]);
    if (fromAudioTimestamp != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioTimestamp'
    ], fromAudioTimestamp);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], fromResponseSchema);
    const fromRoutingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]);
    if (fromRoutingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'routingConfig'
    ], fromRoutingConfig);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], fromSpeechConfig);
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableEnhancedCivicAnswers'
    ]) !== undefined) throw new Error('enableEnhancedCivicAnswers parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$getModelParametersToMldev(apiClient, fromObject, _rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    return toObject;
}
function $e4deb49dba5321bc$var$getModelParametersToVertex(apiClient, fromObject, _rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToMldev$1(fromObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]) !== undefined) throw new Error('authConfig parameter is not supported in Gemini API.');
    const fromEnableWidget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableWidget'
    ]);
    if (fromEnableWidget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableWidget'
    ], fromEnableWidget);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev$1(fromObject, _rootObject) {
    const toObject = {};
    const fromSearchTypes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'searchTypes'
    ]);
    if (fromSearchTypes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'searchTypes'
    ], fromSearchTypes);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'blockingConfidence'
    ]) !== undefined) throw new Error('blockingConfidence parameter is not supported in Gemini API.');
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], fromTimeRangeFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$imageConfigToMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'aspectRatio'
    ], fromAspectRatio);
    const fromImageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageSize'
    ]);
    if (fromImageSize != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageSize'
    ], fromImageSize);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]) !== undefined) throw new Error('personGeneration parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prominentPeople'
    ]) !== undefined) throw new Error('prominentPeople parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]) !== undefined) throw new Error('outputMimeType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]) !== undefined) throw new Error('outputCompressionQuality parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$imageConfigToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'aspectRatio'
    ], fromAspectRatio);
    const fromImageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageSize'
    ]);
    if (fromImageSize != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageSize'
    ], fromImageSize);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'personGeneration'
    ], fromPersonGeneration);
    const fromProminentPeople = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prominentPeople'
    ]);
    if (fromProminentPeople != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prominentPeople'
    ], fromProminentPeople);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageOutputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageOutputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    return toObject;
}
function $e4deb49dba5321bc$var$imageFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromImageBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromImageBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageBytes'
    ], $e4deb49dba5321bc$var$tBytes(fromImageBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$imageFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromImageBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromImageBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageBytes'
    ], $e4deb49dba5321bc$var$tBytes(fromImageBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$imageToMldev(fromObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]) !== undefined) throw new Error('gcsUri parameter is not supported in Gemini API.');
    const fromImageBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageBytes'
    ]);
    if (fromImageBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bytesBase64Encoded'
    ], $e4deb49dba5321bc$var$tBytes(fromImageBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$imageToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromImageBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageBytes'
    ]);
    if (fromImageBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bytesBase64Encoded'
    ], $e4deb49dba5321bc$var$tBytes(fromImageBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsConfigToMldev(apiClient, fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    const fromQueryBase = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'queryBase'
    ]);
    if (parentObject !== undefined && fromQueryBase != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_url',
        'models_url'
    ], $e4deb49dba5321bc$var$tModelsUrl(apiClient, fromQueryBase));
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsConfigToVertex(apiClient, fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    const fromQueryBase = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'queryBase'
    ]);
    if (parentObject !== undefined && fromQueryBase != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_url',
        'models_url'
    ], $e4deb49dba5321bc$var$tModelsUrl(apiClient, fromQueryBase));
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsParametersToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listModelsConfigToMldev(apiClient, fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listModelsConfigToVertex(apiClient, fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsResponseFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromModels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromModels != null) {
        let transformedList = $e4deb49dba5321bc$var$tExtractModels(fromModels);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modelFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'models'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromModels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromModels != null) {
        let transformedList = $e4deb49dba5321bc$var$tExtractModels(fromModels);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modelFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'models'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$maskReferenceConfigToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromMaskMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskMode'
    ]);
    if (fromMaskMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maskMode'
    ], fromMaskMode);
    const fromSegmentationClasses = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'segmentationClasses'
    ]);
    if (fromSegmentationClasses != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maskClasses'
    ], fromSegmentationClasses);
    const fromMaskDilation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskDilation'
    ]);
    if (fromMaskDilation != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dilation'
    ], fromMaskDilation);
    return toObject;
}
function $e4deb49dba5321bc$var$modelFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'version'
    ]);
    if (fromVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'version'
    ], fromVersion);
    const fromTunedModelInfo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromTunedModelInfo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModelInfo'
    ], $e4deb49dba5321bc$var$tunedModelInfoFromMldev(fromTunedModelInfo));
    const fromInputTokenLimit = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputTokenLimit'
    ]);
    if (fromInputTokenLimit != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inputTokenLimit'
    ], fromInputTokenLimit);
    const fromOutputTokenLimit = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputTokenLimit'
    ]);
    if (fromOutputTokenLimit != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'outputTokenLimit'
    ], fromOutputTokenLimit);
    const fromSupportedActions = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'supportedGenerationMethods'
    ]);
    if (fromSupportedActions != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'supportedActions'
    ], fromSupportedActions);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromMaxTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxTemperature'
    ]);
    if (fromMaxTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxTemperature'
    ], fromMaxTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromThinking = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinking'
    ]);
    if (fromThinking != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinking'
    ], fromThinking);
    return toObject;
}
function $e4deb49dba5321bc$var$modelFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'versionId'
    ]);
    if (fromVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'version'
    ], fromVersion);
    const fromEndpoints = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'deployedModels'
    ]);
    if (fromEndpoints != null) {
        let transformedList = fromEndpoints;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$endpointFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'endpoints'
        ], transformedList);
    }
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'labels'
    ], fromLabels);
    const fromTunedModelInfo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromTunedModelInfo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModelInfo'
    ], $e4deb49dba5321bc$var$tunedModelInfoFromVertex(fromTunedModelInfo));
    const fromDefaultCheckpointId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'defaultCheckpointId'
    ]);
    if (fromDefaultCheckpointId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'defaultCheckpointId'
    ], fromDefaultCheckpointId);
    const fromCheckpoints = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'checkpoints'
    ]);
    if (fromCheckpoints != null) {
        let transformedList = fromCheckpoints;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'checkpoints'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev$1(fromObject, rootObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev$1(fromFileData));
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev$1(fromFunctionCall));
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev$1(fromInlineData));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$productImageToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromProductImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'productImage'
    ]);
    if (fromProductImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromProductImage));
    return toObject;
}
function $e4deb49dba5321bc$var$recontextImageConfigToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromBaseSteps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseSteps'
    ]);
    if (parentObject !== undefined && fromBaseSteps != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'baseSteps'
    ], fromBaseSteps);
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromAddWatermark = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'addWatermark'
    ]);
    if (parentObject !== undefined && fromAddWatermark != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'addWatermark'
    ], fromAddWatermark);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromEnhancePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    return toObject;
}
function $e4deb49dba5321bc$var$recontextImageParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$recontextImageSourceToVertex(fromSource, toObject);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$recontextImageConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$recontextImageResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$recontextImageSourceToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (parentObject !== undefined && fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromPersonImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personImage'
    ]);
    if (parentObject !== undefined && fromPersonImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'personImage',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromPersonImage));
    const fromProductImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'productImages'
    ]);
    if (parentObject !== undefined && fromProductImages != null) {
        let transformedList = fromProductImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$productImageToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[0]',
            'productImages'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$referenceImageAPIInternalToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromReferenceImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceImage'
    ]);
    if (fromReferenceImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceImage'
    ], $e4deb49dba5321bc$var$imageToVertex(fromReferenceImage));
    const fromReferenceId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceId'
    ]);
    if (fromReferenceId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceId'
    ], fromReferenceId);
    const fromReferenceType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceType'
    ]);
    if (fromReferenceType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceType'
    ], fromReferenceType);
    const fromMaskImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskImageConfig'
    ]);
    if (fromMaskImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maskImageConfig'
    ], $e4deb49dba5321bc$var$maskReferenceConfigToVertex(fromMaskImageConfig));
    const fromControlImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'controlImageConfig'
    ]);
    if (fromControlImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'controlImageConfig'
    ], $e4deb49dba5321bc$var$controlReferenceConfigToVertex(fromControlImageConfig));
    const fromStyleImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'styleImageConfig'
    ]);
    if (fromStyleImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'styleImageConfig'
    ], fromStyleImageConfig);
    const fromSubjectImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'subjectImageConfig'
    ]);
    if (fromSubjectImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'subjectImageConfig'
    ], fromSubjectImageConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$safetyAttributesFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromCategories = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyAttributes',
        'categories'
    ]);
    if (fromCategories != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'categories'
    ], fromCategories);
    const fromScores = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyAttributes',
        'scores'
    ]);
    if (fromScores != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'scores'
    ], fromScores);
    const fromContentType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contentType'
    ]);
    if (fromContentType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'contentType'
    ], fromContentType);
    return toObject;
}
function $e4deb49dba5321bc$var$safetyAttributesFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromCategories = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyAttributes',
        'categories'
    ]);
    if (fromCategories != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'categories'
    ], fromCategories);
    const fromScores = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyAttributes',
        'scores'
    ]);
    if (fromScores != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'scores'
    ], fromScores);
    const fromContentType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contentType'
    ]);
    if (fromContentType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'contentType'
    ], fromContentType);
    return toObject;
}
function $e4deb49dba5321bc$var$safetySettingToMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromCategory = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'category'
    ]);
    if (fromCategory != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'category'
    ], fromCategory);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'method'
    ]) !== undefined) throw new Error('method parameter is not supported in Gemini API.');
    const fromThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'threshold'
    ]);
    if (fromThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'threshold'
    ], fromThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$scribbleImageToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    return toObject;
}
function $e4deb49dba5321bc$var$segmentImageConfigToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (parentObject !== undefined && fromMode != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'mode'
    ], fromMode);
    const fromMaxPredictions = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxPredictions'
    ]);
    if (parentObject !== undefined && fromMaxPredictions != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'maxPredictions'
    ], fromMaxPredictions);
    const fromConfidenceThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'confidenceThreshold'
    ]);
    if (parentObject !== undefined && fromConfidenceThreshold != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'confidenceThreshold'
    ], fromConfidenceThreshold);
    const fromMaskDilation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskDilation'
    ]);
    if (parentObject !== undefined && fromMaskDilation != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'maskDilation'
    ], fromMaskDilation);
    const fromBinaryColorThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'binaryColorThreshold'
    ]);
    if (parentObject !== undefined && fromBinaryColorThreshold != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'binaryColorThreshold'
    ], fromBinaryColorThreshold);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    return toObject;
}
function $e4deb49dba5321bc$var$segmentImageParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$segmentImageSourceToVertex(fromSource, toObject);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$segmentImageConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$segmentImageResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromGeneratedMasks = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedMasks != null) {
        let transformedList = fromGeneratedMasks;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageMaskFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedMasks'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$segmentImageSourceToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (parentObject !== undefined && fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (parentObject !== undefined && fromImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromScribbleImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'scribbleImage'
    ]);
    if (parentObject !== undefined && fromScribbleImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'scribble'
    ], $e4deb49dba5321bc$var$scribbleImageToVertex(fromScribbleImage));
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToMldev(fromObject, rootObject) {
    const toObject = {};
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], fromRetrievalConfig);
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], $e4deb49dba5321bc$var$functionCallingConfigToMldev(fromFunctionCallingConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev$1(fromObject, rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    const fromFileSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]);
    if (fromFileSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileSearch'
    ], fromFileSearch);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev$1(fromGoogleSearch));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToMldev$1(fromGoogleMaps));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    const fromMcpServers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]);
    if (fromMcpServers != null) {
        let transformedList = fromMcpServers;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mcpServers'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$toolToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]);
    if (fromRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrieval'
    ], fromRetrieval);
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]) !== undefined) throw new Error('fileSearch parameter is not supported in Vertex AI.');
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], fromGoogleSearch);
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    const fromEnterpriseWebSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]);
    if (fromEnterpriseWebSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enterpriseWebSearch'
    ], fromEnterpriseWebSearch);
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], fromGoogleMaps);
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]) !== undefined) throw new Error('mcpServers parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$tunedModelInfoFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    return toObject;
}
function $e4deb49dba5321bc$var$tunedModelInfoFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels',
        'google-vertex-llm-tuning-base-model-id'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    return toObject;
}
function $e4deb49dba5321bc$var$updateModelConfigToMldev(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (parentObject !== undefined && fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'description'
    ], fromDescription);
    const fromDefaultCheckpointId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'defaultCheckpointId'
    ]);
    if (parentObject !== undefined && fromDefaultCheckpointId != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'defaultCheckpointId'
    ], fromDefaultCheckpointId);
    return toObject;
}
function $e4deb49dba5321bc$var$updateModelConfigToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (parentObject !== undefined && fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'description'
    ], fromDescription);
    const fromDefaultCheckpointId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'defaultCheckpointId'
    ]);
    if (parentObject !== undefined && fromDefaultCheckpointId != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'defaultCheckpointId'
    ], fromDefaultCheckpointId);
    return toObject;
}
function $e4deb49dba5321bc$var$updateModelParametersToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$updateModelConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$updateModelParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$updateModelConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$upscaleImageAPIConfigInternalToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeRaiReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromEnhanceInputImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhanceInputImage'
    ]);
    if (parentObject !== undefined && fromEnhanceInputImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'upscaleConfig',
        'enhanceInputImage'
    ], fromEnhanceInputImage);
    const fromImagePreservationFactor = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imagePreservationFactor'
    ]);
    if (parentObject !== undefined && fromImagePreservationFactor != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'upscaleConfig',
        'imagePreservationFactor'
    ], fromImagePreservationFactor);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (parentObject !== undefined && fromMode != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'mode'
    ], fromMode);
    return toObject;
}
function $e4deb49dba5321bc$var$upscaleImageAPIParametersInternalToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromUpscaleFactor = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'upscaleFactor'
    ]);
    if (fromUpscaleFactor != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters',
        'upscaleConfig',
        'upscaleFactor'
    ], fromUpscaleFactor);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$upscaleImageAPIConfigInternalToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$upscaleImageResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$videoFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encodedVideo'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoBytes'
    ], $e4deb49dba5321bc$var$tBytes(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encoding'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoBytes'
    ], $e4deb49dba5321bc$var$tBytes(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoGenerationMaskToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_self'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromMaskMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskMode'
    ]);
    if (fromMaskMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maskMode'
    ], fromMaskMode);
    return toObject;
}
function $e4deb49dba5321bc$var$videoGenerationReferenceImageToMldev(fromObject, rootObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageToMldev(fromImage));
    const fromReferenceType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceType'
    ]);
    if (fromReferenceType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceType'
    ], fromReferenceType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoGenerationReferenceImageToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromReferenceType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceType'
    ]);
    if (fromReferenceType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceType'
    ], fromReferenceType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoToMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoBytes'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'encodedVideo'
    ], $e4deb49dba5321bc$var$tBytes(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'encoding'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoBytes'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bytesBase64Encoded'
    ], $e4deb49dba5321bc$var$tBytes(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$createFileSearchStoreConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    return toObject;
}
function $e4deb49dba5321bc$var$createFileSearchStoreParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createFileSearchStoreConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteFileSearchStoreConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromForce = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'force'
    ]);
    if (parentObject !== undefined && fromForce != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'force'
    ], fromForce);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteFileSearchStoreParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$deleteFileSearchStoreConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$getFileSearchStoreParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$importFileConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromCustomMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'customMetadata'
    ]);
    if (parentObject !== undefined && fromCustomMetadata != null) {
        let transformedList = fromCustomMetadata;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'customMetadata'
        ], transformedList);
    }
    const fromChunkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'chunkingConfig'
    ]);
    if (parentObject !== undefined && fromChunkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'chunkingConfig'
    ], fromChunkingConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$importFileOperationFromMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$importFileResponseFromMldev(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$importFileParametersToMldev(fromObject) {
    const toObject = {};
    const fromFileSearchStoreName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearchStoreName'
    ]);
    if (fromFileSearchStoreName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'file_search_store_name'
    ], fromFileSearchStoreName);
    const fromFileName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]);
    if (fromFileName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileName'
    ], fromFileName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$importFileConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$importFileResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromParent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parent'
    ]);
    if (fromParent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parent'
    ], fromParent);
    const fromDocumentName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'documentName'
    ]);
    if (fromDocumentName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'documentName'
    ], fromDocumentName);
    return toObject;
}
function $e4deb49dba5321bc$var$listFileSearchStoresConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listFileSearchStoresParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listFileSearchStoresConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listFileSearchStoresResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromFileSearchStores = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearchStores'
    ]);
    if (fromFileSearchStores != null) {
        let transformedList = fromFileSearchStores;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'fileSearchStores'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$uploadToFileSearchStoreConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (parentObject !== undefined && fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'mimeType'
    ], fromMimeType);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromCustomMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'customMetadata'
    ]);
    if (parentObject !== undefined && fromCustomMetadata != null) {
        let transformedList = fromCustomMetadata;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'customMetadata'
        ], transformedList);
    }
    const fromChunkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'chunkingConfig'
    ]);
    if (parentObject !== undefined && fromChunkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'chunkingConfig'
    ], fromChunkingConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$uploadToFileSearchStoreParametersToMldev(fromObject) {
    const toObject = {};
    const fromFileSearchStoreName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearchStoreName'
    ]);
    if (fromFileSearchStoreName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'file_search_store_name'
    ], fromFileSearchStoreName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$uploadToFileSearchStoreConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$uploadToFileSearchStoreResumableResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$CONTENT_TYPE_HEADER = 'Content-Type';
const $e4deb49dba5321bc$var$SERVER_TIMEOUT_HEADER = 'X-Server-Timeout';
const $e4deb49dba5321bc$var$USER_AGENT_HEADER = 'User-Agent';
const $e4deb49dba5321bc$var$GOOGLE_API_CLIENT_HEADER = 'x-goog-api-client';
const $e4deb49dba5321bc$var$SDK_VERSION = '1.43.0'; // x-release-please-version
const $e4deb49dba5321bc$var$LIBRARY_LABEL = `google-genai-sdk/${$e4deb49dba5321bc$var$SDK_VERSION}`;
const $e4deb49dba5321bc$var$VERTEX_AI_API_DEFAULT_VERSION = 'v1beta1';
const $e4deb49dba5321bc$var$GOOGLE_AI_API_DEFAULT_VERSION = 'v1beta';
// Default retry options.
// The config is based on https://cloud.google.com/storage/docs/retry-strategy.
const $e4deb49dba5321bc$var$DEFAULT_RETRY_ATTEMPTS = 5; // Including the initial call
// LINT.IfChange
const $e4deb49dba5321bc$var$DEFAULT_RETRY_HTTP_STATUS_CODES = [
    408,
    429,
    500,
    502,
    503,
    504
];
/**
 * The ApiClient class is used to send requests to the Gemini API or Vertex AI
 * endpoints.
 */ class $e4deb49dba5321bc$var$ApiClient {
    constructor(opts){
        var _a, _b, _c;
        this.clientOptions = Object.assign({}, opts);
        this.customBaseUrl = (_a = opts.httpOptions) === null || _a === void 0 ? void 0 : _a.baseUrl;
        if (this.clientOptions.vertexai) {
            if (this.clientOptions.project && this.clientOptions.location) this.clientOptions.apiKey = undefined;
            else if (this.clientOptions.apiKey) {
                this.clientOptions.project = undefined;
                this.clientOptions.location = undefined;
            }
        }
        const initHttpOptions = {};
        if (this.clientOptions.vertexai) {
            if (!this.clientOptions.location && !this.clientOptions.apiKey && !this.customBaseUrl) this.clientOptions.location = 'global';
            const hasSufficientAuth = this.clientOptions.project && this.clientOptions.location || this.clientOptions.apiKey;
            if (!hasSufficientAuth && !this.customBaseUrl) throw new Error('Authentication is not set up. Please provide either a project and location, or an API key, or a custom base URL.');
            const hasConstructorAuth = opts.project && opts.location || !!opts.apiKey;
            if (this.customBaseUrl && !hasConstructorAuth) {
                initHttpOptions.baseUrl = this.customBaseUrl;
                this.clientOptions.project = undefined;
                this.clientOptions.location = undefined;
            } else if (this.clientOptions.apiKey || this.clientOptions.location === 'global') // Vertex Express or global endpoint case.
            initHttpOptions.baseUrl = 'https://aiplatform.googleapis.com/';
            else if (this.clientOptions.project && this.clientOptions.location) initHttpOptions.baseUrl = `https://${this.clientOptions.location}-aiplatform.googleapis.com/`;
            initHttpOptions.apiVersion = (_b = this.clientOptions.apiVersion) !== null && _b !== void 0 ? _b : $e4deb49dba5321bc$var$VERTEX_AI_API_DEFAULT_VERSION;
        } else {
            // Gemini API
            if (!this.clientOptions.apiKey) throw new $e4deb49dba5321bc$export$f2e832acab1bdd79({
                message: 'API key must be set when using the Gemini API.',
                status: 403
            });
            initHttpOptions.apiVersion = (_c = this.clientOptions.apiVersion) !== null && _c !== void 0 ? _c : $e4deb49dba5321bc$var$GOOGLE_AI_API_DEFAULT_VERSION;
            initHttpOptions.baseUrl = `https://generativelanguage.googleapis.com/`;
        }
        initHttpOptions.headers = this.getDefaultHeaders();
        this.clientOptions.httpOptions = initHttpOptions;
        if (opts.httpOptions) this.clientOptions.httpOptions = this.patchHttpOptions(initHttpOptions, opts.httpOptions);
    }
    isVertexAI() {
        var _a;
        return (_a = this.clientOptions.vertexai) !== null && _a !== void 0 ? _a : false;
    }
    getProject() {
        return this.clientOptions.project;
    }
    getLocation() {
        return this.clientOptions.location;
    }
    getCustomBaseUrl() {
        return this.customBaseUrl;
    }
    async getAuthHeaders() {
        const headers = new Headers();
        await this.clientOptions.auth.addAuthHeaders(headers);
        return headers;
    }
    getApiVersion() {
        if (this.clientOptions.httpOptions && this.clientOptions.httpOptions.apiVersion !== undefined) return this.clientOptions.httpOptions.apiVersion;
        throw new Error('API version is not set.');
    }
    getBaseUrl() {
        if (this.clientOptions.httpOptions && this.clientOptions.httpOptions.baseUrl !== undefined) return this.clientOptions.httpOptions.baseUrl;
        throw new Error('Base URL is not set.');
    }
    getRequestUrl() {
        return this.getRequestUrlInternal(this.clientOptions.httpOptions);
    }
    getHeaders() {
        if (this.clientOptions.httpOptions && this.clientOptions.httpOptions.headers !== undefined) return this.clientOptions.httpOptions.headers;
        else throw new Error('Headers are not set.');
    }
    getRequestUrlInternal(httpOptions) {
        if (!httpOptions || httpOptions.baseUrl === undefined || httpOptions.apiVersion === undefined) throw new Error('HTTP options are not correctly set.');
        const baseUrl = httpOptions.baseUrl.endsWith('/') ? httpOptions.baseUrl.slice(0, -1) : httpOptions.baseUrl;
        const urlElement = [
            baseUrl
        ];
        if (httpOptions.apiVersion && httpOptions.apiVersion !== '') urlElement.push(httpOptions.apiVersion);
        return urlElement.join('/');
    }
    getBaseResourcePath() {
        return `projects/${this.clientOptions.project}/locations/${this.clientOptions.location}`;
    }
    getApiKey() {
        return this.clientOptions.apiKey;
    }
    getWebsocketBaseUrl() {
        const baseUrl = this.getBaseUrl();
        const urlParts = new URL(baseUrl);
        urlParts.protocol = urlParts.protocol == 'http:' ? 'ws' : 'wss';
        return urlParts.toString();
    }
    setBaseUrl(url) {
        if (this.clientOptions.httpOptions) this.clientOptions.httpOptions.baseUrl = url;
        else throw new Error('HTTP options are not correctly set.');
    }
    constructUrl(path, httpOptions, prependProjectLocation) {
        const urlElement = [
            this.getRequestUrlInternal(httpOptions)
        ];
        if (prependProjectLocation) urlElement.push(this.getBaseResourcePath());
        if (path !== '') urlElement.push(path);
        const url = new URL(`${urlElement.join('/')}`);
        return url;
    }
    shouldPrependVertexProjectPath(request, httpOptions) {
        if (httpOptions.baseUrl && httpOptions.baseUrlResourceScope === $e4deb49dba5321bc$export$ce358901f8c7a617.COLLECTION) return false;
        if (this.clientOptions.apiKey) return false;
        if (!this.clientOptions.vertexai) return false;
        if (request.path.startsWith('projects/')) // Assume the path already starts with
        // `projects/<project>/location/<location>`.
        return false;
        if (request.httpMethod === 'GET' && request.path.startsWith('publishers/google/models')) // These paths are used by Vertex's models.get and models.list
        // calls. For base models Vertex does not accept a project/location
        // prefix (for tuned model the prefix is required).
        return false;
        return true;
    }
    async request(request) {
        let patchedHttpOptions = this.clientOptions.httpOptions;
        if (request.httpOptions) patchedHttpOptions = this.patchHttpOptions(this.clientOptions.httpOptions, request.httpOptions);
        const prependProjectLocation = this.shouldPrependVertexProjectPath(request, patchedHttpOptions);
        const url = this.constructUrl(request.path, patchedHttpOptions, prependProjectLocation);
        if (request.queryParams) for (const [key, value] of Object.entries(request.queryParams))url.searchParams.append(key, String(value));
        let requestInit = {};
        if (request.httpMethod === 'GET') {
            if (request.body && request.body !== '{}') throw new Error('Request body should be empty for GET request, but got non empty request body');
        } else requestInit.body = request.body;
        requestInit = await this.includeExtraHttpOptionsToRequestInit(requestInit, patchedHttpOptions, url.toString(), request.abortSignal);
        return this.unaryApiCall(url, requestInit, request.httpMethod);
    }
    patchHttpOptions(baseHttpOptions, requestHttpOptions) {
        const patchedHttpOptions = JSON.parse(JSON.stringify(baseHttpOptions));
        for (const [key, value] of Object.entries(requestHttpOptions)){
            // Records compile to objects.
            if (typeof value === 'object') // @ts-expect-error TS2345TS7053: Element implicitly has an 'any' type
            // because expression of type 'string' can't be used to index type
            // 'HttpOptions'.
            patchedHttpOptions[key] = Object.assign(Object.assign({}, patchedHttpOptions[key]), value);
            else if (value !== undefined) // @ts-expect-error TS2345TS7053: Element implicitly has an 'any' type
            // because expression of type 'string' can't be used to index type
            // 'HttpOptions'.
            patchedHttpOptions[key] = value;
        }
        return patchedHttpOptions;
    }
    async requestStream(request) {
        let patchedHttpOptions = this.clientOptions.httpOptions;
        if (request.httpOptions) patchedHttpOptions = this.patchHttpOptions(this.clientOptions.httpOptions, request.httpOptions);
        const prependProjectLocation = this.shouldPrependVertexProjectPath(request, patchedHttpOptions);
        const url = this.constructUrl(request.path, patchedHttpOptions, prependProjectLocation);
        if (!url.searchParams.has('alt') || url.searchParams.get('alt') !== 'sse') url.searchParams.set('alt', 'sse');
        let requestInit = {};
        requestInit.body = request.body;
        requestInit = await this.includeExtraHttpOptionsToRequestInit(requestInit, patchedHttpOptions, url.toString(), request.abortSignal);
        return this.streamApiCall(url, requestInit, request.httpMethod);
    }
    async includeExtraHttpOptionsToRequestInit(requestInit, httpOptions, url, abortSignal) {
        if (httpOptions && httpOptions.timeout || abortSignal) {
            const abortController = new AbortController();
            const signal = abortController.signal;
            if (httpOptions.timeout && (httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.timeout) > 0) {
                const timeoutHandle = setTimeout(()=>abortController.abort(), httpOptions.timeout);
                if (timeoutHandle && typeof timeoutHandle.unref === 'function') // call unref to prevent nodejs process from hanging, see
                // https://nodejs.org/api/timers.html#timeoutunref
                timeoutHandle.unref();
            }
            if (abortSignal) abortSignal.addEventListener('abort', ()=>{
                abortController.abort();
            });
            requestInit.signal = signal;
        }
        if (httpOptions && httpOptions.extraBody !== null) $e4deb49dba5321bc$var$includeExtraBodyToRequestInit(requestInit, httpOptions.extraBody);
        requestInit.headers = await this.getHeadersInternal(httpOptions, url);
        return requestInit;
    }
    async unaryApiCall(url, requestInit, httpMethod) {
        return this.apiCall(url.toString(), Object.assign(Object.assign({}, requestInit), {
            method: httpMethod
        })).then(async (response)=>{
            await $e4deb49dba5321bc$var$throwErrorIfNotOK(response);
            return new $e4deb49dba5321bc$export$1d94dfe0d9d1f1e7(response);
        }).catch((e)=>{
            if (e instanceof Error) throw e;
            else throw new Error(JSON.stringify(e));
        });
    }
    async streamApiCall(url, requestInit, httpMethod) {
        return this.apiCall(url.toString(), Object.assign(Object.assign({}, requestInit), {
            method: httpMethod
        })).then(async (response)=>{
            await $e4deb49dba5321bc$var$throwErrorIfNotOK(response);
            return this.processStreamResponse(response);
        }).catch((e)=>{
            if (e instanceof Error) throw e;
            else throw new Error(JSON.stringify(e));
        });
    }
    processStreamResponse(response) {
        return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* processStreamResponse_1() {
            var _a;
            const reader = (_a = response === null || response === void 0 ? void 0 : response.body) === null || _a === void 0 ? void 0 : _a.getReader();
            const decoder = new TextDecoder('utf-8');
            if (!reader) throw new Error('Response body is empty');
            try {
                let buffer = '';
                const dataPrefix = 'data:';
                const delimiters = [
                    '\n\n',
                    '\r\r',
                    '\r\n\r\n'
                ];
                while(true){
                    const { done: done, value: value } = yield $e4deb49dba5321bc$var$__await(reader.read());
                    if (done) {
                        if (buffer.trim().length > 0) throw new Error('Incomplete JSON segment at the end');
                        break;
                    }
                    const chunkString = decoder.decode(value, {
                        stream: true
                    });
                    // Parse and throw an error if the chunk contains an error.
                    try {
                        const chunkJson = JSON.parse(chunkString);
                        if ('error' in chunkJson) {
                            const errorJson = JSON.parse(JSON.stringify(chunkJson['error']));
                            const status = errorJson['status'];
                            const code = errorJson['code'];
                            const errorMessage = `got status: ${status}. ${JSON.stringify(chunkJson)}`;
                            if (code >= 400 && code < 600) {
                                const apiError = new $e4deb49dba5321bc$export$f2e832acab1bdd79({
                                    message: errorMessage,
                                    status: code
                                });
                                throw apiError;
                            }
                        }
                    } catch (e) {
                        const error = e;
                        if (error.name === 'ApiError') throw e;
                    }
                    buffer += chunkString;
                    let delimiterIndex = -1;
                    let delimiterLength = 0;
                    while(true){
                        delimiterIndex = -1;
                        delimiterLength = 0;
                        for (const delimiter of delimiters){
                            const index = buffer.indexOf(delimiter);
                            if (index !== -1 && (delimiterIndex === -1 || index < delimiterIndex)) {
                                delimiterIndex = index;
                                delimiterLength = delimiter.length;
                            }
                        }
                        if (delimiterIndex === -1) break; // No complete event in buffer
                        const eventString = buffer.substring(0, delimiterIndex);
                        buffer = buffer.substring(delimiterIndex + delimiterLength);
                        const trimmedEvent = eventString.trim();
                        if (trimmedEvent.startsWith(dataPrefix)) {
                            const processedChunkString = trimmedEvent.substring(dataPrefix.length).trim();
                            try {
                                const partialResponse = new Response(processedChunkString, {
                                    headers: response === null || response === void 0 ? void 0 : response.headers,
                                    status: response === null || response === void 0 ? void 0 : response.status,
                                    statusText: response === null || response === void 0 ? void 0 : response.statusText
                                });
                                yield yield $e4deb49dba5321bc$var$__await(new $e4deb49dba5321bc$export$1d94dfe0d9d1f1e7(partialResponse));
                            } catch (e) {
                                throw new Error(`exception parsing stream chunk ${processedChunkString}. ${e}`);
                            }
                        }
                    }
                }
            } finally{
                reader.releaseLock();
            }
        });
    }
    async apiCall(url, requestInit) {
        var _a;
        if (!this.clientOptions.httpOptions || !this.clientOptions.httpOptions.retryOptions) return fetch(url, requestInit);
        const retryOptions = this.clientOptions.httpOptions.retryOptions;
        const runFetch = async ()=>{
            const response = await fetch(url, requestInit);
            if (response.ok) return response;
            if ($e4deb49dba5321bc$var$DEFAULT_RETRY_HTTP_STATUS_CODES.includes(response.status)) throw new Error(`Retryable HTTP Error: ${response.statusText}`);
            throw new (0, $b6d378dfee037fa8$exports.AbortError)(`Non-retryable exception ${response.statusText} sending request`);
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($b6d378dfee037fa8$exports)))(runFetch, {
            // Retry attempts is one less than the number of total attempts.
            retries: ((_a = retryOptions.attempts) !== null && _a !== void 0 ? _a : $e4deb49dba5321bc$var$DEFAULT_RETRY_ATTEMPTS) - 1
        });
    }
    getDefaultHeaders() {
        const headers = {};
        const versionHeaderValue = $e4deb49dba5321bc$var$LIBRARY_LABEL + ' ' + this.clientOptions.userAgentExtra;
        headers[$e4deb49dba5321bc$var$USER_AGENT_HEADER] = versionHeaderValue;
        headers[$e4deb49dba5321bc$var$GOOGLE_API_CLIENT_HEADER] = versionHeaderValue;
        headers[$e4deb49dba5321bc$var$CONTENT_TYPE_HEADER] = 'application/json';
        return headers;
    }
    async getHeadersInternal(httpOptions, url) {
        const headers = new Headers();
        if (httpOptions && httpOptions.headers) {
            for (const [key, value] of Object.entries(httpOptions.headers))headers.append(key, value);
            // Append a timeout header if it is set, note that the timeout option is
            // in milliseconds but the header is in seconds.
            if (httpOptions.timeout && httpOptions.timeout > 0) headers.append($e4deb49dba5321bc$var$SERVER_TIMEOUT_HEADER, String(Math.ceil(httpOptions.timeout / 1000)));
        }
        await this.clientOptions.auth.addAuthHeaders(headers, url);
        return headers;
    }
    getFileName(file) {
        var _a;
        let fileName = '';
        if (typeof file === 'string') {
            fileName = file.replace(/[/\\]+$/, '');
            fileName = (_a = fileName.split(/[/\\]/).pop()) !== null && _a !== void 0 ? _a : '';
        }
        return fileName;
    }
    /**
     * Uploads a file asynchronously using Gemini API only, this is not supported
     * in Vertex AI.
     *
     * @param file The string path to the file to be uploaded or a Blob object.
     * @param config Optional parameters specified in the `UploadFileConfig`
     *     interface. @see {@link types.UploadFileConfig}
     * @return A promise that resolves to a `File` object.
     * @throws An error if called on a Vertex AI client.
     * @throws An error if the `mimeType` is not provided and can not be inferred,
     */ async uploadFile(file, config) {
        var _a;
        const fileToUpload = {};
        if (config != null) {
            fileToUpload.mimeType = config.mimeType;
            fileToUpload.name = config.name;
            fileToUpload.displayName = config.displayName;
        }
        if (fileToUpload.name && !fileToUpload.name.startsWith('files/')) fileToUpload.name = `files/${fileToUpload.name}`;
        const uploader = this.clientOptions.uploader;
        const fileStat = await uploader.stat(file);
        fileToUpload.sizeBytes = String(fileStat.size);
        const mimeType = (_a = config === null || config === void 0 ? void 0 : config.mimeType) !== null && _a !== void 0 ? _a : fileStat.type;
        if (mimeType === undefined || mimeType === '') throw new Error('Can not determine mimeType. Please provide mimeType in the config.');
        fileToUpload.mimeType = mimeType;
        const body = {
            file: fileToUpload
        };
        const fileName = this.getFileName(file);
        const path = $e4deb49dba5321bc$var$formatMap('upload/v1beta/files', body['_url']);
        const uploadUrl = await this.fetchUploadUrl(path, fileToUpload.sizeBytes, fileToUpload.mimeType, fileName, body, config === null || config === void 0 ? void 0 : config.httpOptions);
        return uploader.upload(file, uploadUrl, this);
    }
    /**
     * Uploads a file to a given file search store asynchronously using Gemini API only, this is not supported
     * in Vertex AI.
     *
     * @param fileSearchStoreName The name of the file search store to upload the file to.
     * @param file The string path to the file to be uploaded or a Blob object.
     * @param config Optional parameters specified in the `UploadFileConfig`
     *     interface. @see {@link UploadFileConfig}
     * @return A promise that resolves to a `File` object.
     * @throws An error if called on a Vertex AI client.
     * @throws An error if the `mimeType` is not provided and can not be inferred,
     */ async uploadFileToFileSearchStore(fileSearchStoreName, file, config) {
        var _a;
        const uploader = this.clientOptions.uploader;
        const fileStat = await uploader.stat(file);
        const sizeBytes = String(fileStat.size);
        const mimeType = (_a = config === null || config === void 0 ? void 0 : config.mimeType) !== null && _a !== void 0 ? _a : fileStat.type;
        if (mimeType === undefined || mimeType === '') throw new Error('Can not determine mimeType. Please provide mimeType in the config.');
        const path = `upload/v1beta/${fileSearchStoreName}:uploadToFileSearchStore`;
        const fileName = this.getFileName(file);
        const body = {};
        if (config != null) $e4deb49dba5321bc$var$uploadToFileSearchStoreConfigToMldev(config, body);
        const uploadUrl = await this.fetchUploadUrl(path, sizeBytes, mimeType, fileName, body, config === null || config === void 0 ? void 0 : config.httpOptions);
        return uploader.uploadToFileSearchStore(file, uploadUrl, this);
    }
    /**
     * Downloads a file asynchronously to the specified path.
     *
     * @params params - The parameters for the download request, see {@link
     * types.DownloadFileParameters}
     */ async downloadFile(params) {
        const downloader = this.clientOptions.downloader;
        await downloader.download(params, this);
    }
    async fetchUploadUrl(path, sizeBytes, mimeType, fileName, body, configHttpOptions) {
        var _a;
        let httpOptions = {};
        if (configHttpOptions) httpOptions = configHttpOptions;
        else httpOptions = {
            apiVersion: '',
            headers: Object.assign({
                'Content-Type': 'application/json',
                'X-Goog-Upload-Protocol': 'resumable',
                'X-Goog-Upload-Command': 'start',
                'X-Goog-Upload-Header-Content-Length': `${sizeBytes}`,
                'X-Goog-Upload-Header-Content-Type': `${mimeType}`
            }, fileName ? {
                'X-Goog-Upload-File-Name': fileName
            } : {})
        };
        const httpResponse = await this.request({
            path: path,
            body: JSON.stringify(body),
            httpMethod: 'POST',
            httpOptions: httpOptions
        });
        if (!httpResponse || !(httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.headers)) throw new Error('Server did not return an HttpResponse or the returned HttpResponse did not have headers.');
        const uploadUrl = (_a = httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.headers) === null || _a === void 0 ? void 0 : _a['x-goog-upload-url'];
        if (uploadUrl === undefined) throw new Error('Failed to get upload url. Server did not return the x-google-upload-url in the headers');
        return uploadUrl;
    }
}
async function $e4deb49dba5321bc$var$throwErrorIfNotOK(response) {
    var _a;
    if (response === undefined) throw new Error('response is undefined');
    if (!response.ok) {
        const status = response.status;
        let errorBody;
        if ((_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) errorBody = await response.json();
        else errorBody = {
            error: {
                message: await response.text(),
                code: response.status,
                status: response.statusText
            }
        };
        const errorMessage = JSON.stringify(errorBody);
        if (status >= 400 && status < 600) {
            const apiError = new $e4deb49dba5321bc$export$f2e832acab1bdd79({
                message: errorMessage,
                status: status
            });
            throw apiError;
        }
        throw new Error(errorMessage);
    }
}
/**
 * Recursively updates the `requestInit.body` with values from an `extraBody` object.
 *
 * If `requestInit.body` is a string, it's assumed to be JSON and will be parsed.
 * The `extraBody` is then deeply merged into this parsed object.
 * If `requestInit.body` is a Blob, `extraBody` will be ignored, and a warning logged,
 * as merging structured data into an opaque Blob is not supported.
 *
 * The function does not enforce that updated values from `extraBody` have the
 * same type as existing values in `requestInit.body`. Type mismatches during
 * the merge will result in a warning, but the value from `extraBody` will overwrite
 * the original. `extraBody` users are responsible for ensuring `extraBody` has the correct structure.
 *
 * @param requestInit The RequestInit object whose body will be updated.
 * @param extraBody The object containing updates to be merged into `requestInit.body`.
 */ function $e4deb49dba5321bc$var$includeExtraBodyToRequestInit(requestInit, extraBody) {
    if (!extraBody || Object.keys(extraBody).length === 0) return;
    if (requestInit.body instanceof Blob) {
        console.warn('includeExtraBodyToRequestInit: extraBody provided but current request body is a Blob. extraBody will be ignored as merging is not supported for Blob bodies.');
        return;
    }
    let currentBodyObject = {};
    // If adding new type to HttpRequest.body, please check the code below to
    // see if we need to update the logic.
    if (typeof requestInit.body === 'string' && requestInit.body.length > 0) try {
        const parsedBody = JSON.parse(requestInit.body);
        if (typeof parsedBody === 'object' && parsedBody !== null && !Array.isArray(parsedBody)) currentBodyObject = parsedBody;
        else {
            console.warn('includeExtraBodyToRequestInit: Original request body is valid JSON but not a non-array object. Skip applying extraBody to the request body.');
            return;
        }
    /*  eslint-disable-next-line @typescript-eslint/no-unused-vars */ } catch (e) {
        console.warn('includeExtraBodyToRequestInit: Original request body is not valid JSON. Skip applying extraBody to the request body.');
        return;
    }
    function deepMerge(target, source) {
        const output = Object.assign({}, target);
        for(const key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
            const sourceValue = source[key];
            const targetValue = output[key];
            if (sourceValue && typeof sourceValue === 'object' && !Array.isArray(sourceValue) && targetValue && typeof targetValue === 'object' && !Array.isArray(targetValue)) output[key] = deepMerge(targetValue, sourceValue);
            else {
                if (targetValue && sourceValue && typeof targetValue !== typeof sourceValue) console.warn(`includeExtraBodyToRequestInit:deepMerge: Type mismatch for key "${key}". Original type: ${typeof targetValue}, New type: ${typeof sourceValue}. Overwriting.`);
                output[key] = sourceValue;
            }
        }
        return output;
    }
    const mergedBody = deepMerge(currentBodyObject, extraBody);
    requestInit.body = JSON.stringify(mergedBody);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // TODO: b/416041229 - Determine how to retrieve the MCP package version.
const $e4deb49dba5321bc$var$MCP_LABEL = 'mcp_used/unknown';
// Whether MCP tool usage is detected from mcpToTool. This is used for
// telemetry.
let $e4deb49dba5321bc$var$hasMcpToolUsageFromMcpToTool = false;
// Checks whether the list of tools contains any MCP tools.
function $e4deb49dba5321bc$var$hasMcpToolUsage(tools) {
    for (const tool of tools){
        if ($e4deb49dba5321bc$var$isMcpCallableTool(tool)) return true;
        if (typeof tool === 'object' && 'inputSchema' in tool) return true;
    }
    return $e4deb49dba5321bc$var$hasMcpToolUsageFromMcpToTool;
}
// Sets the MCP version label in the Google API client header.
function $e4deb49dba5321bc$var$setMcpUsageHeader(headers) {
    var _a;
    const existingHeader = (_a = headers[$e4deb49dba5321bc$var$GOOGLE_API_CLIENT_HEADER]) !== null && _a !== void 0 ? _a : '';
    headers[$e4deb49dba5321bc$var$GOOGLE_API_CLIENT_HEADER] = (existingHeader + ` ${$e4deb49dba5321bc$var$MCP_LABEL}`).trimStart();
}
// Returns true if the object is a MCP CallableTool, otherwise false.
function $e4deb49dba5321bc$var$isMcpCallableTool(object) {
    return object !== null && typeof object === 'object' && object instanceof $e4deb49dba5321bc$var$McpCallableTool;
}
// List all tools from the MCP client.
function $e4deb49dba5321bc$var$listAllTools(mcpClient_1) {
    return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* listAllTools_1(mcpClient, maxTools = 100) {
        let cursor = undefined;
        let numTools = 0;
        while(numTools < maxTools){
            const t = yield $e4deb49dba5321bc$var$__await(mcpClient.listTools({
                cursor: cursor
            }));
            for (const tool of t.tools){
                yield yield $e4deb49dba5321bc$var$__await(tool);
                numTools++;
            }
            if (!t.nextCursor) break;
            cursor = t.nextCursor;
        }
    });
}
/**
 * McpCallableTool can be used for model inference and invoking MCP clients with
 * given function call arguments.
 *
 * @experimental Built-in MCP support is an experimental feature, may change in future
 * versions.
 */ class $e4deb49dba5321bc$var$McpCallableTool {
    constructor(mcpClients = [], config){
        this.mcpTools = [];
        this.functionNameToMcpClient = {};
        this.mcpClients = mcpClients;
        this.config = config;
    }
    /**
     * Creates a McpCallableTool.
     */ static create(mcpClients, config) {
        return new $e4deb49dba5321bc$var$McpCallableTool(mcpClients, config);
    }
    /**
     * Validates the function names are not duplicate and initialize the function
     * name to MCP client mapping.
     *
     * @throws {Error} if the MCP tools from the MCP clients have duplicate tool
     *     names.
     */ async initialize() {
        var _a, e_1, _b, _c;
        if (this.mcpTools.length > 0) return;
        const functionMap = {};
        const mcpTools = [];
        for (const mcpClient of this.mcpClients)try {
            for(var _d = true, _e = (e_1 = void 0, $e4deb49dba5321bc$var$__asyncValues($e4deb49dba5321bc$var$listAllTools(mcpClient))), _f; _f = await _e.next(), _a = _f.done, !_a; _d = true){
                _c = _f.value;
                _d = false;
                const mcpTool = _c;
                mcpTools.push(mcpTool);
                const mcpToolName = mcpTool.name;
                if (functionMap[mcpToolName]) throw new Error(`Duplicate function name ${mcpToolName} found in MCP tools. Please ensure function names are unique.`);
                functionMap[mcpToolName] = mcpClient;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (!_d && !_a && (_b = _e.return)) await _b.call(_e);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.mcpTools = mcpTools;
        this.functionNameToMcpClient = functionMap;
    }
    async tool() {
        await this.initialize();
        return $e4deb49dba5321bc$var$mcpToolsToGeminiTool(this.mcpTools, this.config);
    }
    async callTool(functionCalls) {
        await this.initialize();
        const functionCallResponseParts = [];
        for (const functionCall of functionCalls)if (functionCall.name in this.functionNameToMcpClient) {
            const mcpClient = this.functionNameToMcpClient[functionCall.name];
            let requestOptions = undefined;
            // TODO: b/424238654 - Add support for finer grained timeout control.
            if (this.config.timeout) requestOptions = {
                timeout: this.config.timeout
            };
            const callToolResponse = await mcpClient.callTool({
                name: functionCall.name,
                arguments: functionCall.args
            }, // Set the result schema to undefined to allow MCP to rely on the
            // default schema.
            undefined, requestOptions);
            functionCallResponseParts.push({
                functionResponse: {
                    name: functionCall.name,
                    response: callToolResponse.isError ? {
                        error: callToolResponse
                    } : callToolResponse
                }
            });
        }
        return functionCallResponseParts;
    }
}
function $e4deb49dba5321bc$var$isMcpClient(client) {
    return client !== null && typeof client === 'object' && 'listTools' in client && typeof client.listTools === 'function';
}
/**
 * Creates a McpCallableTool from MCP clients and an optional config.
 *
 * The callable tool can invoke the MCP clients with given function call
 * arguments. (often for automatic function calling).
 * Use the config to modify tool parameters such as behavior.
 *
 * @experimental Built-in MCP support is an experimental feature, may change in future
 * versions.
 */ function $e4deb49dba5321bc$export$836b74d9f63bb1cd(...args) {
    // Set MCP usage for telemetry.
    $e4deb49dba5321bc$var$hasMcpToolUsageFromMcpToTool = true;
    if (args.length === 0) throw new Error('No MCP clients provided');
    const maybeConfig = args[args.length - 1];
    if ($e4deb49dba5321bc$var$isMcpClient(maybeConfig)) return $e4deb49dba5321bc$var$McpCallableTool.create(args, {});
    return $e4deb49dba5321bc$var$McpCallableTool.create(args.slice(0, args.length - 1), maybeConfig);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Handles incoming messages from the WebSocket.
 *
 * @remarks
 * This function is responsible for parsing incoming messages, transforming them
 * into LiveMusicServerMessage, and then calling the onmessage callback.
 * Note that the first message which is received from the server is a
 * setupComplete message.
 *
 * @param apiClient The ApiClient instance.
 * @param onmessage The user-provided onmessage callback (if any).
 * @param event The MessageEvent from the WebSocket.
 */ async function $e4deb49dba5321bc$var$handleWebSocketMessage$1(apiClient, onmessage, event) {
    const serverMessage = new $e4deb49dba5321bc$export$5f085d7f78cd2680();
    let data;
    if (event.data instanceof Blob) data = JSON.parse(await event.data.text());
    else data = JSON.parse(event.data);
    Object.assign(serverMessage, data);
    onmessage(serverMessage);
}
/**
   LiveMusic class encapsulates the configuration for live music
   generation via Lyria Live models.

   @experimental
  */ class $e4deb49dba5321bc$var$LiveMusic {
    constructor(apiClient, auth, webSocketFactory){
        this.apiClient = apiClient;
        this.auth = auth;
        this.webSocketFactory = webSocketFactory;
    }
    /**
       Establishes a connection to the specified model and returns a
       LiveMusicSession object representing that connection.
  
       @experimental
  
       @remarks
  
       @param params - The parameters for establishing a connection to the model.
       @return A live session.
  
       @example
       ```ts
       let model = 'models/lyria-realtime-exp';
       const session = await ai.live.music.connect({
         model: model,
         callbacks: {
           onmessage: (e: MessageEvent) => {
             console.log('Received message from the server: %s\n', debug(e.data));
           },
           onerror: (e: ErrorEvent) => {
             console.log('Error occurred: %s\n', debug(e.error));
           },
           onclose: (e: CloseEvent) => {
             console.log('Connection closed.');
           },
         },
       });
       ```
      */ async connect(params) {
        var _a, _b;
        if (this.apiClient.isVertexAI()) throw new Error('Live music is not supported for Vertex AI.');
        console.warn('Live music generation is experimental and may change in future versions.');
        const websocketBaseUrl = this.apiClient.getWebsocketBaseUrl();
        const apiVersion = this.apiClient.getApiVersion();
        const headers = $e4deb49dba5321bc$var$mapToHeaders$1(this.apiClient.getDefaultHeaders());
        const apiKey = this.apiClient.getApiKey();
        const url = `${websocketBaseUrl}/ws/google.ai.generativelanguage.${apiVersion}.GenerativeService.BidiGenerateMusic?key=${apiKey}`;
        let onopenResolve = ()=>{};
        const onopenPromise = new Promise((resolve)=>{
            onopenResolve = resolve;
        });
        const callbacks = params.callbacks;
        const onopenAwaitedCallback = function() {
            onopenResolve({});
        };
        const apiClient = this.apiClient;
        const websocketCallbacks = {
            onopen: onopenAwaitedCallback,
            onmessage: (event)=>{
                $e4deb49dba5321bc$var$handleWebSocketMessage$1(apiClient, callbacks.onmessage, event);
            },
            onerror: (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onerror) !== null && _a !== void 0 ? _a : function(e) {},
            onclose: (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onclose) !== null && _b !== void 0 ? _b : function(e) {}
        };
        const conn = this.webSocketFactory.create(url, $e4deb49dba5321bc$var$headersToMap$1(headers), websocketCallbacks);
        conn.connect();
        // Wait for the websocket to open before sending requests.
        await onopenPromise;
        const model = $e4deb49dba5321bc$var$tModel(this.apiClient, params.model);
        const setup = {
            model: model
        };
        const clientMessage = {
            setup: setup
        };
        conn.send(JSON.stringify(clientMessage));
        return new $e4deb49dba5321bc$var$LiveMusicSession(conn, this.apiClient);
    }
}
/**
   Represents a connection to the API.

   @experimental
  */ class $e4deb49dba5321bc$var$LiveMusicSession {
    constructor(conn, apiClient){
        this.conn = conn;
        this.apiClient = apiClient;
    }
    /**
      Sets inputs to steer music generation. Updates the session's current
      weighted prompts.
  
      @param params - Contains one property, `weightedPrompts`.
  
        - `weightedPrompts` to send to the model; weights are normalized to
          sum to 1.0.
  
      @experimental
     */ async setWeightedPrompts(params) {
        if (!params.weightedPrompts || Object.keys(params.weightedPrompts).length === 0) throw new Error('Weighted prompts must be set and contain at least one entry.');
        const clientContent = $e4deb49dba5321bc$var$liveMusicSetWeightedPromptsParametersToMldev(params);
        this.conn.send(JSON.stringify({
            clientContent: clientContent
        }));
    }
    /**
      Sets a configuration to the model. Updates the session's current
      music generation config.
  
      @param params - Contains one property, `musicGenerationConfig`.
  
        - `musicGenerationConfig` to set in the model. Passing an empty or
      undefined config to the model will reset the config to defaults.
  
      @experimental
     */ async setMusicGenerationConfig(params) {
        if (!params.musicGenerationConfig) params.musicGenerationConfig = {};
        const setConfigParameters = $e4deb49dba5321bc$var$liveMusicSetConfigParametersToMldev(params);
        this.conn.send(JSON.stringify(setConfigParameters));
    }
    sendPlaybackControl(playbackControl) {
        const clientMessage = {
            playbackControl: playbackControl
        };
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
     * Start the music stream.
     *
     * @experimental
     */ play() {
        this.sendPlaybackControl($e4deb49dba5321bc$export$3d1b3b2fa769f3a.PLAY);
    }
    /**
     * Temporarily halt the music stream. Use `play` to resume from the current
     * position.
     *
     * @experimental
     */ pause() {
        this.sendPlaybackControl($e4deb49dba5321bc$export$3d1b3b2fa769f3a.PAUSE);
    }
    /**
     * Stop the music stream and reset the state. Retains the current prompts
     * and config.
     *
     * @experimental
     */ stop() {
        this.sendPlaybackControl($e4deb49dba5321bc$export$3d1b3b2fa769f3a.STOP);
    }
    /**
     * Resets the context of the music generation without stopping it.
     * Retains the current prompts and config.
     *
     * @experimental
     */ resetContext() {
        this.sendPlaybackControl($e4deb49dba5321bc$export$3d1b3b2fa769f3a.RESET_CONTEXT);
    }
    /**
       Terminates the WebSocket connection.
  
       @experimental
     */ close() {
        this.conn.close();
    }
}
// Converts an headers object to a "map" object as expected by the WebSocket
// constructor. We use this as the Auth interface works with Headers objects
// while the WebSocket constructor takes a map.
function $e4deb49dba5321bc$var$headersToMap$1(headers) {
    const headerMap = {};
    headers.forEach((value, key)=>{
        headerMap[key] = value;
    });
    return headerMap;
}
// Converts a "map" object to a headers object. We use this as the Auth
// interface works with Headers objects while the API client default headers
// returns a map.
function $e4deb49dba5321bc$var$mapToHeaders$1(map) {
    const headers = new Headers();
    for (const [key, value] of Object.entries(map))headers.append(key, value);
    return headers;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$FUNCTION_RESPONSE_REQUIRES_ID = 'FunctionResponse request must have an `id` field from the response of a ToolCall.FunctionalCalls in Google AI.';
/**
 * Handles incoming messages from the WebSocket.
 *
 * @remarks
 * This function is responsible for parsing incoming messages, transforming them
 * into LiveServerMessages, and then calling the onmessage callback. Note that
 * the first message which is received from the server is a setupComplete
 * message.
 *
 * @param apiClient The ApiClient instance.
 * @param onmessage The user-provided onmessage callback (if any).
 * @param event The MessageEvent from the WebSocket.
 */ async function $e4deb49dba5321bc$var$handleWebSocketMessage(apiClient, onmessage, event) {
    const serverMessage = new $e4deb49dba5321bc$export$a509bcf6072c871c();
    let jsonData;
    if (event.data instanceof Blob) jsonData = await event.data.text();
    else if (event.data instanceof ArrayBuffer) jsonData = new TextDecoder().decode(event.data);
    else jsonData = event.data;
    const data = JSON.parse(jsonData);
    if (apiClient.isVertexAI()) {
        const resp = $e4deb49dba5321bc$var$liveServerMessageFromVertex(data);
        Object.assign(serverMessage, resp);
    } else {
        const resp = data;
        Object.assign(serverMessage, resp);
    }
    onmessage(serverMessage);
}
/**
   Live class encapsulates the configuration for live interaction with the
   Generative Language API. It embeds ApiClient for general API settings.

   @experimental
  */ class $e4deb49dba5321bc$export$db78b3d0b2aa666a {
    constructor(apiClient, auth, webSocketFactory){
        this.apiClient = apiClient;
        this.auth = auth;
        this.webSocketFactory = webSocketFactory;
        this.music = new $e4deb49dba5321bc$var$LiveMusic(this.apiClient, this.auth, this.webSocketFactory);
    }
    /**
       Establishes a connection to the specified model with the given
       configuration and returns a Session object representing that connection.
  
       @experimental Built-in MCP support is an experimental feature, may change in
       future versions.
  
       @remarks
  
       @param params - The parameters for establishing a connection to the model.
       @return A live session.
  
       @example
       ```ts
       let model: string;
       if (GOOGLE_GENAI_USE_VERTEXAI) {
         model = 'gemini-2.0-flash-live-preview-04-09';
       } else {
         model = 'gemini-live-2.5-flash-preview';
       }
       const session = await ai.live.connect({
         model: model,
         config: {
           responseModalities: [Modality.AUDIO],
         },
         callbacks: {
           onopen: () => {
             console.log('Connected to the socket.');
           },
           onmessage: (e: MessageEvent) => {
             console.log('Received message from the server: %s\n', debug(e.data));
           },
           onerror: (e: ErrorEvent) => {
             console.log('Error occurred: %s\n', debug(e.error));
           },
           onclose: (e: CloseEvent) => {
             console.log('Connection closed.');
           },
         },
       });
       ```
      */ async connect(params) {
        var _a, _b, _c, _d, _e, _f;
        // TODO: b/404946746 - Support per request HTTP options.
        if (params.config && params.config.httpOptions) throw new Error("The Live module does not support httpOptions at request-level in LiveConnectConfig yet. Please use the client-level httpOptions configuration instead.");
        const websocketBaseUrl = this.apiClient.getWebsocketBaseUrl();
        const apiVersion = this.apiClient.getApiVersion();
        let url;
        const clientHeaders = this.apiClient.getHeaders();
        if (params.config && params.config.tools && $e4deb49dba5321bc$var$hasMcpToolUsage(params.config.tools)) $e4deb49dba5321bc$var$setMcpUsageHeader(clientHeaders);
        const headers = $e4deb49dba5321bc$var$mapToHeaders(clientHeaders);
        if (this.apiClient.isVertexAI()) {
            const project = this.apiClient.getProject();
            const location = this.apiClient.getLocation();
            const apiKey = this.apiClient.getApiKey();
            const hasStandardAuth = !!project && !!location || !!apiKey;
            if (this.apiClient.getCustomBaseUrl() && !hasStandardAuth) // Custom base URL without standard auth (e.g., proxy).
            url = websocketBaseUrl;
            else {
                url = `${websocketBaseUrl}/ws/google.cloud.aiplatform.${apiVersion}.LlmBidiService/BidiGenerateContent`;
                await this.auth.addAuthHeaders(headers, url);
            }
        } else {
            const apiKey = this.apiClient.getApiKey();
            let method = 'BidiGenerateContent';
            let keyName = 'key';
            if (apiKey === null || apiKey === void 0 ? void 0 : apiKey.startsWith('auth_tokens/')) {
                console.warn('Warning: Ephemeral token support is experimental and may change in future versions.');
                if (apiVersion !== 'v1alpha') console.warn("Warning: The SDK's ephemeral token support is in v1alpha only. Please use const ai = new GoogleGenAI({apiKey: token.name, httpOptions: { apiVersion: 'v1alpha' }}); before session connection.");
                method = 'BidiGenerateContentConstrained';
                keyName = 'access_token';
            }
            url = `${websocketBaseUrl}/ws/google.ai.generativelanguage.${apiVersion}.GenerativeService.${method}?${keyName}=${apiKey}`;
        }
        let onopenResolve = ()=>{};
        const onopenPromise = new Promise((resolve)=>{
            onopenResolve = resolve;
        });
        const callbacks = params.callbacks;
        const onopenAwaitedCallback = function() {
            var _a;
            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onopen) === null || _a === void 0 || _a.call(callbacks);
            onopenResolve({});
        };
        const apiClient = this.apiClient;
        const websocketCallbacks = {
            onopen: onopenAwaitedCallback,
            onmessage: (event)=>{
                $e4deb49dba5321bc$var$handleWebSocketMessage(apiClient, callbacks.onmessage, event);
            },
            onerror: (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onerror) !== null && _a !== void 0 ? _a : function(e) {},
            onclose: (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onclose) !== null && _b !== void 0 ? _b : function(e) {}
        };
        const conn = this.webSocketFactory.create(url, $e4deb49dba5321bc$var$headersToMap(headers), websocketCallbacks);
        conn.connect();
        // Wait for the websocket to open before sending requests.
        await onopenPromise;
        let transformedModel = $e4deb49dba5321bc$var$tModel(this.apiClient, params.model);
        if (this.apiClient.isVertexAI() && transformedModel.startsWith('publishers/')) {
            const project = this.apiClient.getProject();
            const location = this.apiClient.getLocation();
            if (project && location) transformedModel = `projects/${project}/locations/${location}/` + transformedModel;
        }
        let clientMessage = {};
        if (this.apiClient.isVertexAI() && ((_c = params.config) === null || _c === void 0 ? void 0 : _c.responseModalities) === undefined) {
            // Set default to AUDIO to align with MLDev API.
            if (params.config === undefined) params.config = {
                responseModalities: [
                    $e4deb49dba5321bc$export$9c9a8220008ddfc0.AUDIO
                ]
            };
            else params.config.responseModalities = [
                $e4deb49dba5321bc$export$9c9a8220008ddfc0.AUDIO
            ];
        }
        if ((_d = params.config) === null || _d === void 0 ? void 0 : _d.generationConfig) // Raise deprecation warning for generationConfig.
        console.warn('Setting `LiveConnectConfig.generation_config` is deprecated, please set the fields on `LiveConnectConfig` directly. This will become an error in a future version (not before Q3 2025).');
        const inputTools = (_f = (_e = params.config) === null || _e === void 0 ? void 0 : _e.tools) !== null && _f !== void 0 ? _f : [];
        const convertedTools = [];
        for (const tool of inputTools)if (this.isCallableTool(tool)) {
            const callableTool = tool;
            convertedTools.push(await callableTool.tool());
        } else convertedTools.push(tool);
        if (convertedTools.length > 0) params.config.tools = convertedTools;
        const liveConnectParameters = {
            model: transformedModel,
            config: params.config,
            callbacks: params.callbacks
        };
        if (this.apiClient.isVertexAI()) clientMessage = $e4deb49dba5321bc$var$liveConnectParametersToVertex(this.apiClient, liveConnectParameters);
        else clientMessage = $e4deb49dba5321bc$var$liveConnectParametersToMldev(this.apiClient, liveConnectParameters);
        delete clientMessage['config'];
        conn.send(JSON.stringify(clientMessage));
        return new $e4deb49dba5321bc$export$1fb4852a55678982(conn, this.apiClient);
    }
    // TODO: b/416041229 - Abstract this method to a common place.
    isCallableTool(tool) {
        return 'callTool' in tool && typeof tool.callTool === 'function';
    }
}
const $e4deb49dba5321bc$var$defaultLiveSendClientContentParamerters = {
    turnComplete: true
};
/**
   Represents a connection to the API.

   @experimental
  */ class $e4deb49dba5321bc$export$1fb4852a55678982 {
    constructor(conn, apiClient){
        this.conn = conn;
        this.apiClient = apiClient;
    }
    tLiveClientContent(apiClient, params) {
        if (params.turns !== null && params.turns !== undefined) {
            let contents = [];
            try {
                contents = $e4deb49dba5321bc$var$tContents(params.turns);
                if (!apiClient.isVertexAI()) contents = contents.map((item)=>$e4deb49dba5321bc$var$contentToMldev$1(item));
            } catch (_a) {
                throw new Error(`Failed to parse client content "turns", type: '${typeof params.turns}'`);
            }
            return {
                clientContent: {
                    turns: contents,
                    turnComplete: params.turnComplete
                }
            };
        }
        return {
            clientContent: {
                turnComplete: params.turnComplete
            }
        };
    }
    tLiveClienttToolResponse(apiClient, params) {
        let functionResponses = [];
        if (params.functionResponses == null) throw new Error('functionResponses is required.');
        if (!Array.isArray(params.functionResponses)) functionResponses = [
            params.functionResponses
        ];
        else functionResponses = params.functionResponses;
        if (functionResponses.length === 0) throw new Error('functionResponses is required.');
        for (const functionResponse of functionResponses){
            if (typeof functionResponse !== 'object' || functionResponse === null || !('name' in functionResponse) || !('response' in functionResponse)) throw new Error(`Could not parse function response, type '${typeof functionResponse}'.`);
            if (!apiClient.isVertexAI() && !('id' in functionResponse)) throw new Error($e4deb49dba5321bc$var$FUNCTION_RESPONSE_REQUIRES_ID);
        }
        const clientMessage = {
            toolResponse: {
                functionResponses: functionResponses
            }
        };
        return clientMessage;
    }
    /**
      Send a message over the established connection.
  
      @param params - Contains two **optional** properties, `turns` and
          `turnComplete`.
  
        - `turns` will be converted to a `Content[]`
        - `turnComplete: true` [default] indicates that you are done sending
          content and expect a response. If `turnComplete: false`, the server
          will wait for additional messages before starting generation.
  
      @experimental
  
      @remarks
      There are two ways to send messages to the live API:
      `sendClientContent` and `sendRealtimeInput`.
  
      `sendClientContent` messages are added to the model context **in order**.
      Having a conversation using `sendClientContent` messages is roughly
      equivalent to using the `Chat.sendMessageStream`, except that the state of
      the `chat` history is stored on the API server instead of locally.
  
      Because of `sendClientContent`'s order guarantee, the model cannot respons
      as quickly to `sendClientContent` messages as to `sendRealtimeInput`
      messages. This makes the biggest difference when sending objects that have
      significant preprocessing time (typically images).
  
      The `sendClientContent` message sends a `Content[]`
      which has more options than the `Blob` sent by `sendRealtimeInput`.
  
      So the main use-cases for `sendClientContent` over `sendRealtimeInput` are:
  
      - Sending anything that can't be represented as a `Blob` (text,
      `sendClientContent({turns="Hello?"}`)).
      - Managing turns when not using audio input and voice activity detection.
        (`sendClientContent({turnComplete:true})` or the short form
      `sendClientContent()`)
      - Prefilling a conversation context
        ```
        sendClientContent({
            turns: [
              Content({role:user, parts:...}),
              Content({role:user, parts:...}),
              ...
            ]
        })
        ```
      @experimental
     */ sendClientContent(params) {
        params = Object.assign(Object.assign({}, $e4deb49dba5321bc$var$defaultLiveSendClientContentParamerters), params);
        const clientMessage = this.tLiveClientContent(this.apiClient, params);
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
      Send a realtime message over the established connection.
  
      @param params - Contains one property, `media`.
  
        - `media` will be converted to a `Blob`
  
      @experimental
  
      @remarks
      Use `sendRealtimeInput` for realtime audio chunks and video frames (images).
  
      With `sendRealtimeInput` the api will respond to audio automatically
      based on voice activity detection (VAD).
  
      `sendRealtimeInput` is optimized for responsivness at the expense of
      deterministic ordering guarantees. Audio and video tokens are to the
      context when they become available.
  
      Note: The Call signature expects a `Blob` object, but only a subset
      of audio and image mimetypes are allowed.
     */ sendRealtimeInput(params) {
        let clientMessage = {};
        if (this.apiClient.isVertexAI()) clientMessage = {
            'realtimeInput': $e4deb49dba5321bc$var$liveSendRealtimeInputParametersToVertex(params)
        };
        else clientMessage = {
            'realtimeInput': $e4deb49dba5321bc$var$liveSendRealtimeInputParametersToMldev(params)
        };
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
      Send a function response message over the established connection.
  
      @param params - Contains property `functionResponses`.
  
        - `functionResponses` will be converted to a `functionResponses[]`
  
      @remarks
      Use `sendFunctionResponse` to reply to `LiveServerToolCall` from the server.
  
      Use {@link types.LiveConnectConfig#tools} to configure the callable functions.
  
      @experimental
     */ sendToolResponse(params) {
        if (params.functionResponses == null) throw new Error('Tool response parameters are required.');
        const clientMessage = this.tLiveClienttToolResponse(this.apiClient, params);
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
       Terminates the WebSocket connection.
  
       @experimental
  
       @example
       ```ts
       let model: string;
       if (GOOGLE_GENAI_USE_VERTEXAI) {
         model = 'gemini-2.0-flash-live-preview-04-09';
       } else {
         model = 'gemini-live-2.5-flash-preview';
       }
       const session = await ai.live.connect({
         model: model,
         config: {
           responseModalities: [Modality.AUDIO],
         }
       });
  
       session.close();
       ```
     */ close() {
        this.conn.close();
    }
}
// Converts an headers object to a "map" object as expected by the WebSocket
// constructor. We use this as the Auth interface works with Headers objects
// while the WebSocket constructor takes a map.
function $e4deb49dba5321bc$var$headersToMap(headers) {
    const headerMap = {};
    headers.forEach((value, key)=>{
        headerMap[key] = value;
    });
    return headerMap;
}
// Converts a "map" object to a headers object. We use this as the Auth
// interface works with Headers objects while the API client default headers
// returns a map.
function $e4deb49dba5321bc$var$mapToHeaders(map) {
    const headers = new Headers();
    for (const [key, value] of Object.entries(map))headers.append(key, value);
    return headers;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$DEFAULT_MAX_REMOTE_CALLS = 10;
/** Returns whether automatic function calling is disabled. */ function $e4deb49dba5321bc$var$shouldDisableAfc(config) {
    var _a, _b, _c;
    if ((_a = config === null || config === void 0 ? void 0 : config.automaticFunctionCalling) === null || _a === void 0 ? void 0 : _a.disable) return true;
    let callableToolsPresent = false;
    for (const tool of (_b = config === null || config === void 0 ? void 0 : config.tools) !== null && _b !== void 0 ? _b : [])if ($e4deb49dba5321bc$var$isCallableTool(tool)) {
        callableToolsPresent = true;
        break;
    }
    if (!callableToolsPresent) return true;
    const maxCalls = (_c = config === null || config === void 0 ? void 0 : config.automaticFunctionCalling) === null || _c === void 0 ? void 0 : _c.maximumRemoteCalls;
    if (maxCalls && (maxCalls < 0 || !Number.isInteger(maxCalls)) || maxCalls == 0) {
        console.warn('Invalid maximumRemoteCalls value provided for automatic function calling. Disabled automatic function calling. Please provide a valid integer value greater than 0. maximumRemoteCalls provided:', maxCalls);
        return true;
    }
    return false;
}
function $e4deb49dba5321bc$var$isCallableTool(tool) {
    return 'callTool' in tool && typeof tool.callTool === 'function';
}
// Checks whether the list of tools contains any CallableTools. Will return true
// if there is at least one CallableTool.
function $e4deb49dba5321bc$var$hasCallableTools(params) {
    var _a, _b, _c;
    return (_c = (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools) === null || _b === void 0 ? void 0 : _b.some((tool)=>$e4deb49dba5321bc$var$isCallableTool(tool))) !== null && _c !== void 0 ? _c : false;
}
/**
 * Returns the indexes of the tools that are not compatible with AFC.
 */ function $e4deb49dba5321bc$var$findAfcIncompatibleToolIndexes(params) {
    var _a;
    // Use number[] for an array of numbers in TypeScript
    const afcIncompatibleToolIndexes = [];
    if (!((_a = params === null || params === void 0 ? void 0 : params.config) === null || _a === void 0 ? void 0 : _a.tools)) return afcIncompatibleToolIndexes;
    params.config.tools.forEach((tool, index)=>{
        if ($e4deb49dba5321bc$var$isCallableTool(tool)) return;
        const geminiTool = tool;
        if (geminiTool.functionDeclarations && geminiTool.functionDeclarations.length > 0) afcIncompatibleToolIndexes.push(index);
    });
    return afcIncompatibleToolIndexes;
}
/**
 * Returns whether to append automatic function calling history to the
 * response.
 */ function $e4deb49dba5321bc$var$shouldAppendAfcHistory(config) {
    var _a;
    return !((_a = config === null || config === void 0 ? void 0 : config.automaticFunctionCalling) === null || _a === void 0 ? void 0 : _a.ignoreCallHistory);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$6edbc060ce567afa extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Calculates embeddings for the given contents.
         *
         * @param params - The parameters for embedding contents.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await ai.models.embedContent({
         *  model: 'text-embedding-004',
         *  contents: [
         *    'What is your name?',
         *    'What is your favorite color?',
         *  ],
         *  config: {
         *    outputDimensionality: 64,
         *  },
         * });
         * console.log(response);
         * ```
         */ this.embedContent = async (params)=>{
            if (!this.apiClient.isVertexAI()) return await this.embedContentInternal(params);
            const isVertexEmbedContentModel = params.model.includes('gemini') && params.model !== 'gemini-embedding-001' || params.model.includes('maas');
            if (isVertexEmbedContentModel) {
                const contents = $e4deb49dba5321bc$var$tContents(params.contents);
                if (contents.length > 1) throw new Error('The embedContent API for this model only supports one content at a time.');
                const paramsPrivate = Object.assign(Object.assign({}, params), {
                    content: contents[0],
                    embeddingApiType: $e4deb49dba5321bc$export$adb1a6c77f7d58e6.EMBED_CONTENT
                });
                return await this.embedContentInternal(paramsPrivate);
            } else {
                const paramsPrivate = Object.assign(Object.assign({}, params), {
                    embeddingApiType: $e4deb49dba5321bc$export$adb1a6c77f7d58e6.PREDICT
                });
                return await this.embedContentInternal(paramsPrivate);
            }
        };
        /**
         * Makes an API request to generate content with a given model.
         *
         * For the `model` parameter, supported formats for Vertex AI API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The full resource name starts with 'projects/', for example:
         *  'projects/my-project-id/locations/us-central1/publishers/google/models/gemini-2.0-flash'
         * - The partial resource name with 'publishers/', for example:
         *  'publishers/google/models/gemini-2.0-flash' or
         *  'publishers/meta/models/llama-3.1-405b-instruct-maas'
         * - `/` separated publisher and model name, for example:
         * 'google/gemini-2.0-flash' or 'meta/llama-3.1-405b-instruct-maas'
         *
         * For the `model` parameter, supported formats for Gemini API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The model name starts with 'models/', for example:
         *  'models/gemini-2.0-flash'
         * - For tuned models, the model name starts with 'tunedModels/',
         * for example:
         * 'tunedModels/1234567890123456789'
         *
         * Some models support multimodal input and output.
         *
         * @param params - The parameters for generating content.
         * @return The response from generating content.
         *
         * @example
         * ```ts
         * const response = await ai.models.generateContent({
         *   model: 'gemini-2.0-flash',
         *   contents: 'why is the sky blue?',
         *   config: {
         *     candidateCount: 2,
         *   }
         * });
         * console.log(response);
         * ```
         */ this.generateContent = async (params)=>{
            var _a, _b, _c, _d, _e;
            const transformedParams = await this.processParamsMaybeAddMcpUsage(params);
            this.maybeMoveToResponseJsonSchem(params);
            if (!$e4deb49dba5321bc$var$hasCallableTools(params) || $e4deb49dba5321bc$var$shouldDisableAfc(params.config)) return await this.generateContentInternal(transformedParams);
            const incompatibleToolIndexes = $e4deb49dba5321bc$var$findAfcIncompatibleToolIndexes(params);
            if (incompatibleToolIndexes.length > 0) {
                const formattedIndexes = incompatibleToolIndexes.map((index)=>`tools[${index}]`).join(', ');
                throw new Error(`Automatic function calling with CallableTools (or MCP objects) and basic FunctionDeclarations is not yet supported. Incompatible tools found at ${formattedIndexes}.`);
            }
            let response;
            let functionResponseContent;
            const automaticFunctionCallingHistory = $e4deb49dba5321bc$var$tContents(transformedParams.contents);
            const maxRemoteCalls = (_c = (_b = (_a = transformedParams.config) === null || _a === void 0 ? void 0 : _a.automaticFunctionCalling) === null || _b === void 0 ? void 0 : _b.maximumRemoteCalls) !== null && _c !== void 0 ? _c : $e4deb49dba5321bc$var$DEFAULT_MAX_REMOTE_CALLS;
            let remoteCalls = 0;
            while(remoteCalls < maxRemoteCalls){
                response = await this.generateContentInternal(transformedParams);
                if (!response.functionCalls || response.functionCalls.length === 0) break;
                const responseContent = response.candidates[0].content;
                const functionResponseParts = [];
                for (const tool of (_e = (_d = params.config) === null || _d === void 0 ? void 0 : _d.tools) !== null && _e !== void 0 ? _e : [])if ($e4deb49dba5321bc$var$isCallableTool(tool)) {
                    const callableTool = tool;
                    const parts = await callableTool.callTool(response.functionCalls);
                    functionResponseParts.push(...parts);
                }
                remoteCalls++;
                functionResponseContent = {
                    role: 'user',
                    parts: functionResponseParts
                };
                transformedParams.contents = $e4deb49dba5321bc$var$tContents(transformedParams.contents);
                transformedParams.contents.push(responseContent);
                transformedParams.contents.push(functionResponseContent);
                if ($e4deb49dba5321bc$var$shouldAppendAfcHistory(transformedParams.config)) {
                    automaticFunctionCallingHistory.push(responseContent);
                    automaticFunctionCallingHistory.push(functionResponseContent);
                }
            }
            if ($e4deb49dba5321bc$var$shouldAppendAfcHistory(transformedParams.config)) response.automaticFunctionCallingHistory = automaticFunctionCallingHistory;
            return response;
        };
        /**
         * Makes an API request to generate content with a given model and yields the
         * response in chunks.
         *
         * For the `model` parameter, supported formats for Vertex AI API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The full resource name starts with 'projects/', for example:
         *  'projects/my-project-id/locations/us-central1/publishers/google/models/gemini-2.0-flash'
         * - The partial resource name with 'publishers/', for example:
         *  'publishers/google/models/gemini-2.0-flash' or
         *  'publishers/meta/models/llama-3.1-405b-instruct-maas'
         * - `/` separated publisher and model name, for example:
         * 'google/gemini-2.0-flash' or 'meta/llama-3.1-405b-instruct-maas'
         *
         * For the `model` parameter, supported formats for Gemini API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The model name starts with 'models/', for example:
         *  'models/gemini-2.0-flash'
         * - For tuned models, the model name starts with 'tunedModels/',
         * for example:
         *  'tunedModels/1234567890123456789'
         *
         * Some models support multimodal input and output.
         *
         * @param params - The parameters for generating content with streaming response.
         * @return The response from generating content.
         *
         * @example
         * ```ts
         * const response = await ai.models.generateContentStream({
         *   model: 'gemini-2.0-flash',
         *   contents: 'why is the sky blue?',
         *   config: {
         *     maxOutputTokens: 200,
         *   }
         * });
         * for await (const chunk of response) {
         *   console.log(chunk);
         * }
         * ```
         */ this.generateContentStream = async (params)=>{
            var _a, _b, _c, _d, _e;
            this.maybeMoveToResponseJsonSchem(params);
            if ($e4deb49dba5321bc$var$shouldDisableAfc(params.config)) {
                const transformedParams = await this.processParamsMaybeAddMcpUsage(params);
                return await this.generateContentStreamInternal(transformedParams);
            }
            const incompatibleToolIndexes = $e4deb49dba5321bc$var$findAfcIncompatibleToolIndexes(params);
            if (incompatibleToolIndexes.length > 0) {
                const formattedIndexes = incompatibleToolIndexes.map((index)=>`tools[${index}]`).join(', ');
                throw new Error(`Incompatible tools found at ${formattedIndexes}. Automatic function calling with CallableTools (or MCP objects) and basic FunctionDeclarations" is not yet supported.`);
            }
            // With tool compatibility confirmed, validate that the configuration are
            // compatible with each other and raise an error if invalid.
            const streamFunctionCall = (_c = (_b = (_a = params === null || params === void 0 ? void 0 : params.config) === null || _a === void 0 ? void 0 : _a.toolConfig) === null || _b === void 0 ? void 0 : _b.functionCallingConfig) === null || _c === void 0 ? void 0 : _c.streamFunctionCallArguments;
            const disableAfc = (_e = (_d = params === null || params === void 0 ? void 0 : params.config) === null || _d === void 0 ? void 0 : _d.automaticFunctionCalling) === null || _e === void 0 ? void 0 : _e.disable;
            if (streamFunctionCall && !disableAfc) throw new Error("Running in streaming mode with 'streamFunctionCallArguments' enabled, this feature is not compatible with automatic function calling (AFC). Please set 'config.automaticFunctionCalling.disable' to true to disable AFC or leave 'config.toolConfig.functionCallingConfig.streamFunctionCallArguments' to be undefined or set to false to disable streaming function call arguments feature.");
            return await this.processAfcStream(params);
        };
        /**
         * Generates an image based on a text description and configuration.
         *
         * @param params - The parameters for generating images.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await client.models.generateImages({
         *  model: 'imagen-4.0-generate-001',
         *  prompt: 'Robot holding a red skateboard',
         *  config: {
         *    numberOfImages: 1,
         *    includeRaiReason: true,
         *  },
         * });
         * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
         * ```
         */ this.generateImages = async (params)=>{
            return await this.generateImagesInternal(params).then((apiResponse)=>{
                var _a;
                let positivePromptSafetyAttributes;
                const generatedImages = [];
                if (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.generatedImages) {
                    for (const generatedImage of apiResponse.generatedImages)if (generatedImage && (generatedImage === null || generatedImage === void 0 ? void 0 : generatedImage.safetyAttributes) && ((_a = generatedImage === null || generatedImage === void 0 ? void 0 : generatedImage.safetyAttributes) === null || _a === void 0 ? void 0 : _a.contentType) === 'Positive Prompt') positivePromptSafetyAttributes = generatedImage === null || generatedImage === void 0 ? void 0 : generatedImage.safetyAttributes;
                    else generatedImages.push(generatedImage);
                }
                let response;
                if (positivePromptSafetyAttributes) response = {
                    generatedImages: generatedImages,
                    positivePromptSafetyAttributes: positivePromptSafetyAttributes,
                    sdkHttpResponse: apiResponse.sdkHttpResponse
                };
                else response = {
                    generatedImages: generatedImages,
                    sdkHttpResponse: apiResponse.sdkHttpResponse
                };
                return response;
            });
        };
        this.list = async (params)=>{
            var _a;
            const defaultConfig = {
                queryBase: true
            };
            const actualConfig = Object.assign(Object.assign({}, defaultConfig), params === null || params === void 0 ? void 0 : params.config);
            const actualParams = {
                config: actualConfig
            };
            if (this.apiClient.isVertexAI()) {
                if (!actualParams.config.queryBase) {
                    if ((_a = actualParams.config) === null || _a === void 0 ? void 0 : _a.filter) throw new Error('Filtering tuned models list for Vertex AI is not currently supported');
                    else actualParams.config.filter = 'labels.tune-type:*';
                }
            }
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_MODELS, (x)=>this.listInternal(x), await this.listInternal(actualParams), actualParams);
        };
        /**
         * Edits an image based on a prompt, list of reference images, and configuration.
         *
         * @param params - The parameters for editing an image.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await client.models.editImage({
         *  model: 'imagen-3.0-capability-001',
         *  prompt: 'Generate an image containing a mug with the product logo [1] visible on the side of the mug.',
         *  referenceImages: [subjectReferenceImage]
         *  config: {
         *    numberOfImages: 1,
         *    includeRaiReason: true,
         *  },
         * });
         * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
         * ```
         */ this.editImage = async (params)=>{
            const paramsInternal = {
                model: params.model,
                prompt: params.prompt,
                referenceImages: [],
                config: params.config
            };
            if (params.referenceImages) {
                if (params.referenceImages) paramsInternal.referenceImages = params.referenceImages.map((img)=>img.toReferenceImageAPI());
            }
            return await this.editImageInternal(paramsInternal);
        };
        /**
         * Upscales an image based on an image, upscale factor, and configuration.
         * Only supported in Vertex AI currently.
         *
         * @param params - The parameters for upscaling an image.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await client.models.upscaleImage({
         *  model: 'imagen-4.0-upscale-preview',
         *  image: image,
         *  upscaleFactor: 'x2',
         *  config: {
         *    includeRaiReason: true,
         *  },
         * });
         * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
         * ```
         */ this.upscaleImage = async (params)=>{
            let apiConfig = {
                numberOfImages: 1,
                mode: 'upscale'
            };
            if (params.config) apiConfig = Object.assign(Object.assign({}, apiConfig), params.config);
            const apiParams = {
                model: params.model,
                image: params.image,
                upscaleFactor: params.upscaleFactor,
                config: apiConfig
            };
            return await this.upscaleImageInternal(apiParams);
        };
        /**
         *  Generates videos based on a text description and configuration.
         *
         * @param params - The parameters for generating videos.
         * @return A Promise<GenerateVideosOperation> which allows you to track the progress and eventually retrieve the generated videos using the operations.get method.
         *
         * @example
         * ```ts
         * const operation = await ai.models.generateVideos({
         *  model: 'veo-2.0-generate-001',
         *  source: {
         *    prompt: 'A neon hologram of a cat driving at top speed',
         *  },
         *  config: {
         *    numberOfVideos: 1
         * });
         *
         * while (!operation.done) {
         *   await new Promise(resolve => setTimeout(resolve, 10000));
         *   operation = await ai.operations.getVideosOperation({operation: operation});
         * }
         *
         * console.log(operation.response?.generatedVideos?.[0]?.video?.uri);
         * ```
         */ this.generateVideos = async (params)=>{
            var _a, _b, _c, _d, _e, _f;
            if ((params.prompt || params.image || params.video) && params.source) throw new Error('Source and prompt/image/video are mutually exclusive. Please only use source.');
            // Gemini API does not support video bytes.
            if (!this.apiClient.isVertexAI()) {
                if (((_a = params.video) === null || _a === void 0 ? void 0 : _a.uri) && ((_b = params.video) === null || _b === void 0 ? void 0 : _b.videoBytes)) params.video = {
                    uri: params.video.uri,
                    mimeType: params.video.mimeType
                };
                else if (((_d = (_c = params.source) === null || _c === void 0 ? void 0 : _c.video) === null || _d === void 0 ? void 0 : _d.uri) && ((_f = (_e = params.source) === null || _e === void 0 ? void 0 : _e.video) === null || _f === void 0 ? void 0 : _f.videoBytes)) params.source.video = {
                    uri: params.source.video.uri,
                    mimeType: params.source.video.mimeType
                };
            }
            return await this.generateVideosInternal(params);
        };
    }
    /**
     * This logic is needed for GenerateContentConfig only.
     * Previously we made GenerateContentConfig.responseSchema field to accept
     * unknown. Since v1.9.0, we switch to use backend JSON schema support.
     * To maintain backward compatibility, we move the data that was treated as
     * JSON schema from the responseSchema field to the responseJsonSchema field.
     */ maybeMoveToResponseJsonSchem(params) {
        if (params.config && params.config.responseSchema) {
            if (!params.config.responseJsonSchema) {
                if (Object.keys(params.config.responseSchema).includes('$schema')) {
                    params.config.responseJsonSchema = params.config.responseSchema;
                    delete params.config.responseSchema;
                }
            }
        }
        return;
    }
    /**
     * Transforms the CallableTools in the parameters to be simply Tools, it
     * copies the params into a new object and replaces the tools, it does not
     * modify the original params. Also sets the MCP usage header if there are
     * MCP tools in the parameters.
     */ async processParamsMaybeAddMcpUsage(params) {
        var _a, _b, _c;
        const tools = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools;
        if (!tools) return params;
        const transformedTools = await Promise.all(tools.map(async (tool)=>{
            if ($e4deb49dba5321bc$var$isCallableTool(tool)) {
                const callableTool = tool;
                return await callableTool.tool();
            }
            return tool;
        }));
        const newParams = {
            model: params.model,
            contents: params.contents,
            config: Object.assign(Object.assign({}, params.config), {
                tools: transformedTools
            })
        };
        newParams.config.tools = transformedTools;
        if (params.config && params.config.tools && $e4deb49dba5321bc$var$hasMcpToolUsage(params.config.tools)) {
            const headers = (_c = (_b = params.config.httpOptions) === null || _b === void 0 ? void 0 : _b.headers) !== null && _c !== void 0 ? _c : {};
            let newHeaders = Object.assign({}, headers);
            if (Object.keys(newHeaders).length === 0) newHeaders = this.apiClient.getDefaultHeaders();
            $e4deb49dba5321bc$var$setMcpUsageHeader(newHeaders);
            newParams.config.httpOptions = Object.assign(Object.assign({}, params.config.httpOptions), {
                headers: newHeaders
            });
        }
        return newParams;
    }
    async initAfcToolsMap(params) {
        var _a, _b, _c;
        const afcTools = new Map();
        for (const tool of (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools) !== null && _b !== void 0 ? _b : [])if ($e4deb49dba5321bc$var$isCallableTool(tool)) {
            const callableTool = tool;
            const toolDeclaration = await callableTool.tool();
            for (const declaration of (_c = toolDeclaration.functionDeclarations) !== null && _c !== void 0 ? _c : []){
                if (!declaration.name) throw new Error('Function declaration name is required.');
                if (afcTools.has(declaration.name)) throw new Error(`Duplicate tool declaration name: ${declaration.name}`);
                afcTools.set(declaration.name, callableTool);
            }
        }
        return afcTools;
    }
    async processAfcStream(params) {
        var _a, _b, _c;
        const maxRemoteCalls = (_c = (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.automaticFunctionCalling) === null || _b === void 0 ? void 0 : _b.maximumRemoteCalls) !== null && _c !== void 0 ? _c : $e4deb49dba5321bc$var$DEFAULT_MAX_REMOTE_CALLS;
        let wereFunctionsCalled = false;
        let remoteCallCount = 0;
        const afcToolsMap = await this.initAfcToolsMap(params);
        return function(models, afcTools, params) {
            return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function*() {
                var _a, e_1, _b, _c;
                var _d, _e;
                while(remoteCallCount < maxRemoteCalls){
                    if (wereFunctionsCalled) {
                        remoteCallCount++;
                        wereFunctionsCalled = false;
                    }
                    const transformedParams = yield $e4deb49dba5321bc$var$__await(models.processParamsMaybeAddMcpUsage(params));
                    const response = yield $e4deb49dba5321bc$var$__await(models.generateContentStreamInternal(transformedParams));
                    const functionResponses = [];
                    const responseContents = [];
                    try {
                        for(var _f = true, response_1 = (e_1 = void 0, $e4deb49dba5321bc$var$__asyncValues(response)), response_1_1; response_1_1 = yield $e4deb49dba5321bc$var$__await(response_1.next()), _a = response_1_1.done, !_a; _f = true){
                            _c = response_1_1.value;
                            _f = false;
                            const chunk = _c;
                            yield yield $e4deb49dba5321bc$var$__await(chunk);
                            if (chunk.candidates && ((_d = chunk.candidates[0]) === null || _d === void 0 ? void 0 : _d.content)) {
                                responseContents.push(chunk.candidates[0].content);
                                for (const part of (_e = chunk.candidates[0].content.parts) !== null && _e !== void 0 ? _e : [])if (remoteCallCount < maxRemoteCalls && part.functionCall) {
                                    if (!part.functionCall.name) throw new Error('Function call name was not returned by the model.');
                                    if (!afcTools.has(part.functionCall.name)) throw new Error(`Automatic function calling was requested, but not all the tools the model used implement the CallableTool interface. Available tools: ${afcTools.keys()}, mising tool: ${part.functionCall.name}`);
                                    else {
                                        const responseParts = yield $e4deb49dba5321bc$var$__await(afcTools.get(part.functionCall.name).callTool([
                                            part.functionCall
                                        ]));
                                        functionResponses.push(...responseParts);
                                    }
                                }
                            }
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (!_f && !_a && (_b = response_1.return)) yield $e4deb49dba5321bc$var$__await(_b.call(response_1));
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (functionResponses.length > 0) {
                        wereFunctionsCalled = true;
                        const typedResponseChunk = new $e4deb49dba5321bc$export$87445595052c5212();
                        typedResponseChunk.candidates = [
                            {
                                content: {
                                    role: 'user',
                                    parts: functionResponses
                                }
                            }
                        ];
                        yield yield $e4deb49dba5321bc$var$__await(typedResponseChunk);
                        const newContents = [];
                        newContents.push(...responseContents);
                        newContents.push({
                            role: 'user',
                            parts: functionResponses
                        });
                        const updatedContents = $e4deb49dba5321bc$var$tContents(params.contents).concat(newContents);
                        params.contents = updatedContents;
                    } else break;
                }
            });
        }(this, afcToolsMap, params);
    }
    async generateContentInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$generateContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:generateContent', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateContentResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$87445595052c5212();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$generateContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:generateContent', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateContentResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$87445595052c5212();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async generateContentStreamInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$generateContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:streamGenerateContent?alt=sse', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            const apiClient = this.apiClient;
            response = apiClient.requestStream({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            });
            return response.then(function(apiResponse) {
                return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function*() {
                    var _a, e_2, _b, _c;
                    try {
                        for(var _d = true, apiResponse_1 = $e4deb49dba5321bc$var$__asyncValues(apiResponse), apiResponse_1_1; apiResponse_1_1 = yield $e4deb49dba5321bc$var$__await(apiResponse_1.next()), _a = apiResponse_1_1.done, !_a; _d = true){
                            _c = apiResponse_1_1.value;
                            _d = false;
                            const chunk = _c;
                            const resp = $e4deb49dba5321bc$var$generateContentResponseFromVertex((yield $e4deb49dba5321bc$var$__await(chunk.json())), params);
                            resp['sdkHttpResponse'] = {
                                headers: chunk.headers
                            };
                            const typedResp = new $e4deb49dba5321bc$export$87445595052c5212();
                            Object.assign(typedResp, resp);
                            yield yield $e4deb49dba5321bc$var$__await(typedResp);
                        }
                    } catch (e_2_1) {
                        e_2 = {
                            error: e_2_1
                        };
                    } finally{
                        try {
                            if (!_d && !_a && (_b = apiResponse_1.return)) yield $e4deb49dba5321bc$var$__await(_b.call(apiResponse_1));
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                    }
                });
            });
        } else {
            const body = $e4deb49dba5321bc$var$generateContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:streamGenerateContent?alt=sse', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            const apiClient = this.apiClient;
            response = apiClient.requestStream({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            });
            return response.then(function(apiResponse) {
                return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function*() {
                    var _a, e_3, _b, _c;
                    try {
                        for(var _d = true, apiResponse_2 = $e4deb49dba5321bc$var$__asyncValues(apiResponse), apiResponse_2_1; apiResponse_2_1 = yield $e4deb49dba5321bc$var$__await(apiResponse_2.next()), _a = apiResponse_2_1.done, !_a; _d = true){
                            _c = apiResponse_2_1.value;
                            _d = false;
                            const chunk = _c;
                            const resp = $e4deb49dba5321bc$var$generateContentResponseFromMldev((yield $e4deb49dba5321bc$var$__await(chunk.json())), params);
                            resp['sdkHttpResponse'] = {
                                headers: chunk.headers
                            };
                            const typedResp = new $e4deb49dba5321bc$export$87445595052c5212();
                            Object.assign(typedResp, resp);
                            yield yield $e4deb49dba5321bc$var$__await(typedResp);
                        }
                    } catch (e_3_1) {
                        e_3 = {
                            error: e_3_1
                        };
                    } finally{
                        try {
                            if (!_d && !_a && (_b = apiResponse_2.return)) yield $e4deb49dba5321bc$var$__await(_b.call(apiResponse_2));
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                    }
                });
            });
        }
    }
    /**
     * Calculates embeddings for the given contents. Only text is supported.
     *
     * @param params - The parameters for embedding contents.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.embedContent({
     *  model: 'text-embedding-004',
     *  contents: [
     *    'What is your name?',
     *    'What is your favorite color?',
     *  ],
     *  config: {
     *    outputDimensionality: 64,
     *  },
     * });
     * console.log(response);
     * ```
     */ async embedContentInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$embedContentParametersPrivateToVertex(this.apiClient, params, params);
            const endpointUrl = $e4deb49dba5321bc$var$tIsVertexEmbedContentModel(params.model) ? '{model}:embedContent' : '{model}:predict';
            path = $e4deb49dba5321bc$var$formatMap(endpointUrl, body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$embedContentResponseFromVertex(apiResponse, params);
                const typedResp = new $e4deb49dba5321bc$export$1e9eee8641627f00();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$embedContentParametersPrivateToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:batchEmbedContents', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$embedContentResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$1e9eee8641627f00();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Private method for generating images.
     */ async generateImagesInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$generateImagesParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateImagesResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$f08095e7138eb0f4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$generateImagesParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateImagesResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$f08095e7138eb0f4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Private method for editing an image.
     */ async editImageInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$editImageParametersInternalToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$editImageResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$661afcf00ed2fbe8();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Private method for upscaling an image.
     */ async upscaleImageInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$upscaleImageAPIParametersInternalToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$upscaleImageResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$690402256314214();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Recontextualizes an image.
     *
     * There are two types of recontextualization currently supported:
     * 1) Imagen Product Recontext - Generate images of products in new scenes
     *    and contexts.
     * 2) Virtual Try-On: Generate images of persons modeling fashion products.
     *
     * @param params - The parameters for recontextualizing an image.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response1 = await ai.models.recontextImage({
     *  model: 'imagen-product-recontext-preview-06-30',
     *  source: {
     *    prompt: 'In a modern kitchen setting.',
     *    productImages: [productImage],
     *  },
     *  config: {
     *    numberOfImages: 1,
     *  },
     * });
     * console.log(response1?.generatedImages?.[0]?.image?.imageBytes);
     *
     * const response2 = await ai.models.recontextImage({
     *  model: 'virtual-try-on-001',
     *  source: {
     *    personImage: personImage,
     *    productImages: [productImage],
     *  },
     *  config: {
     *    numberOfImages: 1,
     *  },
     * });
     * console.log(response2?.generatedImages?.[0]?.image?.imageBytes);
     * ```
     */ async recontextImage(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$recontextImageParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$recontextImageResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$c2ead2074351d0f2();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Segments an image, creating a mask of a specified area.
     *
     * @param params - The parameters for segmenting an image.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.segmentImage({
     *  model: 'image-segmentation-001',
     *  source: {
     *    image: image,
     *  },
     *  config: {
     *    mode: 'foreground',
     *  },
     * });
     * console.log(response?.generatedMasks?.[0]?.mask?.imageBytes);
     * ```
     */ async segmentImage(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$segmentImageParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$segmentImageResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$304f360366a6eb53();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Fetches information about a model by name.
     *
     * @example
     * ```ts
     * const modelInfo = await ai.models.get({model: 'gemini-2.0-flash'});
     * ```
     */ async get(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getModelParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$modelFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$getModelParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$modelFromMldev(apiResponse);
                return resp;
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$listModelsParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{models_url}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listModelsResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$f159131a50016456();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$listModelsParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{models_url}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listModelsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$f159131a50016456();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Updates a tuned model by its name.
     *
     * @param params - The parameters for updating the model.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.update({
     *   model: 'tuned-model-name',
     *   config: {
     *     displayName: 'New display name',
     *     description: 'New description',
     *   },
     * });
     * ```
     */ async update(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$updateModelParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$modelFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$updateModelParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$modelFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Deletes a tuned model by its name.
     *
     * @param params - The parameters for deleting the model.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.delete({model: 'tuned-model-name'});
     * ```
     */ async delete(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$deleteModelParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteModelResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$179335935ae1d762();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$deleteModelParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteModelResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$179335935ae1d762();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Counts the number of tokens in the given contents. Multimodal input is
     * supported for Gemini models.
     *
     * @param params - The parameters for counting tokens.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.countTokens({
     *  model: 'gemini-2.0-flash',
     *  contents: 'The quick brown fox jumps over the lazy dog.'
     * });
     * console.log(response);
     * ```
     */ async countTokens(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$countTokensParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:countTokens', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$countTokensResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$b2422e769fe9acde();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$countTokensParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:countTokens', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$countTokensResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$b2422e769fe9acde();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Given a list of contents, returns a corresponding TokensInfo containing
     * the list of tokens and list of token ids.
     *
     * This method is not supported by the Gemini Developer API.
     *
     * @param params - The parameters for computing tokens.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.computeTokens({
     *  model: 'gemini-2.0-flash',
     *  contents: 'What is your name?'
     * });
     * console.log(response);
     * ```
     */ async computeTokens(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$computeTokensParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:computeTokens', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$computeTokensResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$8fb35c7d28173be();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Private method for generating videos.
     */ async generateVideosInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$generateVideosParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predictLongRunning', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateVideosOperationFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$d39812a6cdac2c57();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$generateVideosParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predictLongRunning', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateVideosOperationFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$d39812a6cdac2c57();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$3d72bd1ae0aee044 extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
    }
    /**
     * Gets the status of a long-running operation.
     *
     * @param parameters The parameters for the get operation request.
     * @return The updated Operation object, with the latest status or result.
     */ async getVideosOperation(parameters) {
        const operation = parameters.operation;
        const config = parameters.config;
        if (operation.name === undefined || operation.name === '') throw new Error('Operation name is required.');
        if (this.apiClient.isVertexAI()) {
            const resourceName = operation.name.split('/operations/')[0];
            let httpOptions = undefined;
            if (config && 'httpOptions' in config) httpOptions = config.httpOptions;
            const rawOperation = await this.fetchPredictVideosOperationInternal({
                operationName: operation.name,
                resourceName: resourceName,
                config: {
                    httpOptions: httpOptions
                }
            });
            return operation._fromAPIResponse({
                apiResponse: rawOperation,
                _isVertexAI: true
            });
        } else {
            const rawOperation = await this.getVideosOperationInternal({
                operationName: operation.name,
                config: config
            });
            return operation._fromAPIResponse({
                apiResponse: rawOperation,
                _isVertexAI: false
            });
        }
    }
    /**
     * Gets the status of a long-running operation.
     *
     * @param parameters The parameters for the get operation request.
     * @return The updated Operation object, with the latest status or result.
     */ async get(parameters) {
        const operation = parameters.operation;
        const config = parameters.config;
        if (operation.name === undefined || operation.name === '') throw new Error('Operation name is required.');
        if (this.apiClient.isVertexAI()) {
            const resourceName = operation.name.split('/operations/')[0];
            let httpOptions = undefined;
            if (config && 'httpOptions' in config) httpOptions = config.httpOptions;
            const rawOperation = await this.fetchPredictVideosOperationInternal({
                operationName: operation.name,
                resourceName: resourceName,
                config: {
                    httpOptions: httpOptions
                }
            });
            return operation._fromAPIResponse({
                apiResponse: rawOperation,
                _isVertexAI: true
            });
        } else {
            const rawOperation = await this.getVideosOperationInternal({
                operationName: operation.name,
                config: config
            });
            return operation._fromAPIResponse({
                apiResponse: rawOperation,
                _isVertexAI: false
            });
        }
    }
    async getVideosOperationInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getOperationParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('{operationName}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response;
        } else {
            const body = $e4deb49dba5321bc$var$getOperationParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{operationName}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response;
        }
    }
    async fetchPredictVideosOperationInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$fetchPredictOperationParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('{resourceName}:fetchPredictOperation', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response;
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$blobToMldev(fromObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$createAuthTokenConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    const fromNewSessionExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'newSessionExpireTime'
    ]);
    if (parentObject !== undefined && fromNewSessionExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'newSessionExpireTime'
    ], fromNewSessionExpireTime);
    const fromUses = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uses'
    ]);
    if (parentObject !== undefined && fromUses != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'uses'
    ], fromUses);
    const fromLiveConnectConstraints = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'liveConnectConstraints'
    ]);
    if (parentObject !== undefined && fromLiveConnectConstraints != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'bidiGenerateContentSetup'
    ], $e4deb49dba5321bc$var$liveConnectConstraintsToMldev(apiClient, fromLiveConnectConstraints));
    const fromLockAdditionalFields = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'lockAdditionalFields'
    ]);
    if (parentObject !== undefined && fromLockAdditionalFields != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'fieldMask'
    ], fromLockAdditionalFields);
    return toObject;
}
function $e4deb49dba5321bc$var$createAuthTokenParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$createAuthTokenConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partialArgs'
    ]) !== undefined) throw new Error('partialArgs parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'willContinue'
    ]) !== undefined) throw new Error('willContinue parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToMldev(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]) !== undefined) throw new Error('authConfig parameter is not supported in Gemini API.');
    const fromEnableWidget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableWidget'
    ]);
    if (fromEnableWidget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableWidget'
    ], fromEnableWidget);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev(fromObject) {
    const toObject = {};
    const fromSearchTypes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'searchTypes'
    ]);
    if (fromSearchTypes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'searchTypes'
    ], fromSearchTypes);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'blockingConfidence'
    ]) !== undefined) throw new Error('blockingConfidence parameter is not supported in Gemini API.');
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], fromTimeRangeFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig'
    ], fromGenerationConfig);
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (parentObject !== undefined && fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'responseModalities'
    ], fromResponseModalities);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (parentObject !== undefined && fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (parentObject !== undefined && fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (parentObject !== undefined && fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topK'
    ], fromTopK);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (parentObject !== undefined && fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (parentObject !== undefined && fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'mediaResolution'
    ], fromMediaResolution);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (parentObject !== undefined && fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'speechConfig'
    ], $e4deb49dba5321bc$var$tLiveSpeechConfig(fromSpeechConfig));
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (parentObject !== undefined && fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (parentObject !== undefined && fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'setup',
            'tools'
        ], transformedList);
    }
    const fromSessionResumption = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumption'
    ]);
    if (parentObject !== undefined && fromSessionResumption != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'sessionResumption'
    ], $e4deb49dba5321bc$var$sessionResumptionConfigToMldev(fromSessionResumption));
    const fromInputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromInputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'inputAudioTranscription'
    ], fromInputAudioTranscription);
    const fromOutputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromOutputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'outputAudioTranscription'
    ], fromOutputAudioTranscription);
    const fromRealtimeInputConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'realtimeInputConfig'
    ]);
    if (parentObject !== undefined && fromRealtimeInputConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'realtimeInputConfig'
    ], fromRealtimeInputConfig);
    const fromContextWindowCompression = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contextWindowCompression'
    ]);
    if (parentObject !== undefined && fromContextWindowCompression != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'contextWindowCompression'
    ], fromContextWindowCompression);
    const fromProactivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'proactivity'
    ]);
    if (parentObject !== undefined && fromProactivity != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'proactivity'
    ], fromProactivity);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'explicitVadSignal'
    ]) !== undefined) throw new Error('explicitVadSignal parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectConstraintsToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setup',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$liveConnectConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev(fromObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev(fromFileData));
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev(fromFunctionCall));
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev(fromInlineData));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$sessionResumptionConfigToMldev(fromObject) {
    const toObject = {};
    const fromHandle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'handle'
    ]);
    if (fromHandle != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'handle'
    ], fromHandle);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'transparent'
    ]) !== undefined) throw new Error('transparent parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    const fromFileSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]);
    if (fromFileSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileSearch'
    ], fromFileSearch);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev(fromGoogleSearch));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToMldev(fromGoogleMaps));
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    const fromMcpServers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]);
    if (fromMcpServers != null) {
        let transformedList = fromMcpServers;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mcpServers'
        ], transformedList);
    }
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Returns a comma-separated list of field masks from a given object.
 *
 * @param setup The object to extract field masks from.
 * @return A comma-separated list of field masks.
 */ function $e4deb49dba5321bc$var$getFieldMasks(setup) {
    const fields = [];
    for(const key in setup)if (Object.prototype.hasOwnProperty.call(setup, key)) {
        const value = setup[key];
        // 2nd layer, recursively get field masks see TODO(b/418290100)
        if (typeof value === 'object' && value != null && Object.keys(value).length > 0) {
            const field = Object.keys(value).map((kk)=>`${key}.${kk}`);
            fields.push(...field);
        } else fields.push(key); // 1st layer
    }
    return fields.join(',');
}
/**
 * Converts bidiGenerateContentSetup.
 * @param requestDict - The request dictionary.
 * @param config - The configuration object.
 * @return - The modified request dictionary.
 */ function $e4deb49dba5321bc$var$convertBidiSetupToTokenSetup(requestDict, config) {
    // Convert bidiGenerateContentSetup from bidiGenerateContentSetup.setup.
    let setupForMaskGeneration = null;
    const bidiGenerateContentSetupValue = requestDict['bidiGenerateContentSetup'];
    if (typeof bidiGenerateContentSetupValue === 'object' && bidiGenerateContentSetupValue !== null && 'setup' in bidiGenerateContentSetupValue) {
        // Now we know bidiGenerateContentSetupValue is an object and has a 'setup'
        // property.
        const innerSetup = bidiGenerateContentSetupValue.setup;
        if (typeof innerSetup === 'object' && innerSetup !== null) {
            // Valid inner setup found.
            requestDict['bidiGenerateContentSetup'] = innerSetup;
            setupForMaskGeneration = innerSetup;
        } else // `bidiGenerateContentSetupValue.setup` is not a valid object; treat as
        // if bidiGenerateContentSetup is invalid.
        delete requestDict['bidiGenerateContentSetup'];
    } else if (bidiGenerateContentSetupValue !== undefined) // `bidiGenerateContentSetup` exists but not in the expected
    // shape {setup: {...}}; treat as invalid.
    delete requestDict['bidiGenerateContentSetup'];
    const preExistingFieldMask = requestDict['fieldMask'];
    // Handle mask generation setup.
    if (setupForMaskGeneration) {
        const generatedMaskFromBidi = $e4deb49dba5321bc$var$getFieldMasks(setupForMaskGeneration);
        if (Array.isArray(config === null || config === void 0 ? void 0 : config.lockAdditionalFields) && (config === null || config === void 0 ? void 0 : config.lockAdditionalFields.length) === 0) {
            // Case 1: lockAdditionalFields is an empty array. Lock only fields from
            // bidi setup.
            if (generatedMaskFromBidi) // Only assign if mask is not empty
            requestDict['fieldMask'] = generatedMaskFromBidi;
            else delete requestDict['fieldMask']; // If mask is empty, effectively no
        } else if ((config === null || config === void 0 ? void 0 : config.lockAdditionalFields) && config.lockAdditionalFields.length > 0 && preExistingFieldMask !== null && Array.isArray(preExistingFieldMask) && preExistingFieldMask.length > 0) {
            // Case 2: Lock fields from bidi setup + additional fields
            // (preExistingFieldMask).
            const generationConfigFields = [
                'temperature',
                'topK',
                'topP',
                'maxOutputTokens',
                'responseModalities',
                'seed',
                'speechConfig'
            ];
            let mappedFieldsFromPreExisting = [];
            if (preExistingFieldMask.length > 0) mappedFieldsFromPreExisting = preExistingFieldMask.map((field)=>{
                if (generationConfigFields.includes(field)) return `generationConfig.${field}`;
                return field; // Keep original field name if not in
            // generationConfigFields
            });
            const finalMaskParts = [];
            if (generatedMaskFromBidi) finalMaskParts.push(generatedMaskFromBidi);
            if (mappedFieldsFromPreExisting.length > 0) finalMaskParts.push(...mappedFieldsFromPreExisting);
            if (finalMaskParts.length > 0) requestDict['fieldMask'] = finalMaskParts.join(',');
            else // If no fields from bidi and no valid additional fields from
            // pre-existing mask.
            delete requestDict['fieldMask'];
        } else // Case 3: "Lock all fields" (meaning, don't send a field_mask, let server
        // defaults apply or all are mutable). This is hit if:
        //  - `config.lockAdditionalFields` is undefined.
        //  - `config.lockAdditionalFields` is non-empty, BUT
        //  `preExistingFieldMask` is null, not a string, or an empty string.
        delete requestDict['fieldMask'];
    } else // No valid `bidiGenerateContentSetup` was found or extracted.
    // "Lock additional null fields if any".
    if (preExistingFieldMask !== null && Array.isArray(preExistingFieldMask) && preExistingFieldMask.length > 0) // If there's a pre-existing field mask, it's a string, and it's not
    // empty, then we should lock all fields.
    requestDict['fieldMask'] = preExistingFieldMask.join(',');
    else delete requestDict['fieldMask'];
    return requestDict;
}
class $e4deb49dba5321bc$export$8e1e81ac145e31be extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
    }
    /**
     * Creates an ephemeral auth token resource.
     *
     * @experimental
     *
     * @remarks
     * Ephemeral auth tokens is only supported in the Gemini Developer API.
     * It can be used for the session connection to the Live constrained API.
     * Support in v1alpha only.
     *
     * @param params - The parameters for the create request.
     * @return The created auth token.
     *
     * @example
     * ```ts
     * const ai = new GoogleGenAI({
     *     apiKey: token.name,
     *     httpOptions: { apiVersion: 'v1alpha' }  // Support in v1alpha only.
     * });
     *
     * // Case 1: If LiveEphemeralParameters is unset, unlock LiveConnectConfig
     * // when using the token in Live API sessions. Each session connection can
     * // use a different configuration.
     * const config: CreateAuthTokenConfig = {
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     * }
     * const token = await ai.tokens.create(config);
     *
     * // Case 2: If LiveEphemeralParameters is set, lock all fields in
     * // LiveConnectConfig when using the token in Live API sessions. For
     * // example, changing `outputAudioTranscription` in the Live API
     * // connection will be ignored by the API.
     * const config: CreateAuthTokenConfig =
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     *     LiveEphemeralParameters: {
     *        model: 'gemini-2.0-flash-001',
     *        config: {
     *           'responseModalities': ['AUDIO'],
     *           'systemInstruction': 'Always answer in English.',
     *        }
     *     }
     * }
     * const token = await ai.tokens.create(config);
     *
     * // Case 3: If LiveEphemeralParameters is set and lockAdditionalFields is
     * // set, lock LiveConnectConfig with set and additional fields (e.g.
     * // responseModalities, systemInstruction, temperature in this example) when
     * // using the token in Live API sessions.
     * const config: CreateAuthTokenConfig =
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     *     LiveEphemeralParameters: {
     *        model: 'gemini-2.0-flash-001',
     *        config: {
     *           'responseModalities': ['AUDIO'],
     *           'systemInstruction': 'Always answer in English.',
     *        }
     *     },
     *     lockAdditionalFields: ['temperature'],
     * }
     * const token = await ai.tokens.create(config);
     *
     * // Case 4: If LiveEphemeralParameters is set and lockAdditionalFields is
     * // empty array, lock LiveConnectConfig with set fields (e.g.
     * // responseModalities, systemInstruction in this example) when using the
     * // token in Live API sessions.
     * const config: CreateAuthTokenConfig =
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     *     LiveEphemeralParameters: {
     *        model: 'gemini-2.0-flash-001',
     *        config: {
     *           'responseModalities': ['AUDIO'],
     *           'systemInstruction': 'Always answer in English.',
     *        }
     *     },
     *     lockAdditionalFields: [],
     * }
     * const token = await ai.tokens.create(config);
     * ```
     */ async create(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('The client.tokens.create method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createAuthTokenParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('auth_tokens', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            const transformedBody = $e4deb49dba5321bc$var$convertBidiSetupToTokenSetup(body, params.config);
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(transformedBody),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$deleteDocumentConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromForce = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'force'
    ]);
    if (parentObject !== undefined && fromForce != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'force'
    ], fromForce);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteDocumentParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$deleteDocumentConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$getDocumentParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$listDocumentsConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listDocumentsParametersToMldev(fromObject) {
    const toObject = {};
    const fromParent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parent'
    ]);
    if (fromParent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'parent'
    ], fromParent);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listDocumentsConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listDocumentsResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromDocuments = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'documents'
    ]);
    if (fromDocuments != null) {
        let transformedList = fromDocuments;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'documents'
        ], transformedList);
    }
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$Documents extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists documents.
         *
         * @param params - The parameters for the list request.
         * @return - A pager of documents.
         *
         * @example
         * ```ts
         * const documents = await ai.documents.list({parent:'rag_store_name', config: {'pageSize': 2}});
         * for await (const document of documents) {
         *   console.log(document);
         * }
         * ```
         */ this.list = async (params)=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_DOCUMENTS, (x)=>this.listInternal({
                    parent: params.parent,
                    config: x.config
                }), await this.listInternal(params), params);
        };
    }
    /**
     * Gets a Document.
     *
     * @param params - The parameters for getting a document.
     * @return Document.
     */ async get(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$getDocumentParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    /**
     * Deletes a Document.
     *
     * @param params - The parameters for deleting a document.
     */ async delete(params) {
        var _a, _b;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$deleteDocumentParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            await this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            });
        }
    }
    async listInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$listDocumentsParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{parent}/documents', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listDocumentsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$5cc5885838c19de3();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$FileSearchStores extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient, documents = new $e4deb49dba5321bc$var$Documents(apiClient)){
        super();
        this.apiClient = apiClient;
        this.documents = documents;
        /**
         * Lists file search stores.
         *
         * @param params - The parameters for the list request.
         * @return - A pager of file search stores.
         *
         * @example
         * ```ts
         * const fileSearchStores = await ai.fileSearchStores.list({config: {'pageSize': 2}});
         * for await (const fileSearchStore of fileSearchStores) {
         *   console.log(fileSearchStore);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_FILE_SEARCH_STORES, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
    }
    /**
     * Uploads a file asynchronously to a given File Search Store.
     * This method is not available in Vertex AI.
     * Supported upload sources:
     * - Node.js: File path (string) or Blob object.
     * - Browser: Blob object (e.g., File).
     *
     * @remarks
     * The `mimeType` can be specified in the `config` parameter. If omitted:
     *  - For file path (string) inputs, the `mimeType` will be inferred from the
     *     file extension.
     *  - For Blob object inputs, the `mimeType` will be set to the Blob's `type`
     *     property.
     *
     * This section can contain multiple paragraphs and code examples.
     *
     * @param params - Optional parameters specified in the
     *        `types.UploadToFileSearchStoreParameters` interface.
     *         @see {@link types.UploadToFileSearchStoreParameters#config} for the optional
     *         config in the parameters.
     * @return A promise that resolves to a long running operation.
     * @throws An error if called on a Vertex AI client.
     * @throws An error if the `mimeType` is not provided and can not be inferred,
     * the `mimeType` can be provided in the `params.config` parameter.
     * @throws An error occurs if a suitable upload location cannot be established.
     *
     * @example
     * The following code uploads a file to a given file search store.
     *
     * ```ts
     * const operation = await ai.fileSearchStores.upload({fileSearchStoreName: 'fileSearchStores/foo-bar', file: 'file.txt', config: {
     *   mimeType: 'text/plain',
     * }});
     * console.log(operation.name);
     * ```
     */ async uploadToFileSearchStore(params) {
        if (this.apiClient.isVertexAI()) throw new Error('Vertex AI does not support uploading files to a file search store.');
        return this.apiClient.uploadFileToFileSearchStore(params.fileSearchStoreName, params.file, params.config);
    }
    /**
     * Creates a File Search Store.
     *
     * @param params - The parameters for creating a File Search Store.
     * @return FileSearchStore.
     */ async create(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createFileSearchStoreParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('fileSearchStores', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    /**
     * Gets a File Search Store.
     *
     * @param params - The parameters for getting a File Search Store.
     * @return FileSearchStore.
     */ async get(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$getFileSearchStoreParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    /**
     * Deletes a File Search Store.
     *
     * @param params - The parameters for deleting a File Search Store.
     */ async delete(params) {
        var _a, _b;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$deleteFileSearchStoreParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            await this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            });
        }
    }
    async listInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$listFileSearchStoresParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('fileSearchStores', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listFileSearchStoresResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$e4346969d6f84113();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async uploadToFileSearchStoreInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$uploadToFileSearchStoreParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('upload/v1beta/{file_search_store_name}:uploadToFileSearchStore', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$uploadToFileSearchStoreResumableResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$179988cb790ed88a();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Imports a File from File Service to a FileSearchStore.
     *
     * This is a long-running operation, see aip.dev/151
     *
     * @param params - The parameters for importing a file to a file search store.
     * @return ImportFileOperation.
     */ async importFile(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$importFileParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{file_search_store_name}:importFile', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$importFileOperationFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$12076be78e50463e();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
/**
 * https://stackoverflow.com/a/2117523
 */ let $e4deb49dba5321bc$var$uuid4Internal = function() {
    const { crypto: crypto } = globalThis;
    if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) {
        $e4deb49dba5321bc$var$uuid4Internal = crypto.randomUUID.bind(crypto);
        return crypto.randomUUID();
    }
    const u8 = new Uint8Array(1);
    const randomByte = crypto ? ()=>crypto.getRandomValues(u8)[0] : ()=>Math.random() * 0xff & 0xff;
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c)=>(+c ^ randomByte() & 15 >> +c / 4).toString(16));
};
const $e4deb49dba5321bc$var$uuid4 = ()=>$e4deb49dba5321bc$var$uuid4Internal();
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
function $e4deb49dba5321bc$var$isAbortError(err) {
    return typeof err === 'object' && err !== null && // Spec-compliant fetch implementations
    ('name' in err && err.name === 'AbortError' || // Expo fetch
    'message' in err && String(err.message).includes('FetchRequestCanceledException'));
}
const $e4deb49dba5321bc$var$castToError = (err)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'object' && err !== null) {
        try {
            if (Object.prototype.toString.call(err) === '[object Error]') {
                // @ts-ignore - not all envs have native support for cause yet
                const error = new Error(err.message, err.cause ? {
                    cause: err.cause
                } : {});
                if (err.stack) error.stack = err.stack;
                // @ts-ignore - not all envs have native support for cause yet
                if (err.cause && !error.cause) error.cause = err.cause;
                if (err.name) error.name = err.name;
                return error;
            }
        } catch (_a) {}
        try {
            return new Error(JSON.stringify(err));
        } catch (_b) {}
    }
    return new Error(err);
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
class $e4deb49dba5321bc$var$GeminiNextGenAPIClientError extends Error {
}
class $e4deb49dba5321bc$var$APIError extends $e4deb49dba5321bc$var$GeminiNextGenAPIClientError {
    constructor(status, error, message, headers){
        super(`${$e4deb49dba5321bc$var$APIError.makeMessage(status, error, message)}`);
        this.status = status;
        this.headers = headers;
        this.error = error;
    }
    static makeMessage(status, error, message) {
        const msg = (error === null || error === void 0 ? void 0 : error.message) ? typeof error.message === 'string' ? error.message : JSON.stringify(error.message) : error ? JSON.stringify(error) : message;
        if (status && msg) return `${status} ${msg}`;
        if (status) return `${status} status code (no body)`;
        if (msg) return msg;
        return '(no status code or body)';
    }
    static generate(status, errorResponse, message, headers) {
        if (!status || !headers) return new $e4deb49dba5321bc$var$APIConnectionError({
            message: message,
            cause: $e4deb49dba5321bc$var$castToError(errorResponse)
        });
        const error = errorResponse;
        if (status === 400) return new $e4deb49dba5321bc$var$BadRequestError(status, error, message, headers);
        if (status === 401) return new $e4deb49dba5321bc$var$AuthenticationError(status, error, message, headers);
        if (status === 403) return new $e4deb49dba5321bc$var$PermissionDeniedError(status, error, message, headers);
        if (status === 404) return new $e4deb49dba5321bc$var$NotFoundError(status, error, message, headers);
        if (status === 409) return new $e4deb49dba5321bc$var$ConflictError(status, error, message, headers);
        if (status === 422) return new $e4deb49dba5321bc$var$UnprocessableEntityError(status, error, message, headers);
        if (status === 429) return new $e4deb49dba5321bc$var$RateLimitError(status, error, message, headers);
        if (status >= 500) return new $e4deb49dba5321bc$var$InternalServerError(status, error, message, headers);
        return new $e4deb49dba5321bc$var$APIError(status, error, message, headers);
    }
}
class $e4deb49dba5321bc$var$APIUserAbortError extends $e4deb49dba5321bc$var$APIError {
    constructor({ message: message } = {}){
        super(undefined, undefined, message || 'Request was aborted.', undefined);
    }
}
class $e4deb49dba5321bc$var$APIConnectionError extends $e4deb49dba5321bc$var$APIError {
    constructor({ message: message, cause: cause }){
        super(undefined, undefined, message || 'Connection error.', undefined);
        // in some environments the 'cause' property is already declared
        // @ts-ignore
        if (cause) this.cause = cause;
    }
}
class $e4deb49dba5321bc$var$APIConnectionTimeoutError extends $e4deb49dba5321bc$var$APIConnectionError {
    constructor({ message: message } = {}){
        super({
            message: message !== null && message !== void 0 ? message : 'Request timed out.'
        });
    }
}
class $e4deb49dba5321bc$var$BadRequestError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$AuthenticationError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$PermissionDeniedError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$NotFoundError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$ConflictError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$UnprocessableEntityError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$RateLimitError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$InternalServerError extends $e4deb49dba5321bc$var$APIError {
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
// https://url.spec.whatwg.org/#url-scheme-string
const $e4deb49dba5321bc$var$startsWithSchemeRegexp = /^[a-z][a-z0-9+.-]*:/i;
const $e4deb49dba5321bc$var$isAbsoluteURL = (url)=>{
    return $e4deb49dba5321bc$var$startsWithSchemeRegexp.test(url);
};
let $e4deb49dba5321bc$var$isArrayInternal = (val)=>($e4deb49dba5321bc$var$isArrayInternal = Array.isArray, $e4deb49dba5321bc$var$isArrayInternal(val));
const $e4deb49dba5321bc$var$isArray = $e4deb49dba5321bc$var$isArrayInternal;
let $e4deb49dba5321bc$var$isReadonlyArrayInternal = $e4deb49dba5321bc$var$isArray;
const $e4deb49dba5321bc$var$isReadonlyArray = $e4deb49dba5321bc$var$isReadonlyArrayInternal;
// https://stackoverflow.com/a/34491287
function $e4deb49dba5321bc$var$isEmptyObj(obj) {
    if (!obj) return true;
    for(const _k in obj)return false;
    return true;
}
// https://eslint.org/docs/latest/rules/no-prototype-builtins
function $e4deb49dba5321bc$var$hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
const $e4deb49dba5321bc$var$validatePositiveInteger = (name, n)=>{
    if (typeof n !== 'number' || !Number.isInteger(n)) throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`${name} must be an integer`);
    if (n < 0) throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`${name} must be a positive integer`);
    return n;
};
const $e4deb49dba5321bc$var$safeJSON = (text)=>{
    try {
        return JSON.parse(text);
    } catch (err) {
        return undefined;
    }
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
const $e4deb49dba5321bc$var$sleep$1 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$VERSION = '0.0.1';
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
/**
 * Note this does not detect 'browser'; for that, use getBrowserInfo().
 */ function $e4deb49dba5321bc$var$getDetectedPlatform() {
    if (typeof Deno !== 'undefined' && Deno.build != null) return 'deno';
    if (typeof EdgeRuntime !== 'undefined') return 'edge';
    if (Object.prototype.toString.call(typeof globalThis.process !== 'undefined' ? globalThis.process : 0) === '[object process]') return 'node';
    return 'unknown';
}
const $e4deb49dba5321bc$var$getPlatformProperties = ()=>{
    var _a, _b, _c, _d, _e;
    const detectedPlatform = $e4deb49dba5321bc$var$getDetectedPlatform();
    if (detectedPlatform === 'deno') return {
        'X-Stainless-Lang': 'js',
        'X-Stainless-Package-Version': $e4deb49dba5321bc$var$VERSION,
        'X-Stainless-OS': $e4deb49dba5321bc$var$normalizePlatform(Deno.build.os),
        'X-Stainless-Arch': $e4deb49dba5321bc$var$normalizeArch(Deno.build.arch),
        'X-Stainless-Runtime': 'deno',
        'X-Stainless-Runtime-Version': typeof Deno.version === 'string' ? Deno.version : (_b = (_a = Deno.version) === null || _a === void 0 ? void 0 : _a.deno) !== null && _b !== void 0 ? _b : 'unknown'
    };
    if (typeof EdgeRuntime !== 'undefined') return {
        'X-Stainless-Lang': 'js',
        'X-Stainless-Package-Version': $e4deb49dba5321bc$var$VERSION,
        'X-Stainless-OS': 'Unknown',
        'X-Stainless-Arch': `other:${EdgeRuntime}`,
        'X-Stainless-Runtime': 'edge',
        'X-Stainless-Runtime-Version': globalThis.process.version
    };
    // Check if Node.js
    if (detectedPlatform === 'node') return {
        'X-Stainless-Lang': 'js',
        'X-Stainless-Package-Version': $e4deb49dba5321bc$var$VERSION,
        'X-Stainless-OS': $e4deb49dba5321bc$var$normalizePlatform((_c = globalThis.process.platform) !== null && _c !== void 0 ? _c : 'unknown'),
        'X-Stainless-Arch': $e4deb49dba5321bc$var$normalizeArch((_d = globalThis.process.arch) !== null && _d !== void 0 ? _d : 'unknown'),
        'X-Stainless-Runtime': 'node',
        'X-Stainless-Runtime-Version': (_e = globalThis.process.version) !== null && _e !== void 0 ? _e : 'unknown'
    };
    const browserInfo = $e4deb49dba5321bc$var$getBrowserInfo();
    if (browserInfo) return {
        'X-Stainless-Lang': 'js',
        'X-Stainless-Package-Version': $e4deb49dba5321bc$var$VERSION,
        'X-Stainless-OS': 'Unknown',
        'X-Stainless-Arch': 'unknown',
        'X-Stainless-Runtime': `browser:${browserInfo.browser}`,
        'X-Stainless-Runtime-Version': browserInfo.version
    };
    // TODO add support for Cloudflare workers, etc.
    return {
        'X-Stainless-Lang': 'js',
        'X-Stainless-Package-Version': $e4deb49dba5321bc$var$VERSION,
        'X-Stainless-OS': 'Unknown',
        'X-Stainless-Arch': 'unknown',
        'X-Stainless-Runtime': 'unknown',
        'X-Stainless-Runtime-Version': 'unknown'
    };
};
// Note: modified from https://github.com/JS-DevTools/host-environment/blob/b1ab79ecde37db5d6e163c050e54fe7d287d7c92/src/isomorphic.browser.ts
function $e4deb49dba5321bc$var$getBrowserInfo() {
    if (typeof navigator === 'undefined' || !navigator) return null;
    // NOTE: The order matters here!
    const browserPatterns = [
        {
            key: 'edge',
            pattern: /Edge(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: 'ie',
            pattern: /MSIE(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: 'ie',
            pattern: /Trident(?:.*rv\:(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: 'chrome',
            pattern: /Chrome(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: 'firefox',
            pattern: /Firefox(?:\W+(\d+)\.(\d+)(?:\.(\d+))?)?/
        },
        {
            key: 'safari',
            pattern: /(?:Version\W+(\d+)\.(\d+)(?:\.(\d+))?)?(?:\W+Mobile\S*)?\W+Safari/
        }
    ];
    // Find the FIRST matching browser
    for (const { key: key, pattern: pattern } of browserPatterns){
        const match = pattern.exec(navigator.userAgent);
        if (match) {
            const major = match[1] || 0;
            const minor = match[2] || 0;
            const patch = match[3] || 0;
            return {
                browser: key,
                version: `${major}.${minor}.${patch}`
            };
        }
    }
    return null;
}
const $e4deb49dba5321bc$var$normalizeArch = (arch)=>{
    // Node docs:
    // - https://nodejs.org/api/process.html#processarch
    // Deno docs:
    // - https://doc.deno.land/deno/stable/~/Deno.build
    if (arch === 'x32') return 'x32';
    if (arch === 'x86_64' || arch === 'x64') return 'x64';
    if (arch === 'arm') return 'arm';
    if (arch === 'aarch64' || arch === 'arm64') return 'arm64';
    if (arch) return `other:${arch}`;
    return 'unknown';
};
const $e4deb49dba5321bc$var$normalizePlatform = (platform)=>{
    // Node platforms:
    // - https://nodejs.org/api/process.html#processplatform
    // Deno platforms:
    // - https://doc.deno.land/deno/stable/~/Deno.build
    // - https://github.com/denoland/deno/issues/14799
    platform = platform.toLowerCase();
    // NOTE: this iOS check is untested and may not work
    // Node does not work natively on IOS, there is a fork at
    // https://github.com/nodejs-mobile/nodejs-mobile
    // however it is unknown at the time of writing how to detect if it is running
    if (platform.includes('ios')) return 'iOS';
    if (platform === 'android') return 'Android';
    if (platform === 'darwin') return 'MacOS';
    if (platform === 'win32') return 'Windows';
    if (platform === 'freebsd') return 'FreeBSD';
    if (platform === 'openbsd') return 'OpenBSD';
    if (platform === 'linux') return 'Linux';
    if (platform) return `Other:${platform}`;
    return 'Unknown';
};
let $e4deb49dba5321bc$var$_platformHeaders;
const $e4deb49dba5321bc$var$getPlatformHeaders = ()=>{
    return $e4deb49dba5321bc$var$_platformHeaders !== null && $e4deb49dba5321bc$var$_platformHeaders !== void 0 ? $e4deb49dba5321bc$var$_platformHeaders : $e4deb49dba5321bc$var$_platformHeaders = $e4deb49dba5321bc$var$getPlatformProperties();
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$getDefaultFetch() {
    if (typeof fetch !== 'undefined') return fetch;
    throw new Error('`fetch` is not defined as a global; Either pass `fetch` to the client, `new GeminiNextGenAPIClient({ fetch })` or polyfill the global, `globalThis.fetch = fetch`');
}
function $e4deb49dba5321bc$var$makeReadableStream(...args) {
    const ReadableStream = globalThis.ReadableStream;
    if (typeof ReadableStream === 'undefined') // Note: All of the platforms / runtimes we officially support already define
    // `ReadableStream` as a global, so this should only ever be hit on unsupported runtimes.
    throw new Error('`ReadableStream` is not defined as a global; You will need to polyfill it, `globalThis.ReadableStream = ReadableStream`');
    return new ReadableStream(...args);
}
function $e4deb49dba5321bc$var$ReadableStreamFrom(iterable) {
    let iter = Symbol.asyncIterator in iterable ? iterable[Symbol.asyncIterator]() : iterable[Symbol.iterator]();
    return $e4deb49dba5321bc$var$makeReadableStream({
        start () {},
        async pull (controller) {
            const { done: done, value: value } = await iter.next();
            if (done) controller.close();
            else controller.enqueue(value);
        },
        async cancel () {
            var _a;
            await ((_a = iter.return) === null || _a === void 0 ? void 0 : _a.call(iter));
        }
    });
}
/**
 * Most browsers don't yet have async iterable support for ReadableStream,
 * and Node has a very different way of reading bytes from its "ReadableStream".
 *
 * This polyfill was pulled from https://github.com/MattiasBuelens/web-streams-polyfill/pull/122#issuecomment-1627354490
 */ function $e4deb49dba5321bc$var$ReadableStreamToAsyncIterable(stream) {
    if (stream[Symbol.asyncIterator]) return stream;
    const reader = stream.getReader();
    return {
        async next () {
            try {
                const result = await reader.read();
                if (result === null || result === void 0 ? void 0 : result.done) reader.releaseLock(); // release lock when stream becomes closed
                return result;
            } catch (e) {
                reader.releaseLock(); // release lock when stream becomes errored
                throw e;
            }
        },
        async return () {
            const cancelPromise = reader.cancel();
            reader.releaseLock();
            await cancelPromise;
            return {
                done: true,
                value: undefined
            };
        },
        [Symbol.asyncIterator] () {
            return this;
        }
    };
}
/**
 * Cancels a ReadableStream we don't need to consume.
 * See https://undici.nodejs.org/#/?id=garbage-collection
 */ async function $e4deb49dba5321bc$var$CancelReadableStream(stream) {
    var _a, _b;
    if (stream === null || typeof stream !== 'object') return;
    if (stream[Symbol.asyncIterator]) {
        await ((_b = (_a = stream[Symbol.asyncIterator]()).return) === null || _b === void 0 ? void 0 : _b.call(_a));
        return;
    }
    const reader = stream.getReader();
    const cancelPromise = reader.cancel();
    reader.releaseLock();
    await cancelPromise;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$FallbackEncoder = ({ headers: headers, body: body })=>{
    return {
        bodyHeaders: {
            'content-type': 'application/json'
        },
        body: JSON.stringify(body)
    };
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$checkFileSupport = ()=>{
    var _a;
    if (typeof File === 'undefined') {
        const { process: process } = globalThis;
        const isOldNode = typeof ((_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.node) === 'string' && parseInt(process.versions.node.split('.')) < 20;
        throw new Error('`File` is not defined as a global, which is required for file uploads.' + (isOldNode ? " Update to Node 20 LTS or newer, or set `globalThis.File` to `import('node:buffer').File`." : ''));
    }
};
/**
 * Construct a `File` instance. This is used to ensure a helpful error is thrown
 * for environments that don't define a global `File` yet.
 */ function $e4deb49dba5321bc$var$makeFile(fileBits, fileName, options) {
    $e4deb49dba5321bc$var$checkFileSupport();
    return new File(fileBits, fileName !== null && fileName !== void 0 ? fileName : 'unknown_file', options);
}
function $e4deb49dba5321bc$var$getName(value) {
    return (typeof value === 'object' && value !== null && ('name' in value && value.name && String(value.name) || 'url' in value && value.url && String(value.url) || 'filename' in value && value.filename && String(value.filename) || 'path' in value && value.path && String(value.path)) || '').split(/[\\/]/).pop() || undefined;
}
const $e4deb49dba5321bc$var$isAsyncIterable = (value)=>value != null && typeof value === 'object' && typeof value[Symbol.asyncIterator] === 'function';
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * This check adds the arrayBuffer() method type because it is available and used at runtime
 */ const $e4deb49dba5321bc$var$isBlobLike = (value)=>value != null && typeof value === 'object' && typeof value.size === 'number' && typeof value.type === 'string' && typeof value.text === 'function' && typeof value.slice === 'function' && typeof value.arrayBuffer === 'function';
/**
 * This check adds the arrayBuffer() method type because it is available and used at runtime
 */ const $e4deb49dba5321bc$var$isFileLike = (value)=>value != null && typeof value === 'object' && typeof value.name === 'string' && typeof value.lastModified === 'number' && $e4deb49dba5321bc$var$isBlobLike(value);
const $e4deb49dba5321bc$var$isResponseLike = (value)=>value != null && typeof value === 'object' && typeof value.url === 'string' && typeof value.blob === 'function';
/**
 * Helper for creating a {@link File} to pass to an SDK upload method from a variety of different data formats
 * @param value the raw content of the file. Can be an {@link Uploadable}, BlobLikePart, or AsyncIterable of BlobLikeParts
 * @param {string=} name the name of the file. If omitted, toFile will try to determine a file name from bits if possible
 * @param {Object=} options additional properties
 * @param {string=} options.type the MIME type of the content
 * @param {number=} options.lastModified the last modified timestamp
 * @returns a {@link File} with the given properties
 */ async function $e4deb49dba5321bc$var$toFile(value, name, options) {
    $e4deb49dba5321bc$var$checkFileSupport();
    // If it's a promise, resolve it.
    value = await value;
    // If we've been given a `File` we don't need to do anything
    if ($e4deb49dba5321bc$var$isFileLike(value)) {
        if (value instanceof File) return value;
        return $e4deb49dba5321bc$var$makeFile([
            await value.arrayBuffer()
        ], value.name);
    }
    if ($e4deb49dba5321bc$var$isResponseLike(value)) {
        const blob = await value.blob();
        name || (name = new URL(value.url).pathname.split(/[\\/]/).pop());
        return $e4deb49dba5321bc$var$makeFile(await $e4deb49dba5321bc$var$getBytes(blob), name, options);
    }
    const parts = await $e4deb49dba5321bc$var$getBytes(value);
    name || (name = $e4deb49dba5321bc$var$getName(value));
    if (!(options === null || options === void 0 ? void 0 : options.type)) {
        const type = parts.find((part)=>typeof part === 'object' && 'type' in part && part.type);
        if (typeof type === 'string') options = Object.assign(Object.assign({}, options), {
            type: type
        });
    }
    return $e4deb49dba5321bc$var$makeFile(parts, name, options);
}
async function $e4deb49dba5321bc$var$getBytes(value) {
    var _a, e_1, _b, _c;
    var _d;
    let parts = [];
    if (typeof value === 'string' || ArrayBuffer.isView(value) || // includes Uint8Array, Buffer, etc.
    value instanceof ArrayBuffer) parts.push(value);
    else if ($e4deb49dba5321bc$var$isBlobLike(value)) parts.push(value instanceof Blob ? value : await value.arrayBuffer());
    else if ($e4deb49dba5321bc$var$isAsyncIterable(value) // includes Readable, ReadableStream, etc.
    ) try {
        for(var _e = true, value_1 = $e4deb49dba5321bc$var$__asyncValues(value), value_1_1; value_1_1 = await value_1.next(), _a = value_1_1.done, !_a; _e = true){
            _c = value_1_1.value;
            _e = false;
            const chunk = _c;
            parts.push(...await $e4deb49dba5321bc$var$getBytes(chunk)); // TODO, consider validating?
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (!_e && !_a && (_b = value_1.return)) await _b.call(value_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else {
        const constructor = (_d = value === null || value === void 0 ? void 0 : value.constructor) === null || _d === void 0 ? void 0 : _d.name;
        throw new Error(`Unexpected data type: ${typeof value}${constructor ? `; constructor: ${constructor}` : ''}${$e4deb49dba5321bc$var$propsForError(value)}`);
    }
    return parts;
}
function $e4deb49dba5321bc$var$propsForError(value) {
    if (typeof value !== 'object' || value === null) return '';
    const props = Object.getOwnPropertyNames(value);
    return `; props: [${props.map((p)=>`"${p}"`).join(', ')}]`;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$APIResource {
    constructor(client){
        this._client = client;
    }
}
/**
 * The key path from the client. For example, a resource accessible as `client.resource.subresource` would
 * have a property `static override readonly _key = Object.freeze(['resource', 'subresource'] as const);`.
 */ $e4deb49dba5321bc$var$APIResource._key = [];
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Percent-encode everything that isn't safe to have in a path without encoding safe chars.
 *
 * Taken from https://datatracker.ietf.org/doc/html/rfc3986#section-3.3:
 * > unreserved  = ALPHA / DIGIT / "-" / "." / "_" / "~"
 * > sub-delims  = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
 * > pchar       = unreserved / pct-encoded / sub-delims / ":" / "@"
 */ function $e4deb49dba5321bc$var$encodeURIPath(str) {
    return str.replace(/[^A-Za-z0-9\-._~!$&'()*+,;=:@]+/g, encodeURIComponent);
}
const $e4deb49dba5321bc$var$EMPTY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.create(null));
const $e4deb49dba5321bc$var$createPathTagFunction = (pathEncoder = $e4deb49dba5321bc$var$encodeURIPath)=>function path(statics, ...params) {
        // If there are no params, no processing is needed.
        if (statics.length === 1) return statics[0];
        let postPath = false;
        const invalidSegments = [];
        const path1 = statics.reduce((previousValue, currentValue, index)=>{
            var _a, _b, _c;
            if (/[?#]/.test(currentValue)) postPath = true;
            const value = params[index];
            let encoded = (postPath ? encodeURIComponent : pathEncoder)('' + value);
            if (index !== params.length && (value == null || typeof value === 'object' && // handle values from other realms
            value.toString === ((_c = Object.getPrototypeOf((_b = Object.getPrototypeOf((_a = value.hasOwnProperty) !== null && _a !== void 0 ? _a : $e4deb49dba5321bc$var$EMPTY)) !== null && _b !== void 0 ? _b : $e4deb49dba5321bc$var$EMPTY)) === null || _c === void 0 ? void 0 : _c.toString))) {
                encoded = value + '';
                invalidSegments.push({
                    start: previousValue.length + currentValue.length,
                    length: encoded.length,
                    error: `Value of type ${Object.prototype.toString.call(value).slice(8, -1)} is not a valid path parameter`
                });
            }
            return previousValue + currentValue + (index === params.length ? '' : encoded);
        }, '');
        const pathOnly = path1.split(/[?#]/, 1)[0];
        const invalidSegmentPattern = /(^|\/)(?:\.|%2e){1,2}(?=\/|$)/gi;
        let match;
        // Find all invalid segments
        while((match = invalidSegmentPattern.exec(pathOnly)) !== null){
            const hasLeadingSlash = match[0].startsWith('/');
            const offset = hasLeadingSlash ? 1 : 0;
            const cleanMatch = hasLeadingSlash ? match[0].slice(1) : match[0];
            invalidSegments.push({
                start: match.index + offset,
                length: cleanMatch.length,
                error: `Value "${cleanMatch}" can\'t be safely passed as a path parameter`
            });
        }
        invalidSegments.sort((a, b)=>a.start - b.start);
        if (invalidSegments.length > 0) {
            let lastEnd = 0;
            const underline = invalidSegments.reduce((acc, segment)=>{
                const spaces = ' '.repeat(segment.start - lastEnd);
                const arrows = '^'.repeat(segment.length);
                lastEnd = segment.start + segment.length;
                return acc + spaces + arrows;
            }, '');
            throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`Path parameters result in path with invalid segments:\n${invalidSegments.map((e)=>e.error).join('\n')}\n${path1}\n${underline}`);
        }
        return path1;
    };
/**
 * URI-encodes path params and ensures no unsafe /./ or /../ path segments are introduced.
 */ const $e4deb49dba5321bc$var$path = /* @__PURE__ */ $e4deb49dba5321bc$var$createPathTagFunction($e4deb49dba5321bc$var$encodeURIPath);
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$BaseInteractions extends $e4deb49dba5321bc$var$APIResource {
    create(params, options) {
        var _a;
        const { api_version: api_version = this._client.apiVersion } = params, body = $e4deb49dba5321bc$var$__rest(params, [
            "api_version"
        ]);
        if ('model' in body && 'agent_config' in body) throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`Invalid request: specified \`model\` and \`agent_config\`. If specifying \`model\`, use \`generation_config\`.`);
        if ('agent' in body && 'generation_config' in body) throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`Invalid request: specified \`agent\` and \`generation_config\`. If specifying \`agent\`, use \`agent_config\`.`);
        return this._client.post($e4deb49dba5321bc$var$path`/${api_version}/interactions`, Object.assign(Object.assign({
            body: body
        }, options), {
            stream: (_a = params.stream) !== null && _a !== void 0 ? _a : false
        }));
    }
    /**
     * Deletes the interaction by id.
     *
     * @example
     * ```ts
     * const interaction = await client.interactions.delete('id', {
     *   api_version: 'api_version',
     * });
     * ```
     */ delete(id, params = {}, options) {
        const { api_version: api_version = this._client.apiVersion } = params !== null && params !== void 0 ? params : {};
        return this._client.delete($e4deb49dba5321bc$var$path`/${api_version}/interactions/${id}`, options);
    }
    /**
     * Cancels an interaction by id. This only applies to background interactions that are still running.
     *
     * @example
     * ```ts
     * const interaction = await client.interactions.cancel('id', {
     *   api_version: 'api_version',
     * });
     * ```
     */ cancel(id, params = {}, options) {
        const { api_version: api_version = this._client.apiVersion } = params !== null && params !== void 0 ? params : {};
        return this._client.post($e4deb49dba5321bc$var$path`/${api_version}/interactions/${id}/cancel`, options);
    }
    get(id, params = {}, options) {
        var _a;
        const _b = params !== null && params !== void 0 ? params : {}, { api_version: api_version = this._client.apiVersion } = _b, query = $e4deb49dba5321bc$var$__rest(_b, [
            "api_version"
        ]);
        return this._client.get($e4deb49dba5321bc$var$path`/${api_version}/interactions/${id}`, Object.assign(Object.assign({
            query: query
        }, options), {
            stream: (_a = params === null || params === void 0 ? void 0 : params.stream) !== null && _a !== void 0 ? _a : false
        }));
    }
}
$e4deb49dba5321bc$var$BaseInteractions._key = Object.freeze([
    'interactions'
]);
class $e4deb49dba5321bc$var$Interactions extends $e4deb49dba5321bc$var$BaseInteractions {
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$concatBytes(buffers) {
    let length = 0;
    for (const buffer of buffers)length += buffer.length;
    const output = new Uint8Array(length);
    let index = 0;
    for (const buffer of buffers){
        output.set(buffer, index);
        index += buffer.length;
    }
    return output;
}
let $e4deb49dba5321bc$var$encodeUTF8_;
function $e4deb49dba5321bc$var$encodeUTF8(str) {
    let encoder;
    return ($e4deb49dba5321bc$var$encodeUTF8_ !== null && $e4deb49dba5321bc$var$encodeUTF8_ !== void 0 ? $e4deb49dba5321bc$var$encodeUTF8_ : (encoder = new globalThis.TextEncoder(), $e4deb49dba5321bc$var$encodeUTF8_ = encoder.encode.bind(encoder)))(str);
}
let $e4deb49dba5321bc$var$decodeUTF8_;
function $e4deb49dba5321bc$var$decodeUTF8(bytes) {
    let decoder;
    return ($e4deb49dba5321bc$var$decodeUTF8_ !== null && $e4deb49dba5321bc$var$decodeUTF8_ !== void 0 ? $e4deb49dba5321bc$var$decodeUTF8_ : (decoder = new globalThis.TextDecoder(), $e4deb49dba5321bc$var$decodeUTF8_ = decoder.decode.bind(decoder)))(bytes);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * A re-implementation of httpx's `LineDecoder` in Python that handles incrementally
 * reading lines from text.
 *
 * https://github.com/encode/httpx/blob/920333ea98118e9cf617f246905d7b202510941c/httpx/_decoders.py#L258
 */ class $e4deb49dba5321bc$var$LineDecoder {
    constructor(){
        this.buffer = new Uint8Array();
        this.carriageReturnIndex = null;
    }
    decode(chunk) {
        if (chunk == null) return [];
        const binaryChunk = chunk instanceof ArrayBuffer ? new Uint8Array(chunk) : typeof chunk === 'string' ? $e4deb49dba5321bc$var$encodeUTF8(chunk) : chunk;
        this.buffer = $e4deb49dba5321bc$var$concatBytes([
            this.buffer,
            binaryChunk
        ]);
        const lines = [];
        let patternIndex;
        while((patternIndex = $e4deb49dba5321bc$var$findNewlineIndex(this.buffer, this.carriageReturnIndex)) != null){
            if (patternIndex.carriage && this.carriageReturnIndex == null) {
                // skip until we either get a corresponding `\n`, a new `\r` or nothing
                this.carriageReturnIndex = patternIndex.index;
                continue;
            }
            // we got double \r or \rtext\n
            if (this.carriageReturnIndex != null && (patternIndex.index !== this.carriageReturnIndex + 1 || patternIndex.carriage)) {
                lines.push($e4deb49dba5321bc$var$decodeUTF8(this.buffer.subarray(0, this.carriageReturnIndex - 1)));
                this.buffer = this.buffer.subarray(this.carriageReturnIndex);
                this.carriageReturnIndex = null;
                continue;
            }
            const endIndex = this.carriageReturnIndex !== null ? patternIndex.preceding - 1 : patternIndex.preceding;
            const line = $e4deb49dba5321bc$var$decodeUTF8(this.buffer.subarray(0, endIndex));
            lines.push(line);
            this.buffer = this.buffer.subarray(patternIndex.index);
            this.carriageReturnIndex = null;
        }
        return lines;
    }
    flush() {
        if (!this.buffer.length) return [];
        return this.decode('\n');
    }
}
// prettier-ignore
$e4deb49dba5321bc$var$LineDecoder.NEWLINE_CHARS = new Set([
    '\n',
    '\r'
]);
$e4deb49dba5321bc$var$LineDecoder.NEWLINE_REGEXP = /\r\n|[\n\r]/g;
/**
 * This function searches the buffer for the end patterns, (\r or \n)
 * and returns an object with the index preceding the matched newline and the
 * index after the newline char. `null` is returned if no new line is found.
 *
 * ```ts
 * findNewLineIndex('abc\ndef') -> { preceding: 2, index: 3 }
 * ```
 */ function $e4deb49dba5321bc$var$findNewlineIndex(buffer, startIndex) {
    const newline = 0x0a; // \n
    const carriage = 0x0d; // \r
    for(let i = startIndex !== null && startIndex !== void 0 ? startIndex : 0; i < buffer.length; i++){
        if (buffer[i] === newline) return {
            preceding: i,
            index: i + 1,
            carriage: false
        };
        if (buffer[i] === carriage) return {
            preceding: i,
            index: i + 1,
            carriage: true
        };
    }
    return null;
}
function $e4deb49dba5321bc$var$findDoubleNewlineIndex(buffer) {
    // This function searches the buffer for the end patterns (\r\r, \n\n, \r\n\r\n)
    // and returns the index right after the first occurrence of any pattern,
    // or -1 if none of the patterns are found.
    const newline = 0x0a; // \n
    const carriage = 0x0d; // \r
    for(let i = 0; i < buffer.length - 1; i++){
        if (buffer[i] === newline && buffer[i + 1] === newline) // \n\n
        return i + 2;
        if (buffer[i] === carriage && buffer[i + 1] === carriage) // \r\r
        return i + 2;
        if (buffer[i] === carriage && buffer[i + 1] === newline && i + 3 < buffer.length && buffer[i + 2] === carriage && buffer[i + 3] === newline) // \r\n\r\n
        return i + 4;
    }
    return -1;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
const $e4deb49dba5321bc$var$levelNumbers = {
    off: 0,
    error: 200,
    warn: 300,
    info: 400,
    debug: 500
};
const $e4deb49dba5321bc$var$parseLogLevel = (maybeLevel, sourceName, client)=>{
    if (!maybeLevel) return undefined;
    if ($e4deb49dba5321bc$var$hasOwn($e4deb49dba5321bc$var$levelNumbers, maybeLevel)) return maybeLevel;
    $e4deb49dba5321bc$var$loggerFor(client).warn(`${sourceName} was set to ${JSON.stringify(maybeLevel)}, expected one of ${JSON.stringify(Object.keys($e4deb49dba5321bc$var$levelNumbers))}`);
    return undefined;
};
function $e4deb49dba5321bc$var$noop() {}
function $e4deb49dba5321bc$var$makeLogFn(fnLevel, logger, logLevel) {
    if (!logger || $e4deb49dba5321bc$var$levelNumbers[fnLevel] > $e4deb49dba5321bc$var$levelNumbers[logLevel]) return $e4deb49dba5321bc$var$noop;
    else // Don't wrap logger functions, we want the stacktrace intact!
    return logger[fnLevel].bind(logger);
}
const $e4deb49dba5321bc$var$noopLogger = {
    error: $e4deb49dba5321bc$var$noop,
    warn: $e4deb49dba5321bc$var$noop,
    info: $e4deb49dba5321bc$var$noop,
    debug: $e4deb49dba5321bc$var$noop
};
let $e4deb49dba5321bc$var$cachedLoggers = /* @__PURE__ */ new WeakMap();
function $e4deb49dba5321bc$var$loggerFor(client) {
    var _a;
    const logger = client.logger;
    const logLevel = (_a = client.logLevel) !== null && _a !== void 0 ? _a : 'off';
    if (!logger) return $e4deb49dba5321bc$var$noopLogger;
    const cachedLogger = $e4deb49dba5321bc$var$cachedLoggers.get(logger);
    if (cachedLogger && cachedLogger[0] === logLevel) return cachedLogger[1];
    const levelLogger = {
        error: $e4deb49dba5321bc$var$makeLogFn('error', logger, logLevel),
        warn: $e4deb49dba5321bc$var$makeLogFn('warn', logger, logLevel),
        info: $e4deb49dba5321bc$var$makeLogFn('info', logger, logLevel),
        debug: $e4deb49dba5321bc$var$makeLogFn('debug', logger, logLevel)
    };
    $e4deb49dba5321bc$var$cachedLoggers.set(logger, [
        logLevel,
        levelLogger
    ]);
    return levelLogger;
}
const $e4deb49dba5321bc$var$formatRequestDetails = (details)=>{
    if (details.options) {
        details.options = Object.assign({}, details.options);
        delete details.options['headers']; // redundant + leaks internals
    }
    if (details.headers) details.headers = Object.fromEntries((details.headers instanceof Headers ? [
        ...details.headers
    ] : Object.entries(details.headers)).map(([name, value])=>[
            name,
            name.toLowerCase() === 'x-goog-api-key' || name.toLowerCase() === 'authorization' || name.toLowerCase() === 'cookie' || name.toLowerCase() === 'set-cookie' ? '***' : value
        ]));
    if ('retryOfRequestLogID' in details) {
        if (details.retryOfRequestLogID) details.retryOf = details.retryOfRequestLogID;
        delete details.retryOfRequestLogID;
    }
    return details;
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$Stream {
    constructor(iterator, controller, client){
        this.iterator = iterator;
        this.controller = controller;
        this.client = client;
    }
    static fromSSEResponse(response, controller, client) {
        let consumed = false;
        const logger = client ? $e4deb49dba5321bc$var$loggerFor(client) : console;
        function iterator() {
            return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* iterator_1() {
                var _a, e_1, _b, _c;
                if (consumed) throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError('Cannot iterate over a consumed stream, use `.tee()` to split the stream.');
                consumed = true;
                let done = false;
                try {
                    try {
                        for(var _d = true, _e = $e4deb49dba5321bc$var$__asyncValues($e4deb49dba5321bc$var$_iterSSEMessages(response, controller)), _f; _f = yield $e4deb49dba5321bc$var$__await(_e.next()), _a = _f.done, !_a; _d = true){
                            _c = _f.value;
                            _d = false;
                            const sse = _c;
                            if (done) continue;
                            if (sse.data.startsWith('[DONE]')) {
                                done = true;
                                continue;
                            } else try {
                                // @ts-ignore
                                yield yield $e4deb49dba5321bc$var$__await(JSON.parse(sse.data));
                            } catch (e) {
                                logger.error(`Could not parse message into JSON:`, sse.data);
                                logger.error(`From chunk:`, sse.raw);
                                throw e;
                            }
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (!_d && !_a && (_b = _e.return)) yield $e4deb49dba5321bc$var$__await(_b.call(_e));
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    done = true;
                } catch (e) {
                    // If the user calls `stream.controller.abort()`, we should exit without throwing.
                    if ($e4deb49dba5321bc$var$isAbortError(e)) return yield $e4deb49dba5321bc$var$__await(void 0);
                    throw e;
                } finally{
                    // If the user `break`s, abort the ongoing request.
                    if (!done) controller.abort();
                }
            });
        }
        return new $e4deb49dba5321bc$var$Stream(iterator, controller, client);
    }
    /**
     * Generates a Stream from a newline-separated ReadableStream
     * where each item is a JSON value.
     */ static fromReadableStream(readableStream, controller, client) {
        let consumed = false;
        function iterLines() {
            return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* iterLines_1() {
                var _a, e_2, _b, _c;
                const lineDecoder = new $e4deb49dba5321bc$var$LineDecoder();
                const iter = $e4deb49dba5321bc$var$ReadableStreamToAsyncIterable(readableStream);
                try {
                    for(var _d = true, iter_1 = $e4deb49dba5321bc$var$__asyncValues(iter), iter_1_1; iter_1_1 = yield $e4deb49dba5321bc$var$__await(iter_1.next()), _a = iter_1_1.done, !_a; _d = true){
                        _c = iter_1_1.value;
                        _d = false;
                        const chunk = _c;
                        for (const line of lineDecoder.decode(chunk))yield yield $e4deb49dba5321bc$var$__await(line);
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (!_d && !_a && (_b = iter_1.return)) yield $e4deb49dba5321bc$var$__await(_b.call(iter_1));
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
                for (const line of lineDecoder.flush())yield yield $e4deb49dba5321bc$var$__await(line);
            });
        }
        function iterator() {
            return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* iterator_2() {
                var _a, e_3, _b, _c;
                if (consumed) throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError('Cannot iterate over a consumed stream, use `.tee()` to split the stream.');
                consumed = true;
                let done = false;
                try {
                    try {
                        for(var _d = true, _e = $e4deb49dba5321bc$var$__asyncValues(iterLines()), _f; _f = yield $e4deb49dba5321bc$var$__await(_e.next()), _a = _f.done, !_a; _d = true){
                            _c = _f.value;
                            _d = false;
                            const line = _c;
                            if (done) continue;
                            // @ts-ignore
                            if (line) yield yield $e4deb49dba5321bc$var$__await(JSON.parse(line));
                        }
                    } catch (e_3_1) {
                        e_3 = {
                            error: e_3_1
                        };
                    } finally{
                        try {
                            if (!_d && !_a && (_b = _e.return)) yield $e4deb49dba5321bc$var$__await(_b.call(_e));
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                    }
                    done = true;
                } catch (e) {
                    // If the user calls `stream.controller.abort()`, we should exit without throwing.
                    if ($e4deb49dba5321bc$var$isAbortError(e)) return yield $e4deb49dba5321bc$var$__await(void 0);
                    throw e;
                } finally{
                    // If the user `break`s, abort the ongoing request.
                    if (!done) controller.abort();
                }
            });
        }
        return new $e4deb49dba5321bc$var$Stream(iterator, controller, client);
    }
    [Symbol.asyncIterator]() {
        return this.iterator();
    }
    /**
     * Splits the stream into two streams which can be
     * independently read from at different speeds.
     */ tee() {
        const left = [];
        const right = [];
        const iterator = this.iterator();
        const teeIterator = (queue)=>{
            return {
                next: ()=>{
                    if (queue.length === 0) {
                        const result = iterator.next();
                        left.push(result);
                        right.push(result);
                    }
                    return queue.shift();
                }
            };
        };
        return [
            new $e4deb49dba5321bc$var$Stream(()=>teeIterator(left), this.controller, this.client),
            new $e4deb49dba5321bc$var$Stream(()=>teeIterator(right), this.controller, this.client)
        ];
    }
    /**
     * Converts this stream to a newline-separated ReadableStream of
     * JSON stringified values in the stream
     * which can be turned back into a Stream with `Stream.fromReadableStream()`.
     */ toReadableStream() {
        const self = this;
        let iter;
        return $e4deb49dba5321bc$var$makeReadableStream({
            async start () {
                iter = self[Symbol.asyncIterator]();
            },
            async pull (ctrl) {
                try {
                    const { value: value, done: done } = await iter.next();
                    if (done) return ctrl.close();
                    const bytes = $e4deb49dba5321bc$var$encodeUTF8(JSON.stringify(value) + '\n');
                    ctrl.enqueue(bytes);
                } catch (err) {
                    ctrl.error(err);
                }
            },
            async cancel () {
                var _a;
                await ((_a = iter.return) === null || _a === void 0 ? void 0 : _a.call(iter));
            }
        });
    }
}
function $e4deb49dba5321bc$var$_iterSSEMessages(response, controller) {
    return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* _iterSSEMessages_1() {
        var _a, e_4, _b, _c;
        if (!response.body) {
            controller.abort();
            if (typeof globalThis.navigator !== 'undefined' && globalThis.navigator.product === 'ReactNative') throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`The default react-native fetch implementation does not support streaming. Please use expo/fetch: https://docs.expo.dev/versions/latest/sdk/expo/#expofetch-api`);
            throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`Attempted to iterate over a response with no body`);
        }
        const sseDecoder = new $e4deb49dba5321bc$var$SSEDecoder();
        const lineDecoder = new $e4deb49dba5321bc$var$LineDecoder();
        const iter = $e4deb49dba5321bc$var$ReadableStreamToAsyncIterable(response.body);
        try {
            for(var _d = true, _e = $e4deb49dba5321bc$var$__asyncValues($e4deb49dba5321bc$var$iterSSEChunks(iter)), _f; _f = yield $e4deb49dba5321bc$var$__await(_e.next()), _a = _f.done, !_a; _d = true){
                _c = _f.value;
                _d = false;
                const sseChunk = _c;
                for (const line of lineDecoder.decode(sseChunk)){
                    const sse = sseDecoder.decode(line);
                    if (sse) yield yield $e4deb49dba5321bc$var$__await(sse);
                }
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (!_d && !_a && (_b = _e.return)) yield $e4deb49dba5321bc$var$__await(_b.call(_e));
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        for (const line of lineDecoder.flush()){
            const sse = sseDecoder.decode(line);
            if (sse) yield yield $e4deb49dba5321bc$var$__await(sse);
        }
    });
}
/**
 * Given an async iterable iterator, iterates over it and yields full
 * SSE chunks, i.e. yields when a double new-line is encountered.
 */ function $e4deb49dba5321bc$var$iterSSEChunks(iterator) {
    return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* iterSSEChunks_1() {
        var _a, e_5, _b, _c;
        let data = new Uint8Array();
        try {
            for(var _d = true, iterator_3 = $e4deb49dba5321bc$var$__asyncValues(iterator), iterator_3_1; iterator_3_1 = yield $e4deb49dba5321bc$var$__await(iterator_3.next()), _a = iterator_3_1.done, !_a; _d = true){
                _c = iterator_3_1.value;
                _d = false;
                const chunk = _c;
                if (chunk == null) continue;
                const binaryChunk = chunk instanceof ArrayBuffer ? new Uint8Array(chunk) : typeof chunk === 'string' ? $e4deb49dba5321bc$var$encodeUTF8(chunk) : chunk;
                let newData = new Uint8Array(data.length + binaryChunk.length);
                newData.set(data);
                newData.set(binaryChunk, data.length);
                data = newData;
                let patternIndex;
                while((patternIndex = $e4deb49dba5321bc$var$findDoubleNewlineIndex(data)) !== -1){
                    yield yield $e4deb49dba5321bc$var$__await(data.slice(0, patternIndex));
                    data = data.slice(patternIndex);
                }
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (!_d && !_a && (_b = iterator_3.return)) yield $e4deb49dba5321bc$var$__await(_b.call(iterator_3));
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        if (data.length > 0) yield yield $e4deb49dba5321bc$var$__await(data);
    });
}
class $e4deb49dba5321bc$var$SSEDecoder {
    constructor(){
        this.event = null;
        this.data = [];
        this.chunks = [];
    }
    decode(line) {
        if (line.endsWith('\r')) line = line.substring(0, line.length - 1);
        if (!line) {
            // empty line and we didn't previously encounter any messages
            if (!this.event && !this.data.length) return null;
            const sse = {
                event: this.event,
                data: this.data.join('\n'),
                raw: this.chunks
            };
            this.event = null;
            this.data = [];
            this.chunks = [];
            return sse;
        }
        this.chunks.push(line);
        if (line.startsWith(':')) return null;
        let [fieldname, _, value] = $e4deb49dba5321bc$var$partition(line, ':');
        if (value.startsWith(' ')) value = value.substring(1);
        if (fieldname === 'event') this.event = value;
        else if (fieldname === 'data') this.data.push(value);
        return null;
    }
}
function $e4deb49dba5321bc$var$partition(str, delimiter) {
    const index = str.indexOf(delimiter);
    if (index !== -1) return [
        str.substring(0, index),
        delimiter,
        str.substring(index + delimiter.length)
    ];
    return [
        str,
        '',
        ''
    ];
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ async function $e4deb49dba5321bc$var$defaultParseResponse(client, props) {
    const { response: response, requestLogID: requestLogID, retryOfRequestLogID: retryOfRequestLogID, startTime: startTime } = props;
    const body = await (async ()=>{
        var _a;
        if (props.options.stream) {
            $e4deb49dba5321bc$var$loggerFor(client).debug('response', response.status, response.url, response.headers, response.body);
            // Note: there is an invariant here that isn't represented in the type system
            // that if you set `stream: true` the response type must also be `Stream<T>`
            if (props.options.__streamClass) return props.options.__streamClass.fromSSEResponse(response, props.controller, client);
            return $e4deb49dba5321bc$var$Stream.fromSSEResponse(response, props.controller, client);
        }
        // fetch refuses to read the body when the status code is 204.
        if (response.status === 204) return null;
        if (props.options.__binaryResponse) return response;
        const contentType = response.headers.get('content-type');
        const mediaType = (_a = contentType === null || contentType === void 0 ? void 0 : contentType.split(';')[0]) === null || _a === void 0 ? void 0 : _a.trim();
        const isJSON = (mediaType === null || mediaType === void 0 ? void 0 : mediaType.includes('application/json')) || (mediaType === null || mediaType === void 0 ? void 0 : mediaType.endsWith('+json'));
        if (isJSON) {
            const contentLength = response.headers.get('content-length');
            if (contentLength === '0') // if there is no content we can't do anything
            return undefined;
            const json = await response.json();
            return json;
        }
        const text = await response.text();
        return text;
    })();
    $e4deb49dba5321bc$var$loggerFor(client).debug(`[${requestLogID}] response parsed`, $e4deb49dba5321bc$var$formatRequestDetails({
        retryOfRequestLogID: retryOfRequestLogID,
        url: response.url,
        status: response.status,
        body: body,
        durationMs: Date.now() - startTime
    }));
    return body;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * A subclass of `Promise` providing additional helper methods
 * for interacting with the SDK.
 */ class $e4deb49dba5321bc$var$APIPromise extends Promise {
    constructor(client, responsePromise, parseResponse = $e4deb49dba5321bc$var$defaultParseResponse){
        super((resolve)=>{
            // this is maybe a bit weird but this has to be a no-op to not implicitly
            // parse the response body; instead .then, .catch, .finally are overridden
            // to parse the response
            resolve(null);
        });
        this.responsePromise = responsePromise;
        this.parseResponse = parseResponse;
        this.client = client;
    }
    _thenUnwrap(transform) {
        return new $e4deb49dba5321bc$var$APIPromise(this.client, this.responsePromise, async (client, props)=>transform(await this.parseResponse(client, props), props));
    }
    /**
     * Gets the raw `Response` instance instead of parsing the response
     * data.
     *
     * If you want to parse the response body but still get the `Response`
     * instance, you can use {@link withResponse()}.
     *
     * 👋 Getting the wrong TypeScript type for `Response`?
     * Try setting `"moduleResolution": "NodeNext"` or add `"lib": ["DOM"]`
     * to your `tsconfig.json`.
     */ asResponse() {
        return this.responsePromise.then((p)=>p.response);
    }
    /**
     * Gets the parsed response data and the raw `Response` instance.
     *
     * If you just want to get the raw `Response` instance without parsing it,
     * you can use {@link asResponse()}.
     *
     * 👋 Getting the wrong TypeScript type for `Response`?
     * Try setting `"moduleResolution": "NodeNext"` or add `"lib": ["DOM"]`
     * to your `tsconfig.json`.
     */ async withResponse() {
        const [data, response] = await Promise.all([
            this.parse(),
            this.asResponse()
        ]);
        return {
            data: data,
            response: response
        };
    }
    parse() {
        if (!this.parsedPromise) this.parsedPromise = this.responsePromise.then((data)=>this.parseResponse(this.client, data));
        return this.parsedPromise;
    }
    then(onfulfilled, onrejected) {
        return this.parse().then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.parse().catch(onrejected);
    }
    finally(onfinally) {
        return this.parse().finally(onfinally);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
const $e4deb49dba5321bc$var$brand_privateNullableHeaders = /* @__PURE__ */ Symbol('brand.privateNullableHeaders');
function* $e4deb49dba5321bc$var$iterateHeaders(headers) {
    if (!headers) return;
    if ($e4deb49dba5321bc$var$brand_privateNullableHeaders in headers) {
        const { values: values, nulls: nulls } = headers;
        yield* values.entries();
        for (const name of nulls)yield [
            name,
            null
        ];
        return;
    }
    let shouldClear = false;
    let iter;
    if (headers instanceof Headers) iter = headers.entries();
    else if ($e4deb49dba5321bc$var$isReadonlyArray(headers)) iter = headers;
    else {
        shouldClear = true;
        iter = Object.entries(headers !== null && headers !== void 0 ? headers : {});
    }
    for (let row of iter){
        const name = row[0];
        if (typeof name !== 'string') throw new TypeError('expected header name to be a string');
        const values = $e4deb49dba5321bc$var$isReadonlyArray(row[1]) ? row[1] : [
            row[1]
        ];
        let didClear = false;
        for (const value of values){
            if (value === undefined) continue;
            // Objects keys always overwrite older headers, they never append.
            // Yield a null to clear the header before adding the new values.
            if (shouldClear && !didClear) {
                didClear = true;
                yield [
                    name,
                    null
                ];
            }
            yield [
                name,
                value
            ];
        }
    }
}
const $e4deb49dba5321bc$var$buildHeaders = (newHeaders)=>{
    const targetHeaders = new Headers();
    const nullHeaders = new Set();
    for (const headers of newHeaders){
        const seenHeaders = new Set();
        for (const [name, value] of $e4deb49dba5321bc$var$iterateHeaders(headers)){
            const lowerName = name.toLowerCase();
            if (!seenHeaders.has(lowerName)) {
                targetHeaders.delete(name);
                seenHeaders.add(lowerName);
            }
            if (value === null) {
                targetHeaders.delete(name);
                nullHeaders.add(lowerName);
            } else {
                targetHeaders.append(name, value);
                nullHeaders.delete(lowerName);
            }
        }
    }
    return {
        [$e4deb49dba5321bc$var$brand_privateNullableHeaders]: true,
        values: targetHeaders,
        nulls: nullHeaders
    };
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
/**
 * Read an environment variable.
 *
 * Trims beginning and trailing whitespace.
 *
 * Will return undefined if the environment variable doesn't exist or cannot be accessed.
 */ const $e4deb49dba5321bc$var$readEnv = (env)=>{
    var _a, _b, _c, _d, _e, _f;
    if (typeof globalThis.process !== 'undefined') return (_c = (_b = (_a = globalThis.process.env) === null || _a === void 0 ? void 0 : _a[env]) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : undefined;
    if (typeof globalThis.Deno !== 'undefined') return (_f = (_e = (_d = globalThis.Deno.env) === null || _d === void 0 ? void 0 : _d.get) === null || _e === void 0 ? void 0 : _e.call(_d, env)) === null || _f === void 0 ? void 0 : _f.trim();
    return undefined;
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ var $e4deb49dba5321bc$var$_a;
/**
 * Base class for Gemini Next Gen API API clients.
 */ class $e4deb49dba5321bc$var$BaseGeminiNextGenAPIClient {
    /**
     * API Client for interfacing with the Gemini Next Gen API API.
     *
     * @param {string | null | undefined} [opts.apiKey=process.env['GEMINI_API_KEY'] ?? null]
     * @param {string | undefined} [opts.apiVersion=v1beta]
     * @param {string} [opts.baseURL=process.env['GEMINI_NEXT_GEN_API_BASE_URL'] ?? https://generativelanguage.googleapis.com] - Override the default base URL for the API.
     * @param {number} [opts.timeout=1 minute] - The maximum amount of time (in milliseconds) the client will wait for a response before timing out.
     * @param {MergedRequestInit} [opts.fetchOptions] - Additional `RequestInit` options to be passed to `fetch` calls.
     * @param {Fetch} [opts.fetch] - Specify a custom `fetch` function implementation.
     * @param {number} [opts.maxRetries=2] - The maximum number of times the client will retry a request.
     * @param {HeadersLike} opts.defaultHeaders - Default headers to include with every request to the API.
     * @param {Record<string, string | undefined>} opts.defaultQuery - Default query parameters to include with every request to the API.
     */ constructor(_b){
        var _c, _d, _e, _f, _g, _h, _j;
        var { baseURL: baseURL = $e4deb49dba5321bc$var$readEnv('GEMINI_NEXT_GEN_API_BASE_URL'), apiKey: apiKey = (_c = $e4deb49dba5321bc$var$readEnv('GEMINI_API_KEY')) !== null && _c !== void 0 ? _c : null, apiVersion: apiVersion = 'v1beta' } = _b, opts = $e4deb49dba5321bc$var$__rest(_b, [
            "baseURL",
            "apiKey",
            "apiVersion"
        ]);
        const options = Object.assign(Object.assign({
            apiKey: apiKey,
            apiVersion: apiVersion
        }, opts), {
            baseURL: baseURL || `https://generativelanguage.googleapis.com`
        });
        this.baseURL = options.baseURL;
        this.timeout = (_d = options.timeout) !== null && _d !== void 0 ? _d : $e4deb49dba5321bc$var$BaseGeminiNextGenAPIClient.DEFAULT_TIMEOUT /* 1 minute */ ;
        this.logger = (_e = options.logger) !== null && _e !== void 0 ? _e : console;
        const defaultLogLevel = 'warn';
        // Set default logLevel early so that we can log a warning in parseLogLevel.
        this.logLevel = defaultLogLevel;
        this.logLevel = (_g = (_f = $e4deb49dba5321bc$var$parseLogLevel(options.logLevel, 'ClientOptions.logLevel', this)) !== null && _f !== void 0 ? _f : $e4deb49dba5321bc$var$parseLogLevel($e4deb49dba5321bc$var$readEnv('GEMINI_NEXT_GEN_API_LOG'), "process.env['GEMINI_NEXT_GEN_API_LOG']", this)) !== null && _g !== void 0 ? _g : defaultLogLevel;
        this.fetchOptions = options.fetchOptions;
        this.maxRetries = (_h = options.maxRetries) !== null && _h !== void 0 ? _h : 2;
        this.fetch = (_j = options.fetch) !== null && _j !== void 0 ? _j : $e4deb49dba5321bc$var$getDefaultFetch();
        this.encoder = $e4deb49dba5321bc$var$FallbackEncoder;
        this._options = options;
        this.apiKey = apiKey;
        this.apiVersion = apiVersion;
        this.clientAdapter = options.clientAdapter;
    }
    /**
     * Create a new client instance re-using the same options given to the current client with optional overriding.
     */ withOptions(options) {
        const client = new this.constructor(Object.assign(Object.assign(Object.assign({}, this._options), {
            baseURL: this.baseURL,
            maxRetries: this.maxRetries,
            timeout: this.timeout,
            logger: this.logger,
            logLevel: this.logLevel,
            fetch: this.fetch,
            fetchOptions: this.fetchOptions,
            apiKey: this.apiKey,
            apiVersion: this.apiVersion
        }), options));
        return client;
    }
    /**
     * Check whether the base URL is set to its default.
     */ baseURLOverridden() {
        return this.baseURL !== 'https://generativelanguage.googleapis.com';
    }
    defaultQuery() {
        return this._options.defaultQuery;
    }
    validateHeaders({ values: values, nulls: nulls }) {
        // The headers object handles case insensitivity.
        if (values.has('authorization') || values.has('x-goog-api-key')) return;
        if (this.apiKey && values.get('x-goog-api-key')) return;
        if (nulls.has('x-goog-api-key')) return;
        throw new Error('Could not resolve authentication method. Expected the apiKey to be set. Or for the "x-goog-api-key" headers to be explicitly omitted');
    }
    async authHeaders(opts) {
        const existingHeaders = $e4deb49dba5321bc$var$buildHeaders([
            opts.headers
        ]);
        if (existingHeaders.values.has('authorization') || existingHeaders.values.has('x-goog-api-key')) return undefined;
        if (this.apiKey) return $e4deb49dba5321bc$var$buildHeaders([
            {
                'x-goog-api-key': this.apiKey
            }
        ]);
        if (this.clientAdapter.isVertexAI()) return $e4deb49dba5321bc$var$buildHeaders([
            await this.clientAdapter.getAuthHeaders()
        ]);
        return undefined;
    }
    /**
     * Basic re-implementation of `qs.stringify` for primitive types.
     */ stringifyQuery(query) {
        return Object.entries(query).filter(([_, value])=>typeof value !== 'undefined').map(([key, value])=>{
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            if (value === null) return `${encodeURIComponent(key)}=`;
            throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`Cannot stringify type ${typeof value}; Expected string, number, boolean, or null. If you need to pass nested query parameters, you can manually encode them, e.g. { query: { 'foo[key1]': value1, 'foo[key2]': value2 } }, and please open a GitHub issue requesting better support for your use case.`);
        }).join('&');
    }
    getUserAgent() {
        return `${this.constructor.name}/JS ${$e4deb49dba5321bc$var$VERSION}`;
    }
    defaultIdempotencyKey() {
        return `stainless-node-retry-${$e4deb49dba5321bc$var$uuid4()}`;
    }
    makeStatusError(status, error, message, headers) {
        return $e4deb49dba5321bc$var$APIError.generate(status, error, message, headers);
    }
    buildURL(path, query, defaultBaseURL) {
        const baseURL = !this.baseURLOverridden() && defaultBaseURL || this.baseURL;
        const url = $e4deb49dba5321bc$var$isAbsoluteURL(path) ? new URL(path) : new URL(baseURL + (baseURL.endsWith('/') && path.startsWith('/') ? path.slice(1) : path));
        const defaultQuery = this.defaultQuery();
        if (!$e4deb49dba5321bc$var$isEmptyObj(defaultQuery)) query = Object.assign(Object.assign({}, defaultQuery), query);
        if (typeof query === 'object' && query && !Array.isArray(query)) url.search = this.stringifyQuery(query);
        return url.toString();
    }
    /**
     * Used as a callback for mutating the given `FinalRequestOptions` object.
  
     */ async prepareOptions(options) {
        if (this.clientAdapter && this.clientAdapter.isVertexAI() && !options.path.startsWith(`/${this.apiVersion}/projects/`)) {
            const oldPath = options.path.slice(this.apiVersion.length + 1);
            options.path = `/${this.apiVersion}/projects/${this.clientAdapter.getProject()}/locations/${this.clientAdapter.getLocation()}${oldPath}`;
        }
    }
    /**
     * Used as a callback for mutating the given `RequestInit` object.
     *
     * This is useful for cases where you want to add certain headers based off of
     * the request properties, e.g. `method` or `url`.
     */ async prepareRequest(request, { url: url, options: options }) {}
    get(path, opts) {
        return this.methodRequest('get', path, opts);
    }
    post(path, opts) {
        return this.methodRequest('post', path, opts);
    }
    patch(path, opts) {
        return this.methodRequest('patch', path, opts);
    }
    put(path, opts) {
        return this.methodRequest('put', path, opts);
    }
    delete(path, opts) {
        return this.methodRequest('delete', path, opts);
    }
    methodRequest(method, path, opts) {
        return this.request(Promise.resolve(opts).then((opts)=>{
            return Object.assign({
                method: method,
                path: path
            }, opts);
        }));
    }
    request(options, remainingRetries = null) {
        return new $e4deb49dba5321bc$var$APIPromise(this, this.makeRequest(options, remainingRetries, undefined));
    }
    async makeRequest(optionsInput, retriesRemaining, retryOfRequestLogID) {
        var _b, _c, _d;
        const options = await optionsInput;
        const maxRetries = (_b = options.maxRetries) !== null && _b !== void 0 ? _b : this.maxRetries;
        if (retriesRemaining == null) retriesRemaining = maxRetries;
        await this.prepareOptions(options);
        const { req: req, url: url, timeout: timeout } = await this.buildRequest(options, {
            retryCount: maxRetries - retriesRemaining
        });
        await this.prepareRequest(req, {
            url: url,
            options: options
        });
        /** Not an API request ID, just for correlating local log entries. */ const requestLogID = 'log_' + (Math.random() * 16777216 | 0).toString(16).padStart(6, '0');
        const retryLogStr = retryOfRequestLogID === undefined ? '' : `, retryOf: ${retryOfRequestLogID}`;
        const startTime = Date.now();
        $e4deb49dba5321bc$var$loggerFor(this).debug(`[${requestLogID}] sending request`, $e4deb49dba5321bc$var$formatRequestDetails({
            retryOfRequestLogID: retryOfRequestLogID,
            method: options.method,
            url: url,
            options: options,
            headers: req.headers
        }));
        if ((_c = options.signal) === null || _c === void 0 ? void 0 : _c.aborted) throw new $e4deb49dba5321bc$var$APIUserAbortError();
        const controller = new AbortController();
        const response = await this.fetchWithTimeout(url, req, timeout, controller).catch($e4deb49dba5321bc$var$castToError);
        const headersTime = Date.now();
        if (response instanceof globalThis.Error) {
            const retryMessage = `retrying, ${retriesRemaining} attempts remaining`;
            if ((_d = options.signal) === null || _d === void 0 ? void 0 : _d.aborted) throw new $e4deb49dba5321bc$var$APIUserAbortError();
            // detect native connection timeout errors
            // deno throws "TypeError: error sending request for url (https://example/): client error (Connect): tcp connect error: Operation timed out (os error 60): Operation timed out (os error 60)"
            // undici throws "TypeError: fetch failed" with cause "ConnectTimeoutError: Connect Timeout Error (attempted address: example:443, timeout: 1ms)"
            // others do not provide enough information to distinguish timeouts from other connection errors
            const isTimeout = $e4deb49dba5321bc$var$isAbortError(response) || /timed? ?out/i.test(String(response) + ('cause' in response ? String(response.cause) : ''));
            if (retriesRemaining) {
                $e4deb49dba5321bc$var$loggerFor(this).info(`[${requestLogID}] connection ${isTimeout ? 'timed out' : 'failed'} - ${retryMessage}`);
                $e4deb49dba5321bc$var$loggerFor(this).debug(`[${requestLogID}] connection ${isTimeout ? 'timed out' : 'failed'} (${retryMessage})`, $e4deb49dba5321bc$var$formatRequestDetails({
                    retryOfRequestLogID: retryOfRequestLogID,
                    url: url,
                    durationMs: headersTime - startTime,
                    message: response.message
                }));
                return this.retryRequest(options, retriesRemaining, retryOfRequestLogID !== null && retryOfRequestLogID !== void 0 ? retryOfRequestLogID : requestLogID);
            }
            $e4deb49dba5321bc$var$loggerFor(this).info(`[${requestLogID}] connection ${isTimeout ? 'timed out' : 'failed'} - error; no more retries left`);
            $e4deb49dba5321bc$var$loggerFor(this).debug(`[${requestLogID}] connection ${isTimeout ? 'timed out' : 'failed'} (error; no more retries left)`, $e4deb49dba5321bc$var$formatRequestDetails({
                retryOfRequestLogID: retryOfRequestLogID,
                url: url,
                durationMs: headersTime - startTime,
                message: response.message
            }));
            if (isTimeout) throw new $e4deb49dba5321bc$var$APIConnectionTimeoutError();
            throw new $e4deb49dba5321bc$var$APIConnectionError({
                cause: response
            });
        }
        const responseInfo = `[${requestLogID}${retryLogStr}] ${req.method} ${url} ${response.ok ? 'succeeded' : 'failed'} with status ${response.status} in ${headersTime - startTime}ms`;
        if (!response.ok) {
            const shouldRetry = await this.shouldRetry(response);
            if (retriesRemaining && shouldRetry) {
                const retryMessage = `retrying, ${retriesRemaining} attempts remaining`;
                // We don't need the body of this response.
                await $e4deb49dba5321bc$var$CancelReadableStream(response.body);
                $e4deb49dba5321bc$var$loggerFor(this).info(`${responseInfo} - ${retryMessage}`);
                $e4deb49dba5321bc$var$loggerFor(this).debug(`[${requestLogID}] response error (${retryMessage})`, $e4deb49dba5321bc$var$formatRequestDetails({
                    retryOfRequestLogID: retryOfRequestLogID,
                    url: response.url,
                    status: response.status,
                    headers: response.headers,
                    durationMs: headersTime - startTime
                }));
                return this.retryRequest(options, retriesRemaining, retryOfRequestLogID !== null && retryOfRequestLogID !== void 0 ? retryOfRequestLogID : requestLogID, response.headers);
            }
            const retryMessage = shouldRetry ? `error; no more retries left` : `error; not retryable`;
            $e4deb49dba5321bc$var$loggerFor(this).info(`${responseInfo} - ${retryMessage}`);
            const errText = await response.text().catch((err)=>$e4deb49dba5321bc$var$castToError(err).message);
            const errJSON = $e4deb49dba5321bc$var$safeJSON(errText);
            const errMessage = errJSON ? undefined : errText;
            $e4deb49dba5321bc$var$loggerFor(this).debug(`[${requestLogID}] response error (${retryMessage})`, $e4deb49dba5321bc$var$formatRequestDetails({
                retryOfRequestLogID: retryOfRequestLogID,
                url: response.url,
                status: response.status,
                headers: response.headers,
                message: errMessage,
                durationMs: Date.now() - startTime
            }));
            // @ts-ignore
            const err = this.makeStatusError(response.status, errJSON, errMessage, response.headers);
            throw err;
        }
        $e4deb49dba5321bc$var$loggerFor(this).info(responseInfo);
        $e4deb49dba5321bc$var$loggerFor(this).debug(`[${requestLogID}] response start`, $e4deb49dba5321bc$var$formatRequestDetails({
            retryOfRequestLogID: retryOfRequestLogID,
            url: response.url,
            status: response.status,
            headers: response.headers,
            durationMs: headersTime - startTime
        }));
        return {
            response: response,
            options: options,
            controller: controller,
            requestLogID: requestLogID,
            retryOfRequestLogID: retryOfRequestLogID,
            startTime: startTime
        };
    }
    async fetchWithTimeout(url, init, ms, controller) {
        const _b = init || {}, { signal: signal, method: method } = _b, options = $e4deb49dba5321bc$var$__rest(_b, [
            "signal",
            "method"
        ]);
        const abort = this._makeAbort(controller);
        if (signal) signal.addEventListener('abort', abort, {
            once: true
        });
        const timeout = setTimeout(abort, ms);
        const isReadableBody = globalThis.ReadableStream && options.body instanceof globalThis.ReadableStream || typeof options.body === 'object' && options.body !== null && Symbol.asyncIterator in options.body;
        const fetchOptions = Object.assign(Object.assign(Object.assign({
            signal: controller.signal
        }, isReadableBody ? {
            duplex: 'half'
        } : {}), {
            method: 'GET'
        }), options);
        if (method) // Custom methods like 'patch' need to be uppercased
        // See https://github.com/nodejs/undici/issues/2294
        fetchOptions.method = method.toUpperCase();
        try {
            // use undefined this binding; fetch errors if bound to something else in browser/cloudflare
            return await this.fetch.call(undefined, url, fetchOptions);
        } finally{
            clearTimeout(timeout);
        }
    }
    async shouldRetry(response) {
        // Note this is not a standard header.
        const shouldRetryHeader = response.headers.get('x-should-retry');
        // If the server explicitly says whether or not to retry, obey.
        if (shouldRetryHeader === 'true') return true;
        if (shouldRetryHeader === 'false') return false;
        // Retry on request timeouts.
        if (response.status === 408) return true;
        // Retry on lock timeouts.
        if (response.status === 409) return true;
        // Retry on rate limits.
        if (response.status === 429) return true;
        // Retry internal errors.
        if (response.status >= 500) return true;
        return false;
    }
    async retryRequest(options, retriesRemaining, requestLogID, responseHeaders) {
        var _b;
        let timeoutMillis;
        // Note the `retry-after-ms` header may not be standard, but is a good idea and we'd like proactive support for it.
        const retryAfterMillisHeader = responseHeaders === null || responseHeaders === void 0 ? void 0 : responseHeaders.get('retry-after-ms');
        if (retryAfterMillisHeader) {
            const timeoutMs = parseFloat(retryAfterMillisHeader);
            if (!Number.isNaN(timeoutMs)) timeoutMillis = timeoutMs;
        }
        // About the Retry-After header: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After
        const retryAfterHeader = responseHeaders === null || responseHeaders === void 0 ? void 0 : responseHeaders.get('retry-after');
        if (retryAfterHeader && !timeoutMillis) {
            const timeoutSeconds = parseFloat(retryAfterHeader);
            if (!Number.isNaN(timeoutSeconds)) timeoutMillis = timeoutSeconds * 1000;
            else timeoutMillis = Date.parse(retryAfterHeader) - Date.now();
        }
        // If the API asks us to wait a certain amount of time (and it's a reasonable amount),
        // just do what it says, but otherwise calculate a default
        if (!(timeoutMillis && 0 <= timeoutMillis && timeoutMillis < 60000)) {
            const maxRetries = (_b = options.maxRetries) !== null && _b !== void 0 ? _b : this.maxRetries;
            timeoutMillis = this.calculateDefaultRetryTimeoutMillis(retriesRemaining, maxRetries);
        }
        await $e4deb49dba5321bc$var$sleep$1(timeoutMillis);
        return this.makeRequest(options, retriesRemaining - 1, requestLogID);
    }
    calculateDefaultRetryTimeoutMillis(retriesRemaining, maxRetries) {
        const initialRetryDelay = 0.5;
        const maxRetryDelay = 8.0;
        const numRetries = maxRetries - retriesRemaining;
        // Apply exponential backoff, but not more than the max.
        const sleepSeconds = Math.min(initialRetryDelay * Math.pow(2, numRetries), maxRetryDelay);
        // Apply some jitter, take up to at most 25 percent of the retry time.
        const jitter = 1 - Math.random() * 0.25;
        return sleepSeconds * jitter * 1000;
    }
    async buildRequest(inputOptions, { retryCount: retryCount = 0 } = {}) {
        var _b, _c, _d;
        const options = Object.assign({}, inputOptions);
        const { method: method, path: path, query: query, defaultBaseURL: defaultBaseURL } = options;
        const url = this.buildURL(path, query, defaultBaseURL);
        if ('timeout' in options) $e4deb49dba5321bc$var$validatePositiveInteger('timeout', options.timeout);
        options.timeout = (_b = options.timeout) !== null && _b !== void 0 ? _b : this.timeout;
        const { bodyHeaders: bodyHeaders, body: body } = this.buildBody({
            options: options
        });
        const reqHeaders = await this.buildHeaders({
            options: inputOptions,
            method: method,
            bodyHeaders: bodyHeaders,
            retryCount: retryCount
        });
        const req = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
            method: method,
            headers: reqHeaders
        }, options.signal && {
            signal: options.signal
        }), globalThis.ReadableStream && body instanceof globalThis.ReadableStream && {
            duplex: 'half'
        }), body && {
            body: body
        }), (_c = this.fetchOptions) !== null && _c !== void 0 ? _c : {}), (_d = options.fetchOptions) !== null && _d !== void 0 ? _d : {});
        return {
            req: req,
            url: url,
            timeout: options.timeout
        };
    }
    async buildHeaders({ options: options, method: method, bodyHeaders: bodyHeaders, retryCount: retryCount }) {
        let idempotencyHeaders = {};
        if (this.idempotencyHeader && method !== 'get') {
            if (!options.idempotencyKey) options.idempotencyKey = this.defaultIdempotencyKey();
            idempotencyHeaders[this.idempotencyHeader] = options.idempotencyKey;
        }
        const authHeaders = await this.authHeaders(options);
        let headers = $e4deb49dba5321bc$var$buildHeaders([
            idempotencyHeaders,
            Object.assign(Object.assign({
                Accept: 'application/json',
                'User-Agent': this.getUserAgent(),
                'X-Stainless-Retry-Count': String(retryCount)
            }, options.timeout ? {
                'X-Stainless-Timeout': String(Math.trunc(options.timeout / 1000))
            } : {}), $e4deb49dba5321bc$var$getPlatformHeaders()),
            this._options.defaultHeaders,
            bodyHeaders,
            options.headers,
            authHeaders
        ]);
        this.validateHeaders(headers);
        return headers.values;
    }
    _makeAbort(controller) {
        // note: we can't just inline this method inside `fetchWithTimeout()` because then the closure
        //       would capture all request options, and cause a memory leak.
        return ()=>controller.abort();
    }
    buildBody({ options: { body: body, headers: rawHeaders } }) {
        if (!body) return {
            bodyHeaders: undefined,
            body: undefined
        };
        const headers = $e4deb49dba5321bc$var$buildHeaders([
            rawHeaders
        ]);
        if (// Pass raw type verbatim
        ArrayBuffer.isView(body) || body instanceof ArrayBuffer || body instanceof DataView || typeof body === 'string' && // Preserve legacy string encoding behavior for now
        headers.values.has('content-type') || // `Blob` is superset of `File`
        globalThis.Blob && body instanceof globalThis.Blob || // `FormData` -> `multipart/form-data`
        body instanceof FormData || // `URLSearchParams` -> `application/x-www-form-urlencoded`
        body instanceof URLSearchParams || // Send chunked stream (each chunk has own `length`)
        globalThis.ReadableStream && body instanceof globalThis.ReadableStream) return {
            bodyHeaders: undefined,
            body: body
        };
        else if (typeof body === 'object' && (Symbol.asyncIterator in body || Symbol.iterator in body && 'next' in body && typeof body.next === 'function')) return {
            bodyHeaders: undefined,
            body: $e4deb49dba5321bc$var$ReadableStreamFrom(body)
        };
        else if (typeof body === 'object' && headers.values.get('content-type') === 'application/x-www-form-urlencoded') return {
            bodyHeaders: {
                'content-type': 'application/x-www-form-urlencoded'
            },
            body: this.stringifyQuery(body)
        };
        else return this.encoder({
            body: body,
            headers: headers
        });
    }
}
$e4deb49dba5321bc$var$BaseGeminiNextGenAPIClient.DEFAULT_TIMEOUT = 60000; // 1 minute
/**
 * API Client for interfacing with the Gemini Next Gen API API.
 */ class $e4deb49dba5321bc$var$GeminiNextGenAPIClient extends $e4deb49dba5321bc$var$BaseGeminiNextGenAPIClient {
    constructor(){
        super(...arguments);
        this.interactions = new $e4deb49dba5321bc$var$Interactions(this);
    }
}
$e4deb49dba5321bc$var$_a = $e4deb49dba5321bc$var$GeminiNextGenAPIClient;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.GeminiNextGenAPIClient = $e4deb49dba5321bc$var$_a;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.GeminiNextGenAPIClientError = $e4deb49dba5321bc$var$GeminiNextGenAPIClientError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.APIError = $e4deb49dba5321bc$var$APIError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.APIConnectionError = $e4deb49dba5321bc$var$APIConnectionError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.APIConnectionTimeoutError = $e4deb49dba5321bc$var$APIConnectionTimeoutError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.APIUserAbortError = $e4deb49dba5321bc$var$APIUserAbortError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.NotFoundError = $e4deb49dba5321bc$var$NotFoundError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.ConflictError = $e4deb49dba5321bc$var$ConflictError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.RateLimitError = $e4deb49dba5321bc$var$RateLimitError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.BadRequestError = $e4deb49dba5321bc$var$BadRequestError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.AuthenticationError = $e4deb49dba5321bc$var$AuthenticationError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.InternalServerError = $e4deb49dba5321bc$var$InternalServerError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.PermissionDeniedError = $e4deb49dba5321bc$var$PermissionDeniedError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.UnprocessableEntityError = $e4deb49dba5321bc$var$UnprocessableEntityError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.toFile = $e4deb49dba5321bc$var$toFile;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.Interactions = $e4deb49dba5321bc$var$Interactions;
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$cancelTuningJobParametersToMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$cancelTuningJobParametersToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$cancelTuningJobResponseFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$cancelTuningJobResponseFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$createTuningJobConfigToMldev(fromObject, parentObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'validationDataset'
    ]) !== undefined) throw new Error('validationDataset parameter is not supported in Gemini API.');
    const fromTunedModelDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (parentObject !== undefined && fromTunedModelDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromTunedModelDisplayName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]) !== undefined) throw new Error('description parameter is not supported in Gemini API.');
    const fromEpochCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'epochCount'
    ]);
    if (parentObject !== undefined && fromEpochCount != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'tuningTask',
        'hyperparameters',
        'epochCount'
    ], fromEpochCount);
    const fromLearningRateMultiplier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'learningRateMultiplier'
    ]);
    if (fromLearningRateMultiplier != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tuningTask',
        'hyperparameters',
        'learningRateMultiplier'
    ], fromLearningRateMultiplier);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'exportLastCheckpointOnly'
    ]) !== undefined) throw new Error('exportLastCheckpointOnly parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModelCheckpointId'
    ]) !== undefined) throw new Error('preTunedModelCheckpointId parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'adapterSize'
    ]) !== undefined) throw new Error('adapterSize parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningMode'
    ]) !== undefined) throw new Error('tuningMode parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'customBaseModel'
    ]) !== undefined) throw new Error('customBaseModel parameter is not supported in Gemini API.');
    const fromBatchSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'batchSize'
    ]);
    if (parentObject !== undefined && fromBatchSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'tuningTask',
        'hyperparameters',
        'batchSize'
    ], fromBatchSize);
    const fromLearningRate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'learningRate'
    ]);
    if (parentObject !== undefined && fromLearningRate != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'tuningTask',
        'hyperparameters',
        'learningRate'
    ], fromLearningRate);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'beta'
    ]) !== undefined) throw new Error('beta parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseTeacherModel'
    ]) !== undefined) throw new Error('baseTeacherModel parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedTeacherModelSource'
    ]) !== undefined) throw new Error('tunedTeacherModelSource parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sftLossWeightMultiplier'
    ]) !== undefined) throw new Error('sftLossWeightMultiplier parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputUri'
    ]) !== undefined) throw new Error('outputUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encryptionSpec'
    ]) !== undefined) throw new Error('encryptionSpec parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$createTuningJobConfigToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    let discriminatorValidationDataset = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorValidationDataset === undefined) discriminatorValidationDataset = 'SUPERVISED_FINE_TUNING';
    if (discriminatorValidationDataset === 'SUPERVISED_FINE_TUNING') {
        const fromValidationDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'validationDataset'
        ]);
        if (parentObject !== undefined && fromValidationDataset != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec'
        ], $e4deb49dba5321bc$var$tuningValidationDatasetToVertex(fromValidationDataset));
    } else if (discriminatorValidationDataset === 'PREFERENCE_TUNING') {
        const fromValidationDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'validationDataset'
        ]);
        if (parentObject !== undefined && fromValidationDataset != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec'
        ], $e4deb49dba5321bc$var$tuningValidationDatasetToVertex(fromValidationDataset));
    } else if (discriminatorValidationDataset === 'DISTILLATION') {
        const fromValidationDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'validationDataset'
        ]);
        if (parentObject !== undefined && fromValidationDataset != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec'
        ], $e4deb49dba5321bc$var$tuningValidationDatasetToVertex(fromValidationDataset));
    }
    const fromTunedModelDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (parentObject !== undefined && fromTunedModelDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'tunedModelDisplayName'
    ], fromTunedModelDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (parentObject !== undefined && fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'description'
    ], fromDescription);
    let discriminatorEpochCount = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorEpochCount === undefined) discriminatorEpochCount = 'SUPERVISED_FINE_TUNING';
    if (discriminatorEpochCount === 'SUPERVISED_FINE_TUNING') {
        const fromEpochCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'epochCount'
        ]);
        if (parentObject !== undefined && fromEpochCount != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'hyperParameters',
            'epochCount'
        ], fromEpochCount);
    } else if (discriminatorEpochCount === 'PREFERENCE_TUNING') {
        const fromEpochCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'epochCount'
        ]);
        if (parentObject !== undefined && fromEpochCount != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec',
            'hyperParameters',
            'epochCount'
        ], fromEpochCount);
    } else if (discriminatorEpochCount === 'DISTILLATION') {
        const fromEpochCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'epochCount'
        ]);
        if (parentObject !== undefined && fromEpochCount != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'hyperParameters',
            'epochCount'
        ], fromEpochCount);
    }
    let discriminatorLearningRateMultiplier = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorLearningRateMultiplier === undefined) discriminatorLearningRateMultiplier = 'SUPERVISED_FINE_TUNING';
    if (discriminatorLearningRateMultiplier === 'SUPERVISED_FINE_TUNING') {
        const fromLearningRateMultiplier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'learningRateMultiplier'
        ]);
        if (parentObject !== undefined && fromLearningRateMultiplier != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'hyperParameters',
            'learningRateMultiplier'
        ], fromLearningRateMultiplier);
    } else if (discriminatorLearningRateMultiplier === 'PREFERENCE_TUNING') {
        const fromLearningRateMultiplier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'learningRateMultiplier'
        ]);
        if (parentObject !== undefined && fromLearningRateMultiplier != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec',
            'hyperParameters',
            'learningRateMultiplier'
        ], fromLearningRateMultiplier);
    } else if (discriminatorLearningRateMultiplier === 'DISTILLATION') {
        const fromLearningRateMultiplier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'learningRateMultiplier'
        ]);
        if (parentObject !== undefined && fromLearningRateMultiplier != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'hyperParameters',
            'learningRateMultiplier'
        ], fromLearningRateMultiplier);
    }
    let discriminatorExportLastCheckpointOnly = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorExportLastCheckpointOnly === undefined) discriminatorExportLastCheckpointOnly = 'SUPERVISED_FINE_TUNING';
    if (discriminatorExportLastCheckpointOnly === 'SUPERVISED_FINE_TUNING') {
        const fromExportLastCheckpointOnly = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'exportLastCheckpointOnly'
        ]);
        if (parentObject !== undefined && fromExportLastCheckpointOnly != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'exportLastCheckpointOnly'
        ], fromExportLastCheckpointOnly);
    } else if (discriminatorExportLastCheckpointOnly === 'PREFERENCE_TUNING') {
        const fromExportLastCheckpointOnly = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'exportLastCheckpointOnly'
        ]);
        if (parentObject !== undefined && fromExportLastCheckpointOnly != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec',
            'exportLastCheckpointOnly'
        ], fromExportLastCheckpointOnly);
    } else if (discriminatorExportLastCheckpointOnly === 'DISTILLATION') {
        const fromExportLastCheckpointOnly = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'exportLastCheckpointOnly'
        ]);
        if (parentObject !== undefined && fromExportLastCheckpointOnly != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'exportLastCheckpointOnly'
        ], fromExportLastCheckpointOnly);
    }
    let discriminatorAdapterSize = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorAdapterSize === undefined) discriminatorAdapterSize = 'SUPERVISED_FINE_TUNING';
    if (discriminatorAdapterSize === 'SUPERVISED_FINE_TUNING') {
        const fromAdapterSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'adapterSize'
        ]);
        if (parentObject !== undefined && fromAdapterSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'hyperParameters',
            'adapterSize'
        ], fromAdapterSize);
    } else if (discriminatorAdapterSize === 'PREFERENCE_TUNING') {
        const fromAdapterSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'adapterSize'
        ]);
        if (parentObject !== undefined && fromAdapterSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec',
            'hyperParameters',
            'adapterSize'
        ], fromAdapterSize);
    } else if (discriminatorAdapterSize === 'DISTILLATION') {
        const fromAdapterSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'adapterSize'
        ]);
        if (parentObject !== undefined && fromAdapterSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'hyperParameters',
            'adapterSize'
        ], fromAdapterSize);
    }
    let discriminatorTuningMode = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorTuningMode === undefined) discriminatorTuningMode = 'SUPERVISED_FINE_TUNING';
    if (discriminatorTuningMode === 'SUPERVISED_FINE_TUNING') {
        const fromTuningMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'tuningMode'
        ]);
        if (parentObject !== undefined && fromTuningMode != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'tuningMode'
        ], fromTuningMode);
    }
    const fromCustomBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'customBaseModel'
    ]);
    if (parentObject !== undefined && fromCustomBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'customBaseModel'
    ], fromCustomBaseModel);
    let discriminatorBatchSize = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorBatchSize === undefined) discriminatorBatchSize = 'SUPERVISED_FINE_TUNING';
    if (discriminatorBatchSize === 'SUPERVISED_FINE_TUNING') {
        const fromBatchSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'batchSize'
        ]);
        if (parentObject !== undefined && fromBatchSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'hyperParameters',
            'batchSize'
        ], fromBatchSize);
    }
    let discriminatorLearningRate = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorLearningRate === undefined) discriminatorLearningRate = 'SUPERVISED_FINE_TUNING';
    if (discriminatorLearningRate === 'SUPERVISED_FINE_TUNING') {
        const fromLearningRate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'learningRate'
        ]);
        if (parentObject !== undefined && fromLearningRate != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'hyperParameters',
            'learningRate'
        ], fromLearningRate);
    }
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    const fromBeta = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'beta'
    ]);
    if (parentObject !== undefined && fromBeta != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'preferenceOptimizationSpec',
        'hyperParameters',
        'beta'
    ], fromBeta);
    const fromBaseTeacherModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseTeacherModel'
    ]);
    if (parentObject !== undefined && fromBaseTeacherModel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'distillationSpec',
        'baseTeacherModel'
    ], fromBaseTeacherModel);
    const fromTunedTeacherModelSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedTeacherModelSource'
    ]);
    if (parentObject !== undefined && fromTunedTeacherModelSource != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'distillationSpec',
        'tunedTeacherModelSource'
    ], fromTunedTeacherModelSource);
    const fromSftLossWeightMultiplier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sftLossWeightMultiplier'
    ]);
    if (parentObject !== undefined && fromSftLossWeightMultiplier != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'distillationSpec',
        'hyperParameters',
        'sftLossWeightMultiplier'
    ], fromSftLossWeightMultiplier);
    const fromOutputUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputUri'
    ]);
    if (parentObject !== undefined && fromOutputUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'outputUri'
    ], fromOutputUri);
    const fromEncryptionSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encryptionSpec'
    ]);
    if (parentObject !== undefined && fromEncryptionSpec != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'encryptionSpec'
    ], fromEncryptionSpec);
    return toObject;
}
function $e4deb49dba5321bc$var$createTuningJobParametersPrivateToMldev(fromObject, rootObject) {
    const toObject = {};
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromPreTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModel'
    ]);
    if (fromPreTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'preTunedModel'
    ], fromPreTunedModel);
    const fromTrainingDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'trainingDataset'
    ]);
    if (fromTrainingDataset != null) $e4deb49dba5321bc$var$tuningDatasetToMldev(fromTrainingDataset);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createTuningJobConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$createTuningJobParametersPrivateToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromPreTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModel'
    ]);
    if (fromPreTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'preTunedModel'
    ], fromPreTunedModel);
    const fromTrainingDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'trainingDataset'
    ]);
    if (fromTrainingDataset != null) $e4deb49dba5321bc$var$tuningDatasetToVertex(fromTrainingDataset, toObject, rootObject);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createTuningJobConfigToVertex(fromConfig, toObject, rootObject);
    return toObject;
}
function $e4deb49dba5321bc$var$getTuningJobParametersToMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$getTuningJobParametersToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsConfigToMldev(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsConfigToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsParametersToMldev(fromObject, rootObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listTuningJobsConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsParametersToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listTuningJobsConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsResponseFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromTuningJobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModels'
    ]);
    if (fromTuningJobs != null) {
        let transformedList = fromTuningJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$tuningJobFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'tuningJobs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromTuningJobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningJobs'
    ]);
    if (fromTuningJobs != null) {
        let transformedList = fromTuningJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$tuningJobFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'tuningJobs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$tunedModelFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromEndpoint = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromEndpoint != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endpoint'
    ], fromEndpoint);
    return toObject;
}
function $e4deb49dba5321bc$var$tuningDatasetToMldev(fromObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]) !== undefined) throw new Error('gcsUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'vertexDatasetResource'
    ]) !== undefined) throw new Error('vertexDatasetResource parameter is not supported in Gemini API.');
    const fromExamples = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'examples'
    ]);
    if (fromExamples != null) {
        let transformedList = fromExamples;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'examples',
            'examples'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$tuningDatasetToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    let discriminatorGcsUri = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorGcsUri === undefined) discriminatorGcsUri = 'SUPERVISED_FINE_TUNING';
    if (discriminatorGcsUri === 'SUPERVISED_FINE_TUNING') {
        const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'gcsUri'
        ]);
        if (parentObject !== undefined && fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'trainingDatasetUri'
        ], fromGcsUri);
    } else if (discriminatorGcsUri === 'PREFERENCE_TUNING') {
        const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'gcsUri'
        ]);
        if (parentObject !== undefined && fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec',
            'trainingDatasetUri'
        ], fromGcsUri);
    } else if (discriminatorGcsUri === 'DISTILLATION') {
        const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'gcsUri'
        ]);
        if (parentObject !== undefined && fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'promptDatasetUri'
        ], fromGcsUri);
    }
    let discriminatorVertexDatasetResource = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorVertexDatasetResource === undefined) discriminatorVertexDatasetResource = 'SUPERVISED_FINE_TUNING';
    if (discriminatorVertexDatasetResource === 'SUPERVISED_FINE_TUNING') {
        const fromVertexDatasetResource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'vertexDatasetResource'
        ]);
        if (parentObject !== undefined && fromVertexDatasetResource != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'trainingDatasetUri'
        ], fromVertexDatasetResource);
    } else if (discriminatorVertexDatasetResource === 'PREFERENCE_TUNING') {
        const fromVertexDatasetResource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'vertexDatasetResource'
        ]);
        if (parentObject !== undefined && fromVertexDatasetResource != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec',
            'trainingDatasetUri'
        ], fromVertexDatasetResource);
    } else if (discriminatorVertexDatasetResource === 'DISTILLATION') {
        const fromVertexDatasetResource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'vertexDatasetResource'
        ]);
        if (parentObject !== undefined && fromVertexDatasetResource != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'promptDatasetUri'
        ], fromVertexDatasetResource);
    }
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'examples'
    ]) !== undefined) throw new Error('examples parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$tuningJobFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], $e4deb49dba5321bc$var$tTuningJobStatus(fromState));
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningTask',
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningTask',
        'completeTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModel'
    ], $e4deb49dba5321bc$var$tunedModelFromMldev(fromTunedModel));
    return toObject;
}
function $e4deb49dba5321bc$var$tuningJobFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], $e4deb49dba5321bc$var$tTuningJobStatus(fromState));
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModel'
    ]);
    if (fromTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModel'
    ], fromTunedModel);
    const fromPreTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModel'
    ]);
    if (fromPreTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'preTunedModel'
    ], fromPreTunedModel);
    const fromSupervisedTuningSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'supervisedTuningSpec'
    ]);
    if (fromSupervisedTuningSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'supervisedTuningSpec'
    ], fromSupervisedTuningSpec);
    const fromPreferenceOptimizationSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preferenceOptimizationSpec'
    ]);
    if (fromPreferenceOptimizationSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'preferenceOptimizationSpec'
    ], fromPreferenceOptimizationSpec);
    const fromDistillationSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'distillationSpec'
    ]);
    if (fromDistillationSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'distillationSpec'
    ], fromDistillationSpec);
    const fromTuningDataStats = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningDataStats'
    ]);
    if (fromTuningDataStats != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tuningDataStats'
    ], fromTuningDataStats);
    const fromEncryptionSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encryptionSpec'
    ]);
    if (fromEncryptionSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'encryptionSpec'
    ], fromEncryptionSpec);
    const fromPartnerModelTuningSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partnerModelTuningSpec'
    ]);
    if (fromPartnerModelTuningSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'partnerModelTuningSpec'
    ], fromPartnerModelTuningSpec);
    const fromCustomBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'customBaseModel'
    ]);
    if (fromCustomBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'customBaseModel'
    ], fromCustomBaseModel);
    const fromExperiment = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'experiment'
    ]);
    if (fromExperiment != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'experiment'
    ], fromExperiment);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'labels'
    ], fromLabels);
    const fromOutputUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputUri'
    ]);
    if (fromOutputUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'outputUri'
    ], fromOutputUri);
    const fromPipelineJob = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pipelineJob'
    ]);
    if (fromPipelineJob != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'pipelineJob'
    ], fromPipelineJob);
    const fromServiceAccount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'serviceAccount'
    ]);
    if (fromServiceAccount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'serviceAccount'
    ], fromServiceAccount);
    const fromTunedModelDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (fromTunedModelDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModelDisplayName'
    ], fromTunedModelDisplayName);
    const fromVeoTuningSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'veoTuningSpec'
    ]);
    if (fromVeoTuningSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'veoTuningSpec'
    ], fromVeoTuningSpec);
    return toObject;
}
function $e4deb49dba5321bc$var$tuningOperationFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    return toObject;
}
function $e4deb49dba5321bc$var$tuningValidationDatasetToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'validationDatasetUri'
    ], fromGcsUri);
    const fromVertexDatasetResource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'vertexDatasetResource'
    ]);
    if (fromVertexDatasetResource != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'validationDatasetUri'
    ], fromVertexDatasetResource);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$Tunings extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists tuning jobs.
         *
         * @param params - The parameters for the list request.
         * @return - A pager of tuning jobs.
         *
         * @example
         * ```ts
         * const tuningJobs = await ai.tunings.list({config: {'pageSize': 2}});
         * for await (const tuningJob of tuningJobs) {
         *   console.log(tuningJob);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_TUNING_JOBS, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
        /**
         * Gets a TuningJob.
         *
         * @param name - The resource name of the tuning job.
         * @return - A TuningJob object.
         *
         * @experimental - The SDK's tuning implementation is experimental, and may
         * change in future versions.
         */ this.get = async (params)=>{
            return await this.getInternal(params);
        };
        /**
         * Creates a supervised fine-tuning job.
         *
         * @param params - The parameters for the tuning job.
         * @return - A TuningJob operation.
         *
         * @experimental - The SDK's tuning implementation is experimental, and may
         * change in future versions.
         */ this.tune = async (params)=>{
            var _a;
            if (this.apiClient.isVertexAI()) {
                if (params.baseModel.startsWith('projects/')) {
                    const preTunedModel = {
                        tunedModelName: params.baseModel
                    };
                    if ((_a = params.config) === null || _a === void 0 ? void 0 : _a.preTunedModelCheckpointId) preTunedModel.checkpointId = params.config.preTunedModelCheckpointId;
                    const paramsPrivate = Object.assign(Object.assign({}, params), {
                        preTunedModel: preTunedModel
                    });
                    paramsPrivate.baseModel = undefined;
                    return await this.tuneInternal(paramsPrivate);
                } else {
                    const paramsPrivate = Object.assign({}, params);
                    return await this.tuneInternal(paramsPrivate);
                }
            } else {
                const paramsPrivate = Object.assign({}, params);
                const operation = await this.tuneMldevInternal(paramsPrivate);
                let tunedModelName = '';
                if (operation['metadata'] !== undefined && operation['metadata']['tunedModel'] !== undefined) tunedModelName = operation['metadata']['tunedModel'];
                else if (operation['name'] !== undefined && operation['name'].includes('/operations/')) tunedModelName = operation['name'].split('/operations/')[0];
                const tuningJob = {
                    name: tunedModelName,
                    state: $e4deb49dba5321bc$export$d30a7cb66801c974.JOB_STATE_QUEUED
                };
                return tuningJob;
            }
        };
    }
    async getInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getTuningJobParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$tuningJobFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$getTuningJobParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$tuningJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$listTuningJobsParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('tuningJobs', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listTuningJobsResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$32bcd29afb9d1292();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$listTuningJobsParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('tunedModels', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listTuningJobsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$32bcd29afb9d1292();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Cancels a tuning job.
     *
     * @param params - The parameters for the cancel request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.tunings.cancel({name: '...'}); // The server-generated resource name.
     * ```
     */ async cancel(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$cancelTuningJobParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}:cancel', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$cancelTuningJobResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$4ec84eddeb3a0f6d();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$cancelTuningJobParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}:cancel', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$cancelTuningJobResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$4ec84eddeb3a0f6d();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async tuneInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$createTuningJobParametersPrivateToVertex(params, params);
            path = $e4deb49dba5321bc$var$formatMap('tuningJobs', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$tuningJobFromVertex(apiResponse);
                return resp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    async tuneMldevInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createTuningJobParametersPrivateToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('tunedModels', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$tuningOperationFromMldev(apiResponse);
                return resp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$BrowserDownloader {
    async download(_params, _apiClient) {
        throw new Error('Download to file is not supported in the browser, please use a browser compliant download like an <a> tag.');
    }
}
const $e4deb49dba5321bc$var$MAX_CHUNK_SIZE = 8388608; // bytes
const $e4deb49dba5321bc$var$MAX_RETRY_COUNT = 3;
const $e4deb49dba5321bc$var$INITIAL_RETRY_DELAY_MS = 1000;
const $e4deb49dba5321bc$var$DELAY_MULTIPLIER = 2;
const $e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD = 'x-goog-upload-status';
async function $e4deb49dba5321bc$var$uploadBlob(file, uploadUrl, apiClient) {
    var _a;
    const response = await $e4deb49dba5321bc$var$uploadBlobInternal(file, uploadUrl, apiClient);
    const responseJson = await (response === null || response === void 0 ? void 0 : response.json());
    if (((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a[$e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) !== 'final') throw new Error('Failed to upload file: Upload status is not finalized.');
    return responseJson['file'];
}
async function $e4deb49dba5321bc$var$uploadBlobToFileSearchStore(file, uploadUrl, apiClient) {
    var _a;
    const response = await $e4deb49dba5321bc$var$uploadBlobInternal(file, uploadUrl, apiClient);
    const responseJson = await (response === null || response === void 0 ? void 0 : response.json());
    if (((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a[$e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) !== 'final') throw new Error('Failed to upload file: Upload status is not finalized.');
    const resp = $e4deb49dba5321bc$var$uploadToFileSearchStoreOperationFromMldev(responseJson);
    const typedResp = new $e4deb49dba5321bc$export$9b1ce68551588ef4();
    Object.assign(typedResp, resp);
    return typedResp;
}
async function $e4deb49dba5321bc$var$uploadBlobInternal(file, uploadUrl, apiClient) {
    var _a, _b;
    let fileSize = 0;
    let offset = 0;
    let response = new $e4deb49dba5321bc$export$1d94dfe0d9d1f1e7(new Response());
    let uploadCommand = 'upload';
    fileSize = file.size;
    while(offset < fileSize){
        const chunkSize = Math.min($e4deb49dba5321bc$var$MAX_CHUNK_SIZE, fileSize - offset);
        const chunk = file.slice(offset, offset + chunkSize);
        if (offset + chunkSize >= fileSize) uploadCommand += ', finalize';
        let retryCount = 0;
        let currentDelayMs = $e4deb49dba5321bc$var$INITIAL_RETRY_DELAY_MS;
        while(retryCount < $e4deb49dba5321bc$var$MAX_RETRY_COUNT){
            response = await apiClient.request({
                path: '',
                body: chunk,
                httpMethod: 'POST',
                httpOptions: {
                    apiVersion: '',
                    baseUrl: uploadUrl,
                    headers: {
                        'X-Goog-Upload-Command': uploadCommand,
                        'X-Goog-Upload-Offset': String(offset),
                        'Content-Length': String(chunkSize)
                    }
                }
            });
            if ((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a[$e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) break;
            retryCount++;
            await $e4deb49dba5321bc$var$sleep(currentDelayMs);
            currentDelayMs = currentDelayMs * $e4deb49dba5321bc$var$DELAY_MULTIPLIER;
        }
        offset += chunkSize;
        // The `x-goog-upload-status` header field can be `active`, `final` and
        //`cancelled` in resposne.
        if (((_b = response === null || response === void 0 ? void 0 : response.headers) === null || _b === void 0 ? void 0 : _b[$e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) !== 'active') break;
        // TODO(b/401391430) Investigate why the upload status is not finalized
        // even though all content has been uploaded.
        if (fileSize <= offset) throw new Error('All content has been uploaded, but the upload status is not finalized.');
    }
    return response;
}
async function $e4deb49dba5321bc$var$getBlobStat(file) {
    const fileStat = {
        size: file.size,
        type: file.type
    };
    return fileStat;
}
function $e4deb49dba5321bc$var$sleep(ms) {
    return new Promise((resolvePromise)=>setTimeout(resolvePromise, ms));
}
class $e4deb49dba5321bc$var$BrowserUploader {
    async upload(file, uploadUrl, apiClient) {
        if (typeof file === 'string') throw new Error('File path is not supported in browser uploader.');
        return await $e4deb49dba5321bc$var$uploadBlob(file, uploadUrl, apiClient);
    }
    async uploadToFileSearchStore(file, uploadUrl, apiClient) {
        if (typeof file === 'string') throw new Error('File path is not supported in browser uploader.');
        return await $e4deb49dba5321bc$var$uploadBlobToFileSearchStore(file, uploadUrl, apiClient);
    }
    async stat(file) {
        if (typeof file === 'string') throw new Error('File path is not supported in browser uploader.');
        else return await $e4deb49dba5321bc$var$getBlobStat(file);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$BrowserWebSocketFactory {
    create(url, headers, callbacks) {
        return new $e4deb49dba5321bc$var$BrowserWebSocket(url, headers, callbacks);
    }
}
class $e4deb49dba5321bc$var$BrowserWebSocket {
    constructor(url, headers, callbacks){
        this.url = url;
        this.headers = headers;
        this.callbacks = callbacks;
    }
    connect() {
        this.ws = new WebSocket(this.url);
        this.ws.onopen = this.callbacks.onopen;
        this.ws.onerror = this.callbacks.onerror;
        this.ws.onclose = this.callbacks.onclose;
        this.ws.onmessage = this.callbacks.onmessage;
    }
    send(message) {
        if (this.ws === undefined) throw new Error('WebSocket is not connected');
        this.ws.send(message);
    }
    close() {
        if (this.ws === undefined) throw new Error('WebSocket is not connected');
        this.ws.close();
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$GOOGLE_API_KEY_HEADER = 'x-goog-api-key';
// TODO(b/395122533): We need a secure client side authentication mechanism.
class $e4deb49dba5321bc$var$WebAuth {
    constructor(apiKey){
        this.apiKey = apiKey;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async addAuthHeaders(headers, url) {
        if (headers.get($e4deb49dba5321bc$var$GOOGLE_API_KEY_HEADER) !== null) return;
        if (this.apiKey.startsWith('auth_tokens/')) throw new Error('Ephemeral tokens are only supported by the live API.');
        // Check if API key is empty or null
        if (!this.apiKey) throw new Error('API key is missing. Please provide a valid API key.');
        headers.append($e4deb49dba5321bc$var$GOOGLE_API_KEY_HEADER, this.apiKey);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$LANGUAGE_LABEL_PREFIX = 'gl-node/';
/**
 * The Google GenAI SDK.
 *
 * @remarks
 * Provides access to the GenAI features through either the {@link
 * https://cloud.google.com/vertex-ai/docs/reference/rest | Gemini API} or
 * the {@link https://cloud.google.com/vertex-ai/docs/reference/rest | Vertex AI
 * API}.
 *
 * The {@link GoogleGenAIOptions.vertexai} value determines which of the API
 * services to use.
 *
 * When using the Gemini API, a {@link GoogleGenAIOptions.apiKey} must also be
 * set. When using Vertex AI, currently only {@link GoogleGenAIOptions.apiKey}
 * is supported via Express mode. {@link GoogleGenAIOptions.project} and {@link
 * GoogleGenAIOptions.location} should not be set.
 *
 * @example
 * Initializing the SDK for using the Gemini API:
 * ```ts
 * import {GoogleGenAI} from '@google/genai';
 * const ai = new GoogleGenAI({apiKey: 'GEMINI_API_KEY'});
 * ```
 *
 * @example
 * Initializing the SDK for using the Vertex AI API:
 * ```ts
 * import {GoogleGenAI} from '@google/genai';
 * const ai = new GoogleGenAI({
 *   vertexai: true,
 *   project: 'PROJECT_ID',
 *   location: 'PROJECT_LOCATION'
 * });
 * ```
 *
 */ class $e4deb49dba5321bc$export$60336eb45c8b7f44 {
    get interactions() {
        var _a;
        if (this._interactions !== undefined) return this._interactions;
        console.warn('GoogleGenAI.interactions: Interactions usage is experimental and may change in future versions.');
        const httpOpts = this.httpOptions;
        // Unsupported Options Warnings
        if (httpOpts === null || httpOpts === void 0 ? void 0 : httpOpts.extraBody) console.warn('GoogleGenAI.interactions: Client level httpOptions.extraBody is not supported by the interactions client and will be ignored.');
        const nextGenClient = new $e4deb49dba5321bc$var$GeminiNextGenAPIClient({
            baseURL: this.apiClient.getBaseUrl(),
            apiKey: this.apiKey,
            apiVersion: this.apiClient.getApiVersion(),
            clientAdapter: this.apiClient,
            defaultHeaders: this.apiClient.getDefaultHeaders(),
            timeout: httpOpts === null || httpOpts === void 0 ? void 0 : httpOpts.timeout,
            maxRetries: (_a = httpOpts === null || httpOpts === void 0 ? void 0 : httpOpts.retryOptions) === null || _a === void 0 ? void 0 : _a.attempts
        });
        this._interactions = nextGenClient.interactions;
        return this._interactions;
    }
    constructor(options){
        var _a;
        if (options.apiKey == null) throw new Error('An API Key must be set when running in a browser');
        // Web client only supports API key mode for Vertex AI.
        if (options.project || options.location) throw new Error('Vertex AI project based authentication is not supported on browser runtimes. Please do not provide a project or location.');
        this.vertexai = (_a = options.vertexai) !== null && _a !== void 0 ? _a : false;
        this.apiKey = options.apiKey;
        const baseUrl = $e4deb49dba5321bc$var$getBaseUrl(options.httpOptions, options.vertexai, /*vertexBaseUrlFromEnv*/ undefined, /*geminiBaseUrlFromEnv*/ undefined);
        if (baseUrl) {
            if (options.httpOptions) options.httpOptions.baseUrl = baseUrl;
            else options.httpOptions = {
                baseUrl: baseUrl
            };
        }
        this.apiVersion = options.apiVersion;
        this.httpOptions = options.httpOptions;
        const auth = new $e4deb49dba5321bc$var$WebAuth(this.apiKey);
        this.apiClient = new $e4deb49dba5321bc$var$ApiClient({
            auth: auth,
            apiVersion: this.apiVersion,
            apiKey: this.apiKey,
            vertexai: this.vertexai,
            httpOptions: this.httpOptions,
            userAgentExtra: $e4deb49dba5321bc$var$LANGUAGE_LABEL_PREFIX + 'web',
            uploader: new $e4deb49dba5321bc$var$BrowserUploader(),
            downloader: new $e4deb49dba5321bc$var$BrowserDownloader()
        });
        this.models = new $e4deb49dba5321bc$export$6edbc060ce567afa(this.apiClient);
        this.live = new $e4deb49dba5321bc$export$db78b3d0b2aa666a(this.apiClient, auth, new $e4deb49dba5321bc$var$BrowserWebSocketFactory());
        this.batches = new $e4deb49dba5321bc$export$ed828fcd19953e0d(this.apiClient);
        this.chats = new $e4deb49dba5321bc$export$84088b07cfe11a74(this.models, this.apiClient);
        this.caches = new $e4deb49dba5321bc$export$4c60919c4fe22d9(this.apiClient);
        this.files = new $e4deb49dba5321bc$export$9330ab61a7e5c11b(this.apiClient);
        this.operations = new $e4deb49dba5321bc$export$3d72bd1ae0aee044(this.apiClient);
        this.authTokens = new $e4deb49dba5321bc$export$8e1e81ac145e31be(this.apiClient);
        this.tunings = new $e4deb49dba5321bc$var$Tunings(this.apiClient);
        this.fileSearchStores = new $e4deb49dba5321bc$var$FileSearchStores(this.apiClient);
    }
}


const $c297677ff3eaaedd$var$Playground = ()=>{
    const editorRef = (0, $acw62.useRef)(null);
    const searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
    const initialLanguage = searchParams.get("language") || "javascript";
    const initialCode = searchParams.get("code") ? decodeURIComponent(searchParams.get("code")) : "";
    const [language, setLanguage] = (0, $acw62.useState)(initialLanguage);
    const [explaination, setExplaination] = (0, $acw62.useState)("");
    const [code, setCode] = (0, $acw62.useState)(initialCode);
    const [list, setList] = (0, $acw62.useState)([]);
    const [output, setOutput] = (0, $acw62.useState)("");
    const [idx, setIdx] = (0, $acw62.useState)(0);
    const decorationRef = (0, $acw62.useRef)([]);
    const [isGenerating, setIsGenerating] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const fetchProblem = async ()=>{
            const problemId = searchParams.get("problemId");
            if (problemId) try {
                const backendUrl = "https://leetcodedbot.onrender.com";
                const res = await fetch(`${backendUrl}/api/problems/${problemId}`);
                if (res.ok) {
                    const data = await res.json();
                    const lang = searchParams.get("language") || "javascript";
                    // Map common language names to key names in solutions
                    const langKey = lang.toLowerCase() === 'cpp' || lang.toLowerCase() === 'c++' ? 'cpp' : lang.toLowerCase();
                    const solutionCode = data.solutions[langKey] || data.solutions[lang] || "";
                    if (solutionCode) {
                        setCode(solutionCode);
                        setLanguage(lang);
                    }
                }
            } catch (err) {
                console.error("Failed to fetch problem from backend", err);
            }
        };
        fetchProblem();
    }, []);
    const handleEditorDidMount = (editor, monaco)=>{
        editorRef.current = {
            editor: editor,
            monaco: monaco
        };
    };
    const handleEditorChange = (value)=>{
        setCode(value);
    };
    const applyVisuals = (startIdx, endIdx)=>{
        if (!editorRef.current) return;
        const { editor: editor, monaco: monaco } = editorRef.current;
        decorationRef.current = editor.deltaDecorations(decorationRef.current, []);
        const range = new monaco.Range(startIdx, 1, endIdx, 1);
        decorationRef.current = editor.deltaDecorations([], [
            {
                range: range,
                options: {
                    isWholeLine: true,
                    className: "myHighlight"
                }
            }
        ]);
        // Scroll to the highlighted block
        editor.revealRangeInCenter(range);
    };
    const generateExplaination = async (code)=>{
        setIsGenerating(true);
        setExplaination("Generating explaination....\nThis might take few seconds");
        try {
            const keys = "AIzaSyDLir1bud9K7uW4SGOG5IoO-DI272Efx74,AIzaSyD-Y-_WqbxjgBWWW4sqYngJKVQ9cEPqaMc,AIzaSyAcM3McGv5u8RYRonw0Y88I-aC9Ze3IJY0,AIzaSyBAd_Xc9wIfQkGaL_mH3JzRf63Qb2A_MK4".split(',').map((k)=>k.trim()).filter(Boolean);
            const randomKey = keys[Math.floor(Math.random() * keys.length)];
            const ai = new (0, $e4deb49dba5321bc$export$60336eb45c8b7f44)({
                apiKey: randomKey
            });
            const response = await ai.models.generateContent({
                model: "gemini-3-flash-preview",
                contents: `Act as a senior software engineer and code reviewer.

Your task is to analyze the given code and explain it by following the program's actual execution flow.

RULES

1. Follow execution order only.
   - Start from the entry point.
   - Explain the code exactly in the order it executes.
   - Do not explain unused code.

2. Explain dependencies only when required.
   - If a variable, class, struct, constant, import, or helper function is needed to understand the current execution, explain it immediately before it is used.
   - Do not dump all declarations at the beginning.

3. Cover the entire code.
   - Every line must belong to exactly one block.
   - Do not skip any line.

4. Create meaningful blocks.
   - Each block should represent one logical step.
   - Do not make blocks that are too small or too large.

5. Keep explanations concise and technical.
   - Explain only:
     - What this block does.
     - Why it exists.
     - How it affects execution.
   - Do NOT give examples.
   - Do NOT use analogies.
   - Do NOT use phrases like "Suppose...", "Imagine...", "For example...", "Let's say...", or similar.
   - Do NOT repeat obvious information.
   - Be direct and precise.

6. Functions
   - Do not explain a function when it is defined.
   - Explain it only when execution reaches its first call.
   - Include:
     - Purpose
     - Parameters
     - Return value
     - Internal execution
   - Explain every function exactly once, at its first execution.

7. Loops and conditions
   - Explain the purpose of the loop or condition.
   - Explain how execution flows through it.
   - Do not simulate every iteration unless necessary.

8. Output
   - If the program requires input, choose realistic sample input.
   - Return the exact output produced.

9. Response format
   Return ONLY valid JSON.
   Do not include markdown.
   Do not include code fences.
   Do not include any text outside the JSON.

Required JSON format:

{
  "blocks": [
    {
      "lines": [startLine, endLine],
      "explanation": "Concise explanation of this execution step."
    }
  ],
  "codeOutput": "Exact program output."
}

Analyze the following code:

${code}`
            });
            const parsedData = JSON.parse(response.text);
            const { codeOutput: codeOutput, blocks: blocks } = parsedData;
            console.log(parsedData);
            setOutput(codeOutput);
            setList(blocks);
            setIdx(0);
            if (blocks && blocks.length > 0) {
                setExplaination(blocks[0].explanation);
                applyVisuals(blocks[0].lines[0], blocks[0].lines[1]);
            } else setExplaination('No explanation blocks found.');
        } catch (err) {
            console.log(err);
            setExplaination("Hey API is currently busy.Can you please try again.");
        } finally{
            setIsGenerating(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: "flex-1 flex flex-col md:flex-row overflow-hidden w-full relative  bg-[#0f172a]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "w-full h-1/2 md:w-[45%] md:h-full flex flex-col border-b md:border-b-0 md:border-r- border-gray-800 relative z-10 shadow-2xl",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full h-full flex flex-col font-mono text-sm shadow-xl",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-[#2d2d2d] px-4 py-2 border-b border-[#3e3e42] flex items-center justify-between text-gray-300",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "w-3 h-3 rounded-full bg-red-500"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "w-3 h-3 rounded-full bg-yellow-500"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "w-3 h-3 rounded-full bg-green-500"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: " text-xs text-gray-400 font-medium cursor-pointer",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        className: "border-2 bg-[#2d2d2d] p-1",
                                        value: language,
                                        onChange: (e)=>{
                                            setLanguage(e.target.value);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "javascript",
                                                children: "Javascript"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "python",
                                                children: "Python"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "cpp",
                                                children: "C++"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "java",
                                                children: "Java"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "c",
                                                children: "C"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex-1 relative overflow-hidden min-h-0",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e964c7ac951d5673$export$7cda8d932e2f33c0), {
                                onChange: handleEditorChange,
                                onMount: handleEditorDidMount,
                                height: "100%",
                                theme: "vs-dark",
                                value: code,
                                language: language
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                            className: " w-full  bg-white/5 backdrop-blur-md p-2 md:p-4",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-between items-center ",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    if (idx <= 0) return;
                                                    let newIdx = idx - 1;
                                                    setIdx(newIdx);
                                                    setExplaination(list[newIdx].explanation);
                                                    applyVisuals(list[newIdx].lines[0], list[newIdx].lines[1]);
                                                },
                                                disabled: idx === 0 || isGenerating,
                                                className: `px-4 py-2 cursor-pointer text-sm font-medium border rounded-md 
                    ${idx === 0 || isGenerating ? 'bg-gray-300 text-gray-400 dark:bg-gray-700 dark:text-gray-500 cursor-not-allowed' : 'text-gray-700 bg-white border-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700'}`,
                                                children: "Previous"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    if (idx >= list.length - 1) return;
                                                    const newIdx = idx + 1;
                                                    setIdx(newIdx);
                                                    setExplaination(list[newIdx].explanation);
                                                    applyVisuals(list[newIdx].lines[0], list[newIdx].lines[1]);
                                                },
                                                disabled: idx === list.length - 1 || list.length === 0 || isGenerating,
                                                className: `px-4 py-2 cursor-pointer text-sm font-medium border rounded-md 
                    ${idx === list.length - 1 || list.length === 0 || isGenerating ? 'bg-gray-300 text-gray-400 dark:bg-gray-700 dark:text-gray-500 cursor-not-allowed' : 'text-gray-700 bg-white border-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700'}`,
                                                children: "Next"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            disabled: isGenerating,
                                            onClick: ()=>{
                                                const numberedCode = code.split("\n").map((line, index)=>`${index + 1}: ${line}`).join("\n");
                                                generateExplaination(numberedCode);
                                            },
                                            className: `px-2 md:px-4 py-2 cursor-pointer rounded-lg text-sm font-semibold text-white transition-all duration-200 
                    ${isGenerating ? 'bg-gray-600 cursor-not-allowed opacity-50' : 'bg-gradient-to-r from-indigo-500 to-purple-500 shadow-md hover:from-indigo-600 hover:to-purple-600 hover:shadow-lg active:scale-95'}`,
                                            children: isGenerating ? "Generating..." : "Generate Explanation"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                className: "flex-1 h-full bg-[#0f172a] p-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-col h-full gap-4 md:flex-col-reverse",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-4 h-full min-h-0 md:flex-col-reverse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-[3] min-h-0 bg-white/5 backdrop-blur-md border border-white/10 rounded-lg flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "p-3 border-b border-white/10 text-gray-300 font-semibold",
                                        children: "Explanation"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "p-4 text-gray-200 overflow-y-auto flex-1 text-sm min-h-0",
                                        children: explaination === "" ? "Explanation will be displayed here" : explaination
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-[1] min-h-0 bg-black rounded-lg flex flex-col hidden md:flex max-h-32",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "p-3 bg-white/10 text-white font-semibold border-b border-white/10 ",
                                        children: "Output"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "p-4 whitespace-pre-wrap text-green-400 font-mono text-sm overflow-y-auto flex-1 min-h-0 mb-4 md:mb-0 md:mt-2 rounded-b-lg",
                                        style: {
                                            minHeight: "48px",
                                            maxHeight: "80px"
                                        },
                                        children: output === "" ? "Output will be displayed here..." : output
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $c297677ff3eaaedd$export$2e2bcd8739ae039 = $c297677ff3eaaedd$var$Playground;


const $35da740d59af89ba$var$App = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-screen h-screen flex flex-col",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $065dc4985456da65$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c297677ff3eaaedd$export$2e2bcd8739ae039), {})
        ]
    });
};
const $35da740d59af89ba$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById("root"));
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($35da740d59af89ba$var$App, {}));


//# sourceMappingURL=path0.11f8474c.js.map
